import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2019-12-03T09:54:33Z, compliant with the date-time format. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
};

export type AccessoriesParamsInput = {
  root?: Maybe<Scalars["Boolean"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type AccessorySchema = {
  __typename?: "AccessorySchema";
  _id?: Maybe<Scalars["ID"]>;
  id?: Maybe<Scalars["ID"]>;
  name: Scalars["String"];
  created?: Maybe<Scalars["DateTime"]>;
  root?: Maybe<Scalars["Boolean"]>;
  /** safety, comfort, sound_system, windows, seat, others */
  type: Scalars["String"];
  alias?: Maybe<AccessorySchema>;
  aliasId?: Maybe<Scalars["String"]>;
};

export type AddonServiceDto = {
  name?: Maybe<Scalars["String"]>;
  key: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  cost?: Maybe<Scalars["Float"]>;
};

export type AddonServiceSchema = {
  __typename?: "AddonServiceSchema";
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  key: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  cost?: Maybe<Scalars["Float"]>;
  created?: Maybe<Scalars["DateTime"]>;
  updated?: Maybe<Scalars["DateTime"]>;
};

export type AdminAdSchema = {
  __typename?: "AdminAdSchema";
  _id: Scalars["ID"];
  name: Scalars["String"];
  type?: Maybe<Scalars["String"]>;
  platform?: Maybe<Scalars["String"]>;
  position?: Maybe<Scalars["String"]>;
  make?: Maybe<AdRefSchema>;
  model?: Maybe<AdRefSchema>;
  content?: Maybe<Scalars["String"]>;
  slideAttributes?: Maybe<Scalars["JSON"]>;
  attributes?: Maybe<Scalars["JSON"]>;
  responsive?: Maybe<Scalars["Boolean"]>;
  parallax?: Maybe<Scalars["Boolean"]>;
  width?: Maybe<Scalars["String"]>;
  height?: Maybe<Scalars["String"]>;
  posIndex?: Maybe<Scalars["Int"]>;
  country?: Maybe<Scalars["String"]>;
  startAt?: Maybe<Scalars["DateTime"]>;
  endAt?: Maybe<Scalars["DateTime"]>;
  published?: Maybe<Scalars["Boolean"]>;
};

export type AdminAdsResult = {
  __typename?: "AdminAdsResult";
  ads: Array<AdminAdSchema>;
  total: Scalars["Int"];
};

export type AdminBillingSchema = {
  __typename?: "AdminBillingSchema";
  _id: Scalars["ID"];
  seq?: Maybe<Scalars["Float"]>;
  company?: Maybe<BillingCompanyRef>;
  items?: Maybe<Scalars["JSON"]>;
  period?: Maybe<Scalars["DateTime"]>;
  status?: Maybe<Scalars["String"]>;
  paidAt?: Maybe<Scalars["DateTime"]>;
  sentAt?: Maybe<Scalars["DateTime"]>;
  dueAt?: Maybe<Scalars["DateTime"]>;
  overall?: Maybe<Scalars["Float"]>;
  totalTax?: Maybe<Scalars["Float"]>;
  overallBeforeTax?: Maybe<Scalars["Float"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type AdminBillingsResult = {
  __typename?: "AdminBillingsResult";
  billings: Array<AdminBillingSchema>;
  total: Scalars["Int"];
};

export type AdminCouponSchema = {
  __typename?: "AdminCouponSchema";
  _id: Scalars["ID"];
  code?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  user?: Maybe<CouponUserRef>;
  agent?: Maybe<Scalars["ID"]>;
  owner?: Maybe<CouponUserRef>;
  car?: Maybe<Scalars["ID"]>;
  discountPercent?: Maybe<Scalars["Float"]>;
  discountUSD?: Maybe<Scalars["Float"]>;
  balanceUSD?: Maybe<Scalars["Float"]>;
  expired?: Maybe<Scalars["DateTime"]>;
  created?: Maybe<Scalars["DateTime"]>;
  refers?: Maybe<Scalars["JSON"]>;
  applyConditions?: Maybe<Scalars["JSON"]>;
  isRemoved?: Maybe<Scalars["Boolean"]>;
  maxUSD?: Maybe<Scalars["Float"]>;
  usedTimes?: Maybe<Scalars["Float"]>;
  maxTimes?: Maybe<Scalars["Float"]>;
  maxPaymentTimes?: Maybe<Scalars["Float"]>;
};

export type AdminCouponsResult = {
  __typename?: "AdminCouponsResult";
  coupons: Array<AdminCouponSchema>;
  total: Scalars["Int"];
};

export type AdminFreightParentSchema = {
  __typename?: "AdminFreightParentSchema";
  _id: Scalars["ID"];
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
};

export type AdminFreightSchema = {
  __typename?: "AdminFreightSchema";
  _id: Scalars["ID"];
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  m3USD?: Maybe<Scalars["Float"]>;
  m3JPY?: Maybe<Scalars["Float"]>;
  m3NZD?: Maybe<Scalars["Float"]>;
  carUSD?: Maybe<Scalars["Float"]>;
  carJPY?: Maybe<Scalars["Float"]>;
  carNZD?: Maybe<Scalars["Float"]>;
  inspectName?: Maybe<Scalars["String"]>;
  inspectFee?: Maybe<Scalars["Float"]>;
  condOverM3?: Maybe<Scalars["Float"]>;
  condUnderM3?: Maybe<Scalars["Float"]>;
  condOverHeightCm?: Maybe<Scalars["Float"]>;
  condUnderHeightCm?: Maybe<Scalars["Float"]>;
  condOverWeightTon?: Maybe<Scalars["Float"]>;
  condUnderWeightTon?: Maybe<Scalars["Float"]>;
  company?: Maybe<Scalars["ID"]>;
  parent?: Maybe<AdminFreightParentSchema>;
  isCustomized?: Maybe<Scalars["Boolean"]>;
  cities?: Maybe<Scalars["JSON"]>;
  shippingMethod?: Maybe<Scalars["String"]>;
  priority?: Maybe<Scalars["Int"]>;
  inform?: Maybe<Scalars["JSON"]>;
  needInspection?: Maybe<Scalars["Boolean"]>;
  canBuyNow?: Maybe<Scalars["Boolean"]>;
};

export type AdminFreightsResult = {
  __typename?: "AdminFreightsResult";
  data?: Maybe<Array<AdminFreightSchema>>;
  total?: Maybe<Scalars["Int"]>;
};

export type AdminGuidePagingSchema = {
  __typename?: "AdminGuidePagingSchema";
  nodes?: Maybe<Array<AdminGuideSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type AdminGuideSchema = {
  __typename?: "AdminGuideSchema";
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["Float"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  media?: Maybe<CfjLegacyMedia>;
  read?: Maybe<Scalars["Boolean"]>;
};

export type AdminRegulationPortSchema = {
  __typename?: "AdminRegulationPortSchema";
  port: Scalars["String"];
  messages: Array<Scalars["String"]>;
};

export type AdminRegulationSchema = {
  __typename?: "AdminRegulationSchema";
  _id: Scalars["ID"];
  country: Scalars["String"];
  messages?: Maybe<Array<Scalars["String"]>>;
  targeted?: Maybe<Scalars["Boolean"]>;
  rules?: Maybe<Array<RuleSchema>>;
  ports?: Maybe<Array<AdminRegulationPortSchema>>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  modifiedAt?: Maybe<Scalars["DateTime"]>;
};

export enum AdminSmsDeliveryStatus {
  DELIVERED = "DELIVERED",
  FAILED = "FAILED",
  PENDING = "PENDING"
}

export type AdminSmsLogItemSchema = {
  __typename?: "AdminSmsLogItemSchema";
  id: Scalars["ID"];
  sentAt?: Maybe<Scalars["DateTime"]>;
  /** CFJ Inquiry No. */
  inquiryNo?: Maybe<Scalars["Int"]>;
  destinationCountry?: Maybe<Scalars["String"]>;
  /** InquiryStep code at send time (e.g. ISSUED_INVOICE); translated by the client */
  transactionStep?: Maybe<Scalars["String"]>;
  /** JPY excl. tax; null when the SMS is free */
  price?: Maybe<Scalars["Float"]>;
  /** JPY incl. tax (¥90 → ¥99), from the price and tax rate snapshotted at send time; null when free */
  priceInclTax?: Maybe<Scalars["Float"]>;
  isFree: Scalars["Boolean"];
  freeReason?: Maybe<Scalars["String"]>;
  /** Carrier delivery status */
  status?: Maybe<Scalars["String"]>;
  chargeStatus?: Maybe<Scalars["String"]>;
  companyId?: Maybe<Scalars["ID"]>;
  companyName?: Maybe<Scalars["String"]>;
  /** Recipient number (admins only) */
  to?: Maybe<Scalars["String"]>;
  /** Twilio SID */
  smsId?: Maybe<Scalars["String"]>;
  smsType?: Maybe<Scalars["String"]>;
};

export type AdminSmsLogsResultSchema = {
  __typename?: "AdminSmsLogsResultSchema";
  /** YYYY-MM-DD (JST) */
  dateFrom: Scalars["String"];
  /** YYYY-MM-DD (JST) */
  dateTo: Scalars["String"];
  items: Array<AdminSmsLogItemSchema>;
  total: Scalars["Int"];
  offset: Scalars["Int"];
  limit: Scalars["Int"];
};

export type AdminSmsSellerDetailSchema = {
  __typename?: "AdminSmsSellerDetailSchema";
  companyId: Scalars["ID"];
  companyKey?: Maybe<Scalars["String"]>;
  companyName: Scalars["String"];
  /** Registration date */
  registeredAt?: Maybe<Scalars["DateTime"]>;
  /** Service currently ON */
  active: Scalars["Boolean"];
  totalSms: Scalars["Int"];
  billableSms: Scalars["Int"];
  /** JPY excl. tax, from SMS sent in the range (estimate) */
  estimatedCost: Scalars["Float"];
  /** JPY incl. tax, same estimate — what the seller is quoted */
  estimatedCostInclTax: Scalars["Float"];
  /** JPY incl. tax to add to the listing-fee billing: charged SMS of every JST month the range touches */
  monthlyPayment: Scalars["Float"];
  /** Months of the range with charged SMS, newest first */
  statements: Array<AdminSmsStatementSchema>;
  /** Charged SMS: `statements` once the range has ended, else every SMS that is (or may still be) charged */
  paidSms: Scalars["Int"];
  /** JPY incl. tax: `monthlyPayment` once the range has ended, else the estimate (`estimatedCostInclTax`) */
  amount: Scalars["Float"];
  /** PAID when every charged month of the range is marked paid; null without SMS fees */
  paymentStatus?: Maybe<SmsPaymentStatus>;
  /** Company is on the Seller Nego (enterprise) plan */
  isSellerNego: Scalars["Boolean"];
  activatedAt?: Maybe<Scalars["DateTime"]>;
  deactivatedAt?: Maybe<Scalars["DateTime"]>;
  /** Reason of the last admin override */
  adminNote?: Maybe<Scalars["String"]>;
  freeSms: Scalars["Int"];
  /** Total Successful Delivery */
  totalDelivered: Scalars["Int"];
  failed: Scalars["Int"];
  /** totalDelivered / totalSms × 100, one decimal; 0 without SMS */
  deliveryRate: Scalars["Float"];
  dateFrom: Scalars["String"];
  dateTo: Scalars["String"];
};

export type AdminSmsSellerSchema = {
  __typename?: "AdminSmsSellerSchema";
  companyId: Scalars["ID"];
  companyKey?: Maybe<Scalars["String"]>;
  companyName: Scalars["String"];
  /** Registration date */
  registeredAt?: Maybe<Scalars["DateTime"]>;
  /** Service currently ON */
  active: Scalars["Boolean"];
  totalSms: Scalars["Int"];
  billableSms: Scalars["Int"];
  /** JPY excl. tax, from SMS sent in the range (estimate) */
  estimatedCost: Scalars["Float"];
  /** JPY incl. tax, same estimate — what the seller is quoted */
  estimatedCostInclTax: Scalars["Float"];
  /** JPY incl. tax to add to the listing-fee billing: charged SMS of every JST month the range touches */
  monthlyPayment: Scalars["Float"];
  /** Months of the range with charged SMS, newest first */
  statements: Array<AdminSmsStatementSchema>;
  /** Charged SMS: `statements` once the range has ended, else every SMS that is (or may still be) charged */
  paidSms: Scalars["Int"];
  /** JPY incl. tax: `monthlyPayment` once the range has ended, else the estimate (`estimatedCostInclTax`) */
  amount: Scalars["Float"];
  /** PAID when every charged month of the range is marked paid; null without SMS fees */
  paymentStatus?: Maybe<SmsPaymentStatus>;
};

export enum AdminSmsSellerSort {
  REGISTERED_AT = "REGISTERED_AT",
  MONTHLY_PAYMENT = "MONTHLY_PAYMENT",
  COMPANY_NAME = "COMPANY_NAME"
}

export type AdminSmsSellersResultSchema = {
  __typename?: "AdminSmsSellersResultSchema";
  /** YYYY-MM-DD (JST) */
  dateFrom: Scalars["String"];
  /** YYYY-MM-DD (JST) */
  dateTo: Scalars["String"];
  items: Array<AdminSmsSellerSchema>;
  total: Scalars["Int"];
  offset: Scalars["Int"];
  limit: Scalars["Int"];
};

export type AdminSmsSellerStatsSchema = {
  __typename?: "AdminSmsSellerStatsSchema";
  /** YYYY-MM-DD (JST) */
  dateFrom: Scalars["String"];
  /** YYYY-MM-DD (JST) */
  dateTo: Scalars["String"];
  /** Companies that registered for the service */
  totalRegistered: Scalars["Int"];
  /** Companies incurring costs in the range */
  activeSellers: Scalars["Int"];
};

export enum AdminSmsSellerStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  CHARGED = "CHARGED"
}

export type AdminSmsStatementSchema = {
  __typename?: "AdminSmsStatementSchema";
  /** YYYY-MM (JST) */
  month: Scalars["String"];
  /** SMS-YYMM */
  documentNo: Scalars["String"];
  billableSms: Scalars["Int"];
  /** JPY excl. tax */
  subtotal: Scalars["Float"];
  /** JPY, rounded per unit-price line */
  tax: Scalars["Float"];
  /** JPY incl. tax */
  total: Scalars["Float"];
  paymentStatus: SmsPaymentStatus;
};

export enum AdminSortOrder {
  ASC = "ASC",
  DESC = "DESC"
}

export type AdRefSchema = {
  __typename?: "AdRefSchema";
  _id?: Maybe<Scalars["ID"]>;
};

export type AdsSchema = {
  __typename?: "AdsSchema";
  id?: Maybe<Scalars["ID"]>;
  name: Scalars["String"];
  type: AdType;
  platform: Platform;
  make?: Maybe<Scalars["ID"]>;
  model?: Maybe<Scalars["ID"]>;
  position: Scalars["String"];
  content?: Maybe<Scalars["String"]>;
  slideAttributes?: Maybe<Array<SlideAttributesSchema>>;
  attributes?: Maybe<Scalars["JSON"]>;
  responsive?: Maybe<Scalars["Boolean"]>;
  parallax?: Maybe<Scalars["Boolean"]>;
  width?: Maybe<Scalars["String"]>;
  height?: Maybe<Scalars["String"]>;
  posIndex?: Maybe<Scalars["Float"]>;
  country?: Maybe<Scalars["String"]>;
  startAt?: Maybe<Scalars["DateTime"]>;
  endAt?: Maybe<Scalars["DateTime"]>;
  published: Scalars["Boolean"];
  createdAt: Scalars["DateTime"];
  createdBy: UserSchema;
  modifiedAt: Scalars["DateTime"];
  modifiedBy: UserSchema;
};

export enum AdType {
  ADSENSE = "ADSENSE",
  HTML = "HTML",
  MEDIANET = "MEDIANET",
  DOUBLECLICK = "DOUBLECLICK",
  SLIDE = "SLIDE",
  CATALOG = "CATALOG",
  BACKGROUND = "BACKGROUND"
}

export type AgentType = {
  __typename?: "AgentType";
  _id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  zendeskId?: Maybe<Scalars["Float"]>;
};

export enum ApplyConditionLabel {
  All = "All",
  Brands = "Brands",
  Bodytype = "Bodytype",
  Range = "Range",
  Country = "Country",
  FirstCustomer = "FirstCustomer",
  Seller = "Seller",
  Car = "Car",
  Tag = "Tag",
  Color = "Color"
}

export type ApplyConditionSchema = {
  __typename?: "ApplyConditionSchema";
  label: ApplyConditionLabel;
  active: Scalars["Boolean"];
  logic?: Maybe<Scalars["JSON"]>;
};

export type ArticleSchema = {
  __typename?: "ArticleSchema";
  id: Scalars["ID"];
  locale?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  body: Scalars["String"];
  image?: Maybe<Scalars["String"]>;
  slug?: Maybe<Scalars["String"]>;
  guid?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
  layout: Scalars["String"];
  tags?: Maybe<Array<Scalars["String"]>>;
  created?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  modifiedAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["ID"]>;
  modifiedBy?: Maybe<Scalars["ID"]>;
};

export type AskForSupportArgs = {
  invoiceId: Scalars["String"];
  comment: Scalars["String"];
  subject?: Maybe<Scalars["String"]>;
  files?: Maybe<Array<AskForSupportFileInput>>;
};

export type AskForSupportFileInput = {
  filename: Scalars["String"];
  key: Scalars["String"];
};

export type AskForSupportSchema = {
  __typename?: "AskForSupportSchema";
  id: Scalars["String"];
};

export type Assignee = {
  __typename?: "Assignee";
  id: Scalars["Float"];
  name?: Maybe<Scalars["String"]>;
};

export type AssigneeSchema = {
  __typename?: "AssigneeSchema";
  id: Scalars["Float"];
  name?: Maybe<Scalars["String"]>;
};

export type AuctionSheetDataSchema = {
  __typename?: "AuctionSheetDataSchema";
  evaluation?: Maybe<EvaluationSchema>;
  vehicle_information?: Maybe<VehicleInformationSchema>;
  equipment?: Maybe<EquipmentSchema>;
  aftermarket_parts?: Maybe<Array<Scalars["String"]>>;
  aftermarket_parts_en?: Maybe<Array<Scalars["String"]>>;
  sales_points?: Maybe<Array<Scalars["String"]>>;
  sales_points_en?: Maybe<Array<Scalars["String"]>>;
  special_notes?: Maybe<Array<Scalars["String"]>>;
  special_notes_en?: Maybe<Array<Scalars["String"]>>;
  inspector_notes?: Maybe<Array<Scalars["String"]>>;
  inspector_notes_en?: Maybe<Array<Scalars["String"]>>;
  remarks?: Maybe<Array<Scalars["String"]>>;
  remarks_en?: Maybe<Array<Scalars["String"]>>;
  condition_report?: Maybe<ConditionReportSchema>;
};

export type AuctionSheetPagingSchema = {
  __typename?: "AuctionSheetPagingSchema";
  nodes?: Maybe<Array<AuctionSheetSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type AuctionSheetSchema = {
  __typename?: "AuctionSheetSchema";
  id: Scalars["ID"];
  status: Scalars["String"];
  overallGrade?: Maybe<Scalars["String"]>;
  errorMessage?: Maybe<Scalars["String"]>;
  sourceImage?: Maybe<ImageRefSchema>;
  classified?: Maybe<Scalars["Boolean"]>;
  classification?: Maybe<ClassificationResultSchema>;
  detection?: Maybe<DetectionResultSchema>;
  llm?: Maybe<LlmOutputSchema>;
  translatedImage?: Maybe<ImageRefSchema>;
  predictedGrade?: Maybe<Scalars["String"]>;
  predictedInteriorGrade?: Maybe<Scalars["String"]>;
  predictedExteriorGrade?: Maybe<Scalars["String"]>;
  isVerified?: Maybe<Scalars["Boolean"]>;
  editedBy?: Maybe<Scalars["ID"]>;
  editedAt?: Maybe<Scalars["DateTime"]>;
  verifiedBy?: Maybe<Scalars["ID"]>;
  verifiedAt?: Maybe<Scalars["DateTime"]>;
  createdAt: Scalars["DateTime"];
};

export type AuthorizePaypalOrderArgs = {
  invoiceId: Scalars["ID"];
  paypalOrderId: Scalars["String"];
};

export type AutoReplyMessagePagingSchema = {
  __typename?: "AutoReplyMessagePagingSchema";
  nodes?: Maybe<Array<AutoReplyMessageSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type AutoReplyMessageSchema = {
  __typename?: "AutoReplyMessageSchema";
  id: Scalars["ID"];
  content: Scalars["String"];
  startsAt: Scalars["DateTime"];
  endsAt: Scalars["DateTime"];
  ticketStatuses: Array<Scalars["String"]>;
  agents: Array<UserSchema>;
  agentIds: Array<Scalars["String"]>;
  maxPerDay: Scalars["Int"];
  status: Scalars["String"];
  actionType: Scalars["String"];
  transitions: Array<StatusTransitionConfigSchema>;
  createdBy?: Maybe<UserSchema>;
  modifiedBy?: Maybe<UserSchema>;
  createdAt: Scalars["DateTime"];
  modifiedAt: Scalars["DateTime"];
};

export type AutoSaveDto = {
  name?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  countryCode?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  inspection?: Maybe<Scalars["Boolean"]>;
  insurance?: Maybe<Scalars["Boolean"]>;
  defaultCurrency?: Maybe<Scalars["String"]>;
  gender?: Maybe<Scalars["Int"]>;
  notifyMethod?: Maybe<NotifyMethodDto>;
  viewListType?: Maybe<Scalars["String"]>;
  brokerRecommendation?: Maybe<Scalars["Boolean"]>;
  defaultMileageUnit?: Maybe<Scalars["String"]>;
  defaultEngineUnit?: Maybe<Scalars["String"]>;
};

export type AutoSaveResultSchema = {
  __typename?: "AutoSaveResultSchema";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  namePronounciation?: Maybe<Scalars["String"]>;
  signature?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  roles?: Maybe<Array<Scalars["String"]>>;
  tags?: Maybe<Array<Scalars["String"]>>;
  provider?: Maybe<Scalars["String"]>;
  locale?: Maybe<Scalars["String"]>;
  companies?: Maybe<Array<Scalars["ID"]>>;
  _companies?: Maybe<Array<CompanySchema>>;
  companyIds?: Maybe<Array<Scalars["String"]>>;
  address?: Maybe<Scalars["String"]>;
  address2?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  countryCode?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  facebook?: Maybe<Scalars["JSON"]>;
  twitter?: Maybe<Scalars["JSON"]>;
  google?: Maybe<Scalars["JSON"]>;
  created?: Maybe<Scalars["DateTime"]>;
  lastActivity?: Maybe<Scalars["DateTime"]>;
  logoutAt?: Maybe<Scalars["DateTime"]>;
  lastAssignedAt?: Maybe<Scalars["DateTime"]>;
  verifiedPhoneAt?: Maybe<Scalars["DateTime"]>;
  birthday?: Maybe<Scalars["DateTime"]>;
  notifyMethod?: Maybe<NotifyMethod>;
  image?: Maybe<MediaSchema>;
  zendeskId?: Maybe<Scalars["Float"]>;
  utm_source?: Maybe<Scalars["String"]>;
  utm_medium?: Maybe<Scalars["String"]>;
  inspection?: Maybe<Scalars["Boolean"]>;
  insurance?: Maybe<Scalars["Boolean"]>;
  defaultCurrency?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["Float"]>;
  deactivateAt?: Maybe<Scalars["DateTime"]>;
  changedEmailAt?: Maybe<Scalars["DateTime"]>;
  gender?: Maybe<Scalars["Float"]>;
  defaultMileageUnit?: Maybe<Scalars["String"]>;
  defaultEngineUnit?: Maybe<Scalars["String"]>;
  accessToken?: Maybe<Scalars["String"]>;
};

export type BalanceAmountSchema = {
  __typename?: "BalanceAmountSchema";
  id: Scalars["ID"];
  userId: Scalars["ID"];
  amount: Scalars["Float"];
};

export enum BankType {
  SAVING = "SAVING",
  MULTIPURPOSE = "MULTIPURPOSE",
  CURRENT_ACCOUNT = "CURRENT_ACCOUNT"
}

export type BatchEditModelSpecInput = {
  year?: Maybe<Scalars["Int"]>;
  bodyType?: Maybe<Scalars["Int"]>;
  door?: Maybe<Scalars["Int"]>;
  driveType?: Maybe<Scalars["Int"]>;
  displacement?: Maybe<Scalars["Int"]>;
  fuelType?: Maybe<Scalars["Int"]>;
  vehicleWidth?: Maybe<Scalars["Int"]>;
  vehicleLength?: Maybe<Scalars["Int"]>;
  vehicleHeight?: Maybe<Scalars["Int"]>;
};

export type BatchEditTransformationInput = {
  type?: Maybe<TransformationType>;
  value?: Maybe<Scalars["String"]>;
};

export type BatchInvoicesActionArgs = {
  invoiceIds: Array<Scalars["String"]>;
  action: Scalars["String"];
  data?: Maybe<BatchInvoicesActionData>;
};

export type BatchInvoicesActionData = {
  folder?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type BillingCompanyRef = {
  __typename?: "BillingCompanyRef";
  _id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  enName?: Maybe<Scalars["String"]>;
};

export type BillingItemInput = {
  title?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  price?: Maybe<Scalars["Float"]>;
  quantity?: Maybe<Scalars["Float"]>;
  tax?: Maybe<Scalars["Float"]>;
  totalPrice?: Maybe<Scalars["Float"]>;
};

export type BillingUpsertInput = {
  company?: Maybe<Scalars["ID"]>;
  status?: Maybe<Scalars["String"]>;
  items?: Maybe<Array<BillingItemInput>>;
  period?: Maybe<Scalars["DateTime"]>;
  dueAt?: Maybe<Scalars["DateTime"]>;
  paidAt?: Maybe<Scalars["DateTime"]>;
  sentAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type Boxlink = {
  title: Scalars["String"];
  url: Scalars["String"];
  name?: Maybe<Scalars["String"]>;
};

export type BoxlinkDto = {
  id?: Maybe<Scalars["String"]>;
  path?: Maybe<Scalars["String"]>;
  boxLinks?: Maybe<Array<Boxlink>>;
  isUpdated?: Maybe<Scalars["Boolean"]>;
};

export type BoxLinkSchema = {
  __typename?: "BoxLinkSchema";
  title: Scalars["String"];
  url: Scalars["String"];
  name?: Maybe<Scalars["String"]>;
};

export type BoxtextContentSchema = {
  __typename?: "BoxtextContentSchema";
  _id?: Maybe<Scalars["ID"]>;
  key?: Maybe<Scalars["String"]>;
  settings?: Maybe<Array<Setting>>;
  contents?: Maybe<Array<Content>>;
  currentContent: Scalars["String"];
  drafts?: Maybe<Array<Draft>>;
  isDefaultContent: Scalars["Boolean"];
  isUpdated?: Maybe<Scalars["Boolean"]>;
  edition: Scalars["Float"];
  defaultContent?: Maybe<Scalars["String"]>;
  isUpdatedV2?: Maybe<Scalars["Boolean"]>;
  default: Scalars["String"];
  title?: Maybe<Scalars["String"]>;
  subtitle?: Maybe<Scalars["String"]>;
  tabs?: Maybe<Array<Scalars["JSON"]>>;
  modifiedAt: Scalars["DateTime"];
};

export type BoxtextDto = {
  id?: Maybe<Scalars["String"]>;
  key?: Maybe<Scalars["String"]>;
  content?: Maybe<Scalars["String"]>;
  status: Scalars["Float"];
  isDefaultContent?: Maybe<Scalars["Boolean"]>;
};

export type BoxtextPagingSchema = {
  __typename?: "BoxtextPagingSchema";
  nodes?: Maybe<Array<BoxtextContentSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type Bucket = {
  __typename?: "Bucket";
  key: Scalars["String"];
  doc_count: Scalars["Int"];
  from?: Maybe<Scalars["Float"]>;
  to?: Maybe<Scalars["Float"]>;
};

export type BucketKey = {
  key: Scalars["String"];
};

export type BuyerReplyCommentArgs = {
  id: Scalars["String"];
  comment: Scalars["String"];
  files?: Maybe<Array<BuyerReplyCommentFileInput>>;
};

export type BuyerReplyCommentFileInput = {
  filename: Scalars["String"];
  key: Scalars["String"];
  order?: Maybe<Scalars["Float"]>;
};

export type CampaignActionPagingSchema = {
  __typename?: "CampaignActionPagingSchema";
  nodes?: Maybe<Array<CampaignActionSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type CampaignActionSchema = {
  __typename?: "CampaignActionSchema";
  id: Scalars["ID"];
  buyerEmail?: Maybe<Scalars["String"]>;
  buyerId: Scalars["ID"];
  buyerName?: Maybe<Scalars["String"]>;
  campaignCode: Scalars["String"];
  carName?: Maybe<Scalars["String"]>;
  carImages?: Maybe<Array<CarImage>>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  orderId: Scalars["ID"];
  introducerId: Scalars["ID"];
  introducerName?: Maybe<Scalars["String"]>;
  inquiryNo?: Maybe<Scalars["Float"]>;
  referralCode?: Maybe<Scalars["String"]>;
  balanceAmountForIntroducer: Scalars["Float"];
  confirmedOrder?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type CampaignEmailsSchema = {
  __typename?: "CampaignEmailsSchema";
  _id: Scalars["ID"];
  emails: Array<Scalars["String"]>;
  sourceId: Scalars["Int"];
  sourceName: Scalars["String"];
  userEmail: Scalars["String"];
  couponCode: Scalars["String"];
  discountUSD: Scalars["Float"];
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type CampaignInputDto = {
  discountAmount?: Maybe<Scalars["Float"]>;
  id: Scalars["String"];
};

export type CampaignJoinSchema = {
  __typename?: "CampaignJoinSchema";
  id: Scalars["ID"];
  campaignCode?: Maybe<Scalars["String"]>;
  referralCode?: Maybe<Scalars["String"]>;
  referralLink?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["ID"]>;
  userName?: Maybe<Scalars["String"]>;
  userEmail?: Maybe<Scalars["String"]>;
  discountAmount: Scalars["Float"];
  joinDate?: Maybe<Scalars["DateTime"]>;
  customCommission?: Maybe<Scalars["Float"]>;
  tags?: Maybe<Array<IntroducerTag>>;
  customReferralCode?: Maybe<Scalars["String"]>;
  originalReferralCode?: Maybe<Scalars["String"]>;
  utm_source?: Maybe<Scalars["String"]>;
  utm_medium?: Maybe<Scalars["String"]>;
  utm_campaign?: Maybe<Scalars["String"]>;
};

export type CampaignSchema = {
  __typename?: "CampaignSchema";
  id: Scalars["ID"];
  campaignCode: Scalars["String"];
  campaignName?: Maybe<Scalars["String"]>;
  discountAmount: Scalars["Float"];
  fromDate?: Maybe<Scalars["DateTime"]>;
  toDate?: Maybe<Scalars["DateTime"]>;
};

export type CanaryCheck = {
  __typename?: "CanaryCheck";
  key: Scalars["String"];
  title: Scalars["String"];
  description: Scalars["String"];
  severity: CanarySeverity;
  status: CanaryCheckStatus;
  count: Scalars["Int"];
  total: Scalars["Int"];
  samples: Array<CanaryHealthSample>;
  note?: Maybe<Scalars["String"]>;
  durationMs: Scalars["Int"];
};

export enum CanaryCheckStatus {
  PASS = "PASS",
  FAIL = "FAIL",
  SKIPPED = "SKIPPED",
  ERROR = "ERROR"
}

export type CanaryHealth = {
  __typename?: "CanaryHealth";
  level: CanaryHealthLevel;
  generatedAt: Scalars["DateTime"];
  windowFrom: Scalars["DateTime"];
  windowTo: Scalars["DateTime"];
  windowHours: Scalars["Int"];
  graceMinutes: Scalars["Int"];
  internalInquiries: Scalars["Int"];
  zendeskInquiries: Scalars["Int"];
  unticketedInquiries: Scalars["Int"];
  checks: Array<CanaryCheck>;
  split: Array<CanarySplitBucket>;
  truncated: Scalars["Boolean"];
  durationMs: Scalars["Int"];
};

export type CanaryHealthArgs = {
  windowHours?: Maybe<Scalars["Int"]>;
  graceMinutes?: Maybe<Scalars["Int"]>;
  force?: Maybe<Scalars["Boolean"]>;
};

export enum CanaryHealthLevel {
  HEALTHY = "HEALTHY",
  DEGRADED = "DEGRADED",
  CRITICAL = "CRITICAL"
}

export type CanaryHealthSample = {
  __typename?: "CanaryHealthSample";
  inquiryId?: Maybe<Scalars["String"]>;
  ticketNo?: Maybe<Scalars["Int"]>;
  reason: Scalars["String"];
  at?: Maybe<Scalars["DateTime"]>;
};

export enum CanarySeverity {
  CRITICAL = "CRITICAL",
  WARNING = "WARNING"
}

export type CanarySplitBucket = {
  __typename?: "CanarySplitBucket";
  key: Scalars["String"];
  label: Scalars["String"];
  configuredPercent: Scalars["Int"];
  overridden: Scalars["Boolean"];
  internal: Scalars["Int"];
  zendesk: Scalars["Int"];
  observedPercent?: Maybe<Scalars["Float"]>;
  expectedMin: Scalars["Float"];
  expectedMax: Scalars["Float"];
  status: CanaryCheckStatus;
  since?: Maybe<Scalars["DateTime"]>;
};

export type CancelOrderArgs = {
  invoiceId: Scalars["String"];
};

export type CapturePaypalArgs = {
  invoiceId: Scalars["String"];
  amount: Scalars["Float"];
};

export type CarAccessoriesArgs = {
  keys?: Maybe<Array<BucketKey>>;
};

export type CarAccessoryKeySchema = {
  __typename?: "CarAccessoryKeySchema";
  _id?: Maybe<Scalars["ID"]>;
  id: Scalars["ID"];
  name: Scalars["String"];
  root?: Maybe<Scalars["Boolean"]>;
};

export type CarAccessorySchema = {
  __typename?: "CarAccessorySchema";
  key?: Maybe<CarAccessoryKeySchema>;
};

export type CarAggBucket = {
  __typename?: "CarAggBucket";
  key: Scalars["String"];
  doc_count: Scalars["Int"];
};

export type CarAggsResult = {
  __typename?: "CarAggsResult";
  tags: Array<CarAggBucket>;
  specialities: Array<CarAggBucket>;
};

export type CarCampaignSchema = {
  __typename?: "CarCampaignSchema";
  type: Scalars["String"];
  coupon: Scalars["String"];
};

export type CarChangeCouponSchema = {
  __typename?: "CarChangeCouponSchema";
  code: Scalars["String"];
  before: Scalars["Float"];
  after: Scalars["Float"];
  reason?: Maybe<Scalars["String"]>;
};

export type CarChangePriceLineSchema = {
  __typename?: "CarChangePriceLineSchema";
  label: Scalars["String"];
  before?: Maybe<Scalars["Float"]>;
  after?: Maybe<Scalars["Float"]>;
};

export type CarChangeSideSchema = {
  __typename?: "CarChangeSideSchema";
  carId?: Maybe<Scalars["String"]>;
  cfjNo?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  companyName?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["Int"]>;
  costOffer?: Maybe<Scalars["Float"]>;
  exchangeRate?: Maybe<Scalars["Float"]>;
};

export type CarConfigInput = {
  title?: Maybe<Scalars["String"]>;
  make?: Maybe<Scalars["ID"]>;
  model?: Maybe<Scalars["ID"]>;
  models?: Maybe<Array<Scalars["ID"]>>;
  companies?: Maybe<Array<Scalars["ID"]>>;
  minYear?: Maybe<Scalars["Int"]>;
  maxYear?: Maybe<Scalars["Int"]>;
  minPrice?: Maybe<Scalars["Float"]>;
  maxPrice?: Maybe<Scalars["Float"]>;
  minDisplacement?: Maybe<Scalars["Float"]>;
  maxDisplacement?: Maybe<Scalars["Float"]>;
  minMileage?: Maybe<Scalars["Float"]>;
  maxMileage?: Maybe<Scalars["Float"]>;
  bodyTypes?: Maybe<Array<Scalars["Int"]>>;
  driveTypes?: Maybe<Array<Scalars["Int"]>>;
  transmissions?: Maybe<Array<Scalars["Int"]>>;
  exteriorColors?: Maybe<Array<Scalars["Int"]>>;
  keywords?: Maybe<Scalars["String"]>;
};

export type CarConfigSchema = {
  __typename?: "CarConfigSchema";
  title?: Maybe<Scalars["String"]>;
  models?: Maybe<Array<ModelSchema>>;
  minYear?: Maybe<Scalars["Int"]>;
  maxYear?: Maybe<Scalars["Int"]>;
  minPrice?: Maybe<Scalars["Float"]>;
  maxPrice?: Maybe<Scalars["Float"]>;
  minDisplacement?: Maybe<Scalars["Float"]>;
  maxDisplacement?: Maybe<Scalars["Float"]>;
  minMileage?: Maybe<Scalars["Float"]>;
  maxMileage?: Maybe<Scalars["Float"]>;
  bodyTypes?: Maybe<Array<Scalars["Int"]>>;
  driveTypes?: Maybe<Array<Scalars["Int"]>>;
  transmissions?: Maybe<Array<Scalars["Int"]>>;
  exteriorColors?: Maybe<Array<Scalars["Int"]>>;
  make?: Maybe<MakeSchema>;
  model?: Maybe<ModelSchema>;
  companies?: Maybe<Array<CompanySchema>>;
  keywords?: Maybe<Scalars["String"]>;
};

export type CarCostProfitSchema = {
  __typename?: "CarCostProfitSchema";
  source?: Maybe<Scalars["String"]>;
  costName?: Maybe<Scalars["String"]>;
  invoiceDate?: Maybe<Scalars["DateTime"]>;
  paidDate?: Maybe<Scalars["DateTime"]>;
  zeinukiValue?: Maybe<Scalars["Float"]>;
  hikazeiValue?: Maybe<Scalars["Float"]>;
  recycleFeeValue?: Maybe<Scalars["Float"]>;
  note?: Maybe<Scalars["String"]>;
};

export type CarCouponCarRef = {
  __typename?: "CarCouponCarRef";
  _id: Scalars["ID"];
};

export type CarCouponResult = {
  __typename?: "CarCouponResult";
  _id: Scalars["ID"];
  discountUSD?: Maybe<Scalars["Float"]>;
  car?: Maybe<CarCouponCarRef>;
};

export type CarDashboardStats = {
  __typename?: "CarDashboardStats";
  cars: DashboardPeriodStat;
  views: DashboardPeriodStat;
};

export type CarDashboardSummary = {
  __typename?: "CarDashboardSummary";
  carCount: Scalars["Int"];
  expireSoon: Scalars["Int"];
  countReserved: Scalars["Int"];
};

export type CarDashboardViewDay = {
  __typename?: "CarDashboardViewDay";
  day: Scalars["Int"];
  total: Scalars["Int"];
};

export type CarDetailResultSchema = {
  __typename?: "CarDetailResultSchema";
  car: CarSchema;
  exchangeRates: Array<ExchangeRateSchema>;
  exchangerates: Array<ExchangeRateSchema>;
};

export type CarFacet = {
  __typename?: "CarFacet";
  hasVideo?: Maybe<DetailFacet>;
  bodyType?: Maybe<DetailFacet>;
  minDisplacement?: Maybe<DetailFacet>;
  maxDisplacement?: Maybe<DetailFacet>;
  exteriorColor?: Maybe<DetailFacet>;
  passengers?: Maybe<DetailFacet>;
  makeRoot?: Maybe<DetailFacet>;
  make?: Maybe<DetailFacet>;
  model?: Maybe<DetailFacet>;
  accessories?: Maybe<DetailFacet>;
  minMileage?: Maybe<DetailFacet>;
  maxMileage?: Maybe<DetailFacet>;
  mileage?: Maybe<DetailFacet>;
  priceUSD?: Maybe<DetailFacet>;
  minPrice?: Maybe<DetailFacet>;
  maxPrice?: Maybe<DetailFacet>;
  displacement?: Maybe<DetailFacet>;
  transmission?: Maybe<DetailFacet>;
  year?: Maybe<DetailFacet>;
  driveType?: Maybe<DetailFacet>;
  steering?: Maybe<DetailFacet>;
  tags?: Maybe<DetailFacet>;
  hasInspectionRatings?: Maybe<DetailFacet>;
  fuelType?: Maybe<DetailFacet>;
};

export type CarHistorySchema = {
  __typename?: "CarHistorySchema";
  items?: Maybe<Array<CarSchema>>;
  total?: Maybe<Scalars["Int"]>;
};

export type CarImage = {
  __typename?: "CarImage";
  filename?: Maybe<Scalars["String"]>;
  checksum?: Maybe<Scalars["String"]>;
  cdnUri?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["Float"]>;
};

export type CarImages = {
  filename?: Maybe<Scalars["String"]>;
  checksum?: Maybe<Scalars["String"]>;
  cdnUri?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["Float"]>;
  original?: Maybe<Scalars["String"]>;
  mime?: Maybe<Scalars["String"]>;
};

export type CarListResultSchema = {
  __typename?: "CarListResultSchema";
  nodes?: Maybe<Array<CarSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
  facet?: Maybe<CarFacet>;
  make?: Maybe<MakeSchema>;
  model?: Maybe<ModelSchema>;
  landingTag?: Maybe<LandingTagSchema>;
  highestPrice?: Maybe<Scalars["Float"]>;
  lowestPrice?: Maybe<Scalars["Float"]>;
};

export type CarPagingSchema = {
  __typename?: "CarPagingSchema";
  nodes?: Maybe<Array<CarSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
  facet?: Maybe<CarFacet>;
};

export type CarReceivedArgs = {
  invoiceId: Scalars["String"];
};

export type CarSchema = {
  __typename?: "CarSchema";
  id: Scalars["ID"];
  companyId?: Maybe<Scalars["ID"]>;
  company?: Maybe<CompanySchema>;
  modelId?: Maybe<Scalars["ID"]>;
  model?: Maybe<ModelSchema>;
  makeId?: Maybe<Scalars["ID"]>;
  make?: Maybe<MakeSchema>;
  carUrl?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
  slug?: Maybe<Scalars["String"]>;
  title: Scalars["String"];
  titleShort?: Maybe<Scalars["String"]>;
  images?: Maybe<Array<MediaSchema>>;
  imageCount?: Maybe<Scalars["Float"]>;
  reviewCount?: Maybe<Scalars["Float"]>;
  imagePreview?: Maybe<MediaSchema>;
  videos?: Maybe<Array<MediaSchema>>;
  manufacturedYear?: Maybe<Scalars["Float"]>;
  VIN?: Maybe<Scalars["String"]>;
  user?: Maybe<UserSchema>;
  userId?: Maybe<Scalars["String"]>;
  cfjNo?: Maybe<Scalars["String"]>;
  refNo?: Maybe<Scalars["String"]>;
  oversea?: Maybe<Scalars["Boolean"]>;
  domestic?: Maybe<Scalars["Boolean"]>;
  catchPhrase?: Maybe<Scalars["String"]>;
  registrationDate?: Maybe<Scalars["DateTime"]>;
  registrationMonth?: Maybe<Scalars["Int"]>;
  registrationYear?: Maybe<Scalars["Int"]>;
  manufacturedMonth?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
  makeName?: Maybe<Scalars["String"]>;
  modelName?: Maybe<Scalars["String"]>;
  modelName_?: Maybe<Scalars["String"]>;
  /**
   * Buyer-facing stock state derived from car.status: LISTING -> INSTOCK, RESERVED
   * -> RESERVED, SOLD/EXPIRED -> SOLD, UNLISTED -> UNLISTED. DRAFT and REMOVED
   * leave this unset (not shown in public search).
   */
  availability?: Maybe<Scalars["String"]>;
  youtubeId?: Maybe<Scalars["String"]>;
  driveTypeKey?: Maybe<Scalars["String"]>;
  transmissionKey?: Maybe<Scalars["String"]>;
  fuelKey?: Maybe<Scalars["String"]>;
  makeKey?: Maybe<Scalars["String"]>;
  modelKey?: Maybe<Scalars["String"]>;
  currencyKey?: Maybe<Scalars["String"]>;
  offers?: Maybe<Array<OfferSchema>>;
  offer?: Maybe<OfferSchema>;
  showBuyNow?: Maybe<Scalars["Boolean"]>;
  showPayNow?: Maybe<Scalars["Boolean"]>;
  modelCode?: Maybe<Scalars["String"]>;
  modelCodeShort?: Maybe<Scalars["String"]>;
  emissionCode?: Maybe<Scalars["String"]>;
  grade?: Maybe<Scalars["String"]>;
  mileage?: Maybe<Scalars["Float"]>;
  rateUSD?: Maybe<Scalars["Float"]>;
  price?: Maybe<Scalars["Float"]>;
  priceOriginal?: Maybe<Scalars["Float"]>;
  priceMin?: Maybe<Scalars["Float"]>;
  priceUSD?: Maybe<Scalars["Float"]>;
  priceUSDOriginal?: Maybe<Scalars["Float"]>;
  discountPercent?: Maybe<Scalars["Float"]>;
  discountedAt?: Maybe<Scalars["DateTime"]>;
  tags?: Maybe<Array<Scalars["String"]>>;
  specialities?: Maybe<Array<Scalars["String"]>>;
  currency?: Maybe<Scalars["Int"]>;
  bodyType?: Maybe<Scalars["Int"]>;
  steering?: Maybe<Scalars["Int"]>;
  transmission?: Maybe<Scalars["Int"]>;
  door?: Maybe<Scalars["Int"]>;
  displacement?: Maybe<Scalars["Float"]>;
  passengers?: Maybe<Scalars["Int"]>;
  fuelType?: Maybe<Scalars["Int"]>;
  driveType?: Maybe<Scalars["Int"]>;
  exteriorColor?: Maybe<Scalars["Int"]>;
  interiorColor?: Maybe<Scalars["Int"]>;
  condition?: Maybe<Scalars["Int"]>;
  vehicleWidth?: Maybe<Scalars["Int"]>;
  vehicleLength?: Maybe<Scalars["Int"]>;
  vehicleHeight?: Maybe<Scalars["Int"]>;
  m3?: Maybe<Scalars["Float"]>;
  accessories?: Maybe<Array<AccessorySchema>>;
  accessoryIds?: Maybe<Array<Scalars["String"]>>;
  inspectionGrade?: Maybe<InspectionGradeSchema>;
  inspectionAuthority?: Maybe<Scalars["String"]>;
  inspectionMonth?: Maybe<Scalars["Int"]>;
  inspectionYear?: Maybe<Scalars["Int"]>;
  plusPoint?: Maybe<Scalars["String"]>;
  minusPoint?: Maybe<Scalars["String"]>;
  locationName?: Maybe<Scalars["String"]>;
  locationParent?: Maybe<Scalars["String"]>;
  modified?: Maybe<Scalars["DateTime"]>;
  modifiedAt?: Maybe<Scalars["DateTime"]>;
  lastEmail?: Maybe<Scalars["DateTime"]>;
  created?: Maybe<Scalars["DateTime"]>;
  publishedAt?: Maybe<Scalars["DateTime"]>;
  status?: Maybe<Scalars["Int"]>;
  pvCount?: Maybe<Scalars["Int"]>;
  likeCount?: Maybe<Scalars["Int"]>;
  externalUrl?: Maybe<Scalars["String"]>;
  comment?: Maybe<Scalars["String"]>;
  greetingMessage?: Maybe<Scalars["String"]>;
  internalNote?: Maybe<Scalars["String"]>;
  isBulk?: Maybe<Scalars["Boolean"]>;
  maintenance?: Maybe<Scalars["Boolean"]>;
  restoration?: Maybe<Scalars["Boolean"]>;
  stockingDate?: Maybe<Scalars["String"]>;
  stockingCost?: Maybe<Scalars["String"]>;
  supplier?: Maybe<Scalars["String"]>;
  appraisalExteriorPoints?: Maybe<Scalars["Int"]>;
  appraisalInteriorPoints?: Maybe<Scalars["Int"]>;
  appraisalPoints?: Maybe<Scalars["String"]>;
  appraisalRepairHistoryPoints?: Maybe<Scalars["String"]>;
  loanClassification?: Maybe<Scalars["String"]>;
  monthlyPayment?: Maybe<Scalars["String"]>;
  deferredPrice?: Maybe<Scalars["String"]>;
  downPayment?: Maybe<Scalars["String"]>;
  numberOfPayment?: Maybe<Scalars["String"]>;
  bonusMonthAdditionalAmount?: Maybe<Scalars["String"]>;
  bonusNumberOfTimes?: Maybe<Scalars["String"]>;
  initialPayment?: Maybe<Scalars["String"]>;
  interestRate?: Maybe<Scalars["Float"]>;
  totalLoanVehiclePayment?: Maybe<Scalars["Float"]>;
  recycle?: Maybe<Scalars["String"]>;
  base?: Maybe<CarSchema>;
  countriesScore?: Maybe<Array<CountryScoreSchema>>;
  countriesScoreAt?: Maybe<Scalars["DateTime"]>;
  publishToAutoPort?: Maybe<Scalars["Boolean"]>;
  onShip?: Maybe<Scalars["Boolean"]>;
  expiredAt?: Maybe<Scalars["DateTime"]>;
  forceExpiredAt?: Maybe<Scalars["DateTime"]>;
  isLegit?: Maybe<Scalars["Boolean"]>;
  analysis?: Maybe<Scalars["JSON"]>;
  plan?: Maybe<Scalars["String"]>;
  loadingCapacity?: Maybe<Scalars["Int"]>;
  locked?: Maybe<Scalars["Boolean"]>;
  lockedMedia?: Maybe<Scalars["Boolean"]>;
  tagsCount?: Maybe<Scalars["Int"]>;
  specialitiesCount?: Maybe<Scalars["Int"]>;
  reservedUntil?: Maybe<Scalars["DateTime"]>;
  youtubeURL?: Maybe<Scalars["String"]>;
  inspectionRatings?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  myInquired?: Maybe<PartialInquirySchema>;
  hasCountdownCoupon?: Maybe<Scalars["Boolean"]>;
  isLiked?: Maybe<Scalars["Boolean"]>;
  inquiringNumber?: Maybe<Scalars["Int"]>;
  colorKey?: Maybe<Scalars["String"]>;
  bodyTypeKey?: Maybe<Scalars["String"]>;
  regulations?: Maybe<Array<RegulationSchema>>;
  campaign?: Maybe<CarCampaignSchema>;
  steeringKey?: Maybe<Scalars["String"]>;
  accessoriesName?: Maybe<Array<Scalars["String"]>>;
  accessoriesComfort?: Maybe<Array<Scalars["String"]>>;
  accessoriesOthers?: Maybe<Array<Scalars["String"]>>;
  accessoriesSafety?: Maybe<Array<Scalars["String"]>>;
  accessoriesSeat?: Maybe<Array<Scalars["String"]>>;
  accessoriesSoundSystem?: Maybe<Array<Scalars["String"]>>;
  accessoriesWindows?: Maybe<Array<Scalars["String"]>>;
  likeStatus?: Maybe<LikeStatus>;
  favAt?: Maybe<Scalars["DateTime"]>;
  companyName?: Maybe<Scalars["String"]>;
};

export type CarSpecificationPageProps = {
  __typename?: "CarSpecificationPageProps";
  make?: Maybe<MakeSchema>;
  model?: Maybe<ModelSchema>;
  grade?: Maybe<GradeSchema>;
  countryMakes?: Maybe<Array<CountryMake>>;
  modelGroups?: Maybe<Array<ModelGroup>>;
  grades?: Maybe<Array<GradeGroupSaleFrom>>;
};

export type CarSpecificationPagePropsArgs = {
  makeKey?: Maybe<Scalars["String"]>;
  modelKey?: Maybe<Scalars["String"]>;
  gradeId?: Maybe<Scalars["ID"]>;
};

export type CarSuggestItemSchema = {
  __typename?: "CarSuggestItemSchema";
  type: Scalars["String"];
  keywords?: Maybe<Scalars["String"]>;
  makeKey?: Maybe<Scalars["String"]>;
  modelKey?: Maybe<Scalars["String"]>;
  makeName?: Maybe<Scalars["String"]>;
  modelName?: Maybe<Scalars["String"]>;
  year?: Maybe<Scalars["Int"]>;
};

export type CfjLegacyMedia = {
  __typename?: "CFJLegacyMedia";
  filename: Scalars["String"];
  mimetype?: Maybe<Scalars["String"]>;
  externalUrl?: Maybe<Scalars["String"]>;
  checksum?: Maybe<Scalars["String"]>;
  cdnUri?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["Int"]>;
  size?: Maybe<Scalars["Int"]>;
  originalFilename?: Maybe<Scalars["String"]>;
};

export type CfjNegoByAgentSchema = {
  __typename?: "CfjNegoByAgentSchema";
  agent: Scalars["String"];
  totalSale: Scalars["Float"];
};

export type ChangeEmailInput = {
  currentPassword: Scalars["String"];
  email: Scalars["String"];
};

export type ChangeInquiryCarInput = {
  id: Scalars["String"];
  car: Scalars["String"];
  reason?: Maybe<Scalars["String"]>;
};

export type ChangePasswordInput = {
  password: Scalars["String"];
  confirmPassword: Scalars["String"];
  currentPassword?: Maybe<Scalars["String"]>;
  resetHashed?: Maybe<Scalars["String"]>;
};

export type CheckEmailInput = {
  email: Scalars["String"];
};

export type CheckEmailType = {
  __typename?: "CheckEmailType";
  exists: Scalars["Boolean"];
};

export type CityInput = {
  name?: Maybe<Scalars["String"]>;
  guarantee?: Maybe<Scalars["Boolean"]>;
  options?: Maybe<Array<OptionInput>>;
  deliveries?: Maybe<Array<DeliveryInput>>;
};

export type ClassificationResultSchema = {
  __typename?: "ClassificationResultSchema";
  class_id?: Maybe<Scalars["Int"]>;
  class_name?: Maybe<Scalars["String"]>;
  confidence?: Maybe<Scalars["Float"]>;
};

export type CommentAdminSchema = {
  __typename?: "CommentAdminSchema";
  call?: Maybe<InvoiceCommentCallSchema>;
  id: Scalars["ID"];
  invoiceId?: Maybe<Scalars["ID"]>;
  author?: Maybe<CommentAuthorAdminSchema>;
  body?: Maybe<Scalars["String"]>;
  htmlBody?: Maybe<Scalars["String"]>;
  plainBody?: Maybe<Scalars["String"]>;
  isPublic?: Maybe<Scalars["Boolean"]>;
  syncStatus?: Maybe<Scalars["String"]>;
  syncInfo?: Maybe<CommentSyncInfoAdminSchema>;
  source?: Maybe<Scalars["String"]>;
  attachments?: Maybe<Array<MediaSchema>>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  deletedAt?: Maybe<Scalars["DateTime"]>;
};

export type CommentAuthorAdminSchema = {
  __typename?: "CommentAuthorAdminSchema";
  userId?: Maybe<Scalars["ID"]>;
  externalUserId?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  avatarUrl?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
};

export type CommentSyncInfoAdminSchema = {
  __typename?: "CommentSyncInfoAdminSchema";
  provider?: Maybe<Scalars["String"]>;
  externalId?: Maybe<Scalars["String"]>;
  externalParentId?: Maybe<Scalars["String"]>;
  externalUrl?: Maybe<Scalars["String"]>;
};

export type CompanyAdminType = {
  __typename?: "CompanyAdminType";
  _id?: Maybe<Scalars["ID"]>;
  id?: Maybe<Scalars["ID"]>;
  key?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  enName?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  addressKana?: Maybe<Scalars["String"]>;
  postalCode?: Maybe<Scalars["String"]>;
  telephone?: Maybe<Scalars["String"]>;
  fax?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  website?: Maybe<Scalars["String"]>;
  carCount?: Maybe<Scalars["Int"]>;
  denyImagesIndex?: Maybe<Array<Scalars["Int"]>>;
  denyImages?: Maybe<Array<MediaSchema>>;
  cropingImage?: Maybe<Scalars["JSON"]>;
  buynowSettings?: Maybe<Scalars["JSON"]>;
  inContract?: Maybe<Scalars["Boolean"]>;
  selfNegotiation?: Maybe<Scalars["Boolean"]>;
  plan?: Maybe<Scalars["String"]>;
  assignee?: Maybe<Scalars["JSON"]>;
  reservedCount?: Maybe<Scalars["Int"]>;
  updated30days?: Maybe<Scalars["Int"]>;
  soldLastMonth?: Maybe<Scalars["Int"]>;
  saleCount?: Maybe<Scalars["Int"]>;
  status?: Maybe<Scalars["String"]>;
  importFromTCV?: Maybe<Scalars["Boolean"]>;
  importFromGoo?: Maybe<Scalars["Boolean"]>;
  importFromCarsensor?: Maybe<Scalars["Boolean"]>;
  contractStart?: Maybe<Scalars["DateTime"]>;
  contractEnd?: Maybe<Scalars["DateTime"]>;
  persionInCharge?: Maybe<Scalars["String"]>;
  preferLanguage?: Maybe<Scalars["String"]>;
  totalEmployees?: Maybe<Scalars["String"]>;
  annualSale?: Maybe<Scalars["String"]>;
  daysExp?: Maybe<Scalars["Int"]>;
  capital?: Maybe<Scalars["String"]>;
  yearEstablished?: Maybe<Scalars["String"]>;
  ownershipType?: Maybe<Scalars["String"]>;
  introduction?: Maybe<Scalars["String"]>;
  bankName?: Maybe<Scalars["String"]>;
  bankBranch?: Maybe<Scalars["String"]>;
  bankAccount?: Maybe<Scalars["String"]>;
  bankHolder?: Maybe<Scalars["String"]>;
  kanaBankHolder?: Maybe<Scalars["String"]>;
  bankType?: Maybe<Scalars["String"]>;
  autoResponse?: Maybe<Scalars["Boolean"]>;
  monthlyFee?: Maybe<Scalars["Float"]>;
  annualFee?: Maybe<Scalars["Float"]>;
  marginPercent?: Maybe<Scalars["Float"]>;
  marginPercentCIF?: Maybe<Scalars["Float"]>;
  marginUSD?: Maybe<Scalars["Float"]>;
  marginMin?: Maybe<Scalars["Float"]>;
  marginMax?: Maybe<Scalars["Float"]>;
  domesticBankCharge?: Maybe<Scalars["Float"]>;
  serviceChargeUSD?: Maybe<Scalars["Float"]>;
  adjustCIFbyUSD?: Maybe<Scalars["Float"]>;
  adjustCIFbyPercent?: Maybe<Scalars["Float"]>;
  adjustFOBbyUSD?: Maybe<Scalars["Float"]>;
  adjustFOBbyPercent?: Maybe<Scalars["Float"]>;
  adjustShippingbyUSD?: Maybe<Scalars["Float"]>;
  adjustInsuranceTo?: Maybe<Scalars["Float"]>;
  adjustBuyerProtectionTo?: Maybe<Scalars["Float"]>;
  adminNote?: Maybe<Scalars["String"]>;
  internalNote?: Maybe<Scalars["String"]>;
  startPay?: Maybe<Scalars["DateTime"]>;
  registeredGMOAt?: Maybe<Scalars["DateTime"]>;
  activatedGMO?: Maybe<Scalars["Boolean"]>;
  dealerPage?: Maybe<Scalars["Boolean"]>;
  canEditFreight?: Maybe<Scalars["Boolean"]>;
  serviceTaxInclusive?: Maybe<Scalars["Boolean"]>;
  published?: Maybe<Scalars["Boolean"]>;
  members?: Maybe<Scalars["JSON"]>;
  scoreBoost?: Maybe<Scalars["Float"]>;
  TCVID?: Maybe<Scalars["String"]>;
  gooId?: Maybe<Scalars["String"]>;
  carsensorId?: Maybe<Scalars["String"]>;
  slug?: Maybe<Scalars["String"]>;
  images?: Maybe<Array<MediaSchema>>;
  signature?: Maybe<MediaSchema>;
};

export type CompanyMemberType = {
  __typename?: "CompanyMemberType";
  _id?: Maybe<Scalars["ID"]>;
  id?: Maybe<Scalars["ID"]>;
  email?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type CompanyPagingType = {
  __typename?: "CompanyPagingType";
  companies: Array<CompanyAdminType>;
  total: Scalars["Int"];
};

export type CompanySchema = {
  __typename?: "CompanySchema";
  id: Scalars["ID"];
  _id?: Maybe<Scalars["ID"]>;
  key?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  carCount?: Maybe<Scalars["Float"]>;
  name?: Maybe<Scalars["String"]>;
  enName?: Maybe<Scalars["String"]>;
  persionInCharge?: Maybe<Scalars["String"]>;
  telephone?: Maybe<Scalars["String"]>;
  plan?: Maybe<Scalars["String"]>;
  inContract?: Maybe<Scalars["Boolean"]>;
  status?: Maybe<Scalars["String"]>;
  canEditFreight?: Maybe<Scalars["Boolean"]>;
  contractStart?: Maybe<Scalars["DateTime"]>;
  contractEnd?: Maybe<Scalars["DateTime"]>;
  scoreBoost: Scalars["Float"];
  internalNote?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  marginPercent?: Maybe<Scalars["Float"]>;
  marginPercentCIF?: Maybe<Scalars["Float"]>;
  serviceChargeUSD?: Maybe<Scalars["Float"]>;
  marginMin?: Maybe<Scalars["Float"]>;
  marginMax?: Maybe<Scalars["Float"]>;
  serviceTaxInclusive?: Maybe<Scalars["Boolean"]>;
};

export type ConditionInput = {
  field?: Maybe<Scalars["String"]>;
  operator?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
};

export type ConditionReportSchema = {
  __typename?: "ConditionReportSchema";
  diagram_marks?: Maybe<Array<DiagramMarkSchema>>;
  general_condition?: Maybe<GeneralConditionSchema>;
};

export type ConfigurationPagingSchema = {
  __typename?: "ConfigurationPagingSchema";
  nodes?: Maybe<Array<ConfigurationSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type ConfigurationSchema = {
  __typename?: "ConfigurationSchema";
  id: Scalars["ID"];
  key: Scalars["String"];
  value?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  published?: Maybe<Scalars["Boolean"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type ConfirmCarAvailabilityArgs = {
  key: Scalars["String"];
};

export type ConfirmCarAvailabilitySchema = {
  __typename?: "ConfirmCarAvailabilitySchema";
  invoiceId: Scalars["String"];
  availability: Scalars["String"];
};

export type ConfirmPaymentArgs = {
  invoiceId: Scalars["String"];
  options?: Maybe<ConfirmPaymentOptions>;
};

export type ConfirmPaymentOptions = {
  dontNotifyBuyer?: Maybe<Scalars["Boolean"]>;
  dontNotifySeller?: Maybe<Scalars["Boolean"]>;
  currency: Scalars["String"];
  from: Scalars["String"];
  receivedAmount: Scalars["Float"];
  exchangeRate: Scalars["Float"];
  currencyRate: Scalars["Float"];
};

export type ConfirmTtArgs = {
  invoiceId: Scalars["String"];
};

export type ContactUsInput = {
  name?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  message?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  questionUrl?: Maybe<Scalars["String"]>;
  isFAQFeedback?: Maybe<Scalars["Boolean"]>;
};

export type ContactUsResponse = {
  __typename?: "ContactUsResponse";
  success: Scalars["Boolean"];
  ticketId?: Maybe<Scalars["Int"]>;
};

export type Content = {
  __typename?: "Content";
  title: Scalars["String"];
  content: Scalars["String"];
};

export type ConvertTicketToInquiryInput = {
  id: Scalars["String"];
  car: Scalars["String"];
  country: Scalars["String"];
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  inspection?: Maybe<Scalars["Boolean"]>;
  insurance?: Maybe<Scalars["Boolean"]>;
  assigneeId?: Maybe<Scalars["String"]>;
};

export type ConvertTicketToInquiryResult = {
  __typename?: "ConvertTicketToInquiryResult";
  inquiryId: Scalars["String"];
  ticketId: Scalars["String"];
};

export type CountryCodeSchema = {
  __typename?: "CountryCodeSchema";
  key: Scalars["String"];
  code?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type CountryMake = {
  __typename?: "CountryMake";
  _id?: Maybe<Scalars["String"]>;
  makes?: Maybe<Array<MakeSchema>>;
};

export type CountryPageBankInput = {
  name: Scalars["String"];
  image?: Maybe<LocalPageImageInput>;
};

export type CountryPageFaqInput = {
  question: Scalars["String"];
  answer: Scalars["String"];
};

export type CountryPageImportDocumentInput = {
  title: Scalars["String"];
  content?: Maybe<Scalars["String"]>;
  file?: Maybe<LocalPageImageInput>;
};

export type CountryPageModelInput = {
  _id: Scalars["ID"];
  name: Scalars["String"];
  makeName?: Maybe<Scalars["String"]>;
  makeModelKey?: Maybe<Scalars["String"]>;
};

export type CountryPageRegulationInput = {
  year: Scalars["String"];
  inspection: Scalars["String"];
  port: Scalars["String"];
  deliveryTime: Scalars["String"];
};

export type CountryPageRegulationSchema = {
  __typename?: "CountryPageRegulationSchema";
  year: Scalars["String"];
  inspection: Scalars["String"];
  port: Scalars["String"];
  deliveryTime: Scalars["String"];
};

export type CountryPageSchema = {
  __typename?: "CountryPageSchema";
  id?: Maybe<Scalars["ID"]>;
  _id?: Maybe<Scalars["ID"]>;
  name: Scalars["String"];
  key?: Maybe<Scalars["String"]>;
  region?: Maybe<Scalars["String"]>;
  regulation?: Maybe<CountryPageRegulationSchema>;
  dutiesAndTaxes?: Maybe<Scalars["String"]>;
  faqs?: Maybe<Array<Maybe<FaqSchema>>>;
  models?: Maybe<Scalars["JSON"]>;
  modelImages?: Maybe<Scalars["JSON"]>;
  bannerImages?: Maybe<Scalars["JSON"]>;
  banks?: Maybe<Scalars["JSON"]>;
  importDocuments?: Maybe<Scalars["JSON"]>;
  paymentMethodTT?: Maybe<Scalars["String"]>;
  createdAt: Scalars["DateTime"];
  createdBy?: Maybe<UserSchema>;
  modifiedAt: Scalars["DateTime"];
  modifiedBy?: Maybe<UserSchema>;
};

export type CountryScoreSchema = {
  __typename?: "CountryScoreSchema";
  name: Scalars["String"];
  score: Scalars["Float"];
};

export type CountUpViewCarInput = {
  carId: Scalars["ID"];
  companyId?: Maybe<Scalars["ID"]>;
  referrer?: Maybe<Scalars["String"]>;
};

export type CouponSchema = {
  __typename?: "CouponSchema";
  _id?: Maybe<Scalars["ID"]>;
  id?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  v?: Maybe<Scalars["Float"]>;
  userId?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  discountPercent?: Maybe<Scalars["Float"]>;
  discountUSD?: Maybe<Scalars["Float"]>;
  balanceUSD?: Maybe<Scalars["Float"]>;
  maxUSD?: Maybe<Scalars["Float"]>;
  usedTimes?: Maybe<Scalars["Float"]>;
  maxTimes?: Maybe<Scalars["Float"]>;
  maxPaymentTimes?: Maybe<Scalars["Float"]>;
  isRemoved: Scalars["Boolean"];
  createdAt: Scalars["DateTime"];
  expired?: Maybe<Scalars["DateTime"]>;
  applyConditions?: Maybe<Array<ApplyConditionSchema>>;
  refers?: Maybe<Array<ReferSchema>>;
};

export type CouponUserRef = {
  __typename?: "CouponUserRef";
  _id: Scalars["ID"];
  email?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export enum CrawlCarSource {
  TCV = "TCV",
  BE_FORWARD = "BE_FORWARD",
  CARSENSOR = "CARSENSOR",
  GOO = "GOO",
  ASNET_NEXT = "ASNET_NEXT"
}

export type CreateAdminGuideDto = {
  mediaKey?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type CreateAutoReplyMessageInput = {
  content: Scalars["String"];
  startsAt: Scalars["DateTime"];
  endsAt: Scalars["DateTime"];
  ticketStatuses?: Array<Scalars["String"]>;
  agentIds?: Array<Scalars["String"]>;
  maxPerDay?: Scalars["Int"];
  status?: Scalars["String"];
  actionType?: Scalars["String"];
  transitions?: Array<StatusTransitionConfigInput>;
};

export type CreateCampaignActionDto = {
  buyerEmail: Scalars["String"];
  buyerId: Scalars["String"];
  buyerName: Scalars["String"];
  campaignCode: Scalars["String"];
  carName: Scalars["String"];
  carImages?: Maybe<CarImages>;
  country?: Maybe<Scalars["String"]>;
  port: Scalars["String"];
  state: Scalars["String"];
  referralCode?: Maybe<Scalars["String"]>;
  orderId: Scalars["String"];
  inquiryNo?: Maybe<Scalars["Float"]>;
  introducerId: Scalars["String"];
  introducerName?: Maybe<Scalars["String"]>;
  balanceAmountForIntroducer: Scalars["Float"];
  confirmedOrder?: Maybe<Scalars["DateTime"]>;
  completedAt?: Maybe<Scalars["DateTime"]>;
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
};

export type CreateCampaignJoinDto = {
  campaignCode: Scalars["String"];
  referralCode?: Maybe<Scalars["String"]>;
  referralLink?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
  userName?: Maybe<Scalars["String"]>;
  userEmail?: Maybe<Scalars["String"]>;
  discountAmount?: Maybe<Scalars["Float"]>;
  joinDate?: Maybe<Scalars["DateTime"]>;
  utm_source?: Maybe<Scalars["String"]>;
  utm_medium?: Maybe<Scalars["String"]>;
  utm_campaign?: Maybe<Scalars["String"]>;
};

export type CreateConfigurationDto = {
  key: Scalars["String"];
  value?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  published?: Maybe<Scalars["Boolean"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type CreateExpenseRequestDto = {
  introducerId?: Maybe<Scalars["String"]>;
  introducerName?: Maybe<Scalars["String"]>;
  introducerEmail?: Maybe<Scalars["String"]>;
  buyerName?: Maybe<Scalars["String"]>;
  buyerEmail: Scalars["String"];
  orderId: Scalars["Float"];
  note?: Maybe<Scalars["String"]>;
  reasonReject?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  amount: Scalars["Float"];
  requestAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type CreateGalleryDto = {
  mediaKey?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["Float"]>;
  active?: Maybe<Scalars["Boolean"]>;
};

export type CreateGeneralInquiryInput = {
  name: Scalars["String"];
  email: Scalars["String"];
  phone: Scalars["String"];
  countryCode: Scalars["String"];
  address: Scalars["String"];
  country: Scalars["String"];
  port: Scalars["String"];
  city?: Maybe<Scalars["String"]>;
  makeName?: Maybe<Scalars["String"]>;
  modelName?: Maybe<Scalars["String"]>;
  minYear?: Maybe<Scalars["String"]>;
  maxYear?: Maybe<Scalars["String"]>;
  price?: Maybe<Scalars["String"]>;
  priceType?: Maybe<Scalars["String"]>;
  transmission?: Maybe<Scalars["String"]>;
  mileage?: Maybe<Scalars["String"]>;
  message?: Maybe<Scalars["String"]>;
  weeklyoffers?: Maybe<Scalars["Boolean"]>;
  platform?: Maybe<Scalars["String"]>;
  gRecaptchaResponse?: Maybe<Scalars["String"]>;
};

export type CreateInquiryInput = {
  name: Scalars["String"];
  car: Scalars["String"];
  email: Scalars["String"];
  phone: Scalars["String"];
  address: Scalars["String"];
  coupon?: Maybe<Scalars["String"]>;
  inspection?: Maybe<Scalars["Boolean"]>;
  insurance?: Maybe<Scalars["Boolean"]>;
  country: Scalars["String"];
  gRecaptchaResponse?: Maybe<Scalars["String"]>;
  comment?: Maybe<Scalars["String"]>;
  countryCode: Scalars["String"];
  port: Scalars["String"];
  city?: Maybe<Scalars["String"]>;
  platform: Scalars["String"];
  isBuyNow: Scalars["Boolean"];
  clientId?: Maybe<Scalars["String"]>;
  gaSessionId?: Maybe<Scalars["String"]>;
  ip?: Maybe<Scalars["String"]>;
  utm_source?: Maybe<Scalars["String"]>;
  utm_medium?: Maybe<Scalars["String"]>;
  utm_campaign?: Maybe<Scalars["String"]>;
  referrer?: Maybe<Scalars["String"]>;
  gclid?: Maybe<Scalars["String"]>;
  addonServices?: Maybe<Array<Scalars["String"]>>;
};

export type CreateMcpKeyInput = {
  name: Scalars["String"];
  userId: Scalars["String"];
  permission: Scalars["String"];
  scopes?: Maybe<Array<Scalars["String"]>>;
  expiresIn?: Maybe<Scalars["Int"]>;
};

export type CreateMcpKeyResult = {
  __typename?: "CreateMcpKeyResult";
  key: McpKeySchema;
  rawKey: Scalars["String"];
};

export type CreateOrUpdateCountryPageInput = {
  _id?: Maybe<Scalars["ID"]>;
  name: Scalars["String"];
  key?: Maybe<Scalars["String"]>;
  region?: Maybe<Scalars["String"]>;
  regulation?: Maybe<CountryPageRegulationInput>;
  dutiesAndTaxes?: Maybe<Scalars["String"]>;
  paymentMethodTT?: Maybe<Scalars["String"]>;
  faqs?: Maybe<Array<CountryPageFaqInput>>;
  models?: Maybe<Array<CountryPageModelInput>>;
  modelImages?: Maybe<Array<LocalPageImageInput>>;
  bannerImages?: Maybe<Array<LocalPageImageInput>>;
  banks?: Maybe<Array<CountryPageBankInput>>;
  importDocuments?: Maybe<Array<CountryPageImportDocumentInput>>;
};

export type CreatePaypalOrderArgs = {
  invoiceId: Scalars["ID"];
};

export type CreatePaypalOrderSchema = {
  __typename?: "CreatePaypalOrderSchema";
  orderId: Scalars["String"];
};

export type CreatePendingOrderManagementLineInput = {
  id: Scalars["ID"];
};

export type CreateReviewInput = {
  authorName: Scalars["String"];
  rating: Scalars["Int"];
  title?: Maybe<Scalars["String"]>;
  content: Scalars["String"];
  reviewedAt: Scalars["DateTime"];
  url?: Maybe<Scalars["String"]>;
  isPublished?: Scalars["Boolean"];
  displayOrder?: Maybe<Scalars["Int"]>;
};

export type CreateShippingAgentDto = {
  name: Scalars["String"];
  country: Scalars["String"];
  carrier: Scalars["String"];
  port: Scalars["String"];
  address?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
  fax?: Maybe<Scalars["String"]>;
  mediaKey?: Maybe<Scalars["String"]>;
};

export type CreateShippingDelayNoteDto = {
  title: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  isActive?: Maybe<Scalars["Boolean"]>;
};

export type CreateTicketAdminInput = {
  subject: Scalars["String"];
  name?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  internalNote?: Maybe<Scalars["String"]>;
  comment?: Maybe<Scalars["String"]>;
  htmlBody?: Maybe<Scalars["String"]>;
  isPublic?: Maybe<Scalars["Boolean"]>;
  assignToMe?: Maybe<Scalars["Boolean"]>;
  emailCcAddresses?: Maybe<Array<Scalars["String"]>>;
};

export type CreateTransactionHistoryDto = {
  introducerId: Scalars["String"];
  transactionId: Scalars["String"];
  type: Scalars["String"];
  note: Scalars["String"];
  state: Scalars["String"];
  status: Scalars["String"];
  amount: Scalars["Float"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
};

export type CreateWithdrawRequestDto = {
  bankInJapanInfo?: Maybe<WithdrawRequestBankInJapanInfoInput>;
  internationalBankInfo?: Maybe<WithdrawRequestInternationalBankInfoInput>;
  paypalInfo?: Maybe<WithdrawRequestPaypalInfoInput>;
  withdrawalInformation?: Maybe<Scalars["String"]>;
  withdrawalMethod?: Maybe<Scalars["String"]>;
  reasonReject?: Maybe<Scalars["String"]>;
  introducerId?: Maybe<Scalars["String"]>;
  introducerName?: Maybe<Scalars["String"]>;
  introducerEmail?: Maybe<Scalars["String"]>;
  note?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  amount?: Maybe<Scalars["Float"]>;
  fee?: Maybe<Scalars["Float"]>;
  totalAmount: Scalars["Float"];
  requestAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type CsvListResult = {
  __typename?: "CsvListResult";
  csvs: Array<CsvSchema>;
  total: Scalars["Int"];
};

export type CsvSchema = {
  __typename?: "CsvSchema";
  _id: Scalars["ID"];
  company?: Maybe<CompanySchema>;
  format?: Maybe<Scalars["String"]>;
  original?: Maybe<Scalars["String"]>;
  filename?: Maybe<Scalars["String"]>;
  clearOldCar?: Maybe<Scalars["Boolean"]>;
  result?: Maybe<Scalars["JSON"]>;
  created?: Maybe<Scalars["DateTime"]>;
  modified?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type CtxSchema = {
  __typename?: "CtxSchema";
  me?: Maybe<UserSchema>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  defaultCurrency?: Maybe<Scalars["String"]>;
  defaultMileageUnit?: Maybe<Scalars["String"]>;
  defaultEngineUnit?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  insurance?: Maybe<Scalars["Boolean"]>;
  inspection?: Maybe<Scalars["Boolean"]>;
  locale?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
};

export type CustomCostItemInput = {
  name: Scalars["String"];
  amount: Scalars["Float"];
};

export type CustomCostSchema = {
  __typename?: "CustomCostSchema";
  name?: Maybe<Scalars["String"]>;
  amount?: Maybe<Scalars["Float"]>;
};

export type CustomField = {
  __typename?: "CustomField";
  id?: Maybe<Scalars["Float"]>;
  value?: Maybe<Scalars["String"]>;
};

export type CustomSeoPagingSchema = {
  __typename?: "CustomSeoPagingSchema";
  nodes?: Maybe<Array<CustomSeoSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type CustomSeoSchema = {
  __typename?: "CustomSeoSchema";
  _id: Scalars["String"];
  path: Scalars["String"];
  title?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  boxLinkVersion?: Maybe<Scalars["String"]>;
  boxLinks?: Maybe<Array<BoxLinkSchema>>;
  useDefaultBoxLinks: Scalars["Boolean"];
  isUpdatedMeta: Scalars["Boolean"];
  isUpdatedBoxlink: Scalars["Boolean"];
  defaultMeta?: Maybe<MetaSchema>;
  defaultBoxLink?: Maybe<Array<BoxLinkSchema>>;
  ogImage?: Maybe<OgImage>;
};

export type DailyStatusVolumeSchema = {
  __typename?: "DailyStatusVolumeSchema";
  date: Scalars["String"];
  status: Scalars["String"];
  count: Scalars["Int"];
};

export type DailyVolumeSchema = {
  __typename?: "DailyVolumeSchema";
  date: Scalars["String"];
  count: Scalars["Int"];
};

export type DashboardFiltersInput = {
  from: Scalars["DateTime"];
};

export type DashboardPeriodStat = {
  __typename?: "DashboardPeriodStat";
  current: Scalars["Float"];
  lastMonth: Scalars["Float"];
};

export type DataGuideOrderDto = {
  id: Scalars["String"];
  order: Scalars["Float"];
};

export type DeactivateAccountInput = {
  userId: Scalars["String"];
  key: Scalars["String"];
  expire: Scalars["String"];
};

export type DealerMacroFiltersInput = {
  id?: Maybe<Scalars["String"]>;
  search?: Maybe<Scalars["String"]>;
  published?: Maybe<Scalars["Boolean"]>;
  shared?: Maybe<Scalars["Boolean"]>;
};

export type DealerMacroResultSchema = {
  __typename?: "DealerMacroResultSchema";
  macros: Array<DealerMacroSchema>;
  total: Scalars["Int"];
};

export type DealerMacroSchema = {
  __typename?: "DealerMacroSchema";
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  content?: Maybe<Scalars["String"]>;
  published?: Maybe<Scalars["Boolean"]>;
  shared?: Maybe<Scalars["Boolean"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type DeliveryInput = {
  cost?: Maybe<Scalars["Float"]>;
  deliveryMethod?: Maybe<Scalars["String"]>;
  cond?: Maybe<Array<ConditionInput>>;
};

export type DetailFacet = {
  __typename?: "DetailFacet";
  doc_count?: Maybe<Scalars["Int"]>;
  faceted?: Maybe<Faceted>;
  doc_count_error_upper_bound?: Maybe<Scalars["Int"]>;
  sum_other_doc_count?: Maybe<Scalars["Int"]>;
  buckets?: Maybe<Array<Bucket>>;
};

export type DetectionBoxSchema = {
  __typename?: "DetectionBoxSchema";
  bbox?: Maybe<Array<Scalars["Float"]>>;
  confidence?: Maybe<Scalars["Float"]>;
  class_id?: Maybe<Scalars["Int"]>;
  class_name?: Maybe<Scalars["String"]>;
};

export type DetectionResultSchema = {
  __typename?: "DetectionResultSchema";
  total?: Maybe<Scalars["Int"]>;
  boxes?: Maybe<Array<DetectionBoxSchema>>;
};

export type DiagramMarkSchema = {
  __typename?: "DiagramMarkSchema";
  position?: Maybe<Scalars["String"]>;
  position_en?: Maybe<Scalars["String"]>;
  mark?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  description_en?: Maybe<Scalars["String"]>;
};

export type Draft = {
  __typename?: "Draft";
  title?: Maybe<Scalars["String"]>;
  content: Scalars["String"];
  created: Scalars["DateTime"];
  modified: Scalars["DateTime"];
};

export type DriveFileSchema = {
  __typename?: "DriveFileSchema";
  id: Scalars["String"];
  name: Scalars["String"];
  url: Scalars["String"];
};

export type DriveItemSchema = {
  __typename?: "DriveItemSchema";
  ticketId: Scalars["String"];
  invoiceCode: Scalars["String"];
  receiptCode: Scalars["String"];
  invoiceFilename: Scalars["String"];
  receiptFilename: Scalars["String"];
};

export type DriveUploadResultItemSchema = {
  __typename?: "DriveUploadResultItemSchema";
  ticketId: Scalars["String"];
  receipt?: Maybe<DriveFileSchema>;
  invoice?: Maybe<DriveFileSchema>;
};

export type EditAdminGuidetDto = {
  mediaKey?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type EditExpenseRequestDto = {
  introducerId?: Maybe<Scalars["String"]>;
  introducerName?: Maybe<Scalars["String"]>;
  introducerEmail?: Maybe<Scalars["String"]>;
  buyerName?: Maybe<Scalars["String"]>;
  buyerEmail?: Maybe<Scalars["String"]>;
  orderId?: Maybe<Scalars["Float"]>;
  note?: Maybe<Scalars["String"]>;
  reasonReject?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  amount?: Maybe<Scalars["Float"]>;
  requestAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type EditGalleryDto = {
  mediaKey?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["Float"]>;
  active?: Maybe<Scalars["Boolean"]>;
};

export type EditShippingAgentDto = {
  name?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  carrier?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
  fax?: Maybe<Scalars["String"]>;
  mediaKey?: Maybe<Scalars["String"]>;
};

export type EditShippingDelayNoteDto = {
  title?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  isActive?: Maybe<Scalars["Boolean"]>;
};

export type EditWithdrawalRequestDto = {
  bankInJapanInfo?: Maybe<WithdrawRequestBankInJapanInfoInput>;
  internationalBankInfo?: Maybe<WithdrawRequestInternationalBankInfoInput>;
  paypalInfo?: Maybe<WithdrawRequestPaypalInfoInput>;
  withdrawalInformation?: Maybe<Scalars["String"]>;
  withdrawalMethod?: Maybe<Scalars["String"]>;
  reasonReject?: Maybe<Scalars["String"]>;
  introducerId?: Maybe<Scalars["String"]>;
  introducerName?: Maybe<Scalars["String"]>;
  introducerEmail?: Maybe<Scalars["String"]>;
  note?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  amount?: Maybe<Scalars["Float"]>;
  fee?: Maybe<Scalars["Float"]>;
  totalAmount?: Maybe<Scalars["Float"]>;
  requestAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type EmailPreviewAttachmentSchema = {
  __typename?: "EmailPreviewAttachmentSchema";
  filename?: Maybe<Scalars["String"]>;
  path?: Maybe<Scalars["String"]>;
};

/** Status of the email */
export enum EmailStatus {
  DELIVERY = "DELIVERY",
  SEND = "SEND",
  DEFERRED = "DEFERRED",
  HARD_BOUNCED = "HARD_BOUNCED",
  SOFT_BOUNCED = "SOFT_BOUNCED",
  OPENED = "OPENED",
  CLICKED = "CLICKED",
  SPAMMED = "SPAMMED",
  UNSUBSCRIBED = "UNSUBSCRIBED",
  REJECTED = "REJECTED"
}

export type EmailStatusEntrySchema = {
  __typename?: "EmailStatusEntrySchema";
  email?: Maybe<Scalars["String"]>;
  status: Scalars["String"];
  bounceType?: Maybe<Scalars["String"]>;
  bounceSubType?: Maybe<Scalars["String"]>;
  complaintFeedbackType?: Maybe<Scalars["String"]>;
  reason?: Maybe<Scalars["String"]>;
  ipAddress?: Maybe<Scalars["String"]>;
  userAgent?: Maybe<Scalars["String"]>;
  link?: Maybe<Scalars["String"]>;
  linkTags?: Maybe<Scalars["JSON"]>;
  timestamp: Scalars["DateTime"];
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type EmailTrackingListResultSchema = {
  __typename?: "EmailTrackingListResultSchema";
  nodes?: Maybe<Array<EmailTrackingSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type EmailTrackingPreviewSchema = {
  __typename?: "EmailTrackingPreviewSchema";
  emailTrackingId: Scalars["String"];
  to: Scalars["String"];
  from?: Maybe<Scalars["String"]>;
  replyTo?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  template: Scalars["String"];
  locale: Scalars["String"];
  html?: Maybe<Scalars["String"]>;
  text?: Maybe<Scalars["String"]>;
  attachments: Array<EmailPreviewAttachmentSchema>;
  warnings: Array<Scalars["String"]>;
};

export type EmailTrackingResendResultSchema = {
  __typename?: "EmailTrackingResendResultSchema";
  success: Scalars["Boolean"];
  to: Scalars["String"];
  message?: Maybe<Scalars["String"]>;
};

export type EmailTrackingSchema = {
  __typename?: "EmailTrackingSchema";
  _id: Scalars["String"];
  messageId?: Maybe<Scalars["String"]>;
  email: Scalars["String"];
  subject?: Maybe<Scalars["String"]>;
  template?: Maybe<Scalars["String"]>;
  templateData?: Maybe<Scalars["JSON"]>;
  emailType?: Maybe<Scalars["String"]>;
  entityType?: Maybe<Scalars["String"]>;
  entityId?: Maybe<Scalars["String"]>;
  statuses?: Maybe<Array<EmailStatusEntrySchema>>;
  softBouncedCount?: Maybe<Scalars["Int"]>;
  created?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type EmailTrackingStatsResultSchema = {
  __typename?: "EmailTrackingStatsResultSchema";
  statusCounts: Array<StatusCountSchema>;
  dailyVolume: Array<DailyVolumeSchema>;
  dailyByStatus: Array<DailyStatusVolumeSchema>;
  uniqueRecipients: Scalars["Int"];
  uniqueOpened: Scalars["Int"];
  uniqueDelivered: Scalars["Int"];
  uniqueHardBounced: Scalars["Int"];
  uniqueSoftBounced: Scalars["Int"];
};

/** Type of email */
export enum EmailType {
  OTHER = "OTHER"
}

/** Type of entity associated with the email */
export enum EntityType {
  USER = "USER",
  COMPANY = "COMPANY",
  ORDER = "ORDER",
  CAR = "CAR",
  INQUIRY = "INQUIRY",
  REFERRAL = "REFERRAL",
  SHIPPING = "SHIPPING",
  ZENDESK_COMMENT = "ZENDESK_COMMENT",
  INTERNAL_COMMENT = "INTERNAL_COMMENT",
  LEGACY = "LEGACY",
  OTHER = "OTHER"
}

export type EnumSchema = {
  __typename?: "EnumSchema";
  errorCode: ErrorCode;
  emailType: EmailType;
  entityType: EntityType;
  emailStatus: EmailStatus;
};

export type EquipmentSchema = {
  __typename?: "EquipmentSchema";
  power_steering?: Maybe<Scalars["Boolean"]>;
  power_window?: Maybe<Scalars["Boolean"]>;
  alloy_wheels?: Maybe<Scalars["Boolean"]>;
  sunroof?: Maybe<Scalars["Boolean"]>;
  leather_seats?: Maybe<Scalars["Boolean"]>;
  airbag?: Maybe<Scalars["Boolean"]>;
  abs?: Maybe<Scalars["Boolean"]>;
  navigation?: Maybe<Scalars["Boolean"]>;
  tv?: Maybe<Scalars["Boolean"]>;
  keyless?: Maybe<Scalars["Boolean"]>;
  air_conditioner?: Maybe<Scalars["String"]>;
  air_conditioner_en?: Maybe<Scalars["String"]>;
};

/** Error code */
export enum ErrorCode {
  NOT_FOUND = "NOT_FOUND",
  BAD_REQUEST = "BAD_REQUEST",
  FORBIDDEN = "FORBIDDEN",
  E_UNAUTHORIZED = "E_UNAUTHORIZED",
  E_VALIDATION = "E_VALIDATION",
  E_UNKNOWN = "E_UNKNOWN",
  E_NOT_IMPLEMENTED = "E_NOT_IMPLEMENTED",
  E_TOO_MANY_REQUESTS = "E_TOO_MANY_REQUESTS",
  E_CONFLICT = "E_CONFLICT",
  E_PROXY_BLOCKED = "E_PROXY_BLOCKED",
  E_OVER_LOAD_SEARCH = "E_OVER_LOAD_SEARCH",
  E_EXCHANGE_RATE_NOT_FOUND = "E_EXCHANGE_RATE_NOT_FOUND",
  E_EMAIL_EXISTED = "E_EMAIL_EXISTED",
  E_MSVC_UNKNOW = "E_MSVC_UNKNOW",
  E_SESSION_STORE_NOT_FOUND = "E_SESSION_STORE_NOT_FOUND",
  E_BAD_CAR_STATUS = "E_BAD_CAR_STATUS",
  E_DAILY_REQUEST_LIMIT_REACHED = "E_DAILY_REQUEST_LIMIT_REACHED",
  E_PAYPAL_INVOICE_DATA_INVALID = "E_PAYPAL_INVOICE_DATA_INVALID",
  E_TIMEOUT = "E_TIMEOUT",
  E_PROMPT_NOT_FOUND = "E_PROMPT_NOT_FOUND",
  E_REWARD_AVAILABLE_REFRESH = "E_REWARD_AVAILABLE_REFRESH",
  E_EMAIL_HARD_BOUNCED = "E_EMAIL_HARD_BOUNCED",
  E_COUPON_NOT_FOUND = "E_COUPON_NOT_FOUND",
  E_COUPON_CODE_EXISTED = "E_COUPON_CODE_EXISTED",
  E_SALE_TAG_NOT_FOUND = "E_SALE_TAG_NOT_FOUND"
}

export type EvaluationSchema = {
  __typename?: "EvaluationSchema";
  overall_score?: Maybe<Scalars["String"]>;
  interior_grade?: Maybe<Scalars["String"]>;
  exterior_grade?: Maybe<Scalars["String"]>;
  repair_history?: Maybe<Scalars["String"]>;
  repair_history_en?: Maybe<Scalars["String"]>;
};

export type ExchangeRateSchema = {
  __typename?: "ExchangeRateSchema";
  _id?: Maybe<Scalars["ID"]>;
  id?: Maybe<Scalars["String"]>;
  currency: Scalars["String"];
  TTS?: Maybe<Scalars["Float"]>;
  TTB?: Maybe<Scalars["Float"]>;
  MIDDLE: Scalars["Float"];
  displayFormat: Scalars["String"];
  published?: Maybe<Scalars["Boolean"]>;
  modifiedAt?: Maybe<Scalars["DateTime"]>;
};

export type ExpenseRequestPagingSchema = {
  __typename?: "ExpenseRequestPagingSchema";
  nodes?: Maybe<Array<ExpenseRequestSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type ExpenseRequestSchema = {
  __typename?: "ExpenseRequestSchema";
  id: Scalars["ID"];
  introducerId: Scalars["ID"];
  introducerName?: Maybe<Scalars["String"]>;
  introducerEmail?: Maybe<Scalars["String"]>;
  buyerName?: Maybe<Scalars["String"]>;
  buyerEmail?: Maybe<Scalars["String"]>;
  orderId: Scalars["Float"];
  note?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  reasonReject?: Maybe<Scalars["String"]>;
  amount: Scalars["Float"];
  requestAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type Expired = {
  __typename?: "Expired";
  expiredDate?: Maybe<Scalars["DateTime"]>;
  amount?: Maybe<Scalars["Float"]>;
};

export type ExportCompanyCarDataInput = {
  companies: Array<Scalars["String"]>;
  status?: Maybe<Array<Scalars["Int"]>>;
  from?: Maybe<Scalars["DateTime"]>;
  to?: Maybe<Scalars["DateTime"]>;
  withImages?: Maybe<Scalars["Boolean"]>;
};

export type ExportCompanyCarDataResponse = {
  __typename?: "ExportCompanyCarDataResponse";
  content: Scalars["String"];
  message: Scalars["String"];
};

export type ExporterCompanyType = {
  __typename?: "ExporterCompanyType";
  _id: Scalars["ID"];
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  nameDisplay?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  telephone?: Maybe<Scalars["String"]>;
  fax?: Maybe<Scalars["String"]>;
  website?: Maybe<Scalars["String"]>;
  introduction?: Maybe<Scalars["String"]>;
  yearEstablished?: Maybe<Scalars["String"]>;
  totalEmployees?: Maybe<Scalars["String"]>;
  carCount?: Maybe<Scalars["Int"]>;
  score?: Maybe<Scalars["Float"]>;
  ratingValue?: Maybe<Scalars["Float"]>;
  reviewCount?: Maybe<Scalars["Int"]>;
  inContract?: Maybe<Scalars["Boolean"]>;
  selfNegotiation?: Maybe<Scalars["Boolean"]>;
  images?: Maybe<Array<MediaSchema>>;
};

export type ExporterPagingType = {
  __typename?: "ExporterPagingType";
  companies: Array<ExporterCompanyType>;
  total: Scalars["Int"];
};

export type Faceted = {
  __typename?: "Faceted";
  doc_count_error_upper_bound: Scalars["Int"];
  sum_other_doc_count: Scalars["Int"];
  buckets: Array<Bucket>;
};

export type Faq = {
  question: Scalars["String"];
  answer: Scalars["String"];
};

export type FaqSchema = {
  __typename?: "FaqSchema";
  id?: Maybe<Scalars["ID"]>;
  _id?: Maybe<Scalars["ID"]>;
  question: Scalars["String"];
  answer: Scalars["String"];
};

export type FeedbackSchema = {
  __typename?: "FeedbackSchema";
  cost?: Maybe<Scalars["Int"]>;
  delivery?: Maybe<Scalars["Int"]>;
  communicationSpeed?: Maybe<Scalars["Int"]>;
  communicationQuality?: Maybe<Scalars["Int"]>;
  likeCFJ?: Maybe<Array<Scalars["String"]>>;
  likelyToRecommend?: Maybe<Scalars["Int"]>;
  comment?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<UserSchema>;
  modifiedAt?: Maybe<Scalars["DateTime"]>;
  modifiedBy?: Maybe<UserSchema>;
};

export type FetchAdsInput = {
  country?: Maybe<Scalars["String"]>;
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  platform?: Maybe<Scalars["String"]>;
  position?: Maybe<Array<Scalars["String"]>>;
};

export type FollowUpArgs = {
  invoiceId: Scalars["String"];
};

export type FreightCitySchema = {
  __typename?: "FreightCitySchema";
  name: Scalars["String"];
};

export type FreightFilterInput = {
  company?: Maybe<Scalars["ID"]>;
  keywords?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["ID"]>;
};

export type FreightInformSchema = {
  __typename?: "FreightInformSchema";
  locale?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  content: Scalars["String"];
};

export type FreightSchema = {
  __typename?: "FreightSchema";
  id: Scalars["ID"];
  country: Scalars["String"];
  port: Scalars["String"];
  priority?: Maybe<Scalars["Float"]>;
  inspectName?: Maybe<Scalars["String"]>;
  shippingMethod?: Maybe<Scalars["String"]>;
  canBuyNow?: Maybe<Scalars["Boolean"]>;
  needInspection?: Maybe<Scalars["Boolean"]>;
  cities?: Maybe<Array<FreightCitySchema>>;
  inform?: Maybe<Array<FreightInformSchema>>;
};

export type FullContentAgentSchema = {
  __typename?: "FullContentAgentSchema";
  id?: Maybe<Scalars["ID"]>;
  name: Scalars["String"];
  email?: Maybe<Scalars["String"]>;
};

export type FullContentCommentSchema = {
  __typename?: "FullContentCommentSchema";
  id?: Maybe<Scalars["ID"]>;
  body?: Maybe<Scalars["String"]>;
  html_body?: Maybe<Scalars["String"]>;
  created_at?: Maybe<Scalars["String"]>;
};

export type FullContentRequesterSchema = {
  __typename?: "FullContentRequesterSchema";
  id?: Maybe<Scalars["ID"]>;
  email?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type FullInquiryContentSchema = {
  __typename?: "FullInquiryContentSchema";
  agent?: Maybe<FullContentAgentSchema>;
  comment?: Maybe<FullContentCommentSchema>;
  car?: Maybe<CarSchema>;
  requester?: Maybe<FullContentRequesterSchema>;
  ticketId?: Maybe<Scalars["Int"]>;
  replyTo?: Maybe<Scalars["String"]>;
};

export type GalleryPagingSchema = {
  __typename?: "GalleryPagingSchema";
  nodes?: Maybe<Array<GallerySchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type GallerySchema = {
  __typename?: "GallerySchema";
  id: Scalars["ID"];
  image?: Maybe<CfjLegacyMedia>;
  country?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["Float"]>;
  active?: Maybe<Scalars["Boolean"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type GameInfoSchema = {
  __typename?: "GameInfoSchema";
  id: Scalars["ID"];
  key: Scalars["String"];
  title?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["DateTime"]>;
  endDate?: Maybe<Scalars["DateTime"]>;
};

export type GameRankSchema = {
  __typename?: "GameRankSchema";
  user: GameUserPublicSchema;
  point: Scalars["Float"];
  rank: Scalars["Int"];
};

export type GameResultSchema = {
  __typename?: "GameResultSchema";
  info: GameInfoSchema;
  totalRank: Array<GameRankSchema>;
  results: Array<GameRewardSchema>;
};

export type GameRewardSchema = {
  __typename?: "GameRewardSchema";
  gift?: Maybe<Scalars["String"]>;
  picture?: Maybe<Scalars["String"]>;
  dateAward?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  user?: Maybe<GameUserPublicSchema>;
};

export type GameUserPublicSchema = {
  __typename?: "GameUserPublicSchema";
  id: Scalars["ID"];
  name: Scalars["String"];
  avatar?: Maybe<Scalars["String"]>;
};

export type GeneralConditionSchema = {
  __typename?: "GeneralConditionSchema";
  front_windshield?: Maybe<Scalars["String"]>;
  front_windshield_en?: Maybe<Scalars["String"]>;
  exterior?: Maybe<Scalars["String"]>;
  exterior_en?: Maybe<Scalars["String"]>;
  interior?: Maybe<Scalars["String"]>;
  interior_en?: Maybe<Scalars["String"]>;
};

export type GeneralInquiryResponse = {
  __typename?: "GeneralInquiryResponse";
  ticketNo: Scalars["Int"];
  userId: Scalars["ID"];
  isNewUser: Scalars["Boolean"];
  urlResetPassword?: Maybe<Scalars["String"]>;
};

export type GenerateBoxTextArgs = {
  make?: Maybe<Scalars["String"]>;
  makeKey?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  modelKey?: Maybe<Scalars["String"]>;
  local?: Maybe<Scalars["String"]>;
  landingTag?: Maybe<Scalars["String"]>;
  minYear?: Maybe<Scalars["Int"]>;
  maxYear?: Maybe<Scalars["Int"]>;
  year?: Maybe<Scalars["Int"]>;
  minMonth?: Maybe<Scalars["Int"]>;
  maxMonth?: Maybe<Scalars["Int"]>;
  minPrice?: Maybe<Scalars["Int"]>;
  maxPrice?: Maybe<Scalars["Int"]>;
  minPriceCIF?: Maybe<Scalars["Int"]>;
  maxPriceCIF?: Maybe<Scalars["Int"]>;
  bodyType?: Maybe<Scalars["Int"]>;
  minMileage?: Maybe<Scalars["Int"]>;
  maxMileage?: Maybe<Scalars["Int"]>;
  fuelType?: Maybe<Scalars["Int"]>;
  driveType?: Maybe<Scalars["Int"]>;
  transmission?: Maybe<Scalars["Int"]>;
  steering?: Maybe<Scalars["Int"]>;
  minDiscountPercent?: Maybe<Scalars["String"]>;
  maxDiscountPercent?: Maybe<Scalars["String"]>;
  minDisplacement?: Maybe<Scalars["Int"]>;
  maxDisplacement?: Maybe<Scalars["Int"]>;
  minPassenger?: Maybe<Scalars["Int"]>;
  maxPassenger?: Maybe<Scalars["Int"]>;
  hasVideo?: Maybe<Scalars["Boolean"]>;
  hasInspectionRatings?: Maybe<Scalars["Boolean"]>;
  company?: Maybe<Scalars["String"]>;
  tags?: Maybe<Array<Scalars["String"]>>;
  keywords?: Maybe<Scalars["String"]>;
};

export type GetAdsFiltersInput = {
  _id?: Maybe<Scalars["ID"]>;
  keywords?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  platform?: Maybe<Scalars["String"]>;
  position?: Maybe<Scalars["String"]>;
  published?: Maybe<Scalars["Boolean"]>;
};

export type GetAllMakeArgs = {
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
  skip?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  id?: Maybe<Scalars["String"]>;
  keywords?: Maybe<Scalars["String"]>;
  locked?: Maybe<Scalars["Boolean"]>;
  hasCar?: Maybe<Scalars["Boolean"]>;
};

export type GetBoxtextArgs = {
  _id?: Maybe<Scalars["String"]>;
  path?: Maybe<Scalars["String"]>;
  offset: Scalars["Int"];
  limit: Scalars["Int"];
  sort?: Maybe<Scalars["String"]>;
  keywords?: Maybe<Scalars["String"]>;
  key?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
  hasPriceRange?: Maybe<Scalars["Boolean"]>;
};

export type GetBuyerStatsArgs = {
  buyerIds: Array<Scalars["String"]>;
};

export type GetBuyerStatsSchema = {
  __typename?: "GetBuyerStatsSchema";
  _id: Scalars["ID"];
  purchased?: Maybe<Scalars["Float"]>;
  cancelled?: Maybe<Scalars["Float"]>;
  issued?: Maybe<Scalars["Float"]>;
  inquiries?: Maybe<Scalars["Float"]>;
};

export type GetCarAdminPageviewsArgs = {
  userId?: Maybe<Scalars["String"]>;
  carId?: Maybe<Scalars["String"]>;
  offset?: Maybe<Scalars["Float"]>;
  limit?: Maybe<Scalars["Float"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type GetCarAdminPageviewsSchema = {
  __typename?: "GetCarAdminPageviewsSchema";
  items: Array<PvSchema>;
  total: Scalars["Float"];
};

export type GetCarFavoritesArgs = {
  limit?: Maybe<Scalars["Int"]>;
  page?: Maybe<Scalars["Int"]>;
  hideUnavailableCars?: Maybe<Scalars["Boolean"]>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
};

export type GetCommentsAdminArgs = {
  filters?: Maybe<GetCommentsAdminFilters>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type GetCommentsAdminFilters = {
  invoiceId?: Maybe<Scalars["String"]>;
  authorType?: Maybe<Array<Scalars["String"]>>;
  syncStatus?: Maybe<Array<Scalars["String"]>>;
  provider?: Maybe<Scalars["String"]>;
  isPublic?: Maybe<Scalars["Boolean"]>;
  startDate?: Maybe<Scalars["DateTime"]>;
  endDate?: Maybe<Scalars["DateTime"]>;
  source?: Maybe<Array<Scalars["String"]>>;
  keywords?: Maybe<Scalars["String"]>;
};

export type GetCommentsAdminResult = {
  __typename?: "GetCommentsAdminResult";
  items: Array<CommentAdminSchema>;
  total: Scalars["Int"];
};

export type GetCommentTrackingArgs = {
  commentId: Scalars["String"];
};

export type GetCountriesParamsInput = {
  _id?: Maybe<Scalars["ID"]>;
  key?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  region?: Maybe<Scalars["String"]>;
};

export type GetCustomSeoArgs = {
  id?: Maybe<Scalars["String"]>;
  path?: Maybe<Scalars["String"]>;
  offset: Scalars["Int"];
  limit: Scalars["Int"];
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type GetFeaturedLinkArgs = {
  carId?: Maybe<Scalars["String"]>;
  makeId?: Maybe<Scalars["String"]>;
  modelId?: Maybe<Scalars["String"]>;
  isNew?: Maybe<Scalars["Boolean"]>;
  local?: Maybe<Scalars["String"]>;
  includeMeta?: Maybe<Scalars["Boolean"]>;
  getMetaSeoOnly?: Maybe<Scalars["Boolean"]>;
  key?: Maybe<Scalars["String"]>;
  isDetail?: Maybe<Scalars["Boolean"]>;
};

export type GetFeaturedLinkType = {
  __typename?: "GetFeaturedLinkType";
  links: Array<BoxLinkSchema>;
  meta?: Maybe<MetaSchema>;
};

export type GetInvoiceCommentsAdminDto = {
  __typename?: "GetInvoiceCommentsAdminDto";
  comments?: Maybe<ZendeskCommentsResponse>;
  ticketAudits?: Maybe<ZendeskTicketAuditsResponse>;
  mergedFrom?: Maybe<Array<TicketRecordSchema>>;
};

export type GetInvoiceLoggingArgs = {
  inquiryId: Scalars["String"];
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type GetInvoiceLoggingSchema = {
  __typename?: "GetInvoiceLoggingSchema";
  logs: Array<InvoiceLoggingEntry>;
  total: Scalars["Int"];
};

export type GetInvoicesAdminArgs = {
  filters?: Maybe<GetInvoicesAdminFilters>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
  offset?: Maybe<Scalars["Float"]>;
  limit?: Maybe<Scalars["Float"]>;
};

export type GetInvoicesAdminFilters = {
  _id?: Maybe<Scalars["String"]>;
  user?: Maybe<Scalars["String"]>;
  keywords?: Maybe<Scalars["String"]>;
  startDate?: Maybe<Scalars["DateTime"]>;
  endDate?: Maybe<Scalars["DateTime"]>;
  minYear?: Maybe<Scalars["Float"]>;
  maxYear?: Maybe<Scalars["Float"]>;
  type?: Maybe<Array<Scalars["String"]>>;
  quick?: Maybe<Scalars["String"]>;
  step?: Maybe<Array<Scalars["String"]>>;
  agent?: Maybe<Scalars["Float"]>;
  company?: Maybe<Array<Scalars["String"]>>;
  followup?: Maybe<Scalars["Boolean"]>;
  followupLevel?: Maybe<Array<Scalars["Float"]>>;
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  folder?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
};

export type GetInvoicesAdminSchema = {
  __typename?: "GetInvoicesAdminSchema";
  invoices: Array<InquirySchema>;
  total: Scalars["Float"];
};

export type GetInvoicesAggsAgent = {
  __typename?: "GetInvoicesAggsAgent";
  _id: Scalars["String"];
  name?: Maybe<Scalars["String"]>;
  zendeskId?: Maybe<Scalars["Float"]>;
};

export type GetInvoicesAggsArgs = {
  agent?: Maybe<Scalars["Float"]>;
};

export type GetInvoicesAggsFolder = {
  __typename?: "GetInvoicesAggsFolder";
  _id: Scalars["String"];
};

export type GetInvoicesAggsSchema = {
  __typename?: "GetInvoicesAggsSchema";
  agents?: Maybe<Array<GetInvoicesAggsAgent>>;
  folders?: Maybe<Array<GetInvoicesAggsFolder>>;
  openTickets?: Maybe<Scalars["Float"]>;
  waitForTTTickets?: Maybe<Scalars["Float"]>;
  followUpBuyerTickets?: Maybe<Scalars["Float"]>;
  needShareShip?: Maybe<Scalars["Float"]>;
  needShareBL?: Maybe<Scalars["Float"]>;
  needSendDocs?: Maybe<Scalars["Float"]>;
  needReleaseMoney?: Maybe<Scalars["Float"]>;
  newInvoices?: Maybe<Scalars["Float"]>;
  soldDelivering?: Maybe<Scalars["Float"]>;
  sissFollow?: Maybe<Scalars["Float"]>;
  invoicePriceOrver14500?: Maybe<Scalars["Float"]>;
  invoicePriceUnder14500?: Maybe<Scalars["Float"]>;
};

export type GetInvoicesArgs = {
  page?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["JSON"]>;
  requester?: Maybe<Scalars["Boolean"]>;
  read?: Maybe<Scalars["Boolean"]>;
  important?: Maybe<Scalars["Boolean"]>;
  keywords?: Maybe<Scalars["String"]>;
  ticketTag?: Maybe<Scalars["String"]>;
  unrepliedOnly?: Maybe<Scalars["Boolean"]>;
  step?: Maybe<Array<Scalars["Int"]>>;
  from?: Maybe<Scalars["DateTime"]>;
  to?: Maybe<Scalars["DateTime"]>;
  status?: Maybe<Scalars["JSON"]>;
  showClosed?: Maybe<Scalars["Boolean"]>;
};

export type GetInvoicesCarArgs = {
  carIds: Array<Scalars["String"]>;
};

export type GetInvoicesCarSchema = {
  __typename?: "GetInvoicesCarSchema";
  _id: Scalars["String"];
  inquiryCount?: Maybe<Scalars["Float"]>;
};

export type GetInvoicesCommentsAdminArgs = {
  invoiceId: Scalars["String"];
};

export type GetLandingTagsAdminInput = {
  _id?: Maybe<Scalars["ID"]>;
  key?: Maybe<Scalars["String"]>;
  keywords?: Maybe<Scalars["String"]>;
  published?: Maybe<Scalars["Boolean"]>;
};

export type GetLocalPageArgs = {
  key?: Maybe<Scalars["String"]>;
  countOnly?: Maybe<Scalars["Boolean"]>;
};

export type GetLocalPageType = {
  __typename?: "GetLocalPageType";
  items?: Maybe<Array<Maybe<CountryPageSchema>>>;
  totalCount?: Maybe<Scalars["Float"]>;
};

export type GetManagementMakeType = {
  __typename?: "GetManagementMakeType";
  total: Scalars["Int"];
  items: Array<MakeSchema>;
};

export type GetManagementModelInput = {
  _id?: Maybe<Scalars["ID"]>;
  make?: Maybe<Scalars["ID"]>;
  alias?: Maybe<Scalars["ID"]>;
  locked?: Maybe<Scalars["Boolean"]>;
  keywords?: Maybe<Scalars["String"]>;
  nonASCII?: Maybe<Scalars["Boolean"]>;
  onlyASCII?: Maybe<Scalars["Boolean"]>;
  hasCar?: Maybe<Scalars["Boolean"]>;
};

export type GetManagementModelType = {
  __typename?: "GetManagementModelType";
  total: Scalars["Int"];
  items: Array<ModelSchema>;
};

export type GetManagementUserInput = {
  status?: Maybe<Scalars["Int"]>;
  email?: Maybe<Scalars["String"]>;
  keywords?: Maybe<Scalars["String"]>;
  tags?: Maybe<Array<Scalars["String"]>>;
  roles?: Maybe<Array<Scalars["String"]>>;
};

export type GetManagementUserType = {
  __typename?: "GetManagementUserType";
  users: Array<UserSchema>;
  total: Scalars["Int"];
};

export type GetManyLandingTagsType = {
  __typename?: "GetManyLandingTagsType";
  items: Array<LandingTagSchema>;
  total: Scalars["Float"];
};

export type GetManyModelsArgs = {
  makeId?: Maybe<Scalars["String"]>;
  makeIds?: Maybe<Array<Scalars["String"]>>;
  hasCar?: Maybe<Scalars["Boolean"]>;
  noAlias?: Maybe<Scalars["Boolean"]>;
  ids?: Maybe<Array<Scalars["String"]>>;
  keywords?: Maybe<Scalars["String"]>;
  nonASCII?: Maybe<Scalars["Boolean"]>;
  nonLocked?: Maybe<Scalars["Boolean"]>;
  locked?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["String"]>;
  skip?: Maybe<Scalars["Float"]>;
  limit?: Maybe<Scalars["Float"]>;
  getMake?: Maybe<Scalars["Boolean"]>;
};

export type GetManyModelsType = {
  __typename?: "GetManyModelsType";
  total: Scalars["Int"];
  items: Array<ModelSchema>;
};

export type GetModelSpecsAdminInput = {
  _id?: Maybe<Scalars["ID"]>;
  model?: Maybe<Scalars["ID"]>;
  modelCode?: Maybe<Scalars["String"]>;
  year?: Maybe<Scalars["Int"]>;
  lock?: Maybe<Scalars["Boolean"]>;
  keywords?: Maybe<Scalars["String"]>;
  nonASCII?: Maybe<Scalars["Boolean"]>;
};

export type GetPopularLinksArgs = {
  makeId?: Maybe<Scalars["String"]>;
  modelId?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
};

export type GetSatisfactionArgs = {
  sort?: Maybe<Scalars["String"]>;
  skip?: Maybe<Scalars["Float"]>;
  limit?: Maybe<Scalars["Float"]>;
  includesCarImages?: Maybe<Scalars["Boolean"]>;
  makeName?: Maybe<Scalars["String"]>;
  modelName?: Maybe<Scalars["String"]>;
  avg?: Maybe<Scalars["Boolean"]>;
  published?: Maybe<Scalars["Boolean"]>;
  ticketId?: Maybe<Scalars["String"]>;
  public?: Maybe<Scalars["Boolean"]>;
  company?: Maybe<Scalars["String"]>;
  hasVideo?: Maybe<Scalars["Boolean"]>;
  hasImage?: Maybe<Scalars["Boolean"]>;
  allInquiry?: Maybe<Scalars["Boolean"]>;
  id?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  includeCarImages?: Maybe<Scalars["Boolean"]>;
  landingTag?: Maybe<Scalars["String"]>;
  minYear?: Maybe<Scalars["Float"]>;
  maxYear?: Maybe<Scalars["Float"]>;
};

export type GetSatisfactionsAdminInput = {
  keywords?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  notReplied?: Maybe<Scalars["Boolean"]>;
  published?: Maybe<Scalars["Boolean"]>;
};

export type GetSatisfactionType = {
  __typename?: "GetSatisfactionType";
  items: Array<SatisfactionSchema>;
  total: Scalars["Int"];
  avgScore: Scalars["Float"];
  limit: Scalars["Float"];
  skip: Scalars["Float"];
};

export type GetTicketsAdminArgs = {
  filters?: Maybe<GetTicketsAdminFilters>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type GetTicketsAdminFilters = {
  keyword?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  assigneeId?: Maybe<Scalars["String"]>;
  unassigned?: Maybe<Scalars["Boolean"]>;
  startDate?: Maybe<Scalars["DateTime"]>;
  endDate?: Maybe<Scalars["DateTime"]>;
  noInquiry?: Maybe<Scalars["Boolean"]>;
  hasInquiry?: Maybe<Scalars["Boolean"]>;
};

export type GetTicketsAdminSchema = {
  __typename?: "GetTicketsAdminSchema";
  tickets: Array<TicketRecordSchema>;
  total: Scalars["Float"];
};

export type GetTransformationsAdminInput = {
  _id?: Maybe<Scalars["ID"]>;
  company?: Maybe<Scalars["ID"]>;
  source?: Maybe<Scalars["String"]>;
  key?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
  type?: Maybe<TransformationType>;
  locked?: Maybe<Scalars["Boolean"]>;
  keywords?: Maybe<Scalars["String"]>;
  nonASCII?: Maybe<Scalars["Boolean"]>;
};

export type GmailInboundStatusSchema = {
  __typename?: "GmailInboundStatusSchema";
  connected: Scalars["Boolean"];
  email?: Maybe<Scalars["String"]>;
  connectedAt?: Maybe<Scalars["String"]>;
  lastRefreshAt?: Maybe<Scalars["String"]>;
  lastWatchAt?: Maybe<Scalars["String"]>;
  watchExpiresAt?: Maybe<Scalars["String"]>;
  lastError?: Maybe<Scalars["String"]>;
  accessTokenExpiresAt?: Maybe<Scalars["Float"]>;
  watchEmail: Scalars["String"];
  oauthClientId: Scalars["String"];
  scope: Scalars["String"];
};

export type GradeGroupSaleFrom = {
  __typename?: "GradeGroupSaleFrom";
  _id?: Maybe<Scalars["String"]>;
  grades?: Maybe<Array<GradeSchema>>;
  _makeName?: Maybe<Scalars["String"]>;
  _modelName?: Maybe<Scalars["String"]>;
  _saleFrom?: Maybe<Scalars["String"]>;
  images?: Maybe<Array<MediaSchema>>;
};

export type GradeSchema = {
  __typename?: "GradeSchema";
  id: Scalars["ID"];
  make?: Maybe<MakeSchema>;
  model?: Maybe<ModelSchema>;
  images?: Maybe<Array<MediaSchema>>;
  gooId?: Maybe<Scalars["Float"]>;
  path?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  modelCode?: Maybe<Scalars["String"]>;
  _modelName?: Maybe<Scalars["String"]>;
  _makeName?: Maybe<Scalars["String"]>;
  displacement?: Maybe<Scalars["String"]>;
  doors?: Maybe<Scalars["Int"]>;
  length?: Maybe<Scalars["Float"]>;
  width?: Maybe<Scalars["Float"]>;
  height?: Maybe<Scalars["Float"]>;
  weight?: Maybe<Scalars["Float"]>;
  engineModel?: Maybe<Scalars["String"]>;
  cylinders?: Maybe<Scalars["String"]>;
  maximumPower?: Maybe<Scalars["String"]>;
  maximumTorque?: Maybe<Scalars["String"]>;
  boreStroke?: Maybe<Scalars["String"]>;
  compressionRatio?: Maybe<Scalars["String"]>;
  charger?: Maybe<Scalars["String"]>;
  fuelSupplyEquipment?: Maybe<Scalars["String"]>;
  fuelTankEquipment?: Maybe<Scalars["String"]>;
  fuelType?: Maybe<Scalars["String"]>;
  steeringSystem?: Maybe<Scalars["String"]>;
  minimumTurningRadius?: Maybe<Scalars["String"]>;
  suspensionSystemFront?: Maybe<Scalars["String"]>;
  suspensionSystemRear?: Maybe<Scalars["String"]>;
  breakingSystemFront?: Maybe<Scalars["String"]>;
  breakingSystemRear?: Maybe<Scalars["String"]>;
  tiresSizeFront?: Maybe<Scalars["String"]>;
  tiresSizeRear?: Maybe<Scalars["String"]>;
  LSD?: Maybe<Scalars["String"]>;
  drivingWheel?: Maybe<Scalars["String"]>;
  transmission?: Maybe<Scalars["String"]>;
  gear1st?: Maybe<Scalars["String"]>;
  gear2nd?: Maybe<Scalars["String"]>;
  gear3rd?: Maybe<Scalars["String"]>;
  gear4th?: Maybe<Scalars["String"]>;
  gear5th?: Maybe<Scalars["String"]>;
  gear6th?: Maybe<Scalars["String"]>;
  reverse?: Maybe<Scalars["String"]>;
  finalDriveGearRatio?: Maybe<Scalars["String"]>;
  saleFrom?: Maybe<Scalars["String"]>;
  _saleFrom?: Maybe<Scalars["DateTime"]>;
  groupBy?: Maybe<Scalars["String"]>;
  MSRP?: Maybe<Scalars["String"]>;
  bodyType?: Maybe<Scalars["String"]>;
  wheelBase?: Maybe<Scalars["Float"]>;
  ridingCapacity?: Maybe<Scalars["Int"]>;
};

export type IaucAuctionSheetDataDto = {
  __typename?: "IaucAuctionSheetDataDto";
  evaluation?: Maybe<IaucEvaluationDto>;
  vehicle_information?: Maybe<IaucVehicleInformationDto>;
  equipment?: Maybe<IaucEquipmentDto>;
  aftermarket_parts?: Maybe<Array<Scalars["String"]>>;
  aftermarket_parts_en?: Maybe<Array<Scalars["String"]>>;
  sales_points?: Maybe<Array<Scalars["String"]>>;
  sales_points_en?: Maybe<Array<Scalars["String"]>>;
  special_notes?: Maybe<Array<Scalars["String"]>>;
  special_notes_en?: Maybe<Array<Scalars["String"]>>;
  inspector_notes?: Maybe<Array<Scalars["String"]>>;
  inspector_notes_en?: Maybe<Array<Scalars["String"]>>;
  remarks?: Maybe<Array<Scalars["String"]>>;
  remarks_en?: Maybe<Array<Scalars["String"]>>;
  condition_report?: Maybe<IaucConditionReportDto>;
};

export type IaucClassificationResultDto = {
  __typename?: "IaucClassificationResultDto";
  class_id?: Maybe<Scalars["Float"]>;
  class_name?: Maybe<Scalars["String"]>;
  confidence?: Maybe<Scalars["Float"]>;
};

export type IaucConditionReportDto = {
  __typename?: "IaucConditionReportDto";
  diagram_marks?: Maybe<Array<IaucDiagramMarkDto>>;
  general_condition?: Maybe<IaucGeneralConditionDto>;
};

export type IaucDetectionBoxDto = {
  __typename?: "IaucDetectionBoxDto";
  bbox?: Maybe<Array<Scalars["Float"]>>;
  confidence?: Maybe<Scalars["Float"]>;
  class_id?: Maybe<Scalars["Float"]>;
  class_name?: Maybe<Scalars["String"]>;
};

export type IaucDetectionResultDto = {
  __typename?: "IaucDetectionResultDto";
  total?: Maybe<Scalars["Float"]>;
  boxes?: Maybe<Array<IaucDetectionBoxDto>>;
};

export type IaucDetectorDto = {
  __typename?: "IaucDetectorDto";
  id: Scalars["ID"];
  status: Scalars["String"];
  overallGrade?: Maybe<Scalars["String"]>;
  sourceImage?: Maybe<IaucImageRefDto>;
  translatedImage?: Maybe<IaucImageRefDto>;
  classified?: Maybe<Scalars["Boolean"]>;
  classification?: Maybe<IaucClassificationResultDto>;
  detection?: Maybe<IaucDetectionResultDto>;
  llm?: Maybe<IaucLlmOutputDto>;
  predictedGrade?: Maybe<Scalars["String"]>;
  predictedInteriorGrade?: Maybe<Scalars["String"]>;
  predictedExteriorGrade?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type IaucDiagramMarkDto = {
  __typename?: "IaucDiagramMarkDto";
  position?: Maybe<Scalars["String"]>;
  position_en?: Maybe<Scalars["String"]>;
  mark?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  description_en?: Maybe<Scalars["String"]>;
};

export type IaucEquipmentDto = {
  __typename?: "IaucEquipmentDto";
  power_steering?: Maybe<Scalars["Boolean"]>;
  power_window?: Maybe<Scalars["Boolean"]>;
  alloy_wheels?: Maybe<Scalars["Boolean"]>;
  sunroof?: Maybe<Scalars["Boolean"]>;
  leather_seats?: Maybe<Scalars["Boolean"]>;
  airbag?: Maybe<Scalars["Boolean"]>;
  abs?: Maybe<Scalars["Boolean"]>;
  navigation?: Maybe<Scalars["Boolean"]>;
  tv?: Maybe<Scalars["Boolean"]>;
  keyless?: Maybe<Scalars["Boolean"]>;
  air_conditioner?: Maybe<Scalars["String"]>;
  air_conditioner_en?: Maybe<Scalars["String"]>;
};

export type IaucEvaluationDto = {
  __typename?: "IaucEvaluationDto";
  overall_score?: Maybe<Scalars["String"]>;
  interior_grade?: Maybe<Scalars["String"]>;
  exterior_grade?: Maybe<Scalars["String"]>;
  repair_history?: Maybe<Scalars["String"]>;
  repair_history_en?: Maybe<Scalars["String"]>;
};

export type IaucGeneralConditionDto = {
  __typename?: "IaucGeneralConditionDto";
  front_windshield?: Maybe<Scalars["String"]>;
  front_windshield_en?: Maybe<Scalars["String"]>;
  exterior?: Maybe<Scalars["String"]>;
  exterior_en?: Maybe<Scalars["String"]>;
  interior?: Maybe<Scalars["String"]>;
  interior_en?: Maybe<Scalars["String"]>;
};

export type IaucImageRefDto = {
  __typename?: "IaucImageRefDto";
  key: Scalars["String"];
  bucket: Scalars["String"];
};

export type IaucLlmOutputDto = {
  __typename?: "IaucLLMOutputDto";
  auction_sheet?: Maybe<IaucAuctionSheetDataDto>;
  ai_summary?: Maybe<Scalars["String"]>;
};

export type IaucVehicleInformationDto = {
  __typename?: "IaucVehicleInformationDto";
  maker?: Maybe<Scalars["String"]>;
  maker_en?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  model_en?: Maybe<Scalars["String"]>;
  car_name?: Maybe<Scalars["String"]>;
  car_name_en?: Maybe<Scalars["String"]>;
  grade?: Maybe<Scalars["String"]>;
  grade_en?: Maybe<Scalars["String"]>;
  manufacturing_date?: Maybe<Scalars["String"]>;
  registration_date?: Maybe<Scalars["String"]>;
  body_type?: Maybe<Scalars["String"]>;
  body_type_en?: Maybe<Scalars["String"]>;
  engine_displacement_cc?: Maybe<Scalars["Float"]>;
  model_code?: Maybe<Scalars["String"]>;
  chassis_number?: Maybe<Scalars["String"]>;
  mileage_value?: Maybe<Scalars["Float"]>;
  mileage_unit?: Maybe<Scalars["String"]>;
  fuel?: Maybe<Scalars["String"]>;
  fuel_en?: Maybe<Scalars["String"]>;
  transmission?: Maybe<Scalars["String"]>;
  transmission_en?: Maybe<Scalars["String"]>;
  drive_system?: Maybe<Scalars["String"]>;
  drive_system_en?: Maybe<Scalars["String"]>;
  exterior_color?: Maybe<Scalars["String"]>;
  exterior_color_en?: Maybe<Scalars["String"]>;
  color_number?: Maybe<Scalars["String"]>;
  seating_capacity?: Maybe<Scalars["Float"]>;
  steering_wheel?: Maybe<Scalars["String"]>;
  steering_wheel_en?: Maybe<Scalars["String"]>;
};

export type ImageRefSchema = {
  __typename?: "ImageRefSchema";
  key: Scalars["String"];
  bucket: Scalars["String"];
};

export type ImpersonationTicketType = {
  __typename?: "ImpersonationTicketType";
  token: Scalars["String"];
  expiresAt: Scalars["DateTime"];
  accessToken?: Maybe<Scalars["String"]>;
};

export type InformInput = {
  locale?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  content?: Maybe<Scalars["String"]>;
};

export type InquiryCarChangePreviewSchema = {
  __typename?: "InquiryCarChangePreviewSchema";
  blockers: Array<Scalars["String"]>;
  warnings: Array<Scalars["String"]>;
  from: CarChangeSideSchema;
  to?: Maybe<CarChangeSideSchema>;
  lines: Array<CarChangePriceLineSchema>;
  coupon?: Maybe<CarChangeCouponSchema>;
  note?: Maybe<Scalars["String"]>;
};

export type InquiryCouponInput = {
  car?: Maybe<Scalars["String"]>;
  isBuyNow?: Maybe<Scalars["Boolean"]>;
  country?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
};

export type InquiryDocumentSchema = {
  __typename?: "InquiryDocumentSchema";
  id?: Maybe<Scalars["Float"]>;
  documentType?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  source?: Maybe<Scalars["String"]>;
};

export type InquiryExtraSchema = {
  __typename?: "InquiryExtraSchema";
  issueAt?: Maybe<Scalars["DateTime"]>;
  estimatedProfitJPY?: Maybe<Scalars["Float"]>;
  actualProfitJPY?: Maybe<Scalars["Float"]>;
  actualProfitDate?: Maybe<Scalars["DateTime"]>;
  withTaxEstimatedProfitJPY?: Maybe<Scalars["Float"]>;
  withTaxActualProfitJPY?: Maybe<Scalars["Float"]>;
  followupLevel?: Maybe<Scalars["String"]>;
};

export type InquiryFollowupSchema = {
  __typename?: "InquiryFollowupSchema";
  state?: Maybe<Scalars["String"]>;
  nextActionAt?: Maybe<Scalars["DateTime"]>;
};

export type InquirySchema = {
  __typename?: "InquirySchema";
  _id: Scalars["ID"];
  id: Scalars["ID"];
  availability?: Maybe<Scalars["String"]>;
  year?: Maybe<Scalars["Int"]>;
  step: Scalars["Int"];
  folder?: Maybe<Scalars["String"]>;
  VIN?: Maybe<Scalars["String"]>;
  refNo?: Maybe<Scalars["String"]>;
  modelCodeShort?: Maybe<Scalars["String"]>;
  coupon?: Maybe<Scalars["String"]>;
  ref?: Maybe<Scalars["String"]>;
  supportTicketId?: Maybe<Scalars["Int"]>;
  consigneeName?: Maybe<Scalars["String"]>;
  consigneeAddress?: Maybe<Scalars["String"]>;
  consigneePhone?: Maybe<Scalars["String"]>;
  consigneeEmail?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  options?: Maybe<Array<Scalars["String"]>>;
  comment?: Maybe<Scalars["String"]>;
  insurance?: Maybe<Scalars["Boolean"]>;
  inspection?: Maybe<Scalars["Boolean"]>;
  isBuyNow?: Maybe<Scalars["Boolean"]>;
  isBNPL?: Maybe<Scalars["Boolean"]>;
  shipping: Scalars["Boolean"];
  transferTwice?: Maybe<Scalars["Boolean"]>;
  showBreakdown: Scalars["Boolean"];
  showShipper?: Maybe<Scalars["Boolean"]>;
  costOffer?: Maybe<Scalars["Float"]>;
  costOfferOriginal?: Maybe<Scalars["Float"]>;
  showKenyaBank: Scalars["Boolean"];
  costFOB?: Maybe<Scalars["Float"]>;
  costInsurance?: Maybe<Scalars["Float"]>;
  costInspection?: Maybe<Scalars["Float"]>;
  costShipping?: Maybe<Scalars["Float"]>;
  costDelivery?: Maybe<Scalars["Float"]>;
  costOptions?: Maybe<Scalars["Float"]>;
  costProtection?: Maybe<Scalars["Float"]>;
  costDiscount?: Maybe<Scalars["Float"]>;
  costBuynowDiscount?: Maybe<Scalars["Float"]>;
  additionalCosts?: Maybe<Scalars["String"]>;
  additionalDesc?: Maybe<Scalars["String"]>;
  documentName?: Maybe<Scalars["String"]>;
  documentAddress?: Maybe<Scalars["String"]>;
  documentPhone?: Maybe<Scalars["String"]>;
  documentEmail?: Maybe<Scalars["String"]>;
  ip?: Maybe<Scalars["String"]>;
  userAgent?: Maybe<Scalars["String"]>;
  user?: Maybe<UserSchema>;
  userId?: Maybe<Scalars["String"]>;
  created: Scalars["DateTime"];
  updated?: Maybe<Scalars["DateTime"]>;
  lastActivityAt?: Maybe<Scalars["DateTime"]>;
  utm_source?: Maybe<Scalars["String"]>;
  utm_medium?: Maybe<Scalars["String"]>;
  utm_campaign?: Maybe<Scalars["String"]>;
  clientId?: Maybe<Scalars["String"]>;
  gclid?: Maybe<Scalars["String"]>;
  platform?: Maybe<Scalars["String"]>;
  reservedUSD?: Maybe<Scalars["Float"]>;
  receivedUSD?: Maybe<Scalars["Float"]>;
  receivedJPY?: Maybe<Scalars["Float"]>;
  exchangeRate: Scalars["Float"];
  nzdRate?: Maybe<Scalars["Float"]>;
  bankCharge: Scalars["Float"];
  serviceCharge: Scalars["Float"];
  serviceChargeTax: Scalars["Float"];
  transferCharge: Scalars["Float"];
  transferChargePublic: Scalars["Float"];
  marginPercentCIF?: Maybe<Scalars["Float"]>;
  releasedAt?: Maybe<Scalars["DateTime"]>;
  actualArrivalDate?: Maybe<Scalars["String"]>;
  reservedUntil?: Maybe<Scalars["DateTime"]>;
  internalNote?: Maybe<Scalars["String"]>;
  referrer?: Maybe<Scalars["String"]>;
  orderGroup?: Maybe<Scalars["Int"]>;
  orderGroupRequester?: Maybe<Scalars["Int"]>;
  experiment?: Maybe<Scalars["Int"]>;
  isTargetCountry: Scalars["Boolean"];
  passRegulation: Scalars["Boolean"];
  isQuality: Scalars["Boolean"];
  read: Scalars["Boolean"];
  important: Scalars["Boolean"];
  hideVIN: Scalars["Boolean"];
  currency: Scalars["String"];
  invoiceAmount?: Maybe<Scalars["Float"]>;
  amountAfterCoupon?: Maybe<Scalars["Float"]>;
  banks?: Maybe<Array<Scalars["String"]>>;
  car?: Maybe<CarSchema>;
  carId?: Maybe<Scalars["String"]>;
  ticket?: Maybe<Ticket>;
  internalTicket?: Maybe<InternalTicketSchema>;
  ticketNo?: Maybe<Scalars["Float"]>;
  ticketStatus?: Maybe<Scalars["String"]>;
  paypalAmount?: Maybe<Scalars["Float"]>;
  inquiryCount?: Maybe<Scalars["Int"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  paypal?: Maybe<PaypalInquiry>;
  stats?: Maybe<InquiryStatSchema>;
  tags?: Maybe<Array<InquiryTag>>;
  ETA?: Maybe<Scalars["String"]>;
  ETD?: Maybe<Scalars["String"]>;
  vesselName?: Maybe<Scalars["String"]>;
  trackingShip?: Maybe<TrackingShip>;
  currencySymbol?: Maybe<Scalars["String"]>;
  company?: Maybe<CompanySchema>;
  companyId?: Maybe<Scalars["String"]>;
  addonServices?: Maybe<Array<AddonServiceSchema>>;
  addonServiceIds?: Maybe<Array<Scalars["String"]>>;
  sellerFOB?: Maybe<Scalars["Float"]>;
  customCosts?: Maybe<Array<CustomCostSchema>>;
  costService?: Maybe<Scalars["Float"]>;
  paymentJPY?: Maybe<Scalars["Float"]>;
  saleEvents?: Maybe<Array<SaleEventSchema>>;
  documents?: Maybe<Array<InquiryDocumentSchema>>;
  extra?: Maybe<InquiryExtraSchema>;
  autoFollowup?: Maybe<InquiryFollowupSchema>;
  sendSMSTo?: Maybe<Array<Scalars["String"]>>;
  feedback?: Maybe<SatisfactionSchema>;
  sellerTakenOver: Scalars["Boolean"];
  sellerNotificationRecipients: Array<InternalTicketUserSchema>;
};

export type InquiryStatSchema = {
  __typename?: "InquiryStatSchema";
  lastAgentAnswerAt?: Maybe<Scalars["DateTime"]>;
  lastAgentCalledAt?: Maybe<Scalars["DateTime"]>;
  buyerRepliedTimes?: Maybe<Scalars["Float"]>;
  lastBuyerRepliedAt?: Maybe<Scalars["DateTime"]>;
  agentReplyTimes?: Maybe<Scalars["Float"]>;
  waitAvgMins?: Maybe<Scalars["Float"]>;
  negoType?: Maybe<Scalars["String"]>;
  carRanks?: Maybe<Scalars["JSON"]>;
  numberOfUserInquiry?: Maybe<Scalars["Float"]>;
  numberOfUserPayment?: Maybe<Scalars["Float"]>;
  numberOfCarInquiry?: Maybe<Scalars["Float"]>;
  numberOfViewCarBefore?: Maybe<Scalars["Float"]>;
};

export type InquiryTag = {
  __typename?: "InquiryTag";
  name?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type InquiryTagHistoriesArgs = {
  invoiceId: Scalars["String"];
};

export type InquiryTagHistorySchema = {
  __typename?: "InquiryTagHistorySchema";
  _id: Scalars["String"];
  name: Scalars["String"];
  tagCreatedAt?: Maybe<Scalars["DateTime"]>;
  toStatus?: Maybe<Scalars["String"]>;
  fromStep?: Maybe<Scalars["Int"]>;
  removedBy?: Maybe<Scalars["String"]>;
  removedAt: Scalars["DateTime"];
};

export type InquiryTagSchema = {
  __typename?: "InquiryTagSchema";
  name?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type InspectionGradeSchema = {
  __typename?: "InspectionGradeSchema";
  display?: Maybe<Scalars["String"]>;
  original?: Maybe<Scalars["String"]>;
  predict?: Maybe<Scalars["String"]>;
  sortValue?: Maybe<Scalars["Float"]>;
  hasValue?: Maybe<Scalars["Boolean"]>;
};

export type InterestingModelIds = {
  __typename?: "InterestingModelIds";
  id?: Maybe<Scalars["ID"]>;
  count?: Maybe<Scalars["Float"]>;
};

export type InternalTicketSchema = {
  __typename?: "InternalTicketSchema";
  id?: Maybe<Scalars["ID"]>;
  ticketNo: Scalars["Float"];
  subject?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  assigneeId?: Maybe<Scalars["ID"]>;
  emailCcAddresses?: Maybe<Array<Scalars["String"]>>;
  followerIds?: Maybe<Array<Scalars["ID"]>>;
  assignee?: Maybe<InternalTicketUserSchema>;
  followers?: Maybe<Array<InternalTicketUserSchema>>;
  reopenedAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type InternalTicketUserSchema = {
  __typename?: "InternalTicketUserSchema";
  id: Scalars["ID"];
  name?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  avatarUrl?: Maybe<Scalars["String"]>;
};

export enum IntroducerTag {
  KOL = "KOL"
}

export type InviteCompanyDataInput = {
  email: Scalars["String"];
  companyId: Scalars["String"];
};

export enum InvoiceCallRecipient {
  BUYER = "BUYER",
  CONSIGNEE = "CONSIGNEE"
}

export type InvoiceCallSession = {
  __typename?: "InvoiceCallSession";
  commentId: Scalars["ID"];
  token: Scalars["String"];
  to: Scalars["String"];
  expiresAt: Scalars["DateTime"];
};

export type InvoiceCertificateSchema = {
  __typename?: "InvoiceCertificateSchema";
  _id?: Maybe<Scalars["ID"]>;
  createdAt?: Maybe<Scalars["Float"]>;
  updatedAt?: Maybe<Scalars["Float"]>;
  no?: Maybe<Scalars["String"]>;
  refNo?: Maybe<Scalars["String"]>;
  registrationNo?: Maybe<Scalars["String"]>;
  lastRegistrationYear?: Maybe<Scalars["String"]>;
  lastRegistrationMonth?: Maybe<Scalars["String"]>;
  lastRegistrationDay?: Maybe<Scalars["String"]>;
  firstRegistrationYear?: Maybe<Scalars["String"]>;
  firstRegistrationMonth?: Maybe<Scalars["String"]>;
  firstRegistrationDay?: Maybe<Scalars["String"]>;
  vin?: Maybe<Scalars["String"]>;
  makeName?: Maybe<Scalars["String"]>;
  modelCode?: Maybe<Scalars["String"]>;
  engineModel?: Maybe<Scalars["String"]>;
  ownerName?: Maybe<Scalars["String"]>;
  ownerAddress?: Maybe<Scalars["String"]>;
  principal?: Maybe<Scalars["String"]>;
  userName?: Maybe<Scalars["String"]>;
  userAddress?: Maybe<Scalars["String"]>;
  shapeOfVehicle?: Maybe<Scalars["String"]>;
  classificationFuel?: Maybe<Scalars["String"]>;
  totalEmission?: Maybe<Scalars["String"]>;
  classificationSize?: Maybe<Scalars["String"]>;
  useOfVehicle?: Maybe<Scalars["String"]>;
  purposeOfUse?: Maybe<Scalars["String"]>;
  capacity?: Maybe<Scalars["String"]>;
  carryingCapacity?: Maybe<Scalars["String"]>;
  weightVehicle?: Maybe<Scalars["String"]>;
  maximumGrossWeight?: Maybe<Scalars["String"]>;
  speNo?: Maybe<Scalars["String"]>;
  classNo?: Maybe<Scalars["String"]>;
  ffWeight?: Maybe<Scalars["String"]>;
  frWeight?: Maybe<Scalars["String"]>;
  rfWeight?: Maybe<Scalars["String"]>;
  rrWeight?: Maybe<Scalars["String"]>;
  vehicleLength?: Maybe<Scalars["String"]>;
  vehicleWidth?: Maybe<Scalars["String"]>;
  vehicleHeight?: Maybe<Scalars["String"]>;
  dateExportYear?: Maybe<Scalars["String"]>;
  dateExportMonth?: Maybe<Scalars["String"]>;
  dateExportDay?: Maybe<Scalars["String"]>;
  scheduledExportingYear?: Maybe<Scalars["String"]>;
  scheduledExportingMonth?: Maybe<Scalars["String"]>;
  scheduledExportingDay?: Maybe<Scalars["String"]>;
  stamp?: Maybe<Scalars["Boolean"]>;
  remarks?: Maybe<Scalars["String"]>;
};

export type InvoiceCommentAttachmentSchema = {
  __typename?: "InvoiceCommentAttachmentSchema";
  file_name?: Maybe<Scalars["String"]>;
  content_url?: Maybe<Scalars["String"]>;
  content_type?: Maybe<Scalars["String"]>;
};

export type InvoiceCommentAuthorSchema = {
  __typename?: "InvoiceCommentAuthorSchema";
  userId?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  avatarUrl?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
};

export type InvoiceCommentCallSchema = {
  __typename?: "InvoiceCommentCallSchema";
  direction?: Maybe<Scalars["String"]>;
  to: Scalars["String"];
  from: Scalars["String"];
  status: Scalars["String"];
  callSid?: Maybe<Scalars["String"]>;
  duration?: Maybe<Scalars["Int"]>;
  recordingStatus?: Maybe<Scalars["String"]>;
  recordingDuration?: Maybe<Scalars["Int"]>;
};

export type InvoiceCommentSchema = {
  __typename?: "InvoiceCommentSchema";
  call?: Maybe<InvoiceCommentCallSchema>;
  url?: Maybe<Scalars["String"]>;
  _id?: Maybe<Scalars["ID"]>;
  id?: Maybe<Scalars["Float"]>;
  type?: Maybe<Scalars["String"]>;
  body?: Maybe<Scalars["String"]>;
  html_body?: Maybe<Scalars["String"]>;
  plain_body?: Maybe<Scalars["String"]>;
  public?: Maybe<Scalars["Boolean"]>;
  author?: Maybe<InvoiceCommentAuthorSchema>;
  attachments?: Maybe<Array<InvoiceCommentAttachmentSchema>>;
  created_at?: Maybe<Scalars["String"]>;
  senderWarning?: Maybe<SenderWarningSchema>;
};

export type InvoiceDashboardCountryBuyer = {
  __typename?: "InvoiceDashboardCountryBuyer";
  user?: Maybe<Scalars["String"]>;
  isQuality?: Maybe<Scalars["Boolean"]>;
};

export type InvoiceDashboardCountryRow = {
  __typename?: "InvoiceDashboardCountryRow";
  _id?: Maybe<Scalars["String"]>;
  inquiry: Scalars["Int"];
  qualityInquiry: Scalars["Int"];
  buyers: Array<InvoiceDashboardCountryBuyer>;
  invoices: Scalars["Int"];
  sales: Scalars["Int"];
};

export type InvoiceDashboardFiltersInput = {
  from: Scalars["DateTime"];
};

export type InvoiceDashboardPeriodStat = {
  __typename?: "InvoiceDashboardPeriodStat";
  current: Scalars["Float"];
  lastMonth: Scalars["Float"];
};

export type InvoiceDashboardStatsSchema = {
  __typename?: "InvoiceDashboardStatsSchema";
  inquiries: InvoiceDashboardPeriodStat;
  invoices: InvoiceDashboardPeriodStat;
  payments: InvoiceDashboardPeriodStat;
  revenue: InvoiceDashboardPeriodStat;
};

export type InvoiceDashboardSummarySchema = {
  __typename?: "InvoiceDashboardSummarySchema";
  countNeedUpdate: Scalars["Int"];
  issueInvoice: Array<InquirySchema>;
  totalIssueInvoice: Scalars["Int"];
  confirmPayment: Array<InquirySchema>;
  totalConfirmPayment: Scalars["Int"];
  sharedShippingSchedule: Array<InquirySchema>;
  totalSharedShippingSchedule: Scalars["Int"];
  sharedBLCopy: Array<InquirySchema>;
  totalSharedBLCopy: Scalars["Int"];
};

export type InvoiceDriveInfoSchema = {
  __typename?: "InvoiceDriveInfoSchema";
  folderId: Scalars["String"];
  folderName: Scalars["String"];
  folderPath: Scalars["String"];
  datePrefix: Scalars["String"];
  items: Array<DriveItemSchema>;
};

export type InvoiceIncomingCallToken = {
  __typename?: "InvoiceIncomingCallToken";
  token: Scalars["String"];
  expiresAt: Scalars["DateTime"];
};

export type InvoiceLoggingEntry = {
  __typename?: "InvoiceLoggingEntry";
  id: Scalars["String"];
  target: Scalars["String"];
  type: Scalars["String"];
  operator?: Maybe<Scalars["String"]>;
  ip?: Maybe<Scalars["String"]>;
  user?: Maybe<Scalars["String"]>;
  payload?: Maybe<Scalars["JSON"]>;
  before?: Maybe<Scalars["JSON"]>;
  after?: Maybe<Scalars["JSON"]>;
  succeed: Scalars["Boolean"];
  tags?: Maybe<Array<Scalars["String"]>>;
  createdAt: Scalars["DateTime"];
};

export type InvoicePagingSchema = {
  __typename?: "InvoicePagingSchema";
  nodes?: Maybe<Array<InquirySchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type IssueInvoiceArgs = {
  invoiceId: Scalars["String"];
  message?: Maybe<Scalars["String"]>;
  dontNotifySeller?: Maybe<Scalars["Boolean"]>;
  dontNotifyBuyer?: Maybe<Scalars["Boolean"]>;
  reissue?: Maybe<Scalars["Boolean"]>;
};

export type IssuePaypalArgs = {
  invoiceId: Scalars["String"];
  options?: Maybe<IssuePaypalOptions>;
};

export type IssuePaypalOptions = {
  sendEmailToCustomer?: Maybe<Scalars["Boolean"]>;
  sendEmailToInternalTeam?: Maybe<Scalars["Boolean"]>;
};

export type JoinVipClubInput = {
  email: Scalars["String"];
  name: Scalars["String"];
  country: Scalars["String"];
};

export type LandingTagAdminResult = {
  __typename?: "LandingTagAdminResult";
  tags: Array<LandingTagSchema>;
  total: Scalars["Int"];
};

export type LandingTagSchema = {
  __typename?: "LandingTagSchema";
  id?: Maybe<Scalars["ID"]>;
  key: Scalars["String"];
  bodyTypes?: Maybe<Array<Scalars["Int"]>>;
  fuelTypes?: Maybe<Array<Scalars["Int"]>>;
  driveTypes?: Maybe<Array<Scalars["Int"]>>;
  transmissions?: Maybe<Array<Scalars["Int"]>>;
  steerings?: Maybe<Array<Scalars["Int"]>>;
  exteriorColors?: Maybe<Array<Scalars["Int"]>>;
  accessories?: Maybe<Array<AccessorySchema>>;
  accessoryIds?: Maybe<Array<Scalars["ID"]>>;
  minPrice?: Maybe<Scalars["Int"]>;
  maxPrice?: Maybe<Scalars["Int"]>;
  minDisplacement?: Maybe<Scalars["Int"]>;
  maxDisplacement?: Maybe<Scalars["Int"]>;
  minYear?: Maybe<Scalars["Int"]>;
  maxYear?: Maybe<Scalars["Int"]>;
  models?: Maybe<Array<ModelSchema>>;
  modelIds?: Maybe<Array<Scalars["ID"]>>;
  description: Scalars["String"];
  heading?: Maybe<Scalars["String"]>;
  published: Scalars["Boolean"];
  saleTags?: Maybe<Array<SaleTagSchema>>;
  saleTagIds?: Maybe<Array<Scalars["ID"]>>;
};

export type LikeInput = {
  car: Scalars["String"];
  status: Scalars["Float"];
};

export type LikeSchema = {
  __typename?: "LikeSchema";
  user: Scalars["String"];
  car: Scalars["String"];
  _user?: Maybe<UserSchema>;
  userId?: Maybe<Scalars["ID"]>;
  _car?: Maybe<CarSchema>;
  carId?: Maybe<Scalars["ID"]>;
  status: LikeStatus;
  created: Scalars["DateTime"];
  modifiedAt: Scalars["DateTime"];
};

export enum LikeStatus {
  LIKE = "LIKE",
  UNLIKED = "UNLIKED"
}

export type ListingMetaDto = {
  id?: Maybe<Scalars["String"]>;
  path?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  isUpdated?: Maybe<Scalars["Boolean"]>;
  ogImage?: Maybe<OgImageDto>;
};

export type LlmOutputSchema = {
  __typename?: "LLMOutputSchema";
  auction_sheet?: Maybe<AuctionSheetDataSchema>;
  ai_summary?: Maybe<Scalars["String"]>;
};

export type LocalPageImageInput = {
  filename: Scalars["String"];
  cdnUri?: Maybe<Scalars["String"]>;
  checksum?: Maybe<Scalars["String"]>;
};

export enum LocalPageImageType {
  localPage = "localPage",
  localPageBanner = "localPageBanner"
}

export type LoginByEmailTokenInput = {
  userId: Scalars["String"];
  key: Scalars["String"];
  expire: Scalars["String"];
};

export type LoginInput = {
  email: Scalars["String"];
  password: Scalars["String"];
};

export type MacroPlaceholderSchema = {
  __typename?: "MacroPlaceholderSchema";
  path: Scalars["String"];
  group: Scalars["String"];
  label: Scalars["String"];
};

export type MacroTicketDraftInput = {
  name?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  subject?: Maybe<Scalars["String"]>;
  assignToMe?: Maybe<Scalars["Boolean"]>;
};

export type MacroValidationResultSchema = {
  __typename?: "MacroValidationResultSchema";
  valid: Scalars["Boolean"];
  unknownPaths: Array<Scalars["String"]>;
  syntaxError?: Maybe<Scalars["String"]>;
};

export type MakeInputDto = {
  name: Scalars["String"];
  key: Scalars["String"];
  locked?: Maybe<Scalars["Boolean"]>;
  alias?: Maybe<Scalars["String"]>;
};

export type MakeSchema = {
  __typename?: "MakeSchema";
  id: Scalars["ID"];
  _id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  key?: Maybe<Scalars["String"]>;
  alias?: Maybe<MakeSchema>;
  aliasId?: Maybe<Scalars["String"]>;
  carCount: Scalars["Int"];
  overview?: Maybe<Scalars["String"]>;
  published?: Maybe<Scalars["Boolean"]>;
  image?: Maybe<MediaSchema>;
  locked?: Maybe<Scalars["Boolean"]>;
};

export type MakesParamsInput = {
  hasCar?: Maybe<Scalars["Boolean"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type McpAuditLogSchema = {
  __typename?: "McpAuditLogSchema";
  id: Scalars["ID"];
  keyId: Scalars["String"];
  userId: Scalars["String"];
  tool: Scalars["String"];
  domain: Scalars["String"];
  inputSummary: Scalars["String"];
  status: Scalars["String"];
  errorCode?: Maybe<Scalars["String"]>;
  durationMs: Scalars["Float"];
  createdAt: Scalars["DateTime"];
};

export type McpAuditLogsInput = {
  keyId?: Maybe<Scalars["String"]>;
  userId?: Maybe<Scalars["String"]>;
  tool?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  fromDate?: Maybe<Scalars["DateTime"]>;
  toDate?: Maybe<Scalars["DateTime"]>;
};

export type McpAuditLogsPaginatedSchema = {
  __typename?: "McpAuditLogsPaginatedSchema";
  items: Array<McpAuditLogSchema>;
  total: Scalars["Float"];
};

export type McpKeySchema = {
  __typename?: "McpKeySchema";
  _id?: Maybe<Scalars["ID"]>;
  id?: Maybe<Scalars["String"]>;
  name: Scalars["String"];
  keyPrefix: Scalars["String"];
  permission: Scalars["String"];
  scopes: Array<Scalars["String"]>;
  isActive: Scalars["Boolean"];
  createdAt: Scalars["DateTime"];
  expiresAt: Scalars["DateTime"];
  lastUsedAt?: Maybe<Scalars["DateTime"]>;
};

export type MediaInput = {
  filename?: Maybe<Scalars["String"]>;
  checksum?: Maybe<Scalars["String"]>;
  cdnUri?: Maybe<Scalars["String"]>;
  externalUrl?: Maybe<Scalars["String"]>;
  original?: Maybe<Scalars["String"]>;
  mime?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["Int"]>;
};

export type MediaSchema = {
  __typename?: "MediaSchema";
  filename?: Maybe<Scalars["String"]>;
  checksum?: Maybe<Scalars["String"]>;
  cdnUri?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["Float"]>;
  original?: Maybe<Scalars["String"]>;
  mime?: Maybe<Scalars["String"]>;
  externalUrl?: Maybe<Scalars["String"]>;
  rejected?: Maybe<Scalars["Boolean"]>;
  _id?: Maybe<Scalars["ID"]>;
  id?: Maybe<Scalars["ID"]>;
  isHD?: Maybe<Scalars["Boolean"]>;
};

export type MetaSchema = {
  __typename?: "MetaSchema";
  title?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  ogImage?: Maybe<OgImage>;
};

export type ModelCarCount = {
  __typename?: "ModelCarCount";
  id: Scalars["String"];
  count: Scalars["Int"];
};

export type ModelGroup = {
  __typename?: "ModelGroup";
  _id?: Maybe<Scalars["String"]>;
  models?: Maybe<Array<Scalars["JSON"]>>;
};

export type ModelInputDto = {
  make: Scalars["ID"];
  name: Scalars["String"];
  key: Scalars["String"];
  locked?: Maybe<Scalars["Boolean"]>;
  alias?: Maybe<Scalars["ID"]>;
};

export type ModelSchema = {
  __typename?: "ModelSchema";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  make?: Maybe<MakeSchema>;
  makeId?: Maybe<Scalars["ID"]>;
  key?: Maybe<Scalars["String"]>;
  makeModelKey?: Maybe<Scalars["String"]>;
  overview?: Maybe<Scalars["String"]>;
  published?: Maybe<Scalars["Boolean"]>;
  alias?: Maybe<ModelSchema>;
  aliasId?: Maybe<Scalars["ID"]>;
  carCount?: Maybe<Scalars["Int"]>;
  locked?: Maybe<Scalars["Boolean"]>;
};

export type ModelSpecResult = {
  __typename?: "ModelSpecResult";
  modelspecs?: Maybe<Array<Maybe<ModelSpecSchema>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type ModelSpecSchema = {
  __typename?: "ModelSpecSchema";
  id?: Maybe<Scalars["ID"]>;
  model?: Maybe<ModelSchema>;
  modelCode?: Maybe<Scalars["String"]>;
  year?: Maybe<Scalars["Int"]>;
  bodyType?: Maybe<Scalars["Int"]>;
  door?: Maybe<Scalars["Int"]>;
  driveType?: Maybe<Scalars["Int"]>;
  displacement?: Maybe<Scalars["Int"]>;
  fuelType?: Maybe<Scalars["Int"]>;
  vehicleWidth?: Maybe<Scalars["Int"]>;
  vehicleLength?: Maybe<Scalars["Int"]>;
  vehicleHeight?: Maybe<Scalars["Int"]>;
  keywords?: Maybe<Scalars["String"]>;
  lock?: Maybe<Scalars["Boolean"]>;
};

export type ModelTrendSchema = {
  __typename?: "ModelTrendSchema";
  makeId?: Maybe<Scalars["ID"]>;
  modelId?: Maybe<Scalars["ID"]>;
  count?: Maybe<Scalars["Float"]>;
  make?: Maybe<MakeSchema>;
  model?: Maybe<ModelSchema>;
};

export type Mutation = {
  __typename?: "Mutation";
  updateCar?: Maybe<CarSchema>;
  crawlCar?: Maybe<CarSchema>;
  removeCarImages?: Maybe<CarSchema>;
  addCarImages?: Maybe<CarSchema>;
  setCountryScore: Scalars["Boolean"];
  exportCompanyCarData: ExportCompanyCarDataResponse;
  batchCars: Array<CarSchema>;
  exportCarsCsv: Scalars["String"];
  upsertModel?: Maybe<ModelSchema>;
  upsertModelSpec?: Maybe<ModelSpecSchema>;
  batchEditModelSpec: Scalars["Boolean"];
  upsertMake: MakeSchema;
  upsertTransformation?: Maybe<TransformationSchema>;
  batchEditTransformation: Scalars["Boolean"];
  deleteTransformation?: Maybe<Scalars["ID"]>;
  likeCar?: Maybe<LikeSchema>;
  unlikeCar?: Maybe<LikeSchema>;
  countUpViewCar: Scalars["Boolean"];
  upsertCompany: CompanyAdminType;
  uploadImageCompany: MediaSchema;
  uploadFileCompany: MediaSchema;
  inviteCompany: CompanyAdminType;
  removeMember: CompanyMemberType;
  uncloneStock?: Maybe<CompanyAdminType>;
  cloneStock?: Maybe<CompanyAdminType>;
  unlistAll: Scalars["Boolean"];
  sendSellersNotification: Scalars["Boolean"];
  registerExporterCompany: UserSchema;
  uploadImportCSV: CsvSchema;
  retryCSV: Scalars["Boolean"];
  updateSissPickingStock: SissPickingStockSchema;
  upsertBilling: AdminBillingSchema;
  removeBilling: Scalars["ID"];
  resendBilling: Scalars["ID"];
  upsertFreight: AdminFreightSchema;
  deleteFreight: Scalars["ID"];
  editPriority: AdminFreightSchema;
  upsertRegulation: AdminRegulationSchema;
  removeRegulation: Scalars["Boolean"];
  exportOrderManagementCsv: Scalars["String"];
  createPendingOrderManagement: OrderManagementSchema;
  removePendingOrderManagement: OrderManagementSchema;
  updateOrderManagementStats: Array<OrderManagementSchema>;
  upsertCarCostProfit: Scalars["Boolean"];
  setTicketCanaryPercent: TicketCanarySchema;
  createTicketAdmin: TicketRecordSchema;
  replyTicketComment: InvoiceCommentSchema;
  mergeTicket: TicketRecordSchema;
  convertTicketToInquiry: ConvertTicketToInquiryResult;
  setTicketSubject: TicketRecordSchema;
  assignTicket: TicketRecordSchema;
  setTicketFollowers: TicketRecordSchema;
  setTicketEmailCc: TicketRecordSchema;
  setTicketRequester: TicketRecordSchema;
  setTicketStatus: TicketRecordSchema;
  connectGmailInbound: GmailInboundStatusSchema;
  disconnectGmailInbound: GmailInboundStatusSchema;
  upsertInvoiceCertificate: InvoiceCertificateSchema;
  replyTestimonial: SatisfactionSchema;
  modifyFeedback: SatisfactionSchema;
  publishTestimonial: SatisfactionSchema;
  uploadTestimonialImage: Array<MediaSchema>;
  uploadTestimonialVideo: MediaSchema;
  removeTestimonialImages: SatisfactionSchema;
  removeTestimonialVideos: SatisfactionSchema;
  updateForBuyer: SatisfactionSchema;
  saveSatisfactionInvoice: SatisfactionSchema;
  uploadSatisfactionInvoiceImage: Array<MediaSchema>;
  removeSatisfactionInvoiceImage: Array<MediaSchema>;
  voteSatisfaction?: Maybe<VoteFeedbackResult>;
  createInquiry?: Maybe<SentInquiryResponse>;
  createGeneralInquiry?: Maybe<GeneralInquiryResponse>;
  updateBulk: InquirySchema;
  validateCoupon?: Maybe<ValidateCouponResponse>;
  createCoupon: AdminCouponSchema;
  editCoupon: AdminCouponSchema;
  deleteCoupon: Scalars["ID"];
  upsertCarService: AddonServiceSchema;
  sendContactMessage: ContactUsResponse;
  createAutoReplyMessage: AutoReplyMessageSchema;
  updateAutoReplyMessage: AutoReplyMessageSchema;
  deleteAutoReplyMessage: AutoReplyMessageSchema;
  breakEggCampaign: Scalars["Boolean"];
  updateBuyerContact: UpdateBuyerContactSchema;
  updateInvoice: InquirySchema;
  uploadInvoiceDocument: InquirySchema;
  batchInvoicesAction: Array<InquirySchema>;
  askForSupport: AskForSupportSchema;
  setAvailability: InquirySchema;
  issueInvoice: InquirySchema;
  confirmTT: InquirySchema;
  shareShippingSchedule: InquirySchema;
  shareTracking: InquirySchema;
  shareBLCopy: InquirySchema;
  carReceived: InquirySchema;
  cancelOrder: InquirySchema;
  confirmPayment: InquirySchema;
  releaseMoney: InquirySchema;
  changeInquiryCar: InquirySchema;
  setInquiryTicketSubject: InquirySchema;
  setActualArrivalDate: InquirySchema;
  setManualStatus: InquirySchema;
  restoreInquiryTag: InquirySchema;
  issuePaypal: InquirySchema;
  capturePaypal: InquirySchema;
  followUp: InquirySchema;
  uploadInvoiceDocsToDrive: UploadInvoiceDocsToDriveSchema;
  confirmCarAvailability: ConfirmCarAvailabilitySchema;
  createPaypalOrder: CreatePaypalOrderSchema;
  authorizePaypalOrder: PaypalOrderResultSchema;
  verifyPaypalAuthorize: PaypalOrderResultSchema;
  prepareIncomingInvoiceCalls: InvoiceIncomingCallToken;
  invoiceCallPresence: Scalars["Boolean"];
  prepareInvoiceCall: InvoiceCallSession;
  /** Use for buyer to reply comment for invoice */
  buyerReplyComment: ReplyCommentInvoiceSchema;
  /** Use for admin.carfromjapan.com to reply comment for invoice */
  replyCommentInvoice: ReplyCommentInvoiceSchema;
  triggerZendeskSyncBatch: ZendeskSyncJobSchema;
  stopZendeskSyncJob: ZendeskSyncJobSchema;
  resetZendeskSyncJob: ZendeskSyncJobSchema;
  upsertDealerMacro: DealerMacroSchema;
  deleteDealerMacro: DealerMacroSchema;
  createReview: ReviewSchema;
  updateReview: ReviewSchema;
  deleteReview: ReviewSchema;
  updateReviewSummary: ReviewSummarySchema;
  upsertConfiguration?: Maybe<ConfigurationSchema>;
  upsertJoinSweepstakeCampaign: Scalars["Boolean"];
  upsertJoinRedSunCampaign: Scalars["Boolean"];
  joinCFJCampaign: Scalars["Boolean"];
  autoSave?: Maybe<AutoSaveResultSchema>;
  trackCrmEvent: Scalars["Boolean"];
  improveSellerComment: Scalars["String"];
  translateComment: Scalars["String"];
  explainBuyerMessages: Scalars["String"];
  summarizeAllConversation: Scalars["String"];
  createAdminGuide: AdminGuideSchema;
  removeAdminGuide?: Maybe<AdminGuideSchema>;
  editAdminGuide: AdminGuideSchema;
  readAction?: Maybe<Scalars["Boolean"]>;
  updateGuideOrder: Scalars["Boolean"];
  markAllAsRead: Scalars["Boolean"];
  updateAuctionSheetData: AuctionSheetSchema;
  verifyAuctionSheet: AuctionSheetSchema;
  updateAuctionSheetStatus: AuctionSheetSchema;
  toggleVerifyAuctionSheet: AuctionSheetSchema;
  retryAuctionSheet: Scalars["Boolean"];
  setAuctionSheetSyncDisabled: Scalars["Boolean"];
  deleteAuctionSheets: Scalars["Int"];
  createGallery: GallerySchema;
  editGallery: GallerySchema;
  removeGallery?: Maybe<GallerySchema>;
  login: UserSchema;
  localRegister: UserSchema;
  socialLogin: UserSchema;
  resetPassword: Scalars["Boolean"];
  loginByEmailToken: UserSchema;
  verifyEmail: UserSchema;
  deactivateAccount: Scalars["Boolean"];
  loginByImpersonationTicket: UserSchema;
  logout: Scalars["Boolean"];
  renewToken: UserSchema;
  saveProfile: UserSchema;
  changeEmail: Scalars["Boolean"];
  changePassword: UserSchema;
  uploadProfilePicture: UserSchema;
  removeProfilePicture: UserSchema;
  upsertUser?: Maybe<UserSchema>;
  createImpersonationTicket: ImpersonationTicketType;
  createMcpKey: CreateMcpKeyResult;
  revokeMcpKey: Scalars["Boolean"];
  joinVipClub: Scalars["Boolean"];
  saveCampaignEmails: CampaignEmailsSchema;
  setCustomReferralCode: CampaignJoinSchema;
  joinCampaign: CampaignJoinSchema;
  createCampaignAction: CampaignActionSchema;
  createTransactionHistory: TransactionHistorySchema;
  createWithdrawRequest: WithdrawRequestSchema;
  createExpenseRequest: ExpenseRequestSchema;
  updateStateTransactionHistory: TransactionHistorySchema;
  resyncStateCampaignAction: ResyncStateCampaignAction;
  updateStateWithdrawalRequest: WithdrawRequestSchema;
  updateStateExpenseRequest: ExpenseRequestSchema;
  updateIntroducerCommission: CampaignJoinSchema;
  updateIntroducerTags: CampaignJoinSchema;
  upsertCampaign: CampaignSchema;
  exportIntroducer: Scalars["String"];
  activateSellerSmsService: SellerSmsSubscriptionSchema;
  deactivateSellerSmsService: SellerSmsSubscriptionSchema;
  exportSellerSmsLogsCsv: Scalars["String"];
  exportAdminSmsSellersCsv: Scalars["String"];
  exportAdminSmsLogsCsv: Scalars["String"];
  setAdminSellerSmsService: SellerSmsSubscriptionSchema;
  setAdminSmsPaymentStatus: Scalars["Int"];
  resendTrackedEmail: EmailTrackingResendResultSchema;
  upsertBoxtext: BoxtextContentSchema;
  upsertBoxlink: CustomSeoSchema;
  upsertListingMeta: CustomSeoSchema;
  upsertLandingTag: LandingTagSchema;
  deleteLandingTag: LandingTagSchema;
  upsertTag: SaleTagSchema;
  deleteTag?: Maybe<SaleTagSchema>;
  addCarTagByIds: Scalars["Boolean"];
  upsertAd: AdminAdSchema;
  removeAd: Scalars["Boolean"];
  createOrUpdateCountryPage: CountryPageSchema;
  uploadModelImage: MediaSchema;
  removeImage: MediaSchema;
  removeCountryPage: Scalars["ID"];
  upsertSeoFaq: SeoFaqSchema;
  removeSeoFaq: Scalars["Boolean"];
  createShippingAgent: ShippingAgentSchema;
  editShippingAgent: ShippingAgentSchema;
  removeShippingAgent?: Maybe<ShippingAgentSchema>;
  createShippingDelayNote: ShippingDelayNoteSchema;
  editShippingDelayNote: ShippingDelayNoteSchema;
  removeShippingDelayNote?: Maybe<ShippingDelayNoteSchema>;
};

export type MutationUpdateCarArgs = {
  id: Scalars["String"];
  data: Scalars["JSON"];
};

export type MutationCrawlCarArgs = {
  url: Scalars["String"];
  source: CrawlCarSource;
  company?: Maybe<Scalars["String"]>;
};

export type MutationRemoveCarImagesArgs = {
  id: Scalars["String"];
  images: Array<Scalars["String"]>;
};

export type MutationAddCarImagesArgs = {
  id: Scalars["String"];
  files: Array<Scalars["String"]>;
};

export type MutationSetCountryScoreArgs = {
  id: Scalars["String"];
  country: Scalars["String"];
  score: Scalars["Float"];
};

export type MutationExportCompanyCarDataArgs = {
  data: ExportCompanyCarDataInput;
};

export type MutationBatchCarsArgs = {
  ids: Array<Scalars["String"]>;
  action: Scalars["String"];
  data?: Maybe<Scalars["JSON"]>;
};

export type MutationExportCarsCsvArgs = {
  filters?: Maybe<QueryCarsAdminFilters>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type MutationUpsertModelArgs = {
  id?: Maybe<Scalars["ID"]>;
  data: ModelInputDto;
};

export type MutationUpsertModelSpecArgs = {
  id?: Maybe<Scalars["ID"]>;
  data: UpsertModelSpecInput;
};

export type MutationBatchEditModelSpecArgs = {
  ids: Array<Scalars["ID"]>;
  data: BatchEditModelSpecInput;
};

export type MutationUpsertMakeArgs = {
  data: MakeInputDto;
};

export type MutationUpsertTransformationArgs = {
  id?: Maybe<Scalars["ID"]>;
  data: UpsertTransformationInput;
};

export type MutationBatchEditTransformationArgs = {
  ids: Array<Scalars["ID"]>;
  data: BatchEditTransformationInput;
};

export type MutationDeleteTransformationArgs = {
  id: Scalars["ID"];
};

export type MutationLikeCarArgs = {
  input: LikeInput;
};

export type MutationUnlikeCarArgs = {
  input: UnLikeInput;
};

export type MutationCountUpViewCarArgs = {
  input: CountUpViewCarInput;
};

export type MutationUpsertCompanyArgs = {
  id?: Maybe<Scalars["ID"]>;
  data?: Maybe<Scalars["JSON"]>;
};

export type MutationUploadImageCompanyArgs = {
  files: Array<Scalars["String"]>;
};

export type MutationUploadFileCompanyArgs = {
  files: Array<Scalars["String"]>;
};

export type MutationInviteCompanyArgs = {
  data: InviteCompanyDataInput;
};

export type MutationRemoveMemberArgs = {
  id?: Maybe<Scalars["ID"]>;
  idUser?: Maybe<Scalars["ID"]>;
};

export type MutationUncloneStockArgs = {
  data?: Maybe<Scalars["JSON"]>;
};

export type MutationCloneStockArgs = {
  data?: Maybe<Scalars["JSON"]>;
};

export type MutationUnlistAllArgs = {
  companyId: Scalars["ID"];
  status?: Maybe<Scalars["Int"]>;
};

export type MutationSendSellersNotificationArgs = {
  subject: Scalars["String"];
  content: Scalars["String"];
  ids: Array<Scalars["ID"]>;
  attachments?: Maybe<Array<Scalars["JSON"]>>;
};

export type MutationRegisterExporterCompanyArgs = {
  input: RegisterExporterCompanyInput;
};

export type MutationUploadImportCsvArgs = {
  companyId: Scalars["ID"];
  format: Scalars["String"];
  fileKey: Scalars["String"];
  originalFilename: Scalars["String"];
  clearOldCar?: Maybe<Scalars["Boolean"]>;
};

export type MutationRetryCsvArgs = {
  id: Scalars["ID"];
};

export type MutationUpdateSissPickingStockArgs = {
  id: Scalars["ID"];
  input: SissPickingStockUpdateInput;
};

export type MutationUpsertBillingArgs = {
  id?: Maybe<Scalars["ID"]>;
  data: BillingUpsertInput;
};

export type MutationRemoveBillingArgs = {
  id: Scalars["ID"];
};

export type MutationResendBillingArgs = {
  id: Scalars["ID"];
};

export type MutationUpsertFreightArgs = {
  id?: Maybe<Scalars["ID"]>;
  data?: Maybe<UpsertFreightInput>;
  filter?: Maybe<UpsertFreightFilterInput>;
};

export type MutationDeleteFreightArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export type MutationEditPriorityArgs = {
  id?: Maybe<Scalars["ID"]>;
  priority?: Maybe<Scalars["Int"]>;
};

export type MutationUpsertRegulationArgs = {
  id?: Maybe<Scalars["ID"]>;
  data?: Maybe<UpsertRegulationInput>;
};

export type MutationRemoveRegulationArgs = {
  id: Scalars["ID"];
};

export type MutationExportOrderManagementCsvArgs = {
  agentIds?: Maybe<Array<Scalars["String"]>>;
  sellers?: Maybe<Array<Scalars["String"]>>;
  carServices?: Maybe<Array<Scalars["String"]>>;
  destination?: Maybe<Scalars["String"]>;
  steps: Array<Scalars["Float"]>;
  skip: Scalars["Int"];
  take: Scalars["Int"];
  sortBy?: Maybe<Scalars["String"]>;
  orderBy?: Maybe<Scalars["String"]>;
  viewPending?: Maybe<Scalars["Boolean"]>;
  confirmedPaymentStartDate?: Maybe<Scalars["String"]>;
  confirmedPaymentEndDate?: Maybe<Scalars["String"]>;
  createdStartDate?: Maybe<Scalars["String"]>;
  createdEndDate?: Maybe<Scalars["String"]>;
  keywords?: Maybe<Scalars["String"]>;
  coupon?: Maybe<Scalars["String"]>;
  inquiryType?: Maybe<Scalars["String"]>;
  inquiryIds?: Maybe<Array<Scalars["String"]>>;
};

export type MutationCreatePendingOrderManagementArgs = {
  data: CreatePendingOrderManagementLineInput;
};

export type MutationRemovePendingOrderManagementArgs = {
  data: RemovePendingOrderManagementLineInput;
};

export type MutationUpdateOrderManagementStatsArgs = {
  data: UpdateOrderManagementInput;
};

export type MutationUpsertCarCostProfitArgs = {
  data: UpsertCarCostInput;
  inquiryId: Scalars["String"];
};

export type MutationSetTicketCanaryPercentArgs = {
  quality?: Maybe<Scalars["Int"]>;
  nonQuality?: Maybe<Scalars["Int"]>;
};

export type MutationCreateTicketAdminArgs = {
  input: CreateTicketAdminInput;
};

export type MutationReplyTicketCommentArgs = {
  id: Scalars["String"];
  comment: Scalars["String"];
  isPublic?: Maybe<Scalars["Boolean"]>;
  htmlBody?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
};

export type MutationMergeTicketArgs = {
  id: Scalars["String"];
  targetTicketId: Scalars["String"];
};

export type MutationConvertTicketToInquiryArgs = {
  input: ConvertTicketToInquiryInput;
};

export type MutationSetTicketSubjectArgs = {
  id: Scalars["String"];
  subject: Scalars["String"];
};

export type MutationAssignTicketArgs = {
  id: Scalars["String"];
  assigneeUserId?: Maybe<Scalars["String"]>;
};

export type MutationSetTicketFollowersArgs = {
  id: Scalars["String"];
  followerUserIds: Array<Scalars["String"]>;
};

export type MutationSetTicketEmailCcArgs = {
  id: Scalars["String"];
  emailCcAddresses: Array<Scalars["String"]>;
};

export type MutationSetTicketRequesterArgs = {
  id: Scalars["String"];
  input: UpdateTicketRequesterInput;
};

export type MutationSetTicketStatusArgs = {
  id: Scalars["String"];
  status: Scalars["String"];
};

export type MutationConnectGmailInboundArgs = {
  code: Scalars["String"];
};

export type MutationUpsertInvoiceCertificateArgs = {
  data: UpsertInvoiceCertificateArgs;
};

export type MutationReplyTestimonialArgs = {
  id: Scalars["ID"];
  option?: Maybe<Scalars["String"]>;
};

export type MutationModifyFeedbackArgs = {
  id: Scalars["ID"];
  option?: Maybe<Scalars["String"]>;
};

export type MutationPublishTestimonialArgs = {
  id: Scalars["ID"];
  option: Scalars["Boolean"];
};

export type MutationUploadTestimonialImageArgs = {
  id: Scalars["ID"];
  fileKeys: Array<Scalars["String"]>;
};

export type MutationUploadTestimonialVideoArgs = {
  id: Scalars["ID"];
  fileKey: Scalars["String"];
};

export type MutationRemoveTestimonialImagesArgs = {
  id: Scalars["ID"];
  idsImage: Array<Scalars["ID"]>;
};

export type MutationRemoveTestimonialVideosArgs = {
  id: Scalars["ID"];
  idsVideo: Array<Scalars["ID"]>;
};

export type MutationUpdateForBuyerArgs = {
  id: Scalars["ID"];
  option: UpdateForBuyerInput;
};

export type MutationSaveSatisfactionInvoiceArgs = {
  inquiryId: Scalars["ID"];
  input: SaveSatisfactionInput;
};

export type MutationUploadSatisfactionInvoiceImageArgs = {
  inquiryId: Scalars["ID"];
  fileKeys: Array<Scalars["String"]>;
};

export type MutationRemoveSatisfactionInvoiceImageArgs = {
  inquiryId: Scalars["ID"];
  imageId: Scalars["ID"];
};

export type MutationVoteSatisfactionArgs = {
  satisfactionId: Scalars["ID"];
  score: Scalars["Int"];
};

export type MutationCreateInquiryArgs = {
  data: CreateInquiryInput;
};

export type MutationCreateGeneralInquiryArgs = {
  data: CreateGeneralInquiryInput;
};

export type MutationUpdateBulkArgs = {
  action: Scalars["String"];
  id: Scalars["String"];
};

export type MutationValidateCouponArgs = {
  data: ValidateCouponInput;
};

export type MutationEditCouponArgs = {
  id: Scalars["ID"];
  data: Scalars["JSON"];
};

export type MutationDeleteCouponArgs = {
  id: Scalars["ID"];
};

export type MutationUpsertCarServiceArgs = {
  data: AddonServiceDto;
};

export type MutationSendContactMessageArgs = {
  input: ContactUsInput;
};

export type MutationCreateAutoReplyMessageArgs = {
  data: CreateAutoReplyMessageInput;
};

export type MutationUpdateAutoReplyMessageArgs = {
  id: Scalars["ID"];
  data: UpdateAutoReplyMessageInput;
};

export type MutationDeleteAutoReplyMessageArgs = {
  id: Scalars["ID"];
};

export type MutationBreakEggCampaignArgs = {
  carId: Scalars["String"];
};

export type MutationUpdateBuyerContactArgs = {
  input: UpdateBuyerContactArgs;
};

export type MutationUpdateInvoiceArgs = {
  input: UpdateInvoiceArgs;
};

export type MutationUploadInvoiceDocumentArgs = {
  input: UploadInvoiceDocumentArgs;
};

export type MutationBatchInvoicesActionArgs = {
  input: BatchInvoicesActionArgs;
};

export type MutationAskForSupportArgs = {
  input: AskForSupportArgs;
};

export type MutationSetAvailabilityArgs = {
  input: SetAvailabilityArgs;
};

export type MutationIssueInvoiceArgs = {
  input: IssueInvoiceArgs;
};

export type MutationConfirmTtArgs = {
  input: ConfirmTtArgs;
};

export type MutationShareShippingScheduleArgs = {
  input: ShareShippingScheduleArgs;
};

export type MutationShareTrackingArgs = {
  input: ShareTrackingArgs;
};

export type MutationShareBlCopyArgs = {
  input: ShareBlCopyArgs;
};

export type MutationCarReceivedArgs = {
  input: CarReceivedArgs;
};

export type MutationCancelOrderArgs = {
  input: CancelOrderArgs;
};

export type MutationConfirmPaymentArgs = {
  input: ConfirmPaymentArgs;
};

export type MutationReleaseMoneyArgs = {
  input: ReleaseMoneyArgs;
};

export type MutationChangeInquiryCarArgs = {
  input: ChangeInquiryCarInput;
};

export type MutationSetInquiryTicketSubjectArgs = {
  input: SetInquiryTicketSubjectInput;
};

export type MutationSetActualArrivalDateArgs = {
  input: SetActualArrivalDateInput;
};

export type MutationSetManualStatusArgs = {
  input: SetManualStatusArgs;
};

export type MutationRestoreInquiryTagArgs = {
  input: RestoreInquiryTagArgs;
};

export type MutationIssuePaypalArgs = {
  input: IssuePaypalArgs;
};

export type MutationCapturePaypalArgs = {
  input: CapturePaypalArgs;
};

export type MutationFollowUpArgs = {
  input: FollowUpArgs;
};

export type MutationUploadInvoiceDocsToDriveArgs = {
  invoiceIds: Array<Scalars["String"]>;
};

export type MutationConfirmCarAvailabilityArgs = {
  input: ConfirmCarAvailabilityArgs;
};

export type MutationCreatePaypalOrderArgs = {
  input: CreatePaypalOrderArgs;
};

export type MutationAuthorizePaypalOrderArgs = {
  input: AuthorizePaypalOrderArgs;
};

export type MutationVerifyPaypalAuthorizeArgs = {
  input: AuthorizePaypalOrderArgs;
};

export type MutationInvoiceCallPresenceArgs = {
  available: Scalars["Boolean"];
  busy: Scalars["Boolean"];
};

export type MutationPrepareInvoiceCallArgs = {
  input: PrepareInvoiceCallInput;
};

export type MutationBuyerReplyCommentArgs = {
  input: BuyerReplyCommentArgs;
};

export type MutationReplyCommentInvoiceArgs = {
  input: ReplyCommentInvoiceArgs;
};

export type MutationTriggerZendeskSyncBatchArgs = {
  input?: Maybe<TriggerZendeskSyncBatchInput>;
};

export type MutationUpsertDealerMacroArgs = {
  options: UpsertDealerMacroInput;
  id?: Maybe<Scalars["String"]>;
};

export type MutationDeleteDealerMacroArgs = {
  id: Scalars["String"];
};

export type MutationCreateReviewArgs = {
  data: CreateReviewInput;
};

export type MutationUpdateReviewArgs = {
  id: Scalars["ID"];
  data: UpdateReviewInput;
};

export type MutationDeleteReviewArgs = {
  id: Scalars["ID"];
};

export type MutationUpdateReviewSummaryArgs = {
  data: UpdateReviewSummaryInput;
};

export type MutationUpsertConfigurationArgs = {
  id?: Maybe<Scalars["ID"]>;
  data: CreateConfigurationDto;
};

export type MutationUpsertJoinSweepstakeCampaignArgs = {
  email: Scalars["String"];
  interestedFunc: Scalars["String"];
};

export type MutationUpsertJoinRedSunCampaignArgs = {
  email: Scalars["String"];
  name: Scalars["String"];
};

export type MutationJoinCfjCampaignArgs = {
  email: Scalars["String"];
  listId: Scalars["String"];
  type?: Maybe<Scalars["String"]>;
};

export type MutationAutoSaveArgs = {
  input: AutoSaveDto;
};

export type MutationTrackCrmEventArgs = {
  input: TrackCrmEventInput;
};

export type MutationImproveSellerCommentArgs = {
  comment: Scalars["String"];
  buyerName: Scalars["String"];
};

export type MutationTranslateCommentArgs = {
  comment: Scalars["String"];
};

export type MutationExplainBuyerMessagesArgs = {
  buyerMessages: Array<Scalars["String"]>;
  language: Scalars["String"];
};

export type MutationSummarizeAllConversationArgs = {
  conversations: Array<Scalars["String"]>;
  language: Scalars["String"];
};

export type MutationCreateAdminGuideArgs = {
  data: CreateAdminGuideDto;
};

export type MutationRemoveAdminGuideArgs = {
  id: Scalars["String"];
};

export type MutationEditAdminGuideArgs = {
  data: EditAdminGuidetDto;
  id: Scalars["ID"];
};

export type MutationReadActionArgs = {
  docId: Scalars["String"];
};

export type MutationUpdateGuideOrderArgs = {
  doc: DataGuideOrderDto;
};

export type MutationMarkAllAsReadArgs = {
  ids: Array<Scalars["String"]>;
};

export type MutationUpdateAuctionSheetDataArgs = {
  id: Scalars["ID"];
  data: UpdateAuctionSheetInput;
};

export type MutationVerifyAuctionSheetArgs = {
  id: Scalars["ID"];
};

export type MutationUpdateAuctionSheetStatusArgs = {
  id: Scalars["ID"];
  status: Scalars["String"];
};

export type MutationToggleVerifyAuctionSheetArgs = {
  id: Scalars["ID"];
};

export type MutationRetryAuctionSheetArgs = {
  id: Scalars["ID"];
};

export type MutationSetAuctionSheetSyncDisabledArgs = {
  disabled: Scalars["Boolean"];
  expiredAt?: Scalars["Int"];
};

export type MutationDeleteAuctionSheetsArgs = {
  ids: Array<Scalars["ID"]>;
};

export type MutationCreateGalleryArgs = {
  data: CreateGalleryDto;
};

export type MutationEditGalleryArgs = {
  data: EditGalleryDto;
  id: Scalars["ID"];
};

export type MutationRemoveGalleryArgs = {
  id: Scalars["String"];
};

export type MutationLoginArgs = {
  input: LoginInput;
};

export type MutationLocalRegisterArgs = {
  input: RegisterInput;
};

export type MutationSocialLoginArgs = {
  input: SocialLoginInput;
};

export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};

export type MutationLoginByEmailTokenArgs = {
  input: LoginByEmailTokenInput;
};

export type MutationVerifyEmailArgs = {
  input: VerifyEmailInput;
};

export type MutationDeactivateAccountArgs = {
  input: DeactivateAccountInput;
};

export type MutationLoginByImpersonationTicketArgs = {
  token: Scalars["String"];
};

export type MutationSaveProfileArgs = {
  input: SaveProfileInput;
};

export type MutationChangeEmailArgs = {
  input: ChangeEmailInput;
};

export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};

export type MutationUploadProfilePictureArgs = {
  input: UploadProfilePictureInput;
};

export type MutationRemoveProfilePictureArgs = {
  input?: Maybe<RemoveProfilePictureInput>;
};

export type MutationUpsertUserArgs = {
  id?: Maybe<Scalars["ID"]>;
  data: UserInputDto;
};

export type MutationCreateImpersonationTicketArgs = {
  email: Scalars["String"];
};

export type MutationCreateMcpKeyArgs = {
  input: CreateMcpKeyInput;
};

export type MutationRevokeMcpKeyArgs = {
  keyId: Scalars["ID"];
};

export type MutationJoinVipClubArgs = {
  input: JoinVipClubInput;
};

export type MutationSaveCampaignEmailsArgs = {
  input: SaveCampaignEmailsInput;
};

export type MutationSetCustomReferralCodeArgs = {
  data: SetCustomReferralCodeInput;
};

export type MutationJoinCampaignArgs = {
  data: CreateCampaignJoinDto;
};

export type MutationCreateCampaignActionArgs = {
  data: CreateCampaignActionDto;
};

export type MutationCreateTransactionHistoryArgs = {
  data: CreateTransactionHistoryDto;
};

export type MutationCreateWithdrawRequestArgs = {
  data: CreateWithdrawRequestDto;
};

export type MutationCreateExpenseRequestArgs = {
  data: CreateExpenseRequestDto;
};

export type MutationResyncStateCampaignActionArgs = {
  orderId: Scalars["String"];
};

export type MutationUpdateStateWithdrawalRequestArgs = {
  id: Scalars["ID"];
  data: EditWithdrawalRequestDto;
};

export type MutationUpdateStateExpenseRequestArgs = {
  id: Scalars["ID"];
  data: EditExpenseRequestDto;
};

export type MutationUpdateIntroducerCommissionArgs = {
  data: UpdateIntroducerCommissionInput;
};

export type MutationUpdateIntroducerTagsArgs = {
  data: UpdateIntroducerTagsInput;
};

export type MutationUpsertCampaignArgs = {
  data: CampaignInputDto;
};

export type MutationExportIntroducerArgs = {
  fromDate?: Maybe<Scalars["DateTime"]>;
  toDate?: Maybe<Scalars["DateTime"]>;
  referralCode?: Maybe<Scalars["String"]>;
  introducerEmail?: Maybe<Scalars["String"]>;
  introducerName?: Maybe<Scalars["String"]>;
  tag?: Maybe<Scalars["String"]>;
  skip: Scalars["Int"];
  take: Scalars["Int"];
  sortBy?: Maybe<Scalars["String"]>;
  orderBy?: Maybe<Scalars["String"]>;
};

export type MutationActivateSellerSmsServiceArgs = {
  companyId: Scalars["ID"];
};

export type MutationDeactivateSellerSmsServiceArgs = {
  companyId: Scalars["ID"];
};

export type MutationExportSellerSmsLogsCsvArgs = {
  companyId: Scalars["ID"];
  month: Scalars["String"];
};

export type MutationExportAdminSmsSellersCsvArgs = {
  dateFrom?: Maybe<Scalars["String"]>;
  dateTo?: Maybe<Scalars["String"]>;
  search?: Maybe<Scalars["String"]>;
  status?: Maybe<AdminSmsSellerStatus>;
  paymentStatus?: Maybe<SmsPaymentStatus>;
  sortBy?: Maybe<AdminSmsSellerSort>;
  sortOrder?: Maybe<AdminSortOrder>;
};

export type MutationExportAdminSmsLogsCsvArgs = {
  dateFrom?: Maybe<Scalars["String"]>;
  dateTo?: Maybe<Scalars["String"]>;
  companyId?: Maybe<Scalars["ID"]>;
  search?: Maybe<Scalars["String"]>;
  status?: Maybe<AdminSmsDeliveryStatus>;
};

export type MutationSetAdminSellerSmsServiceArgs = {
  companyId: Scalars["ID"];
  active: Scalars["Boolean"];
  note: Scalars["String"];
};

export type MutationSetAdminSmsPaymentStatusArgs = {
  companyIds: Array<Scalars["ID"]>;
  month: Scalars["String"];
  status: SmsPaymentStatus;
};

export type MutationResendTrackedEmailArgs = {
  id: Scalars["String"];
};

export type MutationUpsertBoxtextArgs = {
  data: BoxtextDto;
};

export type MutationUpsertBoxlinkArgs = {
  data: BoxlinkDto;
};

export type MutationUpsertListingMetaArgs = {
  data: ListingMetaDto;
};

export type MutationUpsertLandingTagArgs = {
  id?: Maybe<Scalars["ID"]>;
  data: UpsertLandingTagInput;
};

export type MutationDeleteLandingTagArgs = {
  id: Scalars["ID"];
};

export type MutationUpsertTagArgs = {
  id?: Maybe<Scalars["ID"]>;
  options?: Maybe<UpsertSaleTagInput>;
};

export type MutationDeleteTagArgs = {
  id: Scalars["ID"];
};

export type MutationAddCarTagByIdsArgs = {
  ids: Scalars["String"];
  key: Scalars["String"];
};

export type MutationUpsertAdArgs = {
  id?: Maybe<Scalars["ID"]>;
  data: UpsertAdInput;
};

export type MutationRemoveAdArgs = {
  id: Scalars["ID"];
};

export type MutationCreateOrUpdateCountryPageArgs = {
  params?: Maybe<CreateOrUpdateCountryPageInput>;
};

export type MutationUploadModelImageArgs = {
  fileKey: Scalars["String"];
  params?: Maybe<UploadModelImageParamsInput>;
};

export type MutationRemoveImageArgs = {
  file: LocalPageImageInput;
};

export type MutationRemoveCountryPageArgs = {
  id: Scalars["ID"];
};

export type MutationUpsertSeoFaqArgs = {
  data: SeoFaqDto;
};

export type MutationRemoveSeoFaqArgs = {
  id: Scalars["String"];
};

export type MutationCreateShippingAgentArgs = {
  data: CreateShippingAgentDto;
};

export type MutationEditShippingAgentArgs = {
  data: EditShippingAgentDto;
  id: Scalars["ID"];
};

export type MutationRemoveShippingAgentArgs = {
  id: Scalars["String"];
};

export type MutationCreateShippingDelayNoteArgs = {
  data: CreateShippingDelayNoteDto;
};

export type MutationEditShippingDelayNoteArgs = {
  id: Scalars["ID"];
  data: EditShippingDelayNoteDto;
};

export type MutationRemoveShippingDelayNoteArgs = {
  id: Scalars["ID"];
};

export type MyInquiriesSchema = {
  __typename?: "MyInquiriesSchema";
  invoicePagingSchema?: Maybe<InvoicePagingSchema>;
  totalPending?: Maybe<Scalars["Int"]>;
};

export type MyPendingStatsSchema = {
  __typename?: "MyPendingStatsSchema";
  totalPendingInquiries: Scalars["Int"];
  totalPendingOrders: Scalars["Int"];
};

export type NotifyMethod = {
  __typename?: "NotifyMethod";
  email: Scalars["Boolean"];
  sms: Scalars["Boolean"];
};

export type NotifyMethodDto = {
  email?: Maybe<Scalars["Boolean"]>;
  sms?: Maybe<Scalars["Boolean"]>;
};

export type OfferSchema = {
  __typename?: "OfferSchema";
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  priceUSD?: Maybe<Scalars["Float"]>;
  protectionUSD?: Maybe<Scalars["Float"]>;
  deliveryUSD?: Maybe<Scalars["Float"]>;
  shippingUSD?: Maybe<Scalars["Float"]>;
  inspectionUSD?: Maybe<Scalars["Float"]>;
  insuranceUSD?: Maybe<Scalars["Float"]>;
  passRegulation?: Maybe<Scalars["Boolean"]>;
  shippingMethod?: Maybe<Scalars["String"]>;
  isTargetCountry?: Maybe<Scalars["Boolean"]>;
  ETD?: Maybe<Scalars["DateTime"]>;
  ETA?: Maybe<Scalars["DateTime"]>;
  shipName?: Maybe<Scalars["String"]>;
  inspection?: Maybe<Scalars["Boolean"]>;
  inspectionName?: Maybe<Scalars["String"]>;
  bndUSD?: Maybe<Scalars["Float"]>;
  bndLimitedUSD?: Maybe<Scalars["Float"]>;
  guarantee?: Maybe<Scalars["Boolean"]>;
  deliveryMethod?: Maybe<Scalars["String"]>;
};

export type OgImage = {
  __typename?: "OgImage";
  original?: Maybe<Scalars["String"]>;
  filename?: Maybe<Scalars["String"]>;
  mime?: Maybe<Scalars["String"]>;
  checksum?: Maybe<Scalars["String"]>;
  cdnUri?: Maybe<Scalars["String"]>;
  externalUrl?: Maybe<Scalars["String"]>;
};

export type OgImageDto = {
  _id?: Maybe<Scalars["String"]>;
  cdnUri?: Maybe<Scalars["String"]>;
  checksum?: Maybe<Scalars["String"]>;
  externalUrl?: Maybe<Scalars["String"]>;
  filename?: Maybe<Scalars["String"]>;
  mime?: Maybe<Scalars["String"]>;
  original?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["Float"]>;
  rejected?: Maybe<Scalars["Boolean"]>;
};

export type OptionInput = {
  name?: Maybe<Scalars["String"]>;
  priceUSD?: Maybe<Scalars["Float"]>;
};

export type OrderDetail = {
  __typename?: "OrderDetail";
  buyerEmail?: Maybe<Scalars["String"]>;
  orderId?: Maybe<Scalars["ID"]>;
  inquiryNo?: Maybe<Scalars["Float"]>;
  step?: Maybe<Scalars["Float"]>;
};

export type OrderManagementPagingSchema = {
  __typename?: "OrderManagementPagingSchema";
  nodes?: Maybe<Array<OrderManagementSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type OrderManagementSchema = {
  __typename?: "OrderManagementSchema";
  id: Scalars["ID"];
  coupon?: Maybe<Scalars["String"]>;
  couponValue?: Maybe<Scalars["Float"]>;
  VIN?: Maybe<Scalars["String"]>;
  ticket?: Maybe<TicketSchema>;
  internalTicket?: Maybe<InternalTicketSchema>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  currency?: Maybe<Scalars["String"]>;
  paymentJPY?: Maybe<Scalars["Float"]>;
  invoiceAmount?: Maybe<Scalars["Float"]>;
  costOffer?: Maybe<Scalars["Float"]>;
  amountAfterCoupon?: Maybe<Scalars["Float"]>;
  exchangeRate?: Maybe<Scalars["Float"]>;
  profitOrderManagementInput?: Maybe<Scalars["Float"]>;
  eta?: Maybe<Scalars["String"]>;
  etd?: Maybe<Scalars["String"]>;
  confirmedTTCopyAt?: Maybe<Scalars["DateTime"]>;
  confirmedPaymentAt?: Maybe<Scalars["DateTime"]>;
  sharedBLAt?: Maybe<Scalars["DateTime"]>;
  trackingShip?: Maybe<TrackingShipSchema>;
  tags?: Maybe<Array<InquiryTagSchema>>;
  step?: Maybe<Scalars["Float"]>;
  carId: Scalars["ID"];
  user?: Maybe<Scalars["ID"]>;
  car?: Maybe<CarSchema>;
  addedToManageAt?: Maybe<Scalars["DateTime"]>;
  releasedAt?: Maybe<Scalars["DateTime"]>;
  paypal?: Maybe<PaypalInquirySchema>;
  orderManagementStat?: Maybe<OrderManagementStatsSchema>;
  paypalNetAmount?: Maybe<Scalars["String"]>;
  created?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type OrderManagementStatsSchema = {
  __typename?: "OrderManagementStatsSchema";
  id?: Maybe<Scalars["ID"]>;
  cfjCode?: Maybe<Scalars["String"]>;
  asOrMs?: Maybe<Scalars["String"]>;
  orderNote?: Maybe<Scalars["String"]>;
  moneyIncomingUSD?: Maybe<Scalars["String"]>;
  moneyIncomingJYP?: Maybe<Scalars["Float"]>;
  bankFee?: Maybe<Scalars["Float"]>;
  refund?: Maybe<Scalars["Float"]>;
  moneyReceivedDate?: Maybe<Scalars["DateTime"]>;
  withdrawFromPaypal?: Maybe<Scalars["Boolean"]>;
  releaseToSellerJPY?: Maybe<Scalars["Float"]>;
  profitWithTax?: Maybe<Scalars["Float"]>;
  profitWithoutTax?: Maybe<Scalars["Float"]>;
  recycleFee?: Maybe<Scalars["Float"]>;
  profit?: Maybe<Scalars["Float"]>;
  carCostProfits?: Maybe<Array<CarCostProfitSchema>>;
};

export type PartialInquirySchema = {
  __typename?: "PartialInquirySchema";
  _id?: Maybe<Scalars["ID"]>;
  id?: Maybe<Scalars["ID"]>;
  availability?: Maybe<Scalars["String"]>;
  year?: Maybe<Scalars["Int"]>;
  step?: Maybe<Scalars["Int"]>;
  folder?: Maybe<Scalars["String"]>;
  VIN?: Maybe<Scalars["String"]>;
  refNo?: Maybe<Scalars["String"]>;
  modelCodeShort?: Maybe<Scalars["String"]>;
  coupon?: Maybe<Scalars["String"]>;
  ref?: Maybe<Scalars["String"]>;
  supportTicketId?: Maybe<Scalars["Int"]>;
  consigneeName?: Maybe<Scalars["String"]>;
  consigneeAddress?: Maybe<Scalars["String"]>;
  consigneePhone?: Maybe<Scalars["String"]>;
  consigneeEmail?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  options?: Maybe<Array<Scalars["String"]>>;
  comment?: Maybe<Scalars["String"]>;
  insurance?: Maybe<Scalars["Boolean"]>;
  inspection?: Maybe<Scalars["Boolean"]>;
  isBuyNow?: Maybe<Scalars["Boolean"]>;
  isBNPL?: Maybe<Scalars["Boolean"]>;
  shipping?: Maybe<Scalars["Boolean"]>;
  transferTwice?: Maybe<Scalars["Boolean"]>;
  showBreakdown?: Maybe<Scalars["Boolean"]>;
  showShipper?: Maybe<Scalars["Boolean"]>;
  costOffer?: Maybe<Scalars["Float"]>;
  costOfferOriginal?: Maybe<Scalars["Float"]>;
  showKenyaBank?: Maybe<Scalars["Boolean"]>;
  costFOB?: Maybe<Scalars["Float"]>;
  costInsurance?: Maybe<Scalars["Float"]>;
  costInspection?: Maybe<Scalars["Float"]>;
  costShipping?: Maybe<Scalars["Float"]>;
  costDelivery?: Maybe<Scalars["Float"]>;
  costOptions?: Maybe<Scalars["Float"]>;
  costProtection?: Maybe<Scalars["Float"]>;
  costDiscount?: Maybe<Scalars["Float"]>;
  costBuynowDiscount?: Maybe<Scalars["Float"]>;
  additionalCosts?: Maybe<Scalars["String"]>;
  additionalDesc?: Maybe<Scalars["String"]>;
  documentName?: Maybe<Scalars["String"]>;
  documentAddress?: Maybe<Scalars["String"]>;
  documentPhone?: Maybe<Scalars["String"]>;
  documentEmail?: Maybe<Scalars["String"]>;
  ip?: Maybe<Scalars["String"]>;
  userAgent?: Maybe<Scalars["String"]>;
  user?: Maybe<UserSchema>;
  userId?: Maybe<Scalars["String"]>;
  created?: Maybe<Scalars["DateTime"]>;
  updated?: Maybe<Scalars["DateTime"]>;
  lastActivityAt?: Maybe<Scalars["DateTime"]>;
  utm_source?: Maybe<Scalars["String"]>;
  utm_medium?: Maybe<Scalars["String"]>;
  utm_campaign?: Maybe<Scalars["String"]>;
  clientId?: Maybe<Scalars["String"]>;
  gclid?: Maybe<Scalars["String"]>;
  platform?: Maybe<Scalars["String"]>;
  reservedUSD?: Maybe<Scalars["Float"]>;
  receivedUSD?: Maybe<Scalars["Float"]>;
  receivedJPY?: Maybe<Scalars["Float"]>;
  exchangeRate?: Maybe<Scalars["Float"]>;
  nzdRate?: Maybe<Scalars["Float"]>;
  bankCharge?: Maybe<Scalars["Float"]>;
  serviceCharge?: Maybe<Scalars["Float"]>;
  serviceChargeTax?: Maybe<Scalars["Float"]>;
  transferCharge?: Maybe<Scalars["Float"]>;
  transferChargePublic?: Maybe<Scalars["Float"]>;
  marginPercentCIF?: Maybe<Scalars["Float"]>;
  releasedAt?: Maybe<Scalars["DateTime"]>;
  actualArrivalDate?: Maybe<Scalars["String"]>;
  reservedUntil?: Maybe<Scalars["DateTime"]>;
  internalNote?: Maybe<Scalars["String"]>;
  referrer?: Maybe<Scalars["String"]>;
  orderGroup?: Maybe<Scalars["Int"]>;
  orderGroupRequester?: Maybe<Scalars["Int"]>;
  experiment?: Maybe<Scalars["Int"]>;
  isTargetCountry?: Maybe<Scalars["Boolean"]>;
  passRegulation?: Maybe<Scalars["Boolean"]>;
  isQuality?: Maybe<Scalars["Boolean"]>;
  read?: Maybe<Scalars["Boolean"]>;
  important?: Maybe<Scalars["Boolean"]>;
  hideVIN?: Maybe<Scalars["Boolean"]>;
  currency?: Maybe<Scalars["String"]>;
  invoiceAmount?: Maybe<Scalars["Float"]>;
  amountAfterCoupon?: Maybe<Scalars["Float"]>;
  banks?: Maybe<Array<Scalars["String"]>>;
  car?: Maybe<CarSchema>;
  carId?: Maybe<Scalars["String"]>;
  ticket?: Maybe<Ticket>;
  internalTicket?: Maybe<InternalTicketSchema>;
  ticketNo?: Maybe<Scalars["Float"]>;
  ticketStatus?: Maybe<Scalars["String"]>;
  paypalAmount?: Maybe<Scalars["Float"]>;
  inquiryCount?: Maybe<Scalars["Int"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  paypal?: Maybe<PaypalInquiry>;
  stats?: Maybe<InquiryStatSchema>;
  tags?: Maybe<Array<InquiryTag>>;
  ETA?: Maybe<Scalars["String"]>;
  ETD?: Maybe<Scalars["String"]>;
  vesselName?: Maybe<Scalars["String"]>;
  trackingShip?: Maybe<TrackingShip>;
  currencySymbol?: Maybe<Scalars["String"]>;
  company?: Maybe<CompanySchema>;
  companyId?: Maybe<Scalars["String"]>;
  addonServices?: Maybe<Array<AddonServiceSchema>>;
  addonServiceIds?: Maybe<Array<Scalars["String"]>>;
  sellerFOB?: Maybe<Scalars["Float"]>;
  customCosts?: Maybe<Array<CustomCostSchema>>;
  costService?: Maybe<Scalars["Float"]>;
  paymentJPY?: Maybe<Scalars["Float"]>;
  saleEvents?: Maybe<Array<SaleEventSchema>>;
  documents?: Maybe<Array<InquiryDocumentSchema>>;
  extra?: Maybe<InquiryExtraSchema>;
  autoFollowup?: Maybe<InquiryFollowupSchema>;
  sendSMSTo?: Maybe<Array<Scalars["String"]>>;
};

export type PaypalInquiry = {
  __typename?: "PaypalInquiry";
  status?: Maybe<Scalars["String"]>;
  amount?: Maybe<Scalars["Float"]>;
  orderId?: Maybe<Scalars["String"]>;
  invoiceId?: Maybe<Scalars["String"]>;
  authorizationId?: Maybe<Scalars["String"]>;
  paymentId?: Maybe<Scalars["String"]>;
  invoiceURL?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["DateTime"]>;
  payURL?: Maybe<Scalars["String"]>;
  checkoutCompleted?: Maybe<Scalars["Boolean"]>;
  breakdown?: Maybe<Scalars["JSON"]>;
};

export type PaypalInquirySchema = {
  __typename?: "PaypalInquirySchema";
  status?: Maybe<Scalars["String"]>;
  amount?: Maybe<Scalars["Float"]>;
  orderId?: Maybe<Scalars["String"]>;
  invoiceId?: Maybe<Scalars["String"]>;
  authorizationId?: Maybe<Scalars["String"]>;
  paymentId?: Maybe<Scalars["String"]>;
  invoiceURL?: Maybe<Scalars["String"]>;
  date?: Maybe<Scalars["DateTime"]>;
};

export type PaypalOrderResultSchema = {
  __typename?: "PaypalOrderResultSchema";
  success: Scalars["Boolean"];
};

export enum Platform {
  AMP = "AMP",
  DESKTOP = "DESKTOP",
  MOBILE = "MOBILE"
}

export type PortSchema = {
  __typename?: "PortSchema";
  port: Scalars["String"];
  messages: Array<Scalars["String"]>;
};

export type PrepareInvoiceCallInput = {
  invoiceId: Scalars["ID"];
  recipient?: InvoiceCallRecipient;
};

export type PvSchema = {
  __typename?: "PVSchema";
  id: Scalars["ID"];
  car: CarSchema;
  carId?: Maybe<Scalars["ID"]>;
  company: CompanySchema;
  companyId?: Maybe<Scalars["ID"]>;
  user: UserSchema;
  userId?: Maybe<Scalars["ID"]>;
  session: Scalars["String"];
  ip: Scalars["String"];
  country: Scalars["String"];
  ua: Scalars["String"];
  referrer: Scalars["String"];
  path: Scalars["String"];
  querystring: Scalars["String"];
  created: Scalars["DateTime"];
};

export type Query = {
  __typename?: "Query";
  publicFreights: Array<FreightSchema>;
  detectIauc?: Maybe<IaucDetectorDto>;
  getListCompanyByName: Array<CompanySchema>;
  getCompanyInfo: CompanySchema;
  getPopularYears?: Maybe<Array<Bucket>>;
  search: CarPagingSchema;
  listingPageProps: CarListResultSchema;
  getListHistory: CarHistorySchema;
  getHistory: Array<CarSchema>;
  getPopularCars: Array<CarSchema>;
  getRecommendCar: Array<CarSchema>;
  getSimilarCar: Array<CarSchema>;
  suggestKeywords: Array<CarSuggestItemSchema>;
  getCarAccessories: Array<CarAccessorySchema>;
  getCarDetail: CarSchema;
  getCarsByIds: Array<CarSchema>;
  carRegulations: Array<RegulationSchema>;
  detailPageProps: CarDetailResultSchema;
  getCarFavorites: CarListResultSchema;
  testTransformCar: CarSchema;
  getFullCarData: CarSchema;
  getCar?: Maybe<CarSchema>;
  masterdata: Scalars["JSON"];
  makes: Array<MakeSchema>;
  accessories: Array<AccessorySchema>;
  getCarAnalytics?: Maybe<Scalars["JSON"]>;
  queryCars: QueryCarsAdminResult;
  countCars: Array<Scalars["Int"]>;
  getCarAggs: CarAggsResult;
  getCarAggsBucket: Scalars["JSON"];
  getAdminAccessories: Array<AccessorySchema>;
  findModelByKey?: Maybe<ModelSchema>;
  getManyModels: GetManyModelsType;
  getModelCarCounts: Array<ModelCarCount>;
  getManagementModel: GetManagementModelType;
  getExchangeRates: Array<ExchangeRateSchema>;
  getModelSpecs: ModelSpecResult;
  getModelTrend?: Maybe<Array<ModelTrendSchema>>;
  getAllMake: Array<MakeSchema>;
  getManagementMake: GetManagementMakeType;
  getTransformations: TransformationResult;
  carSpecificationPageProps: CarSpecificationPageProps;
  getPageviews: GetCarAdminPageviewsSchema;
  getCompaniesAdmin: CompanyPagingType;
  getManipulatedCompanies: CompanyPagingType;
  getMembers: Array<CompanyMemberType>;
  getAgents: Array<AgentType>;
  getExporters: ExporterPagingType;
  getExporter?: Maybe<ExporterCompanyType>;
  queryCSVS: CsvListResult;
  sissPickingStockAggs: SissPickingStockAggs;
  sissPickingStocks: SissPickingStocksResult;
  getBillings: AdminBillingsResult;
  getBillingCompany: Array<BillingCompanyRef>;
  carDashboardSummary: CarDashboardSummary;
  carDashboardStats: CarDashboardStats;
  carDashboardViews: Array<CarDashboardViewDay>;
  freights: AdminFreightsResult;
  getRegulations: Array<AdminRegulationSchema>;
  taxBridge: TaxBridgeType;
  getOrderManagementStats: OrderManagementPagingSchema;
  getOrdersReturnBuyer?: Maybe<Array<ReturnBuyerSchema>>;
  getOrderById: OrderManagementSchema;
  getOrderByIdTicket: OrderManagementSchema;
  getOrdersByTicketIds: Array<OrderManagementSchema>;
  getOrderManagementDetail: OrderManagementSchema;
  getPendingInquiryToAdd: OrderManagementSchema;
  getSummaryOrderManagement: SummaryOrderManagementSchema;
  ticketCanaryPercent: TicketCanarySchema;
  canaryHealth: CanaryHealth;
  getTicketsAdmin: GetTicketsAdminSchema;
  getTicketAdmin: TicketRecordSchema;
  getTicketComments: Array<InvoiceCommentSchema>;
  ticketToInquiryOptions: TicketToInquiryOptionsSchema;
  previewTicketToInquiry: TicketToInquiryPreviewSchema;
  gmailInboundStatus: GmailInboundStatusSchema;
  getInvoiceCertificate?: Maybe<InvoiceCertificateSchema>;
  getSatisfaction: GetSatisfactionType;
  getSatisfactionItem?: Maybe<SatisfactionSchema>;
  getSatisfactionInvoice?: Maybe<SatisfactionSchema>;
  getSatisfactionInvoices?: Maybe<Array<SatisfactionSchema>>;
  getSatisfactions: SatisfactionAdminResult;
  getInquiries: Array<InquirySchema>;
  getInvoice: InquirySchema;
  getInterestingModelIds?: Maybe<Array<InterestingModelIds>>;
  getInvoices: MyInquiriesSchema;
  statsMycar: StatsMyCarSchema;
  statsMyPending: MyPendingStatsSchema;
  getFullInquiryContent?: Maybe<FullInquiryContentSchema>;
  hasCountdownCoupon?: Maybe<Scalars["Boolean"]>;
  getCarCoupons: Array<CarCouponResult>;
  getCarCoupon?: Maybe<CarCouponResult>;
  publicCouponByCar?: Maybe<CouponSchema>;
  getCoupons: AdminCouponsResult;
  validateCoupon?: Maybe<ValidateCouponResponse>;
  getCarServices: Array<AddonServiceSchema>;
  zendeskFAQ?: Maybe<ZendeskFaqSchema>;
  getFaqArticles: Array<ZendeskArticle>;
  listAutoReplyMessages: AutoReplyMessagePagingSchema;
  getAutoReplyMessage?: Maybe<AutoReplyMessageSchema>;
  getInvoicesAggs: GetInvoicesAggsSchema;
  getInvoicesFolders: Array<Scalars["String"]>;
  getInvoicesAdmin: GetInvoicesAdminSchema;
  getBuyerStats: Array<GetBuyerStatsSchema>;
  getInvoiceLogging: GetInvoiceLoggingSchema;
  getInvoicesCar: Array<GetInvoicesCarSchema>;
  ticketSplitDebug: TicketSplitDebugSchema;
  previewInquiryCarChange: InquiryCarChangePreviewSchema;
  inquiryTagHistories: Array<InquiryTagHistorySchema>;
  getInvoiceDriveInfo?: Maybe<InvoiceDriveInfoSchema>;
  getCommentTracking: Array<EmailStatusEntrySchema>;
  /** Get public comments for buyer */
  getInvoiceComments: ZendeskCommentsResponse;
  /** Get all comments for admin.carfromjapan.com, read from our own DB instead of Zendesk */
  getInvoiceCommentsAdmin: GetInvoiceCommentsAdminDto;
  /** This query is used to track sync comment from zendesk to admin.carfromjapan.com */
  getCommentsAdmin: GetCommentsAdminResult;
  getZendeskSyncJob: ZendeskSyncJobSchema;
  getZendeskSyncFailures: Array<ZendeskSyncFailureSchema>;
  renderDealerMacro: Scalars["String"];
  renderCommentPlaceholders: Scalars["String"];
  getFixedMacros: Array<DealerMacroSchema>;
  getMacroPlaceholders: Array<MacroPlaceholderSchema>;
  validateDealerMacro: MacroValidationResultSchema;
  getDealerMacros: DealerMacroResultSchema;
  getSellerMonthlyStats: Array<SellerMonthlyStatsRow>;
  getSellerWeeklyStats: Array<SellerWeeklyStatsRow>;
  listReviews: ReviewPagingSchema;
  publicReviews: ReviewPagingSchema;
  reviewSummary: ReviewSummarySchema;
  getInvoiceDashboardSummary: InvoiceDashboardSummarySchema;
  getInvoiceDashboardStats: InvoiceDashboardStatsSchema;
  getInvoiceDashboardCountry: Array<InvoiceDashboardCountryRow>;
  context: CtxSchema;
  getConfigurations?: Maybe<ConfigurationPagingSchema>;
  getCountriesCode: Array<CountryCodeSchema>;
  defaultPortByCountry: Scalars["JSON"];
  generateEnumType?: Maybe<EnumSchema>;
  getAdminGuides: AdminGuidePagingSchema;
  hasNewDoc: Scalars["Boolean"];
  getAuctionSheets: AuctionSheetPagingSchema;
  getAuctionSheet?: Maybe<AuctionSheetSchema>;
  getAuctionSheetSyncDisabled: Scalars["Boolean"];
  getGalleries: GalleryPagingSchema;
  getGallery?: Maybe<GallerySchema>;
  getPublicGalleries: Array<GallerySchema>;
  getGameResult?: Maybe<GameResultSchema>;
  checkEmail: CheckEmailType;
  getManagementUser: GetManagementUserType;
  getManagementUserById: UserSchema;
  listMcpKeys: Array<McpKeySchema>;
  mcpAuditLogs: McpAuditLogsPaginatedSchema;
  getCurrentCampaign: CampaignSchema;
  getTransactionHistory: TransactionHistoryPagingSchema;
  getCampaignAction: CampaignActionPagingSchema;
  getCampaignActionFull: CampaignActionPagingSchema;
  getWithdrawalRequest: WithdrawRequestPagingSchema;
  getExpenseRequest: ExpenseRequestPagingSchema;
  getSummaryCampaign: Array<SummaryCampaignActionSchema>;
  getBalanceAccount: BalanceAmountSchema;
  getExpenseDetail: ExpenseRequestSchema;
  getWithdrawalDetail: WithdrawRequestSchema;
  getEarningDetail: CampaignActionSchema;
  getCampaignJoin?: Maybe<CampaignJoinSchema>;
  checkReferralCodeAvailability: ReferralCodeAvailabilitySchema;
  getSummaryIntroducer: SummaryIntroducerPagingSchema;
  getCampaigns: Array<CampaignSchema>;
  getSellerSmsSubscription: SellerSmsSubscriptionSchema;
  getSellerSmsSummary: SellerSmsSummarySchema;
  getSellerSmsLogs: SellerSmsLogsResultSchema;
  getSellerSmsLogDetail: SellerSmsLogDetailSchema;
  getSellerSmsStatements: Array<SellerSmsStatementSchema>;
  getAdminSmsSellerStats: AdminSmsSellerStatsSchema;
  getAdminSmsSellers: AdminSmsSellersResultSchema;
  getAdminSmsSellerDetail: AdminSmsSellerDetailSchema;
  getAdminSmsLogs: AdminSmsLogsResultSchema;
  getEmailTrackingList: EmailTrackingListResultSchema;
  getEmailTrackingTemplates: Array<Scalars["String"]>;
  getEmailTrackingStats: EmailTrackingStatsResultSchema;
  getEmailTrackingPreview: EmailTrackingPreviewSchema;
  generateBoxText?: Maybe<BoxtextContentSchema>;
  getBoxtexts: BoxtextPagingSchema;
  getFeaturedLink?: Maybe<GetFeaturedLinkType>;
  getFeaturedLinkCarDetail?: Maybe<GetFeaturedLinkType>;
  getBoxLinks: CustomSeoPagingSchema;
  getListingMeta: CustomSeoPagingSchema;
  getManyLandingTags: GetManyLandingTagsType;
  getOneLandingTag?: Maybe<LandingTagSchema>;
  getCarLandingTags: Array<LandingTagSchema>;
  getPublishedLandingTag: Array<LandingTagSchema>;
  getLandingTags: LandingTagAdminResult;
  getSaleTags: Array<SaleTagSchema>;
  getSaleTagsAdmin: SaleTagResult;
  fetchAds: Array<AdsSchema>;
  getAds: AdminAdsResult;
  getLocalPage: GetLocalPageType;
  getCountries: Array<CountryPageSchema>;
  seoFaqs: SeoFaqPagingSchema;
  getSeoFaq: SeoFaqSchema;
  queryFeed: Array<ArticleSchema>;
  searchShipingAgents: ShippingAgentPagingSchema;
  getCountriesShippingAgent: Array<Scalars["String"]>;
  getPortsFromCountryShippingAgent: Array<Scalars["String"]>;
  searchShippingDelayNotes: ShippingDelayNotePagingSchema;
  getActiveShippingDelayNote?: Maybe<ShippingDelayNoteSchema>;
  getActiveShippingDelayNotes: Array<ShippingDelayNoteSchema>;
  getShipSchedules: ShipScheduleListSchema;
};

export type QueryDetectIaucArgs = {
  carId: Scalars["ID"];
};

export type QueryGetListCompanyByNameArgs = {
  name: Scalars["String"];
};

export type QueryGetCompanyInfoArgs = {
  id: Scalars["String"];
};

export type QueryGetPopularYearsArgs = {
  input: GetPopularLinksArgs;
};

export type QuerySearchArgs = {
  input: SearchArgs;
};

export type QueryListingPagePropsArgs = {
  input: SearchArgs;
};

export type QueryGetListHistoryArgs = {
  limit?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
};

export type QueryGetHistoryArgs = {
  limit?: Maybe<Scalars["Int"]>;
  skip?: Maybe<Scalars["Int"]>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
};

export type QueryGetPopularCarsArgs = {
  limit?: Maybe<Scalars["Int"]>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
};

export type QueryGetRecommendCarArgs = {
  country?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  limit?: Maybe<Scalars["Float"]>;
  includeImages?: Maybe<Scalars["Boolean"]>;
};

export type QueryGetSimilarCarArgs = {
  bodyType?: Maybe<Scalars["Int"]>;
  mileage?: Maybe<Scalars["Float"]>;
  displacement?: Maybe<Scalars["Float"]>;
  priceUSD?: Maybe<Scalars["Float"]>;
  country?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  limit?: Maybe<Scalars["Float"]>;
  includeImages?: Maybe<Scalars["Boolean"]>;
  includeOffers?: Maybe<Scalars["Boolean"]>;
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  maxYear?: Maybe<Scalars["Int"]>;
  minYear?: Maybe<Scalars["Int"]>;
  passRegulation?: Maybe<Scalars["Boolean"]>;
};

export type QuerySuggestKeywordsArgs = {
  input: SuggestKeywordsArgs;
};

export type QueryGetCarAccessoriesArgs = {
  input: CarAccessoriesArgs;
};

export type QueryGetCarDetailArgs = {
  id: Scalars["String"];
  hasRegulation?: Maybe<Scalars["Boolean"]>;
  hasCampaign?: Maybe<Scalars["Boolean"]>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
};

export type QueryGetCarsByIdsArgs = {
  ids: Array<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
};

export type QueryCarRegulationsArgs = {
  carId: Scalars["ID"];
};

export type QueryDetailPagePropsArgs = {
  id: Scalars["String"];
  hasRegulation?: Maybe<Scalars["Boolean"]>;
  hasCampaign?: Maybe<Scalars["Boolean"]>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
};

export type QueryGetCarFavoritesArgs = {
  input: GetCarFavoritesArgs;
};

export type QueryTestTransformCarArgs = {
  id: Scalars["String"];
  minimal?: Maybe<Scalars["Boolean"]>;
};

export type QueryGetFullCarDataArgs = {
  id: Scalars["String"];
};

export type QueryGetCarArgs = {
  id?: Maybe<Scalars["String"]>;
};

export type QueryMakesArgs = {
  params?: Maybe<MakesParamsInput>;
};

export type QueryAccessoriesArgs = {
  params?: Maybe<AccessoriesParamsInput>;
};

export type QueryGetCarAnalyticsArgs = {
  id?: Maybe<Scalars["String"]>;
};

export type QueryQueryCarsArgs = {
  filters?: Maybe<QueryCarsAdminFilters>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type QueryCountCarsArgs = {
  filters: Array<QueryCarsAdminFilters>;
};

export type QueryGetCarAggsBucketArgs = {
  modelCode: Scalars["String"];
};

export type QueryGetAdminAccessoriesArgs = {
  root?: Maybe<Scalars["Boolean"]>;
  keywords?: Maybe<Scalars["String"]>;
  limit?: Maybe<Scalars["Float"]>;
};

export type QueryFindModelByKeyArgs = {
  makeModelKey: Scalars["String"];
};

export type QueryGetManyModelsArgs = {
  input?: Maybe<GetManyModelsArgs>;
};

export type QueryGetModelCarCountsArgs = {
  ids: Array<Scalars["String"]>;
  tags: Array<Scalars["String"]>;
};

export type QueryGetManagementModelArgs = {
  filters?: Maybe<GetManagementModelInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type QueryGetModelSpecsArgs = {
  filters?: Maybe<GetModelSpecsAdminInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type QueryGetModelTrendArgs = {
  country?: Maybe<Scalars["String"]>;
};

export type QueryGetAllMakeArgs = {
  input: GetAllMakeArgs;
};

export type QueryGetManagementMakeArgs = {
  args?: Maybe<GetAllMakeArgs>;
};

export type QueryGetTransformationsArgs = {
  filters?: Maybe<GetTransformationsAdminInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type QueryCarSpecificationPagePropsArgs = {
  input: CarSpecificationPagePropsArgs;
};

export type QueryGetPageviewsArgs = {
  args: GetCarAdminPageviewsArgs;
};

export type QueryGetCompaniesAdminArgs = {
  filters?: Maybe<Scalars["JSON"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type QueryGetManipulatedCompaniesArgs = {
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type QueryGetMembersArgs = {
  id?: Maybe<Scalars["ID"]>;
};

export type QueryGetExportersArgs = {
  page?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  keywords?: Maybe<Scalars["String"]>;
};

export type QueryGetExporterArgs = {
  id: Scalars["ID"];
};

export type QueryQueryCsvsArgs = {
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type QuerySissPickingStockAggsArgs = {
  make?: Maybe<Scalars["String"]>;
};

export type QuerySissPickingStocksArgs = {
  filters?: Maybe<SissPickingStockFilters>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type QueryGetBillingsArgs = {
  filters?: Maybe<Scalars["JSON"]>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type QueryGetBillingCompanyArgs = {
  filters?: Maybe<Scalars["JSON"]>;
};

export type QueryCarDashboardStatsArgs = {
  filters: DashboardFiltersInput;
};

export type QueryCarDashboardViewsArgs = {
  filters: DashboardFiltersInput;
};

export type QueryFreightsArgs = {
  filters?: Maybe<FreightFilterInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type QueryGetRegulationsArgs = {
  country?: Maybe<Scalars["String"]>;
};

export type QueryTaxBridgeArgs = {
  input: TaxBridgeArgs;
};

export type QueryGetOrderManagementStatsArgs = {
  agentIds?: Maybe<Array<Scalars["String"]>>;
  sellers?: Maybe<Array<Scalars["String"]>>;
  carServices?: Maybe<Array<Scalars["String"]>>;
  destination?: Maybe<Scalars["String"]>;
  steps: Array<Scalars["Float"]>;
  skip: Scalars["Int"];
  take: Scalars["Int"];
  sortBy?: Maybe<Scalars["String"]>;
  orderBy?: Maybe<Scalars["String"]>;
  viewPending?: Maybe<Scalars["Boolean"]>;
  confirmedPaymentStartDate?: Maybe<Scalars["String"]>;
  confirmedPaymentEndDate?: Maybe<Scalars["String"]>;
  createdStartDate?: Maybe<Scalars["String"]>;
  createdEndDate?: Maybe<Scalars["String"]>;
  keywords?: Maybe<Scalars["String"]>;
  coupon?: Maybe<Scalars["String"]>;
  inquiryType?: Maybe<Scalars["String"]>;
  inquiryIds?: Maybe<Array<Scalars["String"]>>;
};

export type QueryGetOrdersReturnBuyerArgs = {
  agentIds?: Maybe<Array<Scalars["String"]>>;
  sellers?: Maybe<Array<Scalars["String"]>>;
  carServices?: Maybe<Array<Scalars["String"]>>;
  destination?: Maybe<Scalars["String"]>;
  steps: Array<Scalars["Float"]>;
  skip: Scalars["Int"];
  take: Scalars["Int"];
  sortBy?: Maybe<Scalars["String"]>;
  orderBy?: Maybe<Scalars["String"]>;
  viewPending?: Maybe<Scalars["Boolean"]>;
  confirmedPaymentStartDate?: Maybe<Scalars["String"]>;
  confirmedPaymentEndDate?: Maybe<Scalars["String"]>;
  createdStartDate?: Maybe<Scalars["String"]>;
  createdEndDate?: Maybe<Scalars["String"]>;
  keywords?: Maybe<Scalars["String"]>;
  coupon?: Maybe<Scalars["String"]>;
  inquiryType?: Maybe<Scalars["String"]>;
  inquiryIds?: Maybe<Array<Scalars["String"]>>;
};

export type QueryGetOrderByIdArgs = {
  id: Scalars["String"];
};

export type QueryGetOrderByIdTicketArgs = {
  inquiryNo: Scalars["Float"];
};

export type QueryGetOrdersByTicketIdsArgs = {
  ticketIds: Array<Scalars["Float"]>;
};

export type QueryGetOrderManagementDetailArgs = {
  id: Scalars["String"];
};

export type QueryGetPendingInquiryToAddArgs = {
  inquiryNo: Scalars["Float"];
};

export type QueryGetSummaryOrderManagementArgs = {
  startDate: Scalars["String"];
  endDate: Scalars["String"];
};

export type QueryCanaryHealthArgs = {
  args?: Maybe<CanaryHealthArgs>;
};

export type QueryGetTicketsAdminArgs = {
  args: GetTicketsAdminArgs;
};

export type QueryGetTicketAdminArgs = {
  id: Scalars["String"];
};

export type QueryGetTicketCommentsArgs = {
  id: Scalars["String"];
};

export type QueryTicketToInquiryOptionsArgs = {
  input: TicketToInquiryOptionsInput;
};

export type QueryPreviewTicketToInquiryArgs = {
  input: ConvertTicketToInquiryInput;
};

export type QueryGetInvoiceCertificateArgs = {
  invoiceId: Scalars["String"];
};

export type QueryGetSatisfactionArgs = {
  input: GetSatisfactionArgs;
};

export type QueryGetSatisfactionItemArgs = {
  id: Scalars["String"];
};

export type QueryGetSatisfactionInvoiceArgs = {
  inquiryId: Scalars["String"];
};

export type QueryGetSatisfactionInvoicesArgs = {
  inquiryIds: Array<Scalars["String"]>;
};

export type QueryGetSatisfactionsArgs = {
  params?: Maybe<GetSatisfactionsAdminInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type QueryGetInquiriesArgs = {
  car?: Maybe<Scalars["String"]>;
  cars?: Maybe<Array<Scalars["String"]>>;
};

export type QueryGetInvoiceArgs = {
  id: Scalars["String"];
};

export type QueryGetInterestingModelIdsArgs = {
  country?: Maybe<Scalars["String"]>;
  makeId: Scalars["String"];
};

export type QueryGetInvoicesArgs = {
  args: GetInvoicesArgs;
};

export type QueryGetFullInquiryContentArgs = {
  inquiryId: Scalars["String"];
};

export type QueryHasCountdownCouponArgs = {
  carId: Scalars["String"];
};

export type QueryGetCarCouponsArgs = {
  carIds: Array<Scalars["ID"]>;
};

export type QueryGetCarCouponArgs = {
  carId: Scalars["ID"];
};

export type QueryPublicCouponByCarArgs = {
  carId: Scalars["ID"];
};

export type QueryGetCouponsArgs = {
  filters?: Maybe<Scalars["JSON"]>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type QueryValidateCouponArgs = {
  data: ValidateCouponInput;
};

export type QueryZendeskFaqArgs = {
  args: ZendeskGetFaqArgs;
};

export type QueryGetFaqArticlesArgs = {
  sectionId: Scalars["Float"];
};

export type QueryListAutoReplyMessagesArgs = {
  skip?: Scalars["Int"];
  take?: Scalars["Int"];
  sortBy?: Maybe<Scalars["String"]>;
  sortOrder?: Maybe<Scalars["String"]>;
};

export type QueryGetAutoReplyMessageArgs = {
  id: Scalars["ID"];
};

export type QueryGetInvoicesAggsArgs = {
  args?: Maybe<GetInvoicesAggsArgs>;
};

export type QueryGetInvoicesAdminArgs = {
  args: GetInvoicesAdminArgs;
};

export type QueryGetBuyerStatsArgs = {
  args: GetBuyerStatsArgs;
};

export type QueryGetInvoiceLoggingArgs = {
  args: GetInvoiceLoggingArgs;
};

export type QueryGetInvoicesCarArgs = {
  args: GetInvoicesCarArgs;
};

export type QueryTicketSplitDebugArgs = {
  args?: Maybe<TicketSplitDebugArgs>;
};

export type QueryPreviewInquiryCarChangeArgs = {
  input: ChangeInquiryCarInput;
};

export type QueryInquiryTagHistoriesArgs = {
  input: InquiryTagHistoriesArgs;
};

export type QueryGetInvoiceDriveInfoArgs = {
  invoiceIds: Array<Scalars["String"]>;
};

export type QueryGetCommentTrackingArgs = {
  input: GetCommentTrackingArgs;
};

export type QueryGetInvoiceCommentsArgs = {
  id: Scalars["String"];
};

export type QueryGetInvoiceCommentsAdminArgs = {
  args: GetInvoicesCommentsAdminArgs;
};

export type QueryGetCommentsAdminArgs = {
  args: GetCommentsAdminArgs;
};

export type QueryRenderDealerMacroArgs = {
  id: Scalars["String"];
  inquiryId?: Maybe<Scalars["String"]>;
  ticketId?: Maybe<Scalars["String"]>;
  draftTicket?: Maybe<MacroTicketDraftInput>;
  keepPlaceholders?: Maybe<Scalars["Boolean"]>;
};

export type QueryRenderCommentPlaceholdersArgs = {
  content: Scalars["String"];
  inquiryId?: Maybe<Scalars["String"]>;
  ticketId?: Maybe<Scalars["String"]>;
};

export type QueryValidateDealerMacroArgs = {
  content: Scalars["String"];
};

export type QueryGetDealerMacrosArgs = {
  filters?: Maybe<DealerMacroFiltersInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["Int"]>;
};

export type QueryGetSellerMonthlyStatsArgs = {
  filter: SellerStatsFilterInput;
};

export type QueryGetSellerWeeklyStatsArgs = {
  filter: SellerWeeklyStatsFilterInput;
};

export type QueryListReviewsArgs = {
  skip?: Scalars["Int"];
  take?: Scalars["Int"];
};

export type QueryPublicReviewsArgs = {
  skip?: Scalars["Int"];
  take?: Scalars["Int"];
};

export type QueryGetInvoiceDashboardStatsArgs = {
  filters: InvoiceDashboardFiltersInput;
};

export type QueryGetInvoiceDashboardCountryArgs = {
  filters: InvoiceDashboardFiltersInput;
};

export type QueryGetConfigurationsArgs = {
  key?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  published?: Maybe<Scalars["Boolean"]>;
  skip: Scalars["Int"];
  take: Scalars["Int"];
  sortBy?: Maybe<Scalars["String"]>;
  orderBy?: Maybe<Scalars["String"]>;
};

export type QueryGetAdminGuidesArgs = {
  take: Scalars["Float"];
  skip: Scalars["Float"];
};

export type QueryGetAuctionSheetsArgs = {
  status?: Maybe<Scalars["String"]>;
  maker?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  dateFrom?: Maybe<Scalars["DateTime"]>;
  dateTo?: Maybe<Scalars["DateTime"]>;
  carId?: Maybe<Scalars["String"]>;
  isGradeMismatch?: Maybe<Scalars["Boolean"]>;
  isMissingVehicleInfo?: Maybe<Scalars["Boolean"]>;
  take: Scalars["Int"];
  skip: Scalars["Int"];
};

export type QueryGetAuctionSheetArgs = {
  id: Scalars["ID"];
};

export type QueryGetGalleriesArgs = {
  take: Scalars["Float"];
  skip: Scalars["Float"];
};

export type QueryGetGalleryArgs = {
  id: Scalars["ID"];
};

export type QueryGetPublicGalleriesArgs = {
  country?: Maybe<Scalars["String"]>;
  limit?: Maybe<Scalars["Float"]>;
};

export type QueryGetGameResultArgs = {
  gameKey: Scalars["String"];
};

export type QueryCheckEmailArgs = {
  input: CheckEmailInput;
};

export type QueryGetManagementUserArgs = {
  filters?: Maybe<GetManagementUserInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type QueryGetManagementUserByIdArgs = {
  id: Scalars["ID"];
};

export type QueryListMcpKeysArgs = {
  userId?: Maybe<Scalars["String"]>;
};

export type QueryMcpAuditLogsArgs = {
  filter?: Maybe<McpAuditLogsInput>;
  skip?: Scalars["Float"];
  take?: Scalars["Float"];
};

export type QueryGetTransactionHistoryArgs = {
  introducerId?: Maybe<Scalars["String"]>;
  skip: Scalars["Int"];
  take: Scalars["Int"];
  sortBy?: Maybe<Scalars["String"]>;
  orderBy?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  typeNe?: Maybe<Scalars["String"]>;
};

export type QueryGetCampaignActionArgs = {
  fromDate?: Maybe<Scalars["DateTime"]>;
  toDate?: Maybe<Scalars["DateTime"]>;
  days?: Maybe<Scalars["Int"]>;
  buyerName?: Maybe<Scalars["String"]>;
  buyerEmail?: Maybe<Scalars["String"]>;
  inquiryNo?: Maybe<Scalars["String"]>;
  referralCode?: Maybe<Scalars["String"]>;
  introducerId?: Maybe<Scalars["String"]>;
  skip: Scalars["Int"];
  take: Scalars["Int"];
  sortBy?: Maybe<Scalars["String"]>;
  orderBy?: Maybe<Scalars["String"]>;
};

export type QueryGetCampaignActionFullArgs = {
  fromDate?: Maybe<Scalars["DateTime"]>;
  toDate?: Maybe<Scalars["DateTime"]>;
  days?: Maybe<Scalars["Int"]>;
  buyerName?: Maybe<Scalars["String"]>;
  buyerEmail?: Maybe<Scalars["String"]>;
  inquiryNo?: Maybe<Scalars["String"]>;
  referralCode?: Maybe<Scalars["String"]>;
  introducerId?: Maybe<Scalars["String"]>;
  skip: Scalars["Int"];
  take: Scalars["Int"];
  sortBy?: Maybe<Scalars["String"]>;
  orderBy?: Maybe<Scalars["String"]>;
};

export type QueryGetWithdrawalRequestArgs = {
  fromDate?: Maybe<Scalars["DateTime"]>;
  toDate?: Maybe<Scalars["DateTime"]>;
  withdrawalMethod?: Maybe<Scalars["String"]>;
  introducerEmail?: Maybe<Scalars["String"]>;
  introducerName?: Maybe<Scalars["String"]>;
  introducerId?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  skip: Scalars["Int"];
  take: Scalars["Int"];
  sortBy?: Maybe<Scalars["String"]>;
  orderBy?: Maybe<Scalars["String"]>;
};

export type QueryGetExpenseRequestArgs = {
  fromDate?: Maybe<Scalars["DateTime"]>;
  toDate?: Maybe<Scalars["DateTime"]>;
  introducerEmail?: Maybe<Scalars["String"]>;
  introducerName?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  introducerId?: Maybe<Scalars["String"]>;
  orderId?: Maybe<Scalars["Float"]>;
  skip: Scalars["Int"];
  take: Scalars["Int"];
  sortBy?: Maybe<Scalars["String"]>;
  orderBy?: Maybe<Scalars["String"]>;
};

export type QueryGetSummaryCampaignArgs = {
  days?: Maybe<Scalars["Int"]>;
};

export type QueryGetExpenseDetailArgs = {
  transactionId: Scalars["ID"];
};

export type QueryGetWithdrawalDetailArgs = {
  transactionId: Scalars["ID"];
};

export type QueryGetEarningDetailArgs = {
  transactionId: Scalars["ID"];
};

export type QueryCheckReferralCodeAvailabilityArgs = {
  code: Scalars["String"];
};

export type QueryGetSummaryIntroducerArgs = {
  fromDate?: Maybe<Scalars["DateTime"]>;
  toDate?: Maybe<Scalars["DateTime"]>;
  referralCode?: Maybe<Scalars["String"]>;
  introducerEmail?: Maybe<Scalars["String"]>;
  introducerName?: Maybe<Scalars["String"]>;
  tag?: Maybe<Scalars["String"]>;
  skip: Scalars["Int"];
  take: Scalars["Int"];
  sortBy?: Maybe<Scalars["String"]>;
  orderBy?: Maybe<Scalars["String"]>;
};

export type QueryGetSellerSmsSubscriptionArgs = {
  companyId: Scalars["ID"];
};

export type QueryGetSellerSmsSummaryArgs = {
  companyId: Scalars["ID"];
  month: Scalars["String"];
};

export type QueryGetSellerSmsLogsArgs = {
  month: Scalars["String"];
  companyId: Scalars["ID"];
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type QueryGetSellerSmsLogDetailArgs = {
  id: Scalars["ID"];
};

export type QueryGetSellerSmsStatementsArgs = {
  companyId: Scalars["ID"];
  limit?: Maybe<Scalars["Int"]>;
};

export type QueryGetAdminSmsSellerStatsArgs = {
  dateFrom?: Maybe<Scalars["String"]>;
  dateTo?: Maybe<Scalars["String"]>;
};

export type QueryGetAdminSmsSellersArgs = {
  search?: Maybe<Scalars["String"]>;
  status?: Maybe<AdminSmsSellerStatus>;
  paymentStatus?: Maybe<SmsPaymentStatus>;
  sortBy?: Maybe<AdminSmsSellerSort>;
  sortOrder?: Maybe<AdminSortOrder>;
  dateFrom?: Maybe<Scalars["String"]>;
  dateTo?: Maybe<Scalars["String"]>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type QueryGetAdminSmsSellerDetailArgs = {
  dateFrom?: Maybe<Scalars["String"]>;
  dateTo?: Maybe<Scalars["String"]>;
  companyId: Scalars["ID"];
};

export type QueryGetAdminSmsLogsArgs = {
  companyId?: Maybe<Scalars["ID"]>;
  search?: Maybe<Scalars["String"]>;
  status?: Maybe<AdminSmsDeliveryStatus>;
  dateFrom?: Maybe<Scalars["String"]>;
  dateTo?: Maybe<Scalars["String"]>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type QueryGetEmailTrackingListArgs = {
  email?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
  dateFrom?: Maybe<Scalars["String"]>;
  dateTo?: Maybe<Scalars["String"]>;
  entityType?: Maybe<Scalars["String"]>;
  ticketId?: Maybe<Scalars["String"]>;
  template?: Maybe<Scalars["String"]>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type QueryGetEmailTrackingStatsArgs = {
  dateFrom: Scalars["String"];
  dateTo: Scalars["String"];
  email?: Maybe<Scalars["String"]>;
  template?: Maybe<Scalars["String"]>;
  ticketId?: Maybe<Scalars["String"]>;
};

export type QueryGetEmailTrackingPreviewArgs = {
  id: Scalars["String"];
};

export type QueryGenerateBoxTextArgs = {
  input: GenerateBoxTextArgs;
};

export type QueryGetBoxtextsArgs = {
  input: GetBoxtextArgs;
};

export type QueryGetFeaturedLinkArgs = {
  input: GetFeaturedLinkArgs;
};

export type QueryGetFeaturedLinkCarDetailArgs = {
  input: GetFeaturedLinkArgs;
};

export type QueryGetBoxLinksArgs = {
  input: GetCustomSeoArgs;
};

export type QueryGetListingMetaArgs = {
  input: GetCustomSeoArgs;
};

export type QueryGetManyLandingTagsArgs = {
  page?: Scalars["Int"];
  limit?: Scalars["Int"];
  keywords?: Maybe<Scalars["String"]>;
};

export type QueryGetOneLandingTagArgs = {
  published: Scalars["Boolean"];
  key?: Maybe<Scalars["String"]>;
  saleTags?: Maybe<Scalars["String"]>;
};

export type QueryGetCarLandingTagsArgs = {
  carId: Scalars["String"];
};

export type QueryGetLandingTagsArgs = {
  filters?: Maybe<GetLandingTagsAdminInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type QueryGetSaleTagsAdminArgs = {
  filters?: Maybe<Scalars["JSON"]>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type QueryFetchAdsArgs = {
  input: FetchAdsInput;
};

export type QueryGetAdsArgs = {
  filters?: Maybe<GetAdsFiltersInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
};

export type QueryGetLocalPageArgs = {
  input: GetLocalPageArgs;
};

export type QueryGetCountriesArgs = {
  params?: Maybe<GetCountriesParamsInput>;
};

export type QuerySeoFaqsArgs = {
  skip: Scalars["Int"];
  take: Scalars["Int"];
  path?: Maybe<Scalars["String"]>;
  sortBy?: Maybe<Scalars["String"]>;
  orderBy?: Maybe<Scalars["String"]>;
};

export type QueryGetSeoFaqArgs = {
  id: Scalars["String"];
};

export type QueryQueryFeedArgs = {
  layout?: Maybe<Scalars["String"]>;
  limit?: Maybe<Scalars["Int"]>;
};

export type QuerySearchShipingAgentsArgs = {
  keyword?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  skip: Scalars["Int"];
  take: Scalars["Int"];
  sortBy?: Maybe<Scalars["String"]>;
  orderBy?: Maybe<Scalars["String"]>;
};

export type QueryGetPortsFromCountryShippingAgentArgs = {
  country: Scalars["String"];
};

export type QuerySearchShippingDelayNotesArgs = {
  keyword?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  isActive?: Maybe<Scalars["Boolean"]>;
  skip?: Scalars["Int"];
  take?: Scalars["Int"];
};

export type QueryGetActiveShippingDelayNoteArgs = {
  country?: Maybe<Scalars["String"]>;
};

export type QueryGetActiveShippingDelayNotesArgs = {
  country?: Maybe<Scalars["String"]>;
};

export type QueryGetShipSchedulesArgs = {
  port?: Maybe<Scalars["String"]>;
  keywords?: Maybe<Scalars["String"]>;
};

export type QueryCarsAdminFilters = {
  status?: Maybe<Array<Scalars["Int"]>>;
  company?: Maybe<Array<Scalars["String"]>>;
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Array<Scalars["String"]>>;
  keywords?: Maybe<Scalars["String"]>;
  minYear?: Maybe<Scalars["Int"]>;
  maxYear?: Maybe<Scalars["Int"]>;
  minMileage?: Maybe<Scalars["Int"]>;
  maxMileage?: Maybe<Scalars["Int"]>;
  minPrice?: Maybe<Scalars["Float"]>;
  maxPrice?: Maybe<Scalars["Float"]>;
  minDisplacement?: Maybe<Scalars["Int"]>;
  maxDisplacement?: Maybe<Scalars["Int"]>;
  minM3?: Maybe<Scalars["Float"]>;
  maxM3?: Maybe<Scalars["Float"]>;
  minDiscountPercent?: Maybe<Scalars["Int"]>;
  maxDiscountPercent?: Maybe<Scalars["Int"]>;
  bodyType?: Maybe<Array<Scalars["Int"]>>;
  fuelType?: Maybe<Array<Scalars["Int"]>>;
  driveType?: Maybe<Array<Scalars["Int"]>>;
  steering?: Maybe<Array<Scalars["Int"]>>;
  transmission?: Maybe<Array<Scalars["Int"]>>;
  exteriorColor?: Maybe<Array<Scalars["Int"]>>;
  tags?: Maybe<Array<Scalars["String"]>>;
  specialities?: Maybe<Array<Scalars["String"]>>;
  accessories?: Maybe<Array<Scalars["String"]>>;
  hasVideo?: Maybe<Scalars["Boolean"]>;
  hasImage?: Maybe<Scalars["Boolean"]>;
  VIN?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["String"]>;
  rangeField?: Maybe<Scalars["String"]>;
  from?: Maybe<Scalars["JSON"]>;
  to?: Maybe<Scalars["JSON"]>;
};

export type QueryCarsAdminResult = {
  __typename?: "QueryCarsAdminResult";
  cars: Array<CarSchema>;
  total: Scalars["Int"];
};

export type ReferralCodeAvailabilitySchema = {
  __typename?: "ReferralCodeAvailabilitySchema";
  available: Scalars["Boolean"];
  reason?: Maybe<Scalars["String"]>;
};

export type ReferralSchema = {
  __typename?: "ReferralSchema";
  id: Scalars["ID"];
  name: Array<Scalars["String"]>;
  carrier: Scalars["String"];
  country: Scalars["String"];
  port: Scalars["String"];
  address?: Maybe<Array<Scalars["String"]>>;
  phone?: Maybe<Array<Scalars["String"]>>;
  email?: Maybe<Array<Scalars["String"]>>;
  url?: Maybe<Scalars["String"]>;
  fax?: Maybe<Array<Scalars["String"]>>;
};

export type ReferSchema = {
  __typename?: "ReferSchema";
  userId: Scalars["String"];
  usedAt: Scalars["DateTime"];
};

export type RegisterExporterCompanyInput = {
  ownerName: Scalars["String"];
  ownerNamePronounciation: Scalars["String"];
  ownerEmail: Scalars["String"];
  ownerPassword: Scalars["String"];
  name: Scalars["String"];
  enName: Scalars["String"];
  personCharge: Scalars["String"];
  address: Scalars["String"];
  addressKana: Scalars["String"];
  postalCode: Scalars["String"];
  telephone: Scalars["String"];
  bankName: Scalars["String"];
  bankBranch: Scalars["String"];
  bankAccount: Scalars["String"];
  bankHolder: Scalars["String"];
  kanaBankHolder: Scalars["String"];
  bankType: BankType;
  plan: Scalars["String"];
  agree: Scalars["Boolean"];
  makingAnnualPayment?: Maybe<Scalars["Boolean"]>;
  message?: Maybe<Scalars["String"]>;
};

export type RegisterInput = {
  email: Scalars["String"];
  password: Scalars["String"];
  name: Scalars["String"];
  ip?: Maybe<Scalars["String"]>;
  namePronounciation?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  countryCode?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
};

export type RegulationConditionInput = {
  value?: Maybe<Scalars["JSON"]>;
  number?: Maybe<Scalars["JSON"]>;
  length?: Maybe<Scalars["JSON"]>;
  rule?: Maybe<Scalars["Boolean"]>;
  operator?: Maybe<Scalars["String"]>;
};

export type RegulationPortInput = {
  port: Scalars["String"];
  messages: Array<Scalars["String"]>;
};

export type RegulationRuleFieldsInput = {
  year?: Maybe<RegulationConditionInput>;
  emissionCode?: Maybe<RegulationConditionInput>;
  fuel?: Maybe<RegulationConditionInput>;
  bodyType?: Maybe<RegulationConditionInput>;
  inspectionRatings?: Maybe<RegulationConditionInput>;
  seat?: Maybe<RegulationConditionInput>;
  passengers?: Maybe<RegulationConditionInput>;
  displacement?: Maybe<RegulationConditionInput>;
  loadingCapacity?: Maybe<RegulationConditionInput>;
};

export type RegulationRuleInput = {
  message?: Maybe<Scalars["String"]>;
  rule?: Maybe<RegulationRuleFieldsInput>;
  filter?: Maybe<RegulationRuleFieldsInput>;
};

export type RegulationSchema = {
  __typename?: "RegulationSchema";
  country: Scalars["String"];
  messages: Array<Scalars["String"]>;
  targeted?: Maybe<Scalars["Boolean"]>;
  rules?: Maybe<Array<RuleSchema>>;
  ports?: Maybe<Array<PortSchema>>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<Scalars["String"]>;
  modifiedAt?: Maybe<Scalars["DateTime"]>;
  modifiedBy?: Maybe<Scalars["String"]>;
};

export type ReleaseMoneyArgs = {
  invoiceId: Scalars["String"];
};

export type RemovePendingOrderManagementLineInput = {
  id: Scalars["ID"];
};

export type RemoveProfilePictureInput = {
  userId?: Maybe<Scalars["ID"]>;
};

export type ReplyCommentInvoiceArgs = {
  id: Scalars["String"];
  comment: Scalars["String"];
  htmlBody?: Maybe<Scalars["String"]>;
  files?: Maybe<Array<ReplyCommentInvoiceFileInput>>;
  isPublic?: Maybe<Scalars["Boolean"]>;
  smsNotify?: Maybe<Scalars["Boolean"]>;
  /** Agent/admin "Submit as": open | pending | hold | solved. Omit to keep the automatic status change after a reply. */
  status?: Maybe<Scalars["String"]>;
};

export type ReplyCommentInvoiceFileInput = {
  filename: Scalars["String"];
  key: Scalars["String"];
  order?: Maybe<Scalars["Float"]>;
};

export type ReplyCommentInvoiceSchema = {
  __typename?: "ReplyCommentInvoiceSchema";
  success: Scalars["Boolean"];
  message?: Maybe<Scalars["String"]>;
};

export type ReplySchema = {
  __typename?: "ReplySchema";
  user?: Maybe<UserSchema>;
  comment?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  createdBy?: Maybe<UserSchema>;
  modifiedAt?: Maybe<Scalars["DateTime"]>;
  modifiedBy?: Maybe<UserSchema>;
};

export type ResetPasswordInput = {
  email: Scalars["String"];
};

export type RestoreInquiryTagArgs = {
  invoiceId: Scalars["String"];
  historyId: Scalars["String"];
};

export type ResyncStateCampaignAction = {
  __typename?: "ResyncStateCampaignAction";
  campaignAction?: Maybe<CampaignActionSchema>;
  orderDetail?: Maybe<OrderDetail>;
};

export type ReturnBuyerSchema = {
  __typename?: "ReturnBuyerSchema";
  id?: Maybe<Scalars["ID"]>;
  coupon?: Maybe<Scalars["String"]>;
  couponValue?: Maybe<Scalars["Float"]>;
  VIN?: Maybe<Scalars["String"]>;
  ticket?: Maybe<TicketSchema>;
  internalTicket?: Maybe<InternalTicketSchema>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  currency?: Maybe<Scalars["String"]>;
  paymentJPY?: Maybe<Scalars["Float"]>;
  invoiceAmount?: Maybe<Scalars["Float"]>;
  costOffer?: Maybe<Scalars["Float"]>;
  amountAfterCoupon?: Maybe<Scalars["Float"]>;
  exchangeRate?: Maybe<Scalars["Float"]>;
  profitOrderManagementInput?: Maybe<Scalars["Float"]>;
  eta?: Maybe<Scalars["String"]>;
  etd?: Maybe<Scalars["String"]>;
  confirmedTTCopyAt?: Maybe<Scalars["DateTime"]>;
  confirmedPaymentAt?: Maybe<Scalars["DateTime"]>;
  sharedBLAt?: Maybe<Scalars["DateTime"]>;
  trackingShip?: Maybe<TrackingShipSchema>;
  tags?: Maybe<Array<InquiryTagSchema>>;
  step?: Maybe<Scalars["Float"]>;
  carId?: Maybe<Scalars["ID"]>;
  user?: Maybe<Scalars["ID"]>;
  car?: Maybe<CarSchema>;
  addedToManageAt?: Maybe<Scalars["DateTime"]>;
  releasedAt?: Maybe<Scalars["DateTime"]>;
  paypal?: Maybe<PaypalInquirySchema>;
  orderManagementStat?: Maybe<OrderManagementStatsSchema>;
  paypalNetAmount?: Maybe<Scalars["String"]>;
  created?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  _id?: Maybe<Scalars["ID"]>;
};

export type ReviewPagingSchema = {
  __typename?: "ReviewPagingSchema";
  nodes?: Maybe<Array<ReviewSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type ReviewSchema = {
  __typename?: "ReviewSchema";
  id: Scalars["ID"];
  source: Scalars["String"];
  externalId?: Maybe<Scalars["String"]>;
  authorName: Scalars["String"];
  rating: Scalars["Int"];
  title?: Maybe<Scalars["String"]>;
  content: Scalars["String"];
  reviewedAt: Scalars["DateTime"];
  url?: Maybe<Scalars["String"]>;
  isPublished: Scalars["Boolean"];
  displayOrder?: Maybe<Scalars["Int"]>;
  createdAt: Scalars["DateTime"];
};

export type ReviewSummarySchema = {
  __typename?: "ReviewSummarySchema";
  averageRating: Scalars["Float"];
  totalReviews: Scalars["Int"];
};

export type RuleSchema = {
  __typename?: "RuleSchema";
  message?: Maybe<Scalars["String"]>;
  rule?: Maybe<Scalars["JSON"]>;
  filter?: Maybe<Scalars["JSON"]>;
};

export type SaleEventInput = {
  name?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["JSON"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type SaleEventSchema = {
  __typename?: "SaleEventSchema";
  name?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["JSON"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type SaleTagResult = {
  __typename?: "SaleTagResult";
  tags: Array<SaleTagSchema>;
  total: Scalars["Int"];
};

export type SaleTagSchema = {
  __typename?: "SaleTagSchema";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  key?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  introduction?: Maybe<Scalars["String"]>;
  countries?: Maybe<Array<Scalars["String"]>>;
  showOnAdvanced: Scalars["Boolean"];
  showOnView?: Maybe<Scalars["Boolean"]>;
  images?: Maybe<Array<MediaSchema>>;
  couponId?: Maybe<Scalars["String"]>;
  published?: Maybe<Scalars["Boolean"]>;
  countdown?: Maybe<Scalars["Boolean"]>;
  keepUnmatchedCars?: Maybe<Scalars["Boolean"]>;
  carConfigs?: Maybe<Array<CarConfigSchema>>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  modifiedAt?: Maybe<Scalars["DateTime"]>;
  coupon?: Maybe<CouponSchema>;
};

export type SatisfactionAdminResult = {
  __typename?: "SatisfactionAdminResult";
  satisfactions?: Maybe<Array<Maybe<SatisfactionSchema>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type SatisfactionSchema = {
  __typename?: "SatisfactionSchema";
  _id?: Maybe<Scalars["ID"]>;
  id?: Maybe<Scalars["ID"]>;
  url?: Maybe<Scalars["String"]>;
  company?: Maybe<CompanySchema>;
  car?: Maybe<CarSchema>;
  make?: Maybe<MakeSchema>;
  model?: Maybe<ModelSchema>;
  assignee_id?: Maybe<Scalars["Float"]>;
  group_id?: Maybe<Scalars["Int"]>;
  requester?: Maybe<Scalars["JSON"]>;
  ticket_id?: Maybe<Scalars["Int"]>;
  inquiryId?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  score?: Maybe<Scalars["String"]>;
  created_at?: Maybe<Scalars["DateTime"]>;
  updated_at?: Maybe<Scalars["DateTime"]>;
  comment?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  user?: Maybe<UserSchema>;
  published?: Maybe<Scalars["Boolean"]>;
  votes?: Maybe<Array<VoteSchema>>;
  feedback?: Maybe<FeedbackSchema>;
  reply?: Maybe<ReplySchema>;
  priority?: Maybe<Scalars["Int"]>;
  images?: Maybe<Array<MediaSchema>>;
  videos?: Maybe<Array<MediaSchema>>;
  ratingValue?: Maybe<Scalars["Float"]>;
  countryFlag?: Maybe<Scalars["String"]>;
  image?: Maybe<MediaSchema>;
  upVoteCount?: Maybe<Scalars["Int"]>;
};

export type SaveCampaignEmailsInput = {
  emails: Array<Scalars["String"]>;
  sourceId: Scalars["Int"];
  userEmail: Scalars["String"];
};

export type SaveProfileInput = {
  signature?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  countryCode?: Maybe<Scalars["String"]>;
  notiEmail?: Maybe<Scalars["Boolean"]>;
  notiSms?: Maybe<Scalars["Boolean"]>;
  gender?: Maybe<Scalars["Float"]>;
  birthday?: Maybe<Scalars["DateTime"]>;
};

export type SaveSatisfactionInput = {
  communicationSpeed: Scalars["Int"];
  communicationQuality: Scalars["Int"];
  likelyToRecommend: Scalars["Int"];
  comment: Scalars["String"];
  cost?: Maybe<Scalars["Int"]>;
  delivery?: Maybe<Scalars["Int"]>;
  likeCFJ?: Maybe<Array<Scalars["String"]>>;
};

export type SearchArgs = {
  populateMake?: Maybe<Scalars["Boolean"]>;
  populateModel?: Maybe<Scalars["Boolean"]>;
  populateAccessories?: Maybe<Scalars["Boolean"]>;
  populateAccessory?: Maybe<Scalars["Boolean"]>;
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  models?: Maybe<Array<Scalars["String"]>>;
  year?: Maybe<Scalars["String"]>;
  includeOffers?: Maybe<Scalars["Boolean"]>;
  includeImages?: Maybe<Scalars["Boolean"]>;
  version?: Maybe<Scalars["String"]>;
  page?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  keywords?: Maybe<Scalars["String"]>;
  _id?: Maybe<Scalars["String"]>;
  availability?: Maybe<Scalars["String"]>;
  company?: Maybe<Scalars["String"]>;
  isLegit?: Maybe<Scalars["Boolean"]>;
  makeKey?: Maybe<Scalars["String"]>;
  modelKey?: Maybe<Scalars["String"]>;
  local?: Maybe<Scalars["String"]>;
  passRegulation?: Maybe<Scalars["Boolean"]>;
  country?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  maxYear?: Maybe<Scalars["Int"]>;
  minYear?: Maybe<Scalars["Int"]>;
  minMonth?: Maybe<Scalars["Int"]>;
  maxMonth?: Maybe<Scalars["Int"]>;
  minPrice?: Maybe<Scalars["Int"]>;
  maxPrice?: Maybe<Scalars["Int"]>;
  minPriceCIF?: Maybe<Scalars["Int"]>;
  maxPriceCIF?: Maybe<Scalars["Int"]>;
  maxMileage?: Maybe<Scalars["Int"]>;
  minMileage?: Maybe<Scalars["Int"]>;
  location?: Maybe<Scalars["String"]>;
  isNotBulk?: Maybe<Scalars["Boolean"]>;
  minScore?: Maybe<Scalars["Float"]>;
  maxScore?: Maybe<Scalars["Float"]>;
  minPassenger?: Maybe<Scalars["Int"]>;
  maxPassenger?: Maybe<Scalars["Int"]>;
  minDisplacement?: Maybe<Scalars["Int"]>;
  maxDisplacement?: Maybe<Scalars["Int"]>;
  timeLimit?: Maybe<Scalars["DateTime"]>;
  bodyType?: Maybe<Scalars["JSON"]>;
  fuelType?: Maybe<Scalars["Int"]>;
  steering?: Maybe<Scalars["Int"]>;
  driveType?: Maybe<Scalars["Int"]>;
  transmission?: Maybe<Scalars["Int"]>;
  color?: Maybe<Scalars["JSON"]>;
  accessory?: Maybe<Array<Scalars["String"]>>;
  minDiscountPercent?: Maybe<Scalars["String"]>;
  maxDiscountPercent?: Maybe<Scalars["String"]>;
  tags?: Maybe<Array<Scalars["String"]>>;
  discounted?: Maybe<Scalars["Boolean"]>;
  discountedToday?: Maybe<Scalars["Boolean"]>;
  hasVideo?: Maybe<Scalars["Boolean"]>;
  hasInspectionRatings?: Maybe<Scalars["Boolean"]>;
  hasImage?: Maybe<Scalars["Boolean"]>;
  countOnly?: Maybe<Scalars["Boolean"]>;
  facet?: Maybe<Scalars["Boolean"]>;
  sort?: Maybe<Scalars["String"]>;
  landingTag?: Maybe<Scalars["String"]>;
  makeModelKey?: Maybe<Scalars["String"]>;
  locale?: Maybe<Scalars["String"]>;
  inspection?: Maybe<Scalars["Boolean"]>;
  insurance?: Maybe<Scalars["Boolean"]>;
  position?: Maybe<Scalars["String"]>;
};

export type SellerMonthlyStatsRow = {
  __typename?: "SellerMonthlyStatsRow";
  sellerName: Scalars["String"];
  companyId?: Maybe<Scalars["String"]>;
  plan?: Maybe<Scalars["String"]>;
  stockStatus: Scalars["Int"];
  boostVehicles: Scalars["Int"];
  activities: Scalars["Int"];
  soldVehicles: Scalars["Int"];
};

export type SellerSmsLogDetailSchema = {
  __typename?: "SellerSmsLogDetailSchema";
  id: Scalars["ID"];
  sentAt?: Maybe<Scalars["DateTime"]>;
  /** CFJ Inquiry No. */
  inquiryNo?: Maybe<Scalars["Int"]>;
  destinationCountry?: Maybe<Scalars["String"]>;
  /** InquiryStep code at send time (e.g. ISSUED_INVOICE); translated by the client */
  transactionStep?: Maybe<Scalars["String"]>;
  /** JPY excl. tax; null when the SMS is free */
  price?: Maybe<Scalars["Float"]>;
  /** JPY incl. tax (¥90 → ¥99), from the price and tax rate snapshotted at send time; null when free */
  priceInclTax?: Maybe<Scalars["Float"]>;
  isFree: Scalars["Boolean"];
  freeReason?: Maybe<Scalars["String"]>;
  /** Carrier delivery status */
  status?: Maybe<Scalars["String"]>;
  chargeStatus?: Maybe<Scalars["String"]>;
  buyerName?: Maybe<Scalars["String"]>;
  /** Recipient number, all but last 4 masked */
  maskedTo?: Maybe<Scalars["String"]>;
  /** Fixed template body that was sent */
  body?: Maybe<Scalars["String"]>;
  /** body.length */
  characters: Scalars["Int"];
  errorMessage?: Maybe<Scalars["String"]>;
};

export type SellerSmsLogItemSchema = {
  __typename?: "SellerSmsLogItemSchema";
  id: Scalars["ID"];
  sentAt?: Maybe<Scalars["DateTime"]>;
  /** CFJ Inquiry No. */
  inquiryNo?: Maybe<Scalars["Int"]>;
  destinationCountry?: Maybe<Scalars["String"]>;
  /** InquiryStep code at send time (e.g. ISSUED_INVOICE); translated by the client */
  transactionStep?: Maybe<Scalars["String"]>;
  /** JPY excl. tax; null when the SMS is free */
  price?: Maybe<Scalars["Float"]>;
  /** JPY incl. tax (¥90 → ¥99), from the price and tax rate snapshotted at send time; null when free */
  priceInclTax?: Maybe<Scalars["Float"]>;
  isFree: Scalars["Boolean"];
  freeReason?: Maybe<Scalars["String"]>;
  /** Carrier delivery status */
  status?: Maybe<Scalars["String"]>;
  chargeStatus?: Maybe<Scalars["String"]>;
};

export type SellerSmsLogsResultSchema = {
  __typename?: "SellerSmsLogsResultSchema";
  items: Array<SellerSmsLogItemSchema>;
  total: Scalars["Int"];
  offset: Scalars["Int"];
  limit: Scalars["Int"];
};

export type SellerSmsStatementSchema = {
  __typename?: "SellerSmsStatementSchema";
  /** YYYY-MM, JST */
  month: Scalars["String"];
  /** SMS-YYMM */
  documentNo: Scalars["String"];
  /** Charged + free SMS */
  totalSms: Scalars["Int"];
  billableSms: Scalars["Int"];
  freeSms: Scalars["Int"];
  /** JPY excl. tax */
  subtotal: Scalars["Float"];
  tax: Scalars["Float"];
  /** JPY incl. tax */
  total: Scalars["Float"];
  paymentStatus: SmsPaymentStatus;
};

export type SellerSmsSubscriptionSchema = {
  __typename?: "SellerSmsSubscriptionSchema";
  companyId: Scalars["ID"];
  active: Scalars["Boolean"];
  activatedAt?: Maybe<Scalars["DateTime"]>;
  deactivatedAt?: Maybe<Scalars["DateTime"]>;
  /** JPY per SMS, excluding tax (90) */
  unitPriceJPY: Scalars["Float"];
  /** JPY per SMS, including tax (99) */
  unitPriceInclTaxJPY: Scalars["Float"];
  taxRate: Scalars["Float"];
};

export type SellerSmsSummarySchema = {
  __typename?: "SellerSmsSummarySchema";
  /** YYYY-MM, JST */
  month: Scalars["String"];
  /** Every SMS sent, free ones included */
  totalSms: Scalars["Int"];
  freeSms: Scalars["Int"];
  /** SMS that are, or may still be, charged */
  billableSms: Scalars["Int"];
  /** JPY excl. tax — estimate, see docs */
  estimatedCost: Scalars["Float"];
  /** JPY incl. tax */
  estimatedCostInclTax: Scalars["Float"];
};

export type SellerStatsFilterInput = {
  startDate: Scalars["String"];
  endDate: Scalars["String"];
  plan?: Maybe<Scalars["String"]>;
  keyword?: Maybe<Scalars["String"]>;
  noSalesOnly?: Maybe<Scalars["Boolean"]>;
};

export type SellerWeeklyPeriod = {
  __typename?: "SellerWeeklyPeriod";
  startDate: Scalars["String"];
  endDate: Scalars["String"];
  stockStatus?: Maybe<Scalars["Int"]>;
  confirmedPayments: Scalars["Int"];
};

export type SellerWeeklyStatsFilterInput = {
  weeks: Array<WeekRangeInput>;
  plan?: Maybe<Scalars["String"]>;
  keyword?: Maybe<Scalars["String"]>;
};

export type SellerWeeklyStatsRow = {
  __typename?: "SellerWeeklyStatsRow";
  sellerName: Scalars["String"];
  companyId?: Maybe<Scalars["String"]>;
  plan?: Maybe<Scalars["String"]>;
  periods: Array<SellerWeeklyPeriod>;
};

export type SentInquiryResponse = {
  __typename?: "SentInquiryResponse";
  inquiry?: Maybe<InquirySchema>;
  user?: Maybe<UserSchema>;
  thankyouUrl?: Maybe<Scalars["String"]>;
  urlResetPassword?: Maybe<Scalars["String"]>;
  isNewUser?: Maybe<Scalars["Boolean"]>;
};

export type SeoFaqDto = {
  path: Scalars["String"];
  faqs: Array<Faq>;
};

export type SeoFaqPagingSchema = {
  __typename?: "SeoFaqPagingSchema";
  nodes?: Maybe<Array<SeoFaqSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type SeoFaqSchema = {
  __typename?: "SeoFaqSchema";
  id: Scalars["String"];
  path: Scalars["String"];
  faqs: Array<FaqSchema>;
};

export type SetActualArrivalDateInput = {
  id: Scalars["String"];
  actualArrivalDate?: Maybe<Scalars["String"]>;
};

export type SetAvailabilityArgs = {
  id: Scalars["String"];
  availability: Scalars["String"];
  reservedUntil?: Maybe<Scalars["String"]>;
};

export type SetCustomReferralCodeInput = {
  code: Scalars["String"];
};

export type SetInquiryTicketSubjectInput = {
  id: Scalars["String"];
  subject: Scalars["String"];
};

export type SetManualStatusArgs = {
  invoiceId: Scalars["String"];
  options: SetManualStatusOptions;
};

export type SetManualStatusOptions = {
  inquiryStatus?: Maybe<Scalars["String"]>;
  ticketStatus?: Maybe<Scalars["String"]>;
  reason?: Maybe<Scalars["String"]>;
  keepSubsequentDates?: Maybe<Scalars["Boolean"]>;
};

export type Setting = {
  __typename?: "Setting";
  id: Scalars["ID"];
  variablesConfig: Array<VariablesConfig>;
};

export type ShareBlCopyArgs = {
  invoiceId: Scalars["String"];
  files: Array<ShareBlCopyFileInput>;
};

export type ShareBlCopyFileInput = {
  filename: Scalars["String"];
  key: Scalars["String"];
};

export type ShareShippingScheduleArgs = {
  invoiceId: Scalars["String"];
  ETA: Scalars["String"];
  ETD: Scalars["String"];
  vesselName: Scalars["String"];
  isChanged?: Maybe<Scalars["Boolean"]>;
};

export type ShareTrackingArgs = {
  invoiceId: Scalars["String"];
  trackingNo: Scalars["String"];
  courierService: Scalars["String"];
};

export type ShippingAgentPagingSchema = {
  __typename?: "ShippingAgentPagingSchema";
  nodes?: Maybe<Array<ShippingAgentSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type ShippingAgentSchema = {
  __typename?: "ShippingAgentSchema";
  id: Scalars["ID"];
  name: Scalars["String"];
  carrier: Scalars["String"];
  country: Scalars["String"];
  lat?: Maybe<Scalars["String"]>;
  lng?: Maybe<Scalars["String"]>;
  port: Scalars["String"];
  address?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
  fax?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
  media?: Maybe<CfjLegacyMedia>;
};

export type ShippingDelayNotePagingSchema = {
  __typename?: "ShippingDelayNotePagingSchema";
  nodes: Array<ShippingDelayNoteSchema>;
  totalCount: Scalars["Int"];
};

export type ShippingDelayNoteSchema = {
  __typename?: "ShippingDelayNoteSchema";
  id: Scalars["ID"];
  title: Scalars["String"];
  description?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  isActive: Scalars["Boolean"];
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type ShipScheduleColumnSchema = {
  __typename?: "ShipScheduleColumnSchema";
  /** Port name as stored on the schedule's port calls */
  port: Scalars["String"];
  /** Japanese port of loading (ETD) rather than arrival */
  departure: Scalars["Boolean"];
};

export type ShipScheduleContinentSchema = {
  __typename?: "ShipScheduleContinentSchema";
  continent: Scalars["String"];
  columns: Array<ShipScheduleColumnSchema>;
  schedules: Array<ShipScheduleSchema>;
};

export type ShipScheduleListSchema = {
  __typename?: "ShipScheduleListSchema";
  continents: Array<ShipScheduleContinentSchema>;
  /** Every port that has a column, for the port filter */
  ports: Array<Scalars["String"]>;
};

export type ShipSchedulePortCallSchema = {
  __typename?: "ShipSchedulePortCallSchema";
  name: Scalars["String"];
  ETA?: Maybe<Scalars["DateTime"]>;
};

export type ShipScheduleSchema = {
  __typename?: "ShipScheduleSchema";
  company: Scalars["String"];
  name: Scalars["String"];
  voyage: Scalars["String"];
  ports: Array<ShipSchedulePortCallSchema>;
};

export type SissPickingStockAggs = {
  __typename?: "SissPickingStockAggs";
  makes: Array<Scalars["String"]>;
  models: Array<Scalars["String"]>;
};

export type SissPickingStockFilters = {
  source?: Maybe<Scalars["String"]>;
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  refNo?: Maybe<Scalars["String"]>;
  minYear?: Maybe<Scalars["Int"]>;
  maxYear?: Maybe<Scalars["Int"]>;
  minPrice?: Maybe<Scalars["Float"]>;
  maxPrice?: Maybe<Scalars["Float"]>;
  updatedAfter?: Maybe<Scalars["DateTime"]>;
  updatedBefore?: Maybe<Scalars["DateTime"]>;
  hasCar?: Maybe<Scalars["Boolean"]>;
  ignore?: Maybe<Scalars["Boolean"]>;
};

export type SissPickingStockSchema = {
  __typename?: "SissPickingStockSchema";
  _id: Scalars["ID"];
  refNo: Scalars["String"];
  source: Scalars["String"];
  thumbnail?: Maybe<Scalars["String"]>;
  make: Scalars["String"];
  model: Scalars["String"];
  year?: Maybe<Scalars["Int"]>;
  price: Scalars["Float"];
  link: Scalars["String"];
  note?: Maybe<Scalars["String"]>;
  carId?: Maybe<Scalars["ID"]>;
  ignore: Scalars["Boolean"];
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
};

export type SissPickingStocksResult = {
  __typename?: "SissPickingStocksResult";
  stocks: Array<SissPickingStockSchema>;
  total: Scalars["Int"];
};

export type SissPickingStockUpdateInput = {
  ignore?: Maybe<Scalars["Boolean"]>;
  carId?: Maybe<Scalars["ID"]>;
};

export type SlideAttributesSchema = {
  __typename?: "SlideAttributesSchema";
  title?: Maybe<Scalars["String"]>;
  link?: Maybe<Scalars["String"]>;
  image?: Maybe<MediaSchema>;
  images?: Maybe<Array<SlideImageSchema>>;
};

export type SlideImageSchema = {
  __typename?: "SlideImageSchema";
  image?: Maybe<MediaSchema>;
  link?: Maybe<Scalars["String"]>;
};

/** Why an inbound email sender is not part of the conversation */
export enum SenderWarningReason {
  NEVER_IN_THREAD = "NEVER_IN_THREAD",
  REMOVED_FROM_CC = "REMOVED_FROM_CC"
}

export type SenderWarningSchema = {
  __typename?: "SenderWarningSchema";
  email: Scalars["String"];
  reason: SenderWarningReason;
};

export enum SmsPaymentStatus {
  PAID = "PAID",
  UNPAID = "UNPAID"
}

export type SocialLoginInput = {
  provider: SocialProvider;
  credential: Scalars["String"];
};

export enum SocialProvider {
  GOOGLE = "GOOGLE",
  FACEBOOK = "FACEBOOK"
}

export type StatsMyCarSchema = {
  __typename?: "StatsMyCarSchema";
  totalInquiries: Scalars["Int"];
  totalInquiriesUnreplied: Scalars["Int"];
  totalInquiriesUnread: Scalars["Int"];
  totalInquiriesRead: Scalars["Int"];
  totalInquiriesImportant: Scalars["Int"];
  totalInquiriesClosed: Scalars["Int"];
  totalOrders: Scalars["Int"];
  totalPurchased: Scalars["Int"];
  totalShipped: Scalars["Int"];
  totalOrdersUnread: Scalars["Int"];
  totalOrdersRead: Scalars["Int"];
  totalOrdersImportant: Scalars["Int"];
  totalOrdersClosed: Scalars["Int"];
  totalFavs: Scalars["Int"];
  totalFavsAvailable: Scalars["Int"];
  totalFavsDiscounted: Scalars["Int"];
};

export type StatusCountSchema = {
  __typename?: "StatusCountSchema";
  status: Scalars["String"];
  count: Scalars["Int"];
};

export type StatusTransitionConfigInput = {
  fromStatuses?: Array<Scalars["String"]>;
  toStatus: Scalars["String"];
};

export type StatusTransitionConfigSchema = {
  __typename?: "StatusTransitionConfigSchema";
  fromStatuses: Array<Scalars["String"]>;
  toStatus?: Maybe<Scalars["String"]>;
};

export type SuggestKeywordsArgs = {
  keywords: Scalars["String"];
  limit?: Maybe<Scalars["Int"]>;
  country?: Maybe<Scalars["String"]>;
};

export type SummaryCampaignActionSchema = {
  __typename?: "SummaryCampaignActionSchema";
  state: Scalars["String"];
  amount: Scalars["Float"];
  count: Scalars["Float"];
};

export type SummaryIntroducerPagingSchema = {
  __typename?: "SummaryIntroducerPagingSchema";
  nodes?: Maybe<Array<SummaryIntroducerSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type SummaryIntroducerSchema = {
  __typename?: "SummaryIntroducerSchema";
  introducerId?: Maybe<Scalars["String"]>;
  introducerName?: Maybe<Scalars["String"]>;
  introducerEmail?: Maybe<Scalars["String"]>;
  referralCode?: Maybe<Scalars["String"]>;
  originalReferralCode?: Maybe<Scalars["String"]>;
  ongoingBuyer?: Maybe<Scalars["Float"]>;
  completedBuyer?: Maybe<Scalars["Float"]>;
  totalBuyer?: Maybe<Scalars["Float"]>;
  ongoingAmount?: Maybe<Scalars["Float"]>;
  completedAmount?: Maybe<Scalars["Float"]>;
  availableAmount?: Maybe<Scalars["Float"]>;
  totalAmount?: Maybe<Scalars["Float"]>;
  expired?: Maybe<Expired>;
  customCommission?: Maybe<Scalars["Float"]>;
  tags?: Maybe<Array<IntroducerTag>>;
  joinDate?: Maybe<Scalars["DateTime"]>;
  utm_source?: Maybe<Scalars["String"]>;
  utm_medium?: Maybe<Scalars["String"]>;
  utm_campaign?: Maybe<Scalars["String"]>;
};

export type SummaryOrderManagementSchema = {
  __typename?: "SummaryOrderManagementSchema";
  totalSales: Scalars["Float"];
  totalCfjNegoByAgent: Array<CfjNegoByAgentSchema>;
  totalCfjNegotiateSale: Scalars["Float"];
  totalSellerNegotiateSale: Scalars["Float"];
  totalCfjNegoProfit: Scalars["Float"];
  totalSellerNegoProfit: Scalars["Float"];
};

export type TaxBridgeArgs = {
  country: Scalars["String"];
  make?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  bodyType?: Maybe<Scalars["String"]>;
  engine?: Maybe<Scalars["String"]>;
  year?: Maybe<Scalars["String"]>;
  month?: Maybe<Scalars["String"]>;
  variant?: Maybe<Scalars["String"]>;
  fuel?: Maybe<Scalars["String"]>;
  previouslyRegistered?: Maybe<Scalars["Boolean"]>;
  extraDepreciation?: Maybe<Scalars["Float"]>;
  category?: Maybe<Scalars["String"]>;
};

export type TaxBridgeType = {
  __typename?: "TaxBridgeType";
  makes?: Maybe<Array<TaxOptionType>>;
  models?: Maybe<Array<TaxOptionType>>;
  bodytypes?: Maybe<Array<TaxOptionType>>;
  engines?: Maybe<Array<TaxOptionType>>;
  variants?: Maybe<Array<TaxOptionType>>;
  result?: Maybe<TaxCalculationType>;
  meta?: Maybe<TaxCalculationMetaType>;
  reason?: Maybe<Scalars["String"]>;
};

export type TaxCalculationMetaType = {
  __typename?: "TaxCalculationMetaType";
  category: Scalars["String"];
  vehicleAgeMonths: Scalars["Int"];
  previouslyRegistered: Scalars["Boolean"];
  assumedFuel: Scalars["Boolean"];
  matchedVariants: Scalars["Int"];
  crspEffectiveFrom: Scalars["String"];
};

export type TaxCalculationType = {
  __typename?: "TaxCalculationType";
  csrp?: Maybe<Scalars["Float"]>;
  customsvalue?: Maybe<Scalars["Float"]>;
  depreciation?: Maybe<Scalars["Float"]>;
  importduty?: Maybe<Scalars["Float"]>;
  excisevalue?: Maybe<Scalars["Float"]>;
  exciseduty?: Maybe<Scalars["Float"]>;
  vatvalue?: Maybe<Scalars["Float"]>;
  vat?: Maybe<Scalars["Float"]>;
  rdl?: Maybe<Scalars["Float"]>;
  idf?: Maybe<Scalars["Float"]>;
  totaltaxes?: Maybe<Scalars["Float"]>;
  grandtotal?: Maybe<Scalars["Float"]>;
};

export type TaxOptionType = {
  __typename?: "TaxOptionType";
  value: Scalars["String"];
  label: Scalars["String"];
};

export type Thumbnail = {
  __typename?: "Thumbnail";
  url?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["Float"]>;
  file_name?: Maybe<Scalars["String"]>;
  content_url?: Maybe<Scalars["String"]>;
  mapped_content_url?: Maybe<Scalars["String"]>;
  content_type?: Maybe<Scalars["String"]>;
  size?: Maybe<Scalars["Int"]>;
  width?: Maybe<Scalars["Int"]>;
  height?: Maybe<Scalars["Int"]>;
  inline?: Maybe<Scalars["Boolean"]>;
  deleted?: Maybe<Scalars["Boolean"]>;
  malware_access_override?: Maybe<Scalars["Boolean"]>;
  malware_scan_result?: Maybe<Scalars["String"]>;
};

export type Ticket = {
  __typename?: "Ticket";
  id: Scalars["Float"];
  assignee?: Maybe<Assignee>;
  status?: Maybe<Scalars["String"]>;
  requester_id?: Maybe<Scalars["Float"]>;
  custom_fields?: Maybe<Array<CustomField>>;
};

export type TicketCanaryBucketSchema = {
  __typename?: "TicketCanaryBucketSchema";
  percent: Scalars["Int"];
  overridden: Scalars["Boolean"];
};

export type TicketCanarySchema = {
  __typename?: "TicketCanarySchema";
  quality: TicketCanaryBucketSchema;
  nonQuality: TicketCanaryBucketSchema;
};

export type TicketRecordSchema = {
  __typename?: "TicketRecordSchema";
  id: Scalars["ID"];
  inquiryId?: Maybe<Scalars["ID"]>;
  ticketNo: Scalars["Float"];
  subject?: Maybe<Scalars["String"]>;
  requester?: Maybe<TicketRequesterSchema>;
  status?: Maybe<Scalars["String"]>;
  assigneeId?: Maybe<Scalars["ID"]>;
  emailCcAddresses: Array<Scalars["String"]>;
  followerIds: Array<Scalars["ID"]>;
  followers: Array<InternalTicketUserSchema>;
  mergedIntoId?: Maybe<Scalars["ID"]>;
  assignee?: Maybe<InternalTicketUserSchema>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type TicketRequesterSchema = {
  __typename?: "TicketRequesterSchema";
  name?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
};

export type TicketSchema = {
  __typename?: "TicketSchema";
  id: Scalars["Float"];
  assignee?: Maybe<AssigneeSchema>;
};

export type TicketSplitAgentStat = {
  __typename?: "TicketSplitAgentStat";
  email: Scalars["String"];
  userId?: Maybe<Scalars["String"]>;
  zendeskId?: Maybe<Scalars["Float"]>;
  name?: Maybe<Scalars["String"]>;
  foundInUsers: Scalars["Boolean"];
  configuredRatio: Scalars["Float"];
  buyersOpen: Scalars["Float"];
  ticketsOpen: Scalars["Float"];
  buyersAll: Scalars["Float"];
  ticketsAll: Scalars["Float"];
  actualRatio: Scalars["Float"];
  actualRatioOps: Scalars["Float"];
  deltaVsConfigured: Scalars["Float"];
  accepted: Scalars["Boolean"];
  wouldBeAssigned: Scalars["Boolean"];
};

export type TicketSplitBucket = {
  __typename?: "TicketSplitBucket";
  scope: Scalars["String"];
  country?: Maybe<Scalars["String"]>;
  segment: Scalars["String"];
  bandIndex: Scalars["Float"];
  bandMin: Scalars["Float"];
  bandMax?: Maybe<Scalars["Float"]>;
  matchCondition: Scalars["JSON"];
  ratioSum: Scalars["Float"];
  totalBuyersOpen: Scalars["Float"];
  denominatorUsed: Scalars["Float"];
  totalTicketsAll: Scalars["Float"];
  poolBuyersOpen: Scalars["Float"];
  agents: Array<TicketSplitAgentStat>;
  unmapped: Array<TicketSplitUnmappedStat>;
  wouldAssignTo?: Maybe<Scalars["String"]>;
  warnings: Array<Scalars["String"]>;
};

export type TicketSplitDebugArgs = {
  country?: Maybe<Scalars["String"]>;
  isQuality?: Maybe<Scalars["Boolean"]>;
  costOffer?: Maybe<Scalars["Float"]>;
  from?: Maybe<Scalars["DateTime"]>;
  to?: Maybe<Scalars["DateTime"]>;
};

export type TicketSplitDebugSchema = {
  __typename?: "TicketSplitDebugSchema";
  from: Scalars["DateTime"];
  to?: Maybe<Scalars["DateTime"]>;
  serverTimezone: Scalars["String"];
  cfjAgentGroupId: Scalars["Float"];
  ratioCountries: Array<Scalars["String"]>;
  buckets: Array<TicketSplitBucket>;
  warnings: Array<Scalars["String"]>;
};

export type TicketSplitUnmappedStat = {
  __typename?: "TicketSplitUnmappedStat";
  assigneeId?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  buyersOpen: Scalars["Float"];
  ticketsOpen: Scalars["Float"];
  buyersAll: Scalars["Float"];
  ticketsAll: Scalars["Float"];
  reason: Scalars["String"];
};

export type TicketToInquiryAssigneeSchema = {
  __typename?: "TicketToInquiryAssigneeSchema";
  mode: Scalars["String"];
  id?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
};

export type TicketToInquiryCarSchema = {
  __typename?: "TicketToInquiryCarSchema";
  carId: Scalars["String"];
  cfjNo?: Maybe<Scalars["String"]>;
  title?: Maybe<Scalars["String"]>;
  companyName?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["Int"]>;
};

export type TicketToInquiryCountrySchema = {
  __typename?: "TicketToInquiryCountrySchema";
  name: Scalars["String"];
  inspection: Scalars["String"];
  defaultInspection: Scalars["Boolean"];
  ports: Array<TicketToInquiryPortSchema>;
};

export type TicketToInquiryDefaultsSchema = {
  __typename?: "TicketToInquiryDefaultsSchema";
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  insurance: Scalars["Boolean"];
};

export type TicketToInquiryOptionsInput = {
  id: Scalars["String"];
  car?: Maybe<Scalars["String"]>;
};

export type TicketToInquiryOptionsSchema = {
  __typename?: "TicketToInquiryOptionsSchema";
  car?: Maybe<TicketToInquiryCarSchema>;
  carNotFound: Scalars["Boolean"];
  countries: Array<TicketToInquiryCountrySchema>;
  defaults: TicketToInquiryDefaultsSchema;
};

export type TicketToInquiryPortSchema = {
  __typename?: "TicketToInquiryPortSchema";
  port: Scalars["String"];
  city?: Maybe<Scalars["String"]>;
  shippingUSD?: Maybe<Scalars["Float"]>;
  inspectionUSD?: Maybe<Scalars["Float"]>;
  insuranceUSD?: Maybe<Scalars["Float"]>;
};

export type TicketToInquiryPreviewSchema = {
  __typename?: "TicketToInquiryPreviewSchema";
  blockers: Array<Scalars["String"]>;
  warnings: Array<Scalars["String"]>;
  ticket: TicketToInquiryTicketSchema;
  requester: TicketToInquiryRequesterSchema;
  car?: Maybe<TicketToInquiryCarSchema>;
  ports: Array<Scalars["String"]>;
  costFOB?: Maybe<Scalars["Float"]>;
  costShipping?: Maybe<Scalars["Float"]>;
  costInspection?: Maybe<Scalars["Float"]>;
  costInsurance?: Maybe<Scalars["Float"]>;
  costProtection?: Maybe<Scalars["Float"]>;
  costOffer?: Maybe<Scalars["Float"]>;
  exchangeRate?: Maybe<Scalars["Float"]>;
  inspection: Scalars["Boolean"];
  insurance: Scalars["Boolean"];
  inspectionPolicy?: Maybe<Scalars["String"]>;
  assignee: TicketToInquiryAssigneeSchema;
  duplicateInquiryId?: Maybe<Scalars["String"]>;
};

export type TicketToInquiryRequesterSchema = {
  __typename?: "TicketToInquiryRequesterSchema";
  name?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  isNewAccount: Scalars["Boolean"];
};

export type TicketToInquiryTicketSchema = {
  __typename?: "TicketToInquiryTicketSchema";
  id: Scalars["String"];
  ticketNo: Scalars["Int"];
  subject?: Maybe<Scalars["String"]>;
  status?: Maybe<Scalars["String"]>;
};

export type TrackCrmEventInput = {
  event: Scalars["String"];
  eventdata?: Maybe<Scalars["JSON"]>;
};

export type TrackingShip = {
  __typename?: "TrackingShip";
  shareDate?: Maybe<Scalars["DateTime"]>;
  via?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
};

export type TrackingShipSchema = {
  __typename?: "TrackingShipSchema";
  shareDate?: Maybe<Scalars["DateTime"]>;
  via?: Maybe<Scalars["String"]>;
  code?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
};

export type TransactionHistoryPagingSchema = {
  __typename?: "TransactionHistoryPagingSchema";
  nodes?: Maybe<Array<TransactionHistorySchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
  totalCommission?: Maybe<Scalars["Float"]>;
  totalOut?: Maybe<Scalars["Float"]>;
};

export type TransactionHistorySchema = {
  __typename?: "TransactionHistorySchema";
  id: Scalars["ID"];
  introducerId: Scalars["ID"];
  transactionId: Scalars["ID"];
  type: Scalars["String"];
  note: Scalars["String"];
  state: Scalars["String"];
  status?: Maybe<Scalars["String"]>;
  amount: Scalars["Float"];
  buyerEmail?: Maybe<Scalars["String"]>;
  orderId?: Maybe<Scalars["Float"]>;
  completedAt?: Maybe<Scalars["DateTime"]>;
  createdAt: Scalars["DateTime"];
  updatedAt: Scalars["DateTime"];
};

export type TransformationResult = {
  __typename?: "TransformationResult";
  transformations?: Maybe<Array<Maybe<TransformationSchema>>>;
  total?: Maybe<Scalars["Int"]>;
};

export type TransformationSchema = {
  __typename?: "TransformationSchema";
  id?: Maybe<Scalars["ID"]>;
  key?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
  keywords?: Maybe<Scalars["String"]>;
  source?: Maybe<Scalars["String"]>;
  locked?: Maybe<Scalars["Boolean"]>;
  company?: Maybe<CompanySchema>;
  fullValue?: Maybe<TransformationValueSchema>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  modifiedAt?: Maybe<Scalars["DateTime"]>;
};

/** Kind of value a transformation maps its key onto */
export enum TransformationType {
  bodyType = "bodyType",
  fuelType = "fuelType",
  make = "make",
  model = "model",
  color = "color",
  steering = "steering",
  transmission = "transmission",
  driveType = "driveType",
  accessory = "accessory",
  modelCode = "modelCode",
  grade = "grade",
  condition = "condition"
}

export type TransformationValueSchema = {
  __typename?: "TransformationValueSchema";
  id?: Maybe<Scalars["ID"]>;
  name?: Maybe<Scalars["String"]>;
  make?: Maybe<MakeSchema>;
};

export type TriggerZendeskSyncBatchInput = {
  batchSize?: Maybe<Scalars["Int"]>;
  dryRun?: Maybe<Scalars["Boolean"]>;
  fromDate?: Maybe<Scalars["DateTime"]>;
  toDate?: Maybe<Scalars["DateTime"]>;
  ticketFrom?: Maybe<Scalars["Int"]>;
  ticketTo?: Maybe<Scalars["Int"]>;
  continuous?: Maybe<Scalars["Boolean"]>;
  force?: Maybe<Scalars["Boolean"]>;
  restart?: Maybe<Scalars["Boolean"]>;
  retryFailed?: Maybe<Scalars["Boolean"]>;
  maxRpm?: Maybe<Scalars["Int"]>;
};

export type UnLikeInput = {
  car: Scalars["String"];
};

export type UpdateAuctionSheetInput = {
  overallGrade?: Maybe<Scalars["String"]>;
  evaluation?: Maybe<UpdateEvaluationInput>;
  vehicle_information?: Maybe<UpdateVehicleInformationInput>;
  equipment?: Maybe<UpdateEquipmentInput>;
  aftermarket_parts?: Maybe<Array<Scalars["String"]>>;
  aftermarket_parts_en?: Maybe<Array<Scalars["String"]>>;
  sales_points?: Maybe<Array<Scalars["String"]>>;
  sales_points_en?: Maybe<Array<Scalars["String"]>>;
  special_notes?: Maybe<Array<Scalars["String"]>>;
  special_notes_en?: Maybe<Array<Scalars["String"]>>;
  inspector_notes?: Maybe<Array<Scalars["String"]>>;
  inspector_notes_en?: Maybe<Array<Scalars["String"]>>;
  remarks?: Maybe<Array<Scalars["String"]>>;
  remarks_en?: Maybe<Array<Scalars["String"]>>;
  condition_report?: Maybe<UpdateConditionReportInput>;
  predictedGrade?: Maybe<Scalars["String"]>;
  predictedInteriorGrade?: Maybe<Scalars["String"]>;
  predictedExteriorGrade?: Maybe<Scalars["String"]>;
};

export type UpdateAutoReplyMessageInput = {
  content?: Maybe<Scalars["String"]>;
  startsAt?: Maybe<Scalars["DateTime"]>;
  endsAt?: Maybe<Scalars["DateTime"]>;
  ticketStatuses?: Maybe<Array<Scalars["String"]>>;
  agentIds?: Maybe<Array<Scalars["String"]>>;
  maxPerDay?: Maybe<Scalars["Int"]>;
  status?: Maybe<Scalars["String"]>;
  actionType?: Maybe<Scalars["String"]>;
  transitions?: Maybe<Array<StatusTransitionConfigInput>>;
};

export type UpdateBuyerContactArgs = {
  userId: Scalars["String"];
  name?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
};

export type UpdateBuyerContactSchema = {
  __typename?: "UpdateBuyerContactSchema";
  updatedInquiries: Scalars["Int"];
  userUpdated: Scalars["Boolean"];
  userError?: Maybe<Scalars["String"]>;
};

export type UpdateConditionReportInput = {
  diagram_marks?: Maybe<Array<UpdateDiagramMarkInput>>;
  general_condition?: Maybe<UpdateGeneralConditionInput>;
};

export type UpdateDiagramMarkInput = {
  position?: Maybe<Scalars["String"]>;
  position_en?: Maybe<Scalars["String"]>;
  mark?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  description_en?: Maybe<Scalars["String"]>;
};

export type UpdateEquipmentInput = {
  power_steering?: Maybe<Scalars["Boolean"]>;
  power_window?: Maybe<Scalars["Boolean"]>;
  alloy_wheels?: Maybe<Scalars["Boolean"]>;
  sunroof?: Maybe<Scalars["Boolean"]>;
  leather_seats?: Maybe<Scalars["Boolean"]>;
  airbag?: Maybe<Scalars["Boolean"]>;
  abs?: Maybe<Scalars["Boolean"]>;
  navigation?: Maybe<Scalars["Boolean"]>;
  tv?: Maybe<Scalars["Boolean"]>;
  keyless?: Maybe<Scalars["Boolean"]>;
  air_conditioner?: Maybe<Scalars["String"]>;
  air_conditioner_en?: Maybe<Scalars["String"]>;
};

export type UpdateEvaluationInput = {
  overall_score?: Maybe<Scalars["String"]>;
  interior_grade?: Maybe<Scalars["String"]>;
  exterior_grade?: Maybe<Scalars["String"]>;
  repair_history?: Maybe<Scalars["String"]>;
  repair_history_en?: Maybe<Scalars["String"]>;
};

export type UpdateForBuyerInput = {
  cost?: Maybe<Scalars["Float"]>;
  delivery?: Maybe<Scalars["Float"]>;
  communicationSpeed?: Maybe<Scalars["Float"]>;
  communicationQuality?: Maybe<Scalars["Float"]>;
  likeCFJ?: Maybe<Array<Scalars["String"]>>;
  likelyToRecommend?: Maybe<Scalars["Float"]>;
  score?: Maybe<Scalars["String"]>;
  created_at?: Maybe<Scalars["String"]>;
};

export type UpdateGeneralConditionInput = {
  front_windshield?: Maybe<Scalars["String"]>;
  front_windshield_en?: Maybe<Scalars["String"]>;
  exterior?: Maybe<Scalars["String"]>;
  exterior_en?: Maybe<Scalars["String"]>;
  interior?: Maybe<Scalars["String"]>;
  interior_en?: Maybe<Scalars["String"]>;
};

export type UpdateIntroducerCommissionInput = {
  introducerId: Scalars["String"];
  customCommission?: Maybe<Scalars["Float"]>;
};

export type UpdateIntroducerTagsInput = {
  introducerId: Scalars["String"];
  tags: Array<IntroducerTag>;
};

export type UpdateInvoiceArgs = {
  buyerUserId?: Maybe<Scalars["ID"]>;
  id: Scalars["String"];
  consigneeName?: Maybe<Scalars["String"]>;
  consigneeAddress?: Maybe<Scalars["String"]>;
  consigneePhone?: Maybe<Scalars["String"]>;
  consigneeEmail?: Maybe<Scalars["String"]>;
  name?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  comment?: Maybe<Scalars["String"]>;
  insurance?: Maybe<Scalars["Boolean"]>;
  inspection?: Maybe<Scalars["Boolean"]>;
  shipping?: Maybe<Scalars["Boolean"]>;
  transferTwice?: Maybe<Scalars["Boolean"]>;
  showBreakdown?: Maybe<Scalars["Boolean"]>;
  showShipper?: Maybe<Scalars["Boolean"]>;
  costOffer?: Maybe<Scalars["Float"]>;
  costFOB?: Maybe<Scalars["Float"]>;
  costInsurance?: Maybe<Scalars["Float"]>;
  costInspection?: Maybe<Scalars["Float"]>;
  costShipping?: Maybe<Scalars["Float"]>;
  costDelivery?: Maybe<Scalars["Float"]>;
  costDiscount?: Maybe<Scalars["Float"]>;
  reservedUSD?: Maybe<Scalars["Float"]>;
  currency?: Maybe<Scalars["String"]>;
  invoiceAmount?: Maybe<Scalars["Float"]>;
  amountAfterCoupon?: Maybe<Scalars["Float"]>;
  banks?: Maybe<Array<Scalars["String"]>>;
  hideVIN?: Maybe<Scalars["Boolean"]>;
  bankCharge?: Maybe<Scalars["Float"]>;
  paymentJPY?: Maybe<Scalars["Float"]>;
  transferCharge?: Maybe<Scalars["Float"]>;
  internalNote?: Maybe<Scalars["String"]>;
  additionalCosts?: Maybe<Scalars["String"]>;
  additionalDesc?: Maybe<Scalars["String"]>;
  documentName?: Maybe<Scalars["String"]>;
  documentAddress?: Maybe<Scalars["String"]>;
  documentPhone?: Maybe<Scalars["String"]>;
  documentEmail?: Maybe<Scalars["String"]>;
  folder?: Maybe<Scalars["String"]>;
  coupon?: Maybe<Scalars["String"]>;
  saleEvents?: Maybe<Array<SaleEventInput>>;
  addonServices?: Maybe<Array<Scalars["String"]>>;
  costService?: Maybe<Scalars["Float"]>;
  receivedUSD?: Maybe<Scalars["Float"]>;
  exchangeRate?: Maybe<Scalars["Float"]>;
  costProtection?: Maybe<Scalars["Float"]>;
  isBuyNow?: Maybe<Scalars["Boolean"]>;
  isBNPL?: Maybe<Scalars["Boolean"]>;
  extra?: Maybe<UpdateInvoiceExtraInput>;
  sendSMSTo?: Maybe<Array<Scalars["String"]>>;
  customCosts?: Maybe<Array<CustomCostItemInput>>;
};

export type UpdateInvoiceExtraInput = {
  issueAt?: Maybe<Scalars["DateTime"]>;
  estimatedProfitJPY?: Maybe<Scalars["Float"]>;
  actualProfitJPY?: Maybe<Scalars["Float"]>;
  actualProfitDate?: Maybe<Scalars["DateTime"]>;
  withTaxEstimatedProfitJPY?: Maybe<Scalars["Float"]>;
  withTaxActualProfitJPY?: Maybe<Scalars["Float"]>;
  followupLevel?: Maybe<Scalars["String"]>;
};

export type UpdateOrderManagementInput = {
  updatedLines: Array<UpdateOrderManagementLineInput>;
};

export type UpdateOrderManagementLineInput = {
  id: Scalars["ID"];
  cfjCode?: Maybe<Scalars["String"]>;
  asOrMs?: Maybe<Scalars["String"]>;
  orderNote?: Maybe<Scalars["String"]>;
  moneyIncomingUSD?: Maybe<Scalars["String"]>;
  moneyIncomingJYP?: Maybe<Scalars["Float"]>;
  bankFee?: Maybe<Scalars["Float"]>;
  refund?: Maybe<Scalars["Float"]>;
  moneyReceivedDate?: Maybe<Scalars["DateTime"]>;
  withdrawFromPaypal?: Maybe<Scalars["Boolean"]>;
  releaseToSellerJPY?: Maybe<Scalars["Float"]>;
  profitWithTax?: Maybe<Scalars["Float"]>;
  profitWithoutTax?: Maybe<Scalars["Float"]>;
  recycleFee?: Maybe<Scalars["Float"]>;
  profit?: Maybe<Scalars["Float"]>;
};

export type UpdateReviewInput = {
  authorName?: Maybe<Scalars["String"]>;
  rating?: Maybe<Scalars["Int"]>;
  title?: Maybe<Scalars["String"]>;
  content?: Maybe<Scalars["String"]>;
  reviewedAt?: Maybe<Scalars["DateTime"]>;
  url?: Maybe<Scalars["String"]>;
  isPublished?: Maybe<Scalars["Boolean"]>;
  displayOrder?: Maybe<Scalars["Int"]>;
};

export type UpdateReviewSummaryInput = {
  averageRating: Scalars["Float"];
  totalReviews: Scalars["Int"];
};

export type UpdateTicketRequesterInput = {
  name?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
};

export type UpdateVehicleInformationInput = {
  maker?: Maybe<Scalars["String"]>;
  maker_en?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  model_en?: Maybe<Scalars["String"]>;
  car_name?: Maybe<Scalars["String"]>;
  car_name_en?: Maybe<Scalars["String"]>;
  grade?: Maybe<Scalars["String"]>;
  grade_en?: Maybe<Scalars["String"]>;
  manufacturing_date?: Maybe<Scalars["String"]>;
  registration_date?: Maybe<Scalars["String"]>;
  body_type?: Maybe<Scalars["String"]>;
  body_type_en?: Maybe<Scalars["String"]>;
  engine_displacement_cc?: Maybe<Scalars["Int"]>;
  model_code?: Maybe<Scalars["String"]>;
  chassis_number?: Maybe<Scalars["String"]>;
  mileage_value?: Maybe<Scalars["Float"]>;
  mileage_unit?: Maybe<Scalars["String"]>;
  fuel?: Maybe<Scalars["String"]>;
  fuel_en?: Maybe<Scalars["String"]>;
  transmission?: Maybe<Scalars["String"]>;
  transmission_en?: Maybe<Scalars["String"]>;
  drive_system?: Maybe<Scalars["String"]>;
  drive_system_en?: Maybe<Scalars["String"]>;
  exterior_color?: Maybe<Scalars["String"]>;
  exterior_color_en?: Maybe<Scalars["String"]>;
  color_number?: Maybe<Scalars["String"]>;
  seating_capacity?: Maybe<Scalars["Int"]>;
  steering_wheel?: Maybe<Scalars["String"]>;
  steering_wheel_en?: Maybe<Scalars["String"]>;
};

export type UploadInvoiceDocsToDriveSchema = {
  __typename?: "UploadInvoiceDocsToDriveSchema";
  folderId: Scalars["String"];
  results: Array<DriveUploadResultItemSchema>;
};

export type UploadInvoiceDocumentArgs = {
  invoiceId: Scalars["String"];
  file: UploadInvoiceDocumentFileInput;
  documentType: Scalars["String"];
};

export type UploadInvoiceDocumentFileInput = {
  filename: Scalars["String"];
  key: Scalars["String"];
};

export type UploadModelImageParamsInput = {
  type?: Maybe<LocalPageImageType>;
};

export type UploadProfilePictureInput = {
  fileKey: Scalars["String"];
  userId?: Maybe<Scalars["ID"]>;
};

export type UpsertAdInput = {
  name?: Maybe<Scalars["String"]>;
  type?: Maybe<Scalars["String"]>;
  platform?: Maybe<Scalars["String"]>;
  position?: Maybe<Scalars["String"]>;
  make?: Maybe<Scalars["ID"]>;
  model?: Maybe<Scalars["ID"]>;
  content?: Maybe<Scalars["String"]>;
  slideAttributes?: Maybe<Scalars["JSON"]>;
  attributes?: Maybe<Scalars["JSON"]>;
  responsive?: Maybe<Scalars["Boolean"]>;
  parallax?: Maybe<Scalars["Boolean"]>;
  width?: Maybe<Scalars["String"]>;
  height?: Maybe<Scalars["String"]>;
  posIndex?: Maybe<Scalars["Int"]>;
  country?: Maybe<Scalars["String"]>;
  startAt?: Maybe<Scalars["DateTime"]>;
  endAt?: Maybe<Scalars["DateTime"]>;
  published?: Maybe<Scalars["Boolean"]>;
};

export type UpsertCarCostInput = {
  updatedLines: Array<UpsertCarCostLineInput>;
};

export type UpsertCarCostLineInput = {
  source?: Maybe<Scalars["String"]>;
  costName?: Maybe<Scalars["String"]>;
  invoiceDate?: Maybe<Scalars["DateTime"]>;
  paidDate?: Maybe<Scalars["DateTime"]>;
  zeinukiValue?: Maybe<Scalars["Float"]>;
  hikazeiValue?: Maybe<Scalars["Float"]>;
  recycleFeeValue?: Maybe<Scalars["Float"]>;
  note?: Maybe<Scalars["String"]>;
};

export type UpsertDealerMacroInput = {
  name: Scalars["String"];
  content: Scalars["String"];
  published?: Maybe<Scalars["Boolean"]>;
  shared?: Maybe<Scalars["Boolean"]>;
};

export type UpsertFreightFilterInput = {
  company?: Maybe<Scalars["ID"]>;
};

export type UpsertFreightInput = {
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  inspectName?: Maybe<Scalars["String"]>;
  inspectFee?: Maybe<Scalars["Float"]>;
  shippingMethod?: Maybe<Scalars["String"]>;
  m3USD?: Maybe<Scalars["Float"]>;
  m3JPY?: Maybe<Scalars["Float"]>;
  m3NZD?: Maybe<Scalars["Float"]>;
  carUSD?: Maybe<Scalars["Float"]>;
  carJPY?: Maybe<Scalars["Float"]>;
  carNZD?: Maybe<Scalars["Float"]>;
  condOverM3?: Maybe<Scalars["Float"]>;
  condUnderM3?: Maybe<Scalars["Float"]>;
  condOverHeightCm?: Maybe<Scalars["Float"]>;
  condUnderHeightCm?: Maybe<Scalars["Float"]>;
  condOverWeightTon?: Maybe<Scalars["Float"]>;
  condUnderWeightTon?: Maybe<Scalars["Float"]>;
  priority?: Maybe<Scalars["Int"]>;
  needInspection?: Maybe<Scalars["Boolean"]>;
  canBuyNow?: Maybe<Scalars["Boolean"]>;
  inform?: Maybe<Array<InformInput>>;
  cities?: Maybe<Array<CityInput>>;
};

export type UpsertInvoiceCertificateArgs = {
  _id?: Maybe<Scalars["String"]>;
  invoice?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["Float"]>;
  updatedAt?: Maybe<Scalars["Float"]>;
  no?: Maybe<Scalars["String"]>;
  refNo?: Maybe<Scalars["String"]>;
  registrationNo?: Maybe<Scalars["String"]>;
  lastRegistrationYear?: Maybe<Scalars["String"]>;
  lastRegistrationMonth?: Maybe<Scalars["String"]>;
  lastRegistrationDay?: Maybe<Scalars["String"]>;
  firstRegistrationYear?: Maybe<Scalars["String"]>;
  firstRegistrationMonth?: Maybe<Scalars["String"]>;
  firstRegistrationDay?: Maybe<Scalars["String"]>;
  vin?: Maybe<Scalars["String"]>;
  makeName?: Maybe<Scalars["String"]>;
  modelCode?: Maybe<Scalars["String"]>;
  engineModel?: Maybe<Scalars["String"]>;
  ownerName?: Maybe<Scalars["String"]>;
  ownerAddress?: Maybe<Scalars["String"]>;
  principal?: Maybe<Scalars["String"]>;
  userName?: Maybe<Scalars["String"]>;
  userAddress?: Maybe<Scalars["String"]>;
  shapeOfVehicle?: Maybe<Scalars["String"]>;
  classificationFuel?: Maybe<Scalars["String"]>;
  totalEmission?: Maybe<Scalars["String"]>;
  classificationSize?: Maybe<Scalars["String"]>;
  useOfVehicle?: Maybe<Scalars["String"]>;
  purposeOfUse?: Maybe<Scalars["String"]>;
  capacity?: Maybe<Scalars["String"]>;
  carryingCapacity?: Maybe<Scalars["String"]>;
  weightVehicle?: Maybe<Scalars["String"]>;
  maximumGrossWeight?: Maybe<Scalars["String"]>;
  speNo?: Maybe<Scalars["String"]>;
  classNo?: Maybe<Scalars["String"]>;
  ffWeight?: Maybe<Scalars["String"]>;
  frWeight?: Maybe<Scalars["String"]>;
  rfWeight?: Maybe<Scalars["String"]>;
  rrWeight?: Maybe<Scalars["String"]>;
  vehicleLength?: Maybe<Scalars["String"]>;
  vehicleWidth?: Maybe<Scalars["String"]>;
  vehicleHeight?: Maybe<Scalars["String"]>;
  dateExportYear?: Maybe<Scalars["String"]>;
  dateExportMonth?: Maybe<Scalars["String"]>;
  dateExportDay?: Maybe<Scalars["String"]>;
  scheduledExportingYear?: Maybe<Scalars["String"]>;
  scheduledExportingMonth?: Maybe<Scalars["String"]>;
  scheduledExportingDay?: Maybe<Scalars["String"]>;
  stamp?: Maybe<Scalars["Boolean"]>;
  remarks?: Maybe<Scalars["String"]>;
};

export type UpsertLandingTagInput = {
  key?: Maybe<Scalars["String"]>;
  heading?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  bodyTypes?: Maybe<Array<Scalars["Int"]>>;
  fuelTypes?: Maybe<Array<Scalars["Int"]>>;
  driveTypes?: Maybe<Array<Scalars["Int"]>>;
  transmissions?: Maybe<Array<Scalars["Int"]>>;
  steerings?: Maybe<Array<Scalars["Int"]>>;
  exteriorColors?: Maybe<Array<Scalars["Int"]>>;
  accessories?: Maybe<Array<Scalars["ID"]>>;
  models?: Maybe<Array<Scalars["ID"]>>;
  saleTags?: Maybe<Array<Scalars["ID"]>>;
  minPrice?: Maybe<Scalars["Int"]>;
  maxPrice?: Maybe<Scalars["Int"]>;
  minDisplacement?: Maybe<Scalars["Int"]>;
  maxDisplacement?: Maybe<Scalars["Int"]>;
  minYear?: Maybe<Scalars["Int"]>;
  maxYear?: Maybe<Scalars["Int"]>;
  published?: Maybe<Scalars["Boolean"]>;
};

export type UpsertModelSpecInput = {
  model?: Maybe<Scalars["ID"]>;
  modelCode?: Maybe<Scalars["String"]>;
  year?: Maybe<Scalars["Int"]>;
  bodyType?: Maybe<Scalars["Int"]>;
  door?: Maybe<Scalars["Int"]>;
  driveType?: Maybe<Scalars["Int"]>;
  displacement?: Maybe<Scalars["Int"]>;
  fuelType?: Maybe<Scalars["Int"]>;
  vehicleWidth?: Maybe<Scalars["Int"]>;
  vehicleLength?: Maybe<Scalars["Int"]>;
  vehicleHeight?: Maybe<Scalars["Int"]>;
  keywords?: Maybe<Scalars["String"]>;
};

export type UpsertRegulationInput = {
  country?: Maybe<Scalars["String"]>;
  messages?: Maybe<Array<Scalars["String"]>>;
  targeted?: Maybe<Scalars["Boolean"]>;
  rules?: Maybe<Array<RegulationRuleInput>>;
  ports?: Maybe<Array<RegulationPortInput>>;
};

export type UpsertSaleTagInput = {
  name?: Maybe<Scalars["String"]>;
  key?: Maybe<Scalars["String"]>;
  description?: Maybe<Scalars["String"]>;
  introduction?: Maybe<Scalars["String"]>;
  countries?: Maybe<Array<Scalars["String"]>>;
  showOnAdvanced?: Maybe<Scalars["Boolean"]>;
  showOnView?: Maybe<Scalars["Boolean"]>;
  published?: Maybe<Scalars["Boolean"]>;
  countdown?: Maybe<Scalars["Boolean"]>;
  keepUnmatchedCars?: Maybe<Scalars["Boolean"]>;
  images?: Maybe<Array<MediaInput>>;
  carConfigs?: Maybe<Array<CarConfigInput>>;
};

export type UpsertTransformationInput = {
  company?: Maybe<Scalars["ID"]>;
  source?: Maybe<Scalars["String"]>;
  key?: Maybe<Scalars["String"]>;
  type?: Maybe<TransformationType>;
  value?: Maybe<Scalars["String"]>;
};

export type UserInputDto = {
  status?: Maybe<Scalars["Int"]>;
  name: Scalars["String"];
  email: Scalars["String"];
  password?: Maybe<Scalars["String"]>;
  roles?: Maybe<Array<Scalars["String"]>>;
  tags?: Maybe<Array<Scalars["String"]>>;
  zendeskId?: Maybe<Scalars["Float"]>;
  namePronounciation?: Maybe<Scalars["String"]>;
  address?: Maybe<Scalars["String"]>;
  address2?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  locale?: Maybe<Scalars["String"]>;
};

export type UserSchema = {
  __typename?: "UserSchema";
  id: Scalars["ID"];
  name: Scalars["String"];
  namePronounciation?: Maybe<Scalars["String"]>;
  signature?: Maybe<Scalars["String"]>;
  email?: Maybe<Scalars["String"]>;
  roles: Array<Scalars["String"]>;
  tags?: Maybe<Array<Scalars["String"]>>;
  provider: Scalars["String"];
  locale: Scalars["String"];
  companies?: Maybe<Array<Scalars["ID"]>>;
  _companies?: Maybe<Array<CompanySchema>>;
  companyIds?: Maybe<Array<Scalars["String"]>>;
  address?: Maybe<Scalars["String"]>;
  address2?: Maybe<Scalars["String"]>;
  country?: Maybe<Scalars["String"]>;
  port?: Maybe<Scalars["String"]>;
  city?: Maybe<Scalars["String"]>;
  countryCode?: Maybe<Scalars["String"]>;
  phone?: Maybe<Scalars["String"]>;
  facebook?: Maybe<Scalars["JSON"]>;
  twitter?: Maybe<Scalars["JSON"]>;
  google?: Maybe<Scalars["JSON"]>;
  created: Scalars["DateTime"];
  lastActivity?: Maybe<Scalars["DateTime"]>;
  logoutAt?: Maybe<Scalars["DateTime"]>;
  lastAssignedAt?: Maybe<Scalars["DateTime"]>;
  verifiedPhoneAt?: Maybe<Scalars["DateTime"]>;
  birthday?: Maybe<Scalars["DateTime"]>;
  notifyMethod?: Maybe<NotifyMethod>;
  image?: Maybe<MediaSchema>;
  zendeskId?: Maybe<Scalars["Float"]>;
  utm_source?: Maybe<Scalars["String"]>;
  utm_medium?: Maybe<Scalars["String"]>;
  inspection?: Maybe<Scalars["Boolean"]>;
  insurance?: Maybe<Scalars["Boolean"]>;
  defaultCurrency: Scalars["String"];
  status?: Maybe<Scalars["Float"]>;
  deactivateAt?: Maybe<Scalars["DateTime"]>;
  changedEmailAt?: Maybe<Scalars["DateTime"]>;
  gender?: Maybe<Scalars["Float"]>;
  defaultMileageUnit?: Maybe<Scalars["String"]>;
  defaultEngineUnit?: Maybe<Scalars["String"]>;
  accessToken?: Maybe<Scalars["String"]>;
};

export type ValidateCouponInput = {
  coupon: Scalars["String"];
  inquiry?: Maybe<InquiryCouponInput>;
  userId?: Maybe<Scalars["String"]>;
  userEmail?: Maybe<Scalars["String"]>;
};

export type ValidateCouponResponse = {
  __typename?: "ValidateCouponResponse";
  valid?: Maybe<Scalars["Boolean"]>;
  message?: Maybe<Scalars["String"]>;
  messages?: Maybe<Array<Scalars["String"]>>;
  coupon?: Maybe<CouponSchema>;
};

export type VariablesConfig = {
  __typename?: "VariablesConfig";
  name: Scalars["String"];
  id: Scalars["ID"];
};

export type VehicleInformationSchema = {
  __typename?: "VehicleInformationSchema";
  maker?: Maybe<Scalars["String"]>;
  maker_en?: Maybe<Scalars["String"]>;
  model?: Maybe<Scalars["String"]>;
  model_en?: Maybe<Scalars["String"]>;
  car_name?: Maybe<Scalars["String"]>;
  car_name_en?: Maybe<Scalars["String"]>;
  grade?: Maybe<Scalars["String"]>;
  grade_en?: Maybe<Scalars["String"]>;
  manufacturing_date?: Maybe<Scalars["String"]>;
  registration_date?: Maybe<Scalars["String"]>;
  body_type?: Maybe<Scalars["String"]>;
  body_type_en?: Maybe<Scalars["String"]>;
  engine_displacement_cc?: Maybe<Scalars["Int"]>;
  model_code?: Maybe<Scalars["String"]>;
  chassis_number?: Maybe<Scalars["String"]>;
  mileage_value?: Maybe<Scalars["Float"]>;
  mileage_unit?: Maybe<Scalars["String"]>;
  fuel?: Maybe<Scalars["String"]>;
  fuel_en?: Maybe<Scalars["String"]>;
  transmission?: Maybe<Scalars["String"]>;
  transmission_en?: Maybe<Scalars["String"]>;
  drive_system?: Maybe<Scalars["String"]>;
  drive_system_en?: Maybe<Scalars["String"]>;
  exterior_color?: Maybe<Scalars["String"]>;
  exterior_color_en?: Maybe<Scalars["String"]>;
  color_number?: Maybe<Scalars["String"]>;
  seating_capacity?: Maybe<Scalars["Int"]>;
  steering_wheel?: Maybe<Scalars["String"]>;
  steering_wheel_en?: Maybe<Scalars["String"]>;
};

export type VerifyEmailInput = {
  userId: Scalars["String"];
  email: Scalars["String"];
  key: Scalars["String"];
  expire: Scalars["String"];
  confirm?: Maybe<Scalars["Boolean"]>;
};

export type VoteFeedbackResult = {
  __typename?: "VoteFeedbackResult";
  upVote: Scalars["Int"];
  downVote: Scalars["Int"];
  score?: Maybe<Scalars["Int"]>;
};

export type VoteSchema = {
  __typename?: "VoteSchema";
  user?: Maybe<UserSchema>;
  country?: Maybe<Scalars["String"]>;
  sessionId?: Maybe<Scalars["String"]>;
  userAgent?: Maybe<Scalars["String"]>;
  score?: Maybe<Scalars["Int"]>;
  ip?: Maybe<Scalars["String"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
};

export type WeekRangeInput = {
  startDate: Scalars["String"];
  endDate: Scalars["String"];
};

export type WithdrawRequestBankInJapanInfo = {
  __typename?: "WithdrawRequestBankInJapanInfo";
  accountName: Scalars["String"];
  accountNumber: Scalars["String"];
  bankName: Scalars["String"];
  typeOfAccount: Scalars["String"];
};

export type WithdrawRequestBankInJapanInfoInput = {
  accountName: Scalars["String"];
  accountNumber: Scalars["String"];
  bankName: Scalars["String"];
  typeOfAccount: Scalars["String"];
};

export type WithdrawRequestInternationalBankInfo = {
  __typename?: "WithdrawRequestInternationalBankInfo";
  bankName: Scalars["String"];
  beneficiaryAccountNumber: Scalars["String"];
  beneficiaryAddress: Scalars["String"];
  beneficiaryContact: Scalars["String"];
  beneficiaryName: Scalars["String"];
  branchAddress: Scalars["String"];
  branchName: Scalars["String"];
  swiftCode: Scalars["String"];
  noteForAdmin?: Maybe<Scalars["String"]>;
};

export type WithdrawRequestInternationalBankInfoInput = {
  bankName: Scalars["String"];
  beneficiaryAccountNumber: Scalars["String"];
  beneficiaryAddress: Scalars["String"];
  beneficiaryContact: Scalars["String"];
  beneficiaryName: Scalars["String"];
  branchAddress: Scalars["String"];
  branchName: Scalars["String"];
  swiftCode: Scalars["String"];
  noteForAdmin?: Maybe<Scalars["String"]>;
};

export type WithdrawRequestPagingSchema = {
  __typename?: "WithdrawRequestPagingSchema";
  nodes?: Maybe<Array<WithdrawRequestSchema>>;
  totalCount: Scalars["Int"];
  totalPage?: Maybe<Scalars["Int"]>;
  currentPage?: Maybe<Scalars["Int"]>;
};

export type WithdrawRequestPaypalInfo = {
  __typename?: "WithdrawRequestPaypalInfo";
  accountName: Scalars["String"];
  email: Scalars["String"];
};

export type WithdrawRequestPaypalInfoInput = {
  accountName: Scalars["String"];
  email: Scalars["String"];
};

export type WithdrawRequestSchema = {
  __typename?: "WithdrawRequestSchema";
  id: Scalars["ID"];
  bankInJapanInfo?: Maybe<WithdrawRequestBankInJapanInfo>;
  internationalBankInfo?: Maybe<WithdrawRequestInternationalBankInfo>;
  paypalInfo?: Maybe<WithdrawRequestPaypalInfo>;
  withdrawalInformation?: Maybe<Scalars["String"]>;
  withdrawalMethod?: Maybe<Scalars["String"]>;
  reasonReject?: Maybe<Scalars["String"]>;
  introducerId?: Maybe<Scalars["ID"]>;
  introducerName?: Maybe<Scalars["String"]>;
  introducerEmail?: Maybe<Scalars["String"]>;
  note?: Maybe<Scalars["String"]>;
  state?: Maybe<Scalars["String"]>;
  amount?: Maybe<Scalars["Float"]>;
  fee?: Maybe<Scalars["Float"]>;
  totalAmount: Scalars["Float"];
  requestAt?: Maybe<Scalars["DateTime"]>;
  createdAt?: Maybe<Scalars["DateTime"]>;
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export type ZendeskArticle = {
  __typename?: "ZendeskArticle";
  id: Scalars["Float"];
  url: Scalars["String"];
  html_url: Scalars["String"];
  author_id: Scalars["Float"];
  comments_disabled: Scalars["Boolean"];
  draft: Scalars["Boolean"];
  promoted: Scalars["Boolean"];
  position: Scalars["Float"];
  vote_sum: Scalars["Float"];
  vote_count: Scalars["Float"];
  section_id: Scalars["Float"];
  body: Scalars["String"];
  locale: Scalars["String"];
  title: Scalars["String"];
  name: Scalars["String"];
  updated_at?: Maybe<Scalars["DateTime"]>;
};

export type ZendeskAttachment = {
  __typename?: "ZendeskAttachment";
  url?: Maybe<Scalars["String"]>;
  id?: Maybe<Scalars["Float"]>;
  file_name?: Maybe<Scalars["String"]>;
  content_url?: Maybe<Scalars["String"]>;
  mapped_content_url?: Maybe<Scalars["String"]>;
  content_type?: Maybe<Scalars["String"]>;
  size?: Maybe<Scalars["Int"]>;
  width?: Maybe<Scalars["Float"]>;
  height?: Maybe<Scalars["Float"]>;
  inline?: Maybe<Scalars["Boolean"]>;
  deleted?: Maybe<Scalars["Boolean"]>;
  malware_access_override?: Maybe<Scalars["Boolean"]>;
  malware_scan_result?: Maybe<Scalars["String"]>;
  thumbnails?: Maybe<Array<Thumbnail>>;
};

export type ZendeskCommentsResponse = {
  __typename?: "ZendeskCommentsResponse";
  comments?: Maybe<Array<InvoiceCommentSchema>>;
};

export type ZendeskFaqArticleSchema = {
  __typename?: "ZendeskFAQArticleSchema";
  id: Scalars["Float"];
  url: Scalars["String"];
  html_url: Scalars["String"];
  author_id: Scalars["Float"];
  comments_disabled: Scalars["Boolean"];
  draft: Scalars["Boolean"];
  promoted: Scalars["Boolean"];
  position: Scalars["Float"];
  vote_sum: Scalars["Float"];
  vote_count: Scalars["Float"];
  section_id: Scalars["Float"];
  created_at: Scalars["String"];
  updated_at: Scalars["String"];
  name: Scalars["String"];
  title: Scalars["String"];
  source_locale: Scalars["String"];
  locale: Scalars["String"];
  outdated: Scalars["Boolean"];
  body: Scalars["String"];
};

export type ZendeskFaqCategorySchema = {
  __typename?: "ZendeskFAQCategorySchema";
  id: Scalars["Float"];
  url: Scalars["String"];
  html_url: Scalars["String"];
  position: Scalars["Float"];
  created_at: Scalars["String"];
  updated_at: Scalars["String"];
  name: Scalars["String"];
  description: Scalars["String"];
  locale: Scalars["String"];
  source_locale: Scalars["String"];
  outdated: Scalars["Boolean"];
};

export type ZendeskFaqSchema = {
  __typename?: "ZendeskFAQSchema";
  categories?: Maybe<Array<ZendeskFaqCategorySchema>>;
  sections?: Maybe<Array<ZendeskFaqSectionSchema>>;
  articles?: Maybe<Array<ZendeskFaqArticleSchema>>;
  results?: Maybe<Scalars["JSON"]>;
  page?: Maybe<Scalars["Float"]>;
  previous_page?: Maybe<Scalars["String"]>;
  next_page?: Maybe<Scalars["String"]>;
  per_page?: Maybe<Scalars["Float"]>;
  page_count?: Maybe<Scalars["Float"]>;
  count?: Maybe<Scalars["Float"]>;
  sort_by?: Maybe<Scalars["String"]>;
  sort_order?: Maybe<Scalars["String"]>;
};

export type ZendeskFaqSectionSchema = {
  __typename?: "ZendeskFAQSectionSchema";
  id: Scalars["Float"];
  url: Scalars["String"];
  html_url: Scalars["String"];
  category_id: Scalars["Float"];
  position: Scalars["Float"];
  sorting: Scalars["String"];
  created_at: Scalars["String"];
  updated_at: Scalars["String"];
  name: Scalars["String"];
  description: Scalars["String"];
  locale: Scalars["String"];
  source_locale: Scalars["String"];
  outdated: Scalars["Boolean"];
  articles?: Maybe<Array<ZendeskFaqArticleSchema>>;
};

export type ZendeskGetFaqArgs = {
  root: Scalars["String"];
  query?: Maybe<Scalars["String"]>;
  per_page?: Maybe<Scalars["Float"]>;
  id?: Maybe<Scalars["String"]>;
  fetch_content?: Maybe<Scalars["Boolean"]>;
  label?: Maybe<Scalars["String"]>;
};

export type ZendeskSyncFailureSchema = {
  __typename?: "ZendeskSyncFailureSchema";
  ticketId: Scalars["Int"];
  zendeskTicketId: Scalars["Int"];
  error: Scalars["String"];
  at: Scalars["String"];
};

export type ZendeskSyncJobSchema = {
  __typename?: "ZendeskSyncJobSchema";
  status: Scalars["String"];
  lastId?: Maybe<Scalars["ID"]>;
  processed: Scalars["Int"];
  skipped?: Maybe<Scalars["Int"]>;
  failed: Scalars["Int"];
  total: Scalars["Int"];
  scope?: Maybe<ZendeskSyncScopeSchema>;
  startedAt?: Maybe<Scalars["String"]>;
  updatedAt?: Maybe<Scalars["String"]>;
  stopRequested?: Maybe<Scalars["Boolean"]>;
  stale: Scalars["Boolean"];
};

export type ZendeskSyncScopeSchema = {
  __typename?: "ZendeskSyncScopeSchema";
  fromDate?: Maybe<Scalars["String"]>;
  ticketFrom?: Maybe<Scalars["Int"]>;
  ticketTo?: Maybe<Scalars["Int"]>;
  force?: Maybe<Scalars["Boolean"]>;
  continuous?: Maybe<Scalars["Boolean"]>;
  maxRpm?: Maybe<Scalars["Int"]>;
};

export type ZendeskTicketAudit = {
  __typename?: "ZendeskTicketAudit";
  id: Scalars["Float"];
  ticket_id: Scalars["Float"];
  author_id: Scalars["Float"];
  created_at: Scalars["String"];
  events: Array<ZendeskTicketAuditEvent>;
};

export type ZendeskTicketAuditEvent = {
  __typename?: "ZendeskTicketAuditEvent";
  id: Scalars["Float"];
  type: Scalars["String"];
  author_id?: Maybe<Scalars["Float"]>;
  body?: Maybe<Scalars["String"]>;
  html_body?: Maybe<Scalars["String"]>;
  public?: Maybe<Scalars["Boolean"]>;
  field_name?: Maybe<Scalars["String"]>;
  previous_value?: Maybe<Scalars["String"]>;
  value?: Maybe<Scalars["String"]>;
  attachments?: Maybe<Array<ZendeskAttachment>>;
};

export type ZendeskTicketAuditsResponse = {
  __typename?: "ZendeskTicketAuditsResponse";
  audits: Array<ZendeskTicketAudit>;
  count: Scalars["Float"];
  next_page?: Maybe<Scalars["String"]>;
  previous_page?: Maybe<Scalars["String"]>;
};

export type GetAdsQueryVariables = Exact<{
  filters?: Maybe<GetAdsFiltersInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
}>;

export type GetAdsQuery = { __typename?: "Query" } & {
  getAds: { __typename?: "AdminAdsResult" } & Pick<AdminAdsResult, "total"> & {
      ads: Array<
        { __typename?: "AdminAdSchema" } & Pick<
          AdminAdSchema,
          "_id" | "name" | "type" | "platform" | "position" | "attributes" | "responsive" | "startAt" | "endAt" | "slideAttributes" | "parallax" | "width" | "height" | "posIndex" | "content" | "country" | "published"
        > & {
            make?: Maybe<{ __typename?: "AdRefSchema" } & Pick<AdRefSchema, "_id">>;
            model?: Maybe<{ __typename?: "AdRefSchema" } & Pick<AdRefSchema, "_id">>;
          }
      >;
    };
};

export type UpsertAdMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  data: UpsertAdInput;
}>;

export type UpsertAdMutation = { __typename?: "Mutation" } & {
  upsertAd: { __typename?: "AdminAdSchema" } & Pick<
    AdminAdSchema,
    "_id" | "name" | "type" | "platform" | "position" | "attributes" | "slideAttributes" | "responsive" | "parallax" | "width" | "height" | "posIndex" | "content" | "country" | "published"
  > & {
      make?: Maybe<{ __typename?: "AdRefSchema" } & Pick<AdRefSchema, "_id">>;
      model?: Maybe<{ __typename?: "AdRefSchema" } & Pick<AdRefSchema, "_id">>;
    };
};

export type DeleteAdMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DeleteAdMutation = { __typename?: "Mutation" } & Pick<Mutation, "removeAd">;

export type LoginMutationVariables = Exact<{
  input: LoginInput;
}>;

export type LoginMutation = { __typename?: "Mutation" } & {
  login: { __typename?: "UserSchema" } & Pick<UserSchema, "id" | "email" | "name" | "roles" | "accessToken">;
};

export type SocialLoginMutationVariables = Exact<{
  input: SocialLoginInput;
}>;

export type SocialLoginMutation = { __typename?: "Mutation" } & {
  socialLogin: { __typename?: "UserSchema" } & Pick<UserSchema, "id" | "email" | "name" | "roles" | "accessToken">;
};

export type RenewTokenMutationVariables = Exact<{ [key: string]: never }>;

export type RenewTokenMutation = { __typename?: "Mutation" } & {
  renewToken: { __typename?: "UserSchema" } & Pick<UserSchema, "id" | "email" | "accessToken">;
};

export type LogoutMutationVariables = Exact<{ [key: string]: never }>;

export type LogoutMutation = { __typename?: "Mutation" } & Pick<Mutation, "logout">;

export type GetBillingCompanyQueryVariables = Exact<{
  filters?: Maybe<Scalars["JSON"]>;
}>;

export type GetBillingCompanyQuery = { __typename?: "Query" } & {
  getBillingCompany: Array<{ __typename?: "BillingCompanyRef" } & Pick<BillingCompanyRef, "_id" | "enName" | "name">>;
};

export type GetBillingsQueryVariables = Exact<{
  filters?: Maybe<Scalars["JSON"]>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
}>;

export type GetBillingsQuery = { __typename?: "Query" } & {
  getBillings: { __typename?: "AdminBillingsResult" } & Pick<AdminBillingsResult, "total"> & {
      billings: Array<
        { __typename?: "AdminBillingSchema" } & Pick<AdminBillingSchema, "_id" | "seq" | "items" | "period" | "status" | "paidAt" | "sentAt" | "dueAt" | "overall" | "totalTax" | "overallBeforeTax" | "createdAt"> & {
            company?: Maybe<{ __typename?: "BillingCompanyRef" } & Pick<BillingCompanyRef, "_id" | "enName" | "name">>;
          }
      >;
    };
};

export type UpsertBillingMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  data: BillingUpsertInput;
}>;

export type UpsertBillingMutation = { __typename?: "Mutation" } & {
  upsertBilling: { __typename?: "AdminBillingSchema" } & Pick<AdminBillingSchema, "_id" | "seq" | "items" | "period" | "status" | "paidAt" | "sentAt" | "dueAt" | "overall" | "totalTax" | "overallBeforeTax" | "createdAt"> & {
      company?: Maybe<{ __typename?: "BillingCompanyRef" } & Pick<BillingCompanyRef, "_id" | "enName" | "name">>;
    };
};

export type RemoveBillingMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type RemoveBillingMutation = { __typename?: "Mutation" } & Pick<Mutation, "removeBilling">;

export type ResendBillingMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type ResendBillingMutation = { __typename?: "Mutation" } & Pick<Mutation, "resendBilling">;

export type CanaryHealthQueryVariables = Exact<{
  args?: Maybe<CanaryHealthArgs>;
}>;

export type CanaryHealthQuery = { __typename?: "Query" } & {
  canaryHealth: { __typename?: "CanaryHealth" } & Pick<
    CanaryHealth,
    "level" | "generatedAt" | "windowFrom" | "windowTo" | "windowHours" | "graceMinutes" | "internalInquiries" | "zendeskInquiries" | "unticketedInquiries" | "truncated" | "durationMs"
  > & {
      checks: Array<
        { __typename?: "CanaryCheck" } & Pick<CanaryCheck, "key" | "title" | "description" | "severity" | "status" | "count" | "total" | "note" | "durationMs"> & {
            samples: Array<{ __typename?: "CanaryHealthSample" } & Pick<CanaryHealthSample, "inquiryId" | "ticketNo" | "reason" | "at">>;
          }
      >;
      split: Array<{ __typename?: "CanarySplitBucket" } & Pick<CanarySplitBucket, "key" | "label" | "configuredPercent" | "overridden" | "internal" | "zendesk" | "observedPercent" | "expectedMin" | "expectedMax" | "status" | "since">>;
    };
};

export type ConfirmCarAvailabilityMutationVariables = Exact<{
  key: Scalars["String"];
}>;

export type ConfirmCarAvailabilityMutation = { __typename?: "Mutation" } & {
  confirmCarAvailability: {
    __typename?: "ConfirmCarAvailabilitySchema";
  } & Pick<ConfirmCarAvailabilitySchema, "invoiceId" | "availability">;
};

export type GetCarQueryVariables = Exact<{
  id?: Maybe<Scalars["String"]>;
}>;

export type GetCarQuery = { __typename?: "Query" } & {
  getCar?: Maybe<
    { __typename?: "CarSchema" } & Pick<
      CarSchema,
      | "id"
      | "refNo"
      | "currency"
      | "oversea"
      | "domestic"
      | "internalNote"
      | "title"
      | "catchPhrase"
      | "status"
      | "price"
      | "priceMin"
      | "modifiedAt"
      | "expiredAt"
      | "VIN"
      | "youtubeURL"
      | "grade"
      | "inspectionAuthority"
      | "inspectionRatings"
      | "plusPoint"
      | "minusPoint"
      | "modelCode"
      | "tags"
      | "specialities"
      | "currencyKey"
      | "door"
      | "mileage"
      | "displacement"
      | "passengers"
      | "bodyType"
      | "fuelType"
      | "driveType"
      | "steering"
      | "transmission"
      | "exteriorColor"
      | "interiorColor"
      | "vehicleWidth"
      | "vehicleLength"
      | "vehicleHeight"
      | "registrationMonth"
      | "registrationYear"
      | "manufacturedMonth"
      | "manufacturedYear"
      | "m3"
      | "comment"
      | "priceUSD"
      | "priceOriginal"
      | "reservedUntil"
      | "locked"
      | "lockedMedia"
    > & {
        images?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "id" | "filename" | "cdnUri" | "order" | "mime">>>;
        accessories?: Maybe<Array<{ __typename?: "AccessorySchema" } & Pick<AccessorySchema, "id">>>;
        make?: Maybe<{ __typename?: "MakeSchema" } & Pick<MakeSchema, "id">>;
        model?: Maybe<{ __typename?: "ModelSchema" } & Pick<ModelSchema, "id">>;
        company?: Maybe<{ __typename?: "CompanySchema" } & Pick<CompanySchema, "id" | "name" | "enName">>;
      }
  >;
};

export type UpdateCarMutationVariables = Exact<{
  id: Scalars["String"];
  data: Scalars["JSON"];
}>;

export type UpdateCarMutation = { __typename?: "Mutation" } & {
  updateCar?: Maybe<
    { __typename?: "CarSchema" } & Pick<
      CarSchema,
      | "id"
      | "refNo"
      | "currency"
      | "oversea"
      | "domestic"
      | "internalNote"
      | "title"
      | "catchPhrase"
      | "status"
      | "price"
      | "priceMin"
      | "modifiedAt"
      | "expiredAt"
      | "VIN"
      | "youtubeURL"
      | "grade"
      | "inspectionAuthority"
      | "inspectionRatings"
      | "plusPoint"
      | "minusPoint"
      | "modelCode"
      | "tags"
      | "specialities"
      | "currencyKey"
      | "door"
      | "mileage"
      | "displacement"
      | "passengers"
      | "fuelType"
      | "driveType"
      | "bodyType"
      | "steering"
      | "transmission"
      | "exteriorColor"
      | "interiorColor"
      | "vehicleWidth"
      | "vehicleLength"
      | "vehicleHeight"
      | "registrationMonth"
      | "registrationYear"
      | "manufacturedMonth"
      | "manufacturedYear"
      | "m3"
      | "comment"
      | "priceUSD"
      | "priceOriginal"
      | "locked"
      | "lockedMedia"
      | "reservedUntil"
    > & {
        images?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "id" | "filename" | "cdnUri" | "order" | "mime">>>;
        accessories?: Maybe<Array<{ __typename?: "AccessorySchema" } & Pick<AccessorySchema, "id">>>;
        make?: Maybe<{ __typename?: "MakeSchema" } & Pick<MakeSchema, "id">>;
        model?: Maybe<{ __typename?: "ModelSchema" } & Pick<ModelSchema, "id">>;
        company?: Maybe<{ __typename?: "CompanySchema" } & Pick<CompanySchema, "id">>;
      }
  >;
};

export type CountCarsQueryVariables = Exact<{
  filters: Array<QueryCarsAdminFilters> | QueryCarsAdminFilters;
}>;

export type CountCarsQuery = { __typename?: "Query" } & Pick<Query, "countCars">;

export type QueryCarsQueryVariables = Exact<{
  filters?: Maybe<QueryCarsAdminFilters>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
}>;

export type QueryCarsQuery = { __typename?: "Query" } & {
  queryCars: { __typename?: "QueryCarsAdminResult" } & Pick<QueryCarsAdminResult, "total"> & {
      cars: Array<
        { __typename?: "CarSchema" } & Pick<
          CarSchema,
          "id" | "status" | "refNo" | "price" | "priceMin" | "pvCount" | "url" | "carUrl" | "internalNote" | "created" | "modifiedAt" | "expiredAt" | "title" | "VIN" | "tags" | "specialities" | "currencyKey" | "discountPercent"
        > & {
            images?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "_id" | "filename" | "cdnUri" | "order" | "mime">>>;
            company?: Maybe<{ __typename?: "CompanySchema" } & Pick<CompanySchema, "id" | "name" | "enName" | "inContract" | "plan">>;
          }
      >;
    };
};

export type ExportCarsCsvMutationVariables = Exact<{
  filters?: Maybe<QueryCarsAdminFilters>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
}>;

export type ExportCarsCsvMutation = { __typename?: "Mutation" } & Pick<Mutation, "exportCarsCsv">;

export type GetCarAggsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCarAggsQuery = { __typename?: "Query" } & {
  getCarAggs: { __typename?: "CarAggsResult" } & {
    tags: Array<{ __typename?: "CarAggBucket" } & Pick<CarAggBucket, "key" | "doc_count">>;
    specialities: Array<{ __typename?: "CarAggBucket" } & Pick<CarAggBucket, "key" | "doc_count">>;
  };
};

export type BatchCarsMutationVariables = Exact<{
  ids: Array<Scalars["String"]> | Scalars["String"];
  action: Scalars["String"];
  data?: Maybe<Scalars["JSON"]>;
}>;

export type BatchCarsMutation = { __typename?: "Mutation" } & {
  batchCars: Array<{ __typename?: "CarSchema" } & Pick<CarSchema, "id" | "status" | "price" | "priceMin" | "internalNote" | "created" | "modifiedAt" | "expiredAt" | "tags" | "specialities">>;
};

export type AddCarImagesMutationVariables = Exact<{
  id: Scalars["String"];
  files: Array<Scalars["String"]> | Scalars["String"];
}>;

export type AddCarImagesMutation = { __typename?: "Mutation" } & {
  addCarImages?: Maybe<
    { __typename?: "CarSchema" } & Pick<CarSchema, "id"> & {
        images?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "id" | "filename" | "cdnUri" | "order" | "mime">>>;
      }
  >;
};

export type RemoveCarImagesMutationVariables = Exact<{
  id: Scalars["String"];
  images: Array<Scalars["String"]> | Scalars["String"];
}>;

export type RemoveCarImagesMutation = { __typename?: "Mutation" } & {
  removeCarImages?: Maybe<
    { __typename?: "CarSchema" } & Pick<CarSchema, "id"> & {
        images?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "id" | "filename" | "cdnUri" | "order" | "mime">>>;
      }
  >;
};

export type SetCountryScoreMutationVariables = Exact<{
  id: Scalars["String"];
  country: Scalars["String"];
  score: Scalars["Float"];
}>;

export type SetCountryScoreMutation = { __typename?: "Mutation" } & Pick<Mutation, "setCountryScore">;

export type GetCarAggsBucketQueryVariables = Exact<{
  modelCode: Scalars["String"];
}>;

export type GetCarAggsBucketQuery = { __typename?: "Query" } & Pick<Query, "getCarAggsBucket">;

export type GetAdminAccessoriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetAdminAccessoriesQuery = { __typename?: "Query" } & {
  getAdminAccessories: Array<{ __typename?: "AccessorySchema" } & Pick<AccessorySchema, "id" | "name" | "type">>;
};

export type GetManagementMakeQueryVariables = Exact<{
  args?: Maybe<GetAllMakeArgs>;
}>;

export type GetManagementMakeQuery = { __typename?: "Query" } & {
  getManagementMake: { __typename?: "GetManagementMakeType" } & Pick<GetManagementMakeType, "total"> & {
      items: Array<{ __typename?: "MakeSchema" } & Pick<MakeSchema, "id" | "name" | "key">>;
    };
};

export type GetManyModelsQueryVariables = Exact<{
  input?: Maybe<GetManyModelsArgs>;
}>;

export type GetManyModelsQuery = { __typename?: "Query" } & {
  getManyModels: { __typename?: "GetManyModelsType" } & Pick<GetManyModelsType, "total"> & {
      items: Array<{ __typename?: "ModelSchema" } & Pick<ModelSchema, "id" | "name" | "key" | "makeModelKey">>;
    };
};

export type DetailsCarContextQueryVariables = Exact<{
  id?: Maybe<Scalars["String"]>;
}>;

export type DetailsCarContextQuery = { __typename?: "Query" } & Pick<Query, "masterdata" | "getCarAnalytics"> & {
    makes: Array<{ __typename?: "MakeSchema" } & Pick<MakeSchema, "id" | "name" | "key">>;
    accessories: Array<{ __typename?: "AccessorySchema" } & Pick<AccessorySchema, "id" | "name" | "type">>;
  };

export type CrawlCarMutationVariables = Exact<{
  url: Scalars["String"];
  source: CrawlCarSource;
  company?: Maybe<Scalars["String"]>;
}>;

export type CrawlCarMutation = { __typename?: "Mutation" } & {
  crawlCar?: Maybe<{ __typename?: "CarSchema" } & Pick<CarSchema, "id">>;
};

export type CarDashboardSummaryQueryVariables = Exact<{ [key: string]: never }>;

export type CarDashboardSummaryQuery = { __typename?: "Query" } & {
  carDashboardSummary: { __typename?: "CarDashboardSummary" } & Pick<CarDashboardSummary, "carCount" | "expireSoon" | "countReserved">;
};

export type CarDashboardStatsQueryVariables = Exact<{
  filters: DashboardFiltersInput;
}>;

export type CarDashboardStatsQuery = { __typename?: "Query" } & {
  carDashboardStats: { __typename?: "CarDashboardStats" } & {
    cars: { __typename?: "DashboardPeriodStat" } & Pick<DashboardPeriodStat, "current" | "lastMonth">;
    views: { __typename?: "DashboardPeriodStat" } & Pick<DashboardPeriodStat, "current" | "lastMonth">;
  };
};

export type CarDashboardViewsQueryVariables = Exact<{
  filters: DashboardFiltersInput;
}>;

export type CarDashboardViewsQuery = { __typename?: "Query" } & {
  carDashboardViews: Array<{ __typename?: "CarDashboardViewDay" } & Pick<CarDashboardViewDay, "day" | "total">>;
};

export type GetCompaniesAdminQueryVariables = Exact<{
  filters?: Maybe<Scalars["JSON"]>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
}>;

export type GetCompaniesAdminQuery = { __typename?: "Query" } & {
  getCompaniesAdmin: { __typename?: "CompanyPagingType" } & Pick<CompanyPagingType, "total"> & {
      companies: Array<
        { __typename?: "CompanyAdminType" } & Pick<
          CompanyAdminType,
          | "_id"
          | "key"
          | "name"
          | "enName"
          | "address"
          | "addressKana"
          | "postalCode"
          | "telephone"
          | "fax"
          | "email"
          | "website"
          | "carCount"
          | "denyImagesIndex"
          | "cropingImage"
          | "buynowSettings"
          | "inContract"
          | "selfNegotiation"
          | "plan"
          | "assignee"
          | "reservedCount"
          | "updated30days"
          | "soldLastMonth"
          | "saleCount"
          | "status"
          | "importFromTCV"
          | "importFromGoo"
          | "importFromCarsensor"
          | "contractStart"
          | "contractEnd"
          | "persionInCharge"
          | "preferLanguage"
          | "totalEmployees"
          | "annualSale"
          | "daysExp"
          | "capital"
          | "yearEstablished"
          | "ownershipType"
          | "introduction"
          | "bankName"
          | "bankBranch"
          | "bankAccount"
          | "bankHolder"
          | "kanaBankHolder"
          | "bankType"
          | "autoResponse"
          | "monthlyFee"
          | "annualFee"
          | "marginPercent"
          | "marginPercentCIF"
          | "marginUSD"
          | "marginMin"
          | "marginMax"
          | "domesticBankCharge"
          | "serviceChargeUSD"
          | "adjustCIFbyUSD"
          | "adjustCIFbyPercent"
          | "adjustFOBbyUSD"
          | "adjustFOBbyPercent"
          | "adjustShippingbyUSD"
          | "adjustInsuranceTo"
          | "adjustBuyerProtectionTo"
          | "adminNote"
          | "internalNote"
          | "startPay"
          | "registeredGMOAt"
          | "activatedGMO"
          | "dealerPage"
          | "canEditFreight"
          | "serviceTaxInclusive"
          | "published"
          | "members"
          | "scoreBoost"
          | "TCVID"
          | "gooId"
          | "carsensorId"
          | "slug"
        > & {
            denyImages?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "original" | "filename" | "mime" | "checksum" | "cdnUri">>>;
            images?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "original" | "filename" | "mime" | "checksum" | "cdnUri">>>;
            signature?: Maybe<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "original" | "filename" | "mime" | "checksum" | "cdnUri">>;
          }
      >;
    };
};

export type GetManipulatedCompaniesQueryVariables = Exact<{
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
}>;

export type GetManipulatedCompaniesQuery = { __typename?: "Query" } & {
  getManipulatedCompanies: { __typename?: "CompanyPagingType" } & Pick<CompanyPagingType, "total"> & {
      companies: Array<
        { __typename?: "CompanyAdminType" } & Pick<
          CompanyAdminType,
          | "_id"
          | "key"
          | "name"
          | "enName"
          | "address"
          | "addressKana"
          | "postalCode"
          | "telephone"
          | "fax"
          | "email"
          | "website"
          | "carCount"
          | "denyImagesIndex"
          | "cropingImage"
          | "buynowSettings"
          | "inContract"
          | "selfNegotiation"
          | "plan"
          | "assignee"
          | "reservedCount"
          | "updated30days"
          | "soldLastMonth"
          | "saleCount"
          | "status"
          | "importFromTCV"
          | "importFromGoo"
          | "importFromCarsensor"
          | "contractStart"
          | "contractEnd"
          | "persionInCharge"
          | "preferLanguage"
          | "totalEmployees"
          | "annualSale"
          | "daysExp"
          | "capital"
          | "yearEstablished"
          | "ownershipType"
          | "introduction"
          | "bankName"
          | "bankBranch"
          | "bankAccount"
          | "bankHolder"
          | "kanaBankHolder"
          | "bankType"
          | "autoResponse"
          | "monthlyFee"
          | "annualFee"
          | "marginPercent"
          | "marginPercentCIF"
          | "marginUSD"
          | "marginMin"
          | "marginMax"
          | "domesticBankCharge"
          | "serviceChargeUSD"
          | "adjustCIFbyUSD"
          | "adjustCIFbyPercent"
          | "adjustFOBbyUSD"
          | "adjustFOBbyPercent"
          | "adjustShippingbyUSD"
          | "adjustInsuranceTo"
          | "adjustBuyerProtectionTo"
          | "adminNote"
          | "internalNote"
          | "startPay"
          | "registeredGMOAt"
          | "activatedGMO"
          | "dealerPage"
          | "canEditFreight"
          | "serviceTaxInclusive"
          | "published"
          | "members"
          | "scoreBoost"
          | "TCVID"
          | "gooId"
          | "carsensorId"
          | "slug"
        > & {
            denyImages?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "original" | "filename" | "mime" | "checksum" | "cdnUri">>>;
            images?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "original" | "filename" | "mime" | "checksum" | "cdnUri">>>;
            signature?: Maybe<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "original" | "filename" | "mime" | "checksum" | "cdnUri">>;
          }
      >;
    };
};

export type UpsertCompanyMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  data?: Maybe<Scalars["JSON"]>;
}>;

export type UpsertCompanyMutation = { __typename?: "Mutation" } & {
  upsertCompany: { __typename?: "CompanyAdminType" } & Pick<
    CompanyAdminType,
    | "_id"
    | "key"
    | "name"
    | "enName"
    | "address"
    | "addressKana"
    | "postalCode"
    | "telephone"
    | "fax"
    | "email"
    | "website"
    | "carCount"
    | "daysExp"
    | "denyImagesIndex"
    | "cropingImage"
    | "buynowSettings"
    | "inContract"
    | "selfNegotiation"
    | "plan"
    | "reservedCount"
    | "updated30days"
    | "soldLastMonth"
    | "saleCount"
    | "assignee"
    | "status"
    | "importFromTCV"
    | "importFromGoo"
    | "importFromCarsensor"
    | "contractStart"
    | "contractEnd"
    | "persionInCharge"
    | "preferLanguage"
    | "totalEmployees"
    | "annualSale"
    | "capital"
    | "yearEstablished"
    | "ownershipType"
    | "introduction"
    | "bankName"
    | "bankBranch"
    | "bankAccount"
    | "bankHolder"
    | "kanaBankHolder"
    | "bankType"
    | "autoResponse"
    | "monthlyFee"
    | "annualFee"
    | "marginPercent"
    | "marginPercentCIF"
    | "marginUSD"
    | "marginMin"
    | "marginMax"
    | "domesticBankCharge"
    | "serviceChargeUSD"
    | "adjustCIFbyUSD"
    | "adjustCIFbyPercent"
    | "adjustFOBbyUSD"
    | "adjustFOBbyPercent"
    | "adjustShippingbyUSD"
    | "adjustInsuranceTo"
    | "adjustBuyerProtectionTo"
    | "adminNote"
    | "internalNote"
    | "startPay"
    | "registeredGMOAt"
    | "activatedGMO"
    | "dealerPage"
    | "canEditFreight"
    | "serviceTaxInclusive"
    | "published"
    | "members"
    | "scoreBoost"
    | "TCVID"
    | "gooId"
    | "carsensorId"
    | "slug"
  > & {
      denyImages?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "original" | "filename" | "mime" | "checksum" | "cdnUri">>>;
      images?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "original" | "filename" | "mime" | "checksum" | "cdnUri">>>;
      signature?: Maybe<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "original" | "filename" | "mime" | "checksum" | "cdnUri">>;
    };
};

export type InviteCompanyMutationVariables = Exact<{
  data: InviteCompanyDataInput;
}>;

export type InviteCompanyMutation = { __typename?: "Mutation" } & {
  inviteCompany: { __typename?: "CompanyAdminType" } & Pick<CompanyAdminType, "_id">;
};

export type GetMembersQueryVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type GetMembersQuery = { __typename?: "Query" } & {
  getMembers: Array<{ __typename?: "CompanyMemberType" } & Pick<CompanyMemberType, "_id" | "email">>;
};

export type RemoveMemberMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  idUser?: Maybe<Scalars["ID"]>;
}>;

export type RemoveMemberMutation = { __typename?: "Mutation" } & {
  removeMember: { __typename?: "CompanyMemberType" } & Pick<CompanyMemberType, "_id">;
};

export type UploadImageCompanyMutationVariables = Exact<{
  files: Array<Scalars["String"]> | Scalars["String"];
}>;

export type UploadImageCompanyMutation = { __typename?: "Mutation" } & {
  uploadImageCompany: { __typename?: "MediaSchema" } & Pick<MediaSchema, "filename" | "cdnUri" | "checksum" | "original">;
};

export type UploadFileCompanyMutationVariables = Exact<{
  files: Array<Scalars["String"]> | Scalars["String"];
}>;

export type UploadFileCompanyMutation = { __typename?: "Mutation" } & {
  uploadFileCompany: { __typename?: "MediaSchema" } & Pick<MediaSchema, "filename" | "cdnUri" | "checksum" | "original" | "mime">;
};

export type UncloneStockMutationVariables = Exact<{
  data?: Maybe<Scalars["JSON"]>;
}>;

export type UncloneStockMutation = { __typename?: "Mutation" } & {
  uncloneStock?: Maybe<{ __typename?: "CompanyAdminType" } & Pick<CompanyAdminType, "_id">>;
};

export type CloneStockMutationVariables = Exact<{
  data?: Maybe<Scalars["JSON"]>;
}>;

export type CloneStockMutation = { __typename?: "Mutation" } & {
  cloneStock?: Maybe<{ __typename?: "CompanyAdminType" } & Pick<CompanyAdminType, "_id">>;
};

export type UnlistAllMutationVariables = Exact<{
  companyId: Scalars["ID"];
  status?: Maybe<Scalars["Int"]>;
}>;

export type UnlistAllMutation = { __typename?: "Mutation" } & Pick<Mutation, "unlistAll">;

export type GetAgentsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAgentsQuery = { __typename?: "Query" } & {
  getAgents: Array<{ __typename?: "AgentType" } & Pick<AgentType, "_id" | "name" | "zendeskId">>;
};

export type SendEmailsMutationVariables = Exact<{
  subject: Scalars["String"];
  content: Scalars["String"];
  ids: Array<Scalars["ID"]> | Scalars["ID"];
  attachments?: Maybe<Array<Scalars["JSON"]> | Scalars["JSON"]>;
}>;

export type SendEmailsMutation = { __typename?: "Mutation" } & Pick<Mutation, "sendSellersNotification">;

export type GetCouponsQueryVariables = Exact<{
  filters?: Maybe<Scalars["JSON"]>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
}>;

export type GetCouponsQuery = { __typename?: "Query" } & {
  getCoupons: { __typename?: "AdminCouponsResult" } & Pick<AdminCouponsResult, "total"> & {
      coupons: Array<
        { __typename?: "AdminCouponSchema" } & Pick<
          AdminCouponSchema,
          "_id" | "code" | "type" | "agent" | "discountPercent" | "maxPaymentTimes" | "maxUSD" | "discountUSD" | "expired" | "created" | "isRemoved" | "refers" | "balanceUSD" | "applyConditions"
        > & {
            user?: Maybe<{ __typename?: "CouponUserRef" } & Pick<CouponUserRef, "_id" | "email" | "name">>;
            owner?: Maybe<{ __typename?: "CouponUserRef" } & Pick<CouponUserRef, "_id">>;
          }
      >;
    };
};

export type CreateCouponMutationVariables = Exact<{ [key: string]: never }>;

export type CreateCouponMutation = { __typename?: "Mutation" } & {
  createCoupon: { __typename?: "AdminCouponSchema" } & Pick<
    AdminCouponSchema,
    "_id" | "code" | "type" | "agent" | "discountPercent" | "discountUSD" | "maxPaymentTimes" | "expired" | "maxUSD" | "created" | "isRemoved" | "refers" | "balanceUSD" | "applyConditions"
  > & {
      user?: Maybe<{ __typename?: "CouponUserRef" } & Pick<CouponUserRef, "_id" | "email" | "name">>;
      owner?: Maybe<{ __typename?: "CouponUserRef" } & Pick<CouponUserRef, "_id">>;
    };
};

export type EditCouponMutationVariables = Exact<{
  id: Scalars["ID"];
  data: Scalars["JSON"];
}>;

export type EditCouponMutation = { __typename?: "Mutation" } & {
  editCoupon: { __typename?: "AdminCouponSchema" } & Pick<
    AdminCouponSchema,
    "_id" | "code" | "type" | "agent" | "discountPercent" | "maxPaymentTimes" | "discountUSD" | "expired" | "maxUSD" | "created" | "isRemoved" | "refers" | "balanceUSD" | "applyConditions"
  > & {
      user?: Maybe<{ __typename?: "CouponUserRef" } & Pick<CouponUserRef, "_id" | "email" | "name">>;
      owner?: Maybe<{ __typename?: "CouponUserRef" } & Pick<CouponUserRef, "_id">>;
    };
};

export type DeleteCouponMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DeleteCouponMutation = { __typename?: "Mutation" } & Pick<Mutation, "deleteCoupon">;

export type GetCarCouponsQueryVariables = Exact<{
  carIds: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type GetCarCouponsQuery = { __typename?: "Query" } & {
  getCarCoupons: Array<
    { __typename?: "CarCouponResult" } & Pick<CarCouponResult, "_id" | "discountUSD"> & {
        car?: Maybe<{ __typename?: "CarCouponCarRef" } & Pick<CarCouponCarRef, "_id">>;
      }
  >;
};

export type GetOrdersByCouponQueryVariables = Exact<{
  coupon: Scalars["String"];
  steps: Array<Scalars["Float"]> | Scalars["Float"];
  skip: Scalars["Int"];
  take: Scalars["Int"];
  sortBy?: Maybe<Scalars["String"]>;
  orderBy?: Maybe<Scalars["String"]>;
}>;

export type GetOrdersByCouponQuery = { __typename?: "Query" } & {
  getOrderManagementStats: {
    __typename?: "OrderManagementPagingSchema";
  } & Pick<OrderManagementPagingSchema, "totalCount"> & {
      nodes?: Maybe<
        Array<
          { __typename?: "OrderManagementSchema" } & Pick<OrderManagementSchema, "id" | "coupon" | "couponValue" | "confirmedPaymentAt" | "country" | "port"> & {
              ticket?: Maybe<{ __typename?: "TicketSchema" } & Pick<TicketSchema, "id">>;
              internalTicket?: Maybe<{ __typename?: "InternalTicketSchema" } & Pick<InternalTicketSchema, "ticketNo">>;
              car?: Maybe<{ __typename?: "CarSchema" } & Pick<CarSchema, "title" | "titleShort" | "carUrl">>;
            }
        >
      >;
    };
};

export type UploadImportCsvMutationVariables = Exact<{
  companyId: Scalars["ID"];
  format: Scalars["String"];
  fileKey: Scalars["String"];
  originalFilename: Scalars["String"];
  clearOldCar?: Maybe<Scalars["Boolean"]>;
}>;

export type UploadImportCsvMutation = { __typename?: "Mutation" } & {
  uploadImportCSV: { __typename?: "CsvSchema" } & Pick<CsvSchema, "_id">;
};

export type RetryImportCsvMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type RetryImportCsvMutation = { __typename?: "Mutation" } & Pick<Mutation, "retryCSV">;

export type GetFreightsQueryVariables = Exact<{
  filters?: Maybe<FreightFilterInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
}>;

export type GetFreightsQuery = { __typename?: "Query" } & {
  freights: { __typename?: "AdminFreightsResult" } & Pick<AdminFreightsResult, "total"> & {
      data?: Maybe<
        Array<
          { __typename?: "AdminFreightSchema" } & Pick<
            AdminFreightSchema,
            | "_id"
            | "country"
            | "port"
            | "m3USD"
            | "m3JPY"
            | "m3NZD"
            | "carUSD"
            | "carJPY"
            | "carNZD"
            | "inspectName"
            | "inspectFee"
            | "condOverM3"
            | "condUnderM3"
            | "condOverHeightCm"
            | "condUnderHeightCm"
            | "condOverWeightTon"
            | "condUnderWeightTon"
            | "company"
            | "isCustomized"
            | "cities"
            | "shippingMethod"
            | "priority"
            | "inform"
            | "needInspection"
            | "canBuyNow"
          > & {
              parent?: Maybe<{ __typename?: "AdminFreightParentSchema" } & Pick<AdminFreightParentSchema, "_id" | "country" | "port">>;
            }
        >
      >;
    };
};

export type GetFreightCountriesQueryVariables = Exact<{
  filters?: Maybe<FreightFilterInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
}>;

export type GetFreightCountriesQuery = { __typename?: "Query" } & {
  freights: { __typename?: "AdminFreightsResult" } & {
    data?: Maybe<Array<{ __typename?: "AdminFreightSchema" } & Pick<AdminFreightSchema, "country">>>;
  };
};

export type UpsertFreightMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  data?: Maybe<UpsertFreightInput>;
  filter?: Maybe<UpsertFreightFilterInput>;
}>;

export type UpsertFreightMutation = { __typename?: "Mutation" } & {
  upsertFreight: { __typename?: "AdminFreightSchema" } & Pick<
    AdminFreightSchema,
    | "_id"
    | "country"
    | "port"
    | "m3USD"
    | "m3JPY"
    | "m3NZD"
    | "carUSD"
    | "carJPY"
    | "carNZD"
    | "inspectName"
    | "inspectFee"
    | "condOverM3"
    | "condUnderM3"
    | "condOverHeightCm"
    | "condUnderHeightCm"
    | "condOverWeightTon"
    | "condUnderWeightTon"
    | "company"
    | "isCustomized"
    | "cities"
    | "shippingMethod"
    | "priority"
    | "inform"
    | "needInspection"
    | "canBuyNow"
  > & {
      parent?: Maybe<{ __typename?: "AdminFreightParentSchema" } & Pick<AdminFreightParentSchema, "_id" | "country" | "port">>;
    };
};

export type DeleteFreightMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
}>;

export type DeleteFreightMutation = { __typename?: "Mutation" } & Pick<Mutation, "deleteFreight">;

export type EditPriorityMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  priority?: Maybe<Scalars["Int"]>;
}>;

export type EditPriorityMutation = { __typename?: "Mutation" } & {
  editPriority: { __typename?: "AdminFreightSchema" } & Pick<AdminFreightSchema, "_id">;
};

export type PrepareInvoiceCallMutationVariables = Exact<{
  input: PrepareInvoiceCallInput;
}>;

export type PrepareInvoiceCallMutation = { __typename?: "Mutation" } & {
  prepareInvoiceCall: { __typename?: "InvoiceCallSession" } & Pick<InvoiceCallSession, "commentId" | "token" | "to" | "expiresAt">;
};

export type GetInvoiceCallStateQueryVariables = Exact<{
  args: GetInvoicesCommentsAdminArgs;
}>;

export type GetInvoiceCallStateQuery = { __typename?: "Query" } & {
  getInvoiceCommentsAdmin: { __typename?: "GetInvoiceCommentsAdminDto" } & {
    comments?: Maybe<
      { __typename?: "ZendeskCommentsResponse" } & {
        comments?: Maybe<
          Array<
            { __typename?: "InvoiceCommentSchema" } & Pick<InvoiceCommentSchema, "_id"> & {
                call?: Maybe<{ __typename?: "InvoiceCommentCallSchema" } & Pick<InvoiceCommentCallSchema, "status" | "recordingStatus">>;
                attachments?: Maybe<Array<{ __typename?: "InvoiceCommentAttachmentSchema" } & Pick<InvoiceCommentAttachmentSchema, "content_url" | "content_type">>>;
              }
          >
        >;
      }
    >;
  };
};

export type PrepareIncomingInvoiceCallsMutationVariables = Exact<{
  [key: string]: never;
}>;

export type PrepareIncomingInvoiceCallsMutation = {
  __typename?: "Mutation";
} & {
  prepareIncomingInvoiceCalls: {
    __typename?: "InvoiceIncomingCallToken";
  } & Pick<InvoiceIncomingCallToken, "token" | "expiresAt">;
};

export type InvoiceCallPresenceMutationVariables = Exact<{
  available: Scalars["Boolean"];
  busy: Scalars["Boolean"];
}>;

export type InvoiceCallPresenceMutation = { __typename?: "Mutation" } & Pick<Mutation, "invoiceCallPresence">;

export type GetCommentsAdminQueryVariables = Exact<{
  args: GetCommentsAdminArgs;
}>;

export type GetCommentsAdminQuery = { __typename?: "Query" } & {
  getCommentsAdmin: { __typename?: "GetCommentsAdminResult" } & Pick<GetCommentsAdminResult, "total"> & {
      items: Array<
        { __typename?: "CommentAdminSchema" } & Pick<CommentAdminSchema, "id" | "invoiceId" | "body" | "plainBody" | "htmlBody" | "isPublic" | "syncStatus" | "source" | "createdAt" | "updatedAt" | "deletedAt"> & {
            author?: Maybe<{ __typename?: "CommentAuthorAdminSchema" } & Pick<CommentAuthorAdminSchema, "userId" | "externalUserId" | "name" | "avatarUrl" | "type">>;
            syncInfo?: Maybe<{ __typename?: "CommentSyncInfoAdminSchema" } & Pick<CommentSyncInfoAdminSchema, "provider" | "externalId" | "externalParentId" | "externalUrl">>;
            attachments?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "id" | "filename" | "cdnUri" | "mime">>>;
          }
      >;
    };
};

export type GetInvoicesAggsQueryVariables = Exact<{
  args?: Maybe<GetInvoicesAggsArgs>;
}>;

export type GetInvoicesAggsQuery = { __typename?: "Query" } & {
  getInvoicesAggs: { __typename?: "GetInvoicesAggsSchema" } & Pick<
    GetInvoicesAggsSchema,
    "openTickets" | "waitForTTTickets" | "followUpBuyerTickets" | "needShareShip" | "needShareBL" | "needSendDocs" | "needReleaseMoney" | "newInvoices" | "soldDelivering" | "sissFollow" | "invoicePriceOrver14500" | "invoicePriceUnder14500"
  > & {
      agents?: Maybe<Array<{ __typename?: "GetInvoicesAggsAgent" } & Pick<GetInvoicesAggsAgent, "_id" | "name" | "zendeskId">>>;
      folders?: Maybe<Array<{ __typename?: "GetInvoicesAggsFolder" } & Pick<GetInvoicesAggsFolder, "_id">>>;
    };
};

export type GetInvoicesFoldersQueryVariables = Exact<{ [key: string]: never }>;

export type GetInvoicesFoldersQuery = { __typename?: "Query" } & Pick<Query, "getInvoicesFolders">;

export type GetInvoicesAdminQueryVariables = Exact<{
  args: GetInvoicesAdminArgs;
}>;

export type GetInvoicesAdminQuery = { __typename?: "Query" } & {
  getInvoicesAdmin: { __typename?: "GetInvoicesAdminSchema" } & Pick<GetInvoicesAdminSchema, "total"> & {
      invoices: Array<
        { __typename?: "InquirySchema" } & Pick<
          InquirySchema,
          | "_id"
          | "availability"
          | "name"
          | "address"
          | "phone"
          | "email"
          | "carId"
          | "coupon"
          | "sellerTakenOver"
          | "ticketNo"
          | "ticketStatus"
          | "vesselName"
          | "insurance"
          | "inspection"
          | "country"
          | "port"
          | "city"
          | "isTargetCountry"
          | "passRegulation"
          | "isQuality"
          | "ETD"
          | "ETA"
          | "actualArrivalDate"
          | "isBuyNow"
          | "isBNPL"
          | "consigneeName"
          | "consigneeAddress"
          | "consigneePhone"
          | "consigneeEmail"
          | "documentName"
          | "documentAddress"
          | "documentPhone"
          | "documentEmail"
          | "showShipper"
          | "showBreakdown"
          | "transferTwice"
          | "costFOB"
          | "sellerFOB"
          | "costInspection"
          | "costInsurance"
          | "costShipping"
          | "costDelivery"
          | "costService"
          | "costProtection"
          | "costOffer"
          | "costOfferOriginal"
          | "paypalAmount"
          | "costBuynowDiscount"
          | "reservedUSD"
          | "receivedUSD"
          | "shipping"
          | "additionalCosts"
          | "additionalDesc"
          | "costDiscount"
          | "exchangeRate"
          | "serviceCharge"
          | "serviceChargeTax"
          | "bankCharge"
          | "transferCharge"
          | "transferChargePublic"
          | "paymentJPY"
          | "step"
          | "folder"
          | "internalNote"
          | "utm_source"
          | "utm_campaign"
          | "utm_medium"
          | "platform"
          | "currency"
          | "invoiceAmount"
          | "amountAfterCoupon"
          | "banks"
          | "sendSMSTo"
          | "hideVIN"
          | "releasedAt"
          | "reservedUntil"
          | "updated"
          | "lastActivityAt"
          | "created"
          | "important"
        > & {
            ticket?: Maybe<
              { __typename?: "Ticket" } & Pick<Ticket, "id" | "status" | "requester_id"> & {
                  assignee?: Maybe<{ __typename?: "Assignee" } & Pick<Assignee, "id" | "name">>;
                }
            >;
            internalTicket?: Maybe<
              { __typename?: "InternalTicketSchema" } & Pick<InternalTicketSchema, "id" | "ticketNo" | "subject" | "status" | "assigneeId" | "followerIds" | "emailCcAddresses" | "reopenedAt"> & {
                  followers?: Maybe<Array<{ __typename?: "InternalTicketUserSchema" } & Pick<InternalTicketUserSchema, "id" | "name" | "email">>>;
                  assignee?: Maybe<{ __typename?: "InternalTicketUserSchema" } & Pick<InternalTicketUserSchema, "id" | "name">>;
                }
            >;
            customCosts?: Maybe<Array<{ __typename?: "CustomCostSchema" } & Pick<CustomCostSchema, "name" | "amount">>>;
            tags?: Maybe<Array<{ __typename?: "InquiryTag" } & Pick<InquiryTag, "name" | "createdAt">>>;
            stats?: Maybe<
              { __typename?: "InquiryStatSchema" } & Pick<
                InquiryStatSchema,
                | "lastAgentAnswerAt"
                | "lastAgentCalledAt"
                | "buyerRepliedTimes"
                | "lastBuyerRepliedAt"
                | "agentReplyTimes"
                | "waitAvgMins"
                | "negoType"
                | "carRanks"
                | "numberOfUserInquiry"
                | "numberOfUserPayment"
                | "numberOfCarInquiry"
                | "numberOfViewCarBefore"
              >
            >;
            addonServices?: Maybe<Array<{ __typename?: "AddonServiceSchema" } & Pick<AddonServiceSchema, "id" | "key" | "name" | "cost">>>;
            saleEvents?: Maybe<Array<{ __typename?: "SaleEventSchema" } & Pick<SaleEventSchema, "name" | "value" | "createdAt">>>;
            documents?: Maybe<Array<{ __typename?: "InquiryDocumentSchema" } & Pick<InquiryDocumentSchema, "id" | "documentType" | "name" | "createdAt" | "source">>>;
            extra?: Maybe<
              { __typename?: "InquiryExtraSchema" } & Pick<InquiryExtraSchema, "issueAt" | "estimatedProfitJPY" | "actualProfitJPY" | "actualProfitDate" | "withTaxEstimatedProfitJPY" | "withTaxActualProfitJPY" | "followupLevel">
            >;
            autoFollowup?: Maybe<{ __typename?: "InquiryFollowupSchema" } & Pick<InquiryFollowupSchema, "state" | "nextActionAt">>;
            trackingShip?: Maybe<{ __typename?: "TrackingShip" } & Pick<TrackingShip, "shareDate" | "via" | "code" | "url">>;
            paypal?: Maybe<{ __typename?: "PaypalInquiry" } & Pick<PaypalInquiry, "status" | "amount" | "orderId" | "invoiceId" | "authorizationId" | "paymentId" | "invoiceURL" | "date" | "payURL" | "checkoutCompleted" | "breakdown">>;
            user?: Maybe<{ __typename?: "UserSchema" } & Pick<UserSchema, "id" | "name" | "tags">>;
            company?: Maybe<
              { __typename?: "CompanySchema" } & Pick<CompanySchema, "id" | "plan" | "name" | "enName" | "address" | "marginPercent" | "marginPercentCIF" | "serviceChargeUSD" | "marginMin" | "marginMax" | "serviceTaxInclusive">
            >;
            car?: Maybe<
              { __typename?: "CarSchema" } & Pick<
                CarSchema,
                | "id"
                | "title"
                | "url"
                | "displacement"
                | "mileage"
                | "driveTypeKey"
                | "door"
                | "steeringKey"
                | "grade"
                | "fuelKey"
                | "transmissionKey"
                | "transmission"
                | "exteriorColor"
                | "passengers"
                | "VIN"
                | "cfjNo"
                | "refNo"
                | "carUrl"
                | "companyId"
                | "year"
                | "titleShort"
                | "makeName"
                | "modelName_"
                | "modelCode"
                | "vehicleLength"
                | "vehicleWidth"
                | "vehicleHeight"
                | "registrationYear"
                | "registrationMonth"
                | "expiredAt"
                | "status"
                | "plan"
              > & {
                  images?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "filename" | "cdnUri" | "order" | "mime">>>;
                }
            >;
          }
      >;
    };
};

export type GetInvoiceCommentsAdminQueryVariables = Exact<{
  args: GetInvoicesCommentsAdminArgs;
}>;

export type GetInvoiceCommentsAdminQuery = { __typename?: "Query" } & {
  getInvoiceCommentsAdmin: { __typename?: "GetInvoiceCommentsAdminDto" } & {
    comments?: Maybe<
      { __typename?: "ZendeskCommentsResponse" } & {
        comments?: Maybe<
          Array<
            { __typename?: "InvoiceCommentSchema" } & Pick<InvoiceCommentSchema, "_id" | "id" | "created_at" | "public" | "html_body" | "url" | "type" | "body" | "plain_body"> & {
                author?: Maybe<{ __typename?: "InvoiceCommentAuthorSchema" } & Pick<InvoiceCommentAuthorSchema, "userId" | "name" | "avatarUrl" | "type">>;
                attachments?: Maybe<Array<{ __typename?: "InvoiceCommentAttachmentSchema" } & Pick<InvoiceCommentAttachmentSchema, "file_name" | "content_url" | "content_type">>>;
                senderWarning?: Maybe<{ __typename?: "SenderWarningSchema" } & Pick<SenderWarningSchema, "email" | "reason">>;
              }
          >
        >;
      }
    >;
    mergedFrom?: Maybe<Array<{ __typename?: "TicketRecordSchema" } & Pick<TicketRecordSchema, "id" | "ticketNo" | "subject">>>;
    ticketAudits?: Maybe<
      { __typename?: "ZendeskTicketAuditsResponse" } & Pick<ZendeskTicketAuditsResponse, "count" | "next_page" | "previous_page"> & {
          audits: Array<
            { __typename?: "ZendeskTicketAudit" } & Pick<ZendeskTicketAudit, "id" | "ticket_id" | "author_id" | "created_at"> & {
                events: Array<
                  { __typename?: "ZendeskTicketAuditEvent" } & Pick<ZendeskTicketAuditEvent, "id" | "type" | "body" | "author_id" | "html_body" | "public" | "field_name" | "previous_value" | "value"> & {
                      attachments?: Maybe<Array<{ __typename?: "ZendeskAttachment" } & Pick<ZendeskAttachment, "id" | "file_name" | "content_url" | "content_type">>>;
                    }
                >;
              }
          >;
        }
    >;
  };
};

export type GetBuyerStatsQueryVariables = Exact<{
  args: GetBuyerStatsArgs;
}>;

export type GetBuyerStatsQuery = { __typename?: "Query" } & {
  getBuyerStats: Array<{ __typename?: "GetBuyerStatsSchema" } & Pick<GetBuyerStatsSchema, "_id" | "purchased" | "cancelled" | "issued" | "inquiries">>;
};

export type GetInvoiceLoggingQueryVariables = Exact<{
  args: GetInvoiceLoggingArgs;
}>;

export type GetInvoiceLoggingQuery = { __typename?: "Query" } & {
  getInvoiceLogging: { __typename?: "GetInvoiceLoggingSchema" } & Pick<GetInvoiceLoggingSchema, "total"> & {
      logs: Array<{ __typename?: "InvoiceLoggingEntry" } & Pick<InvoiceLoggingEntry, "id" | "target" | "type" | "operator" | "payload" | "createdAt">>;
    };
};

export type GetInvoicesCarQueryVariables = Exact<{
  args: GetInvoicesCarArgs;
}>;

export type GetInvoicesCarQuery = { __typename?: "Query" } & {
  getInvoicesCar: Array<{ __typename?: "GetInvoicesCarSchema" } & Pick<GetInvoicesCarSchema, "_id" | "inquiryCount">>;
};

export type UpdateInvoiceMutationVariables = Exact<{
  input: UpdateInvoiceArgs;
}>;

export type UpdateInvoiceMutation = { __typename?: "Mutation" } & {
  updateInvoice: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type AdminUpdateInvoiceMutationVariables = Exact<{
  input: UpdateInvoiceArgs;
}>;

export type AdminUpdateInvoiceMutation = { __typename?: "Mutation" } & {
  updateInvoice: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id" | "step" | "receivedUSD" | "exchangeRate"> & {
      tags?: Maybe<Array<{ __typename?: "InquiryTag" } & Pick<InquiryTag, "name" | "createdAt">>>;
      saleEvents?: Maybe<Array<{ __typename?: "SaleEventSchema" } & Pick<SaleEventSchema, "name" | "value" | "createdAt">>>;
    };
};

export type ReplyCommentInvoiceMutationVariables = Exact<{
  input: ReplyCommentInvoiceArgs;
}>;

export type ReplyCommentInvoiceMutation = { __typename?: "Mutation" } & {
  replyCommentInvoice: { __typename?: "ReplyCommentInvoiceSchema" } & Pick<ReplyCommentInvoiceSchema, "success" | "message">;
};

export type UploadInvoiceDocumentMutationVariables = Exact<{
  input: UploadInvoiceDocumentArgs;
}>;

export type UploadInvoiceDocumentMutation = { __typename?: "Mutation" } & {
  uploadInvoiceDocument: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type BatchInvoicesActionMutationVariables = Exact<{
  input: BatchInvoicesActionArgs;
}>;

export type BatchInvoicesActionMutation = { __typename?: "Mutation" } & {
  batchInvoicesAction: Array<{ __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">>;
};

export type AskForSupportMutationVariables = Exact<{
  input: AskForSupportArgs;
}>;

export type AskForSupportMutation = { __typename?: "Mutation" } & {
  askForSupport: { __typename?: "AskForSupportSchema" } & Pick<AskForSupportSchema, "id">;
};

export type SetInvoiceAvailabilityMutationVariables = Exact<{
  input: SetAvailabilityArgs;
}>;

export type SetInvoiceAvailabilityMutation = { __typename?: "Mutation" } & {
  setAvailability: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id" | "availability">;
};

export type IssueInvoiceMutationVariables = Exact<{
  input: IssueInvoiceArgs;
}>;

export type IssueInvoiceMutation = { __typename?: "Mutation" } & {
  issueInvoice: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type ConfirmTtMutationVariables = Exact<{
  input: ConfirmTtArgs;
}>;

export type ConfirmTtMutation = { __typename?: "Mutation" } & {
  confirmTT: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type ShareShippingScheduleMutationVariables = Exact<{
  input: ShareShippingScheduleArgs;
}>;

export type ShareShippingScheduleMutation = { __typename?: "Mutation" } & {
  shareShippingSchedule: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type ShareTrackingMutationVariables = Exact<{
  input: ShareTrackingArgs;
}>;

export type ShareTrackingMutation = { __typename?: "Mutation" } & {
  shareTracking: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type ShareBlCopyMutationVariables = Exact<{
  input: ShareBlCopyArgs;
}>;

export type ShareBlCopyMutation = { __typename?: "Mutation" } & {
  shareBLCopy: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type CarReceivedMutationVariables = Exact<{
  input: CarReceivedArgs;
}>;

export type CarReceivedMutation = { __typename?: "Mutation" } & {
  carReceived: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type SetActualArrivalDateMutationVariables = Exact<{
  input: SetActualArrivalDateInput;
}>;

export type SetActualArrivalDateMutation = { __typename?: "Mutation" } & {
  setActualArrivalDate: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type CancelOrderMutationVariables = Exact<{
  input: CancelOrderArgs;
}>;

export type CancelOrderMutation = { __typename?: "Mutation" } & {
  cancelOrder: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type ConfirmPaymentMutationVariables = Exact<{
  input: ConfirmPaymentArgs;
}>;

export type ConfirmPaymentMutation = { __typename?: "Mutation" } & {
  confirmPayment: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type ReleaseMoneyMutationVariables = Exact<{
  input: ReleaseMoneyArgs;
}>;

export type ReleaseMoneyMutation = { __typename?: "Mutation" } & {
  releaseMoney: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type AdminInvoiceStatusMutationVariables = Exact<{
  input: SetManualStatusArgs;
}>;

export type AdminInvoiceStatusMutation = { __typename?: "Mutation" } & {
  setManualStatus: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type InquiryTagHistoriesQueryVariables = Exact<{
  input: InquiryTagHistoriesArgs;
}>;

export type InquiryTagHistoriesQuery = { __typename?: "Query" } & {
  inquiryTagHistories: Array<{ __typename?: "InquiryTagHistorySchema" } & Pick<InquiryTagHistorySchema, "_id" | "name" | "tagCreatedAt" | "toStatus" | "removedAt">>;
};

export type RestoreInquiryTagMutationVariables = Exact<{
  input: RestoreInquiryTagArgs;
}>;

export type RestoreInquiryTagMutation = { __typename?: "Mutation" } & {
  restoreInquiryTag: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type IssueInvoicePaypalMutationVariables = Exact<{
  input: IssuePaypalArgs;
}>;

export type IssueInvoicePaypalMutation = { __typename?: "Mutation" } & {
  issuePaypal: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type FollowUpInvoiceMutationVariables = Exact<{
  input: FollowUpArgs;
}>;

export type FollowUpInvoiceMutation = { __typename?: "Mutation" } & {
  followUp: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type CapturePaypalMutationVariables = Exact<{
  input: CapturePaypalArgs;
}>;

export type CapturePaypalMutation = { __typename?: "Mutation" } & {
  capturePaypal: { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id">;
};

export type GetCommentTrackingQueryVariables = Exact<{
  input: GetCommentTrackingArgs;
}>;

export type GetCommentTrackingQuery = { __typename?: "Query" } & {
  getCommentTracking: Array<
    { __typename?: "EmailStatusEntrySchema" } & Pick<EmailStatusEntrySchema, "status" | "bounceType" | "bounceSubType" | "complaintFeedbackType" | "reason" | "ipAddress" | "userAgent" | "link" | "linkTags" | "timestamp" | "createdAt">
  >;
};

export type ImproveSellerCommentMutationVariables = Exact<{
  comment: Scalars["String"];
  buyerName: Scalars["String"];
}>;

export type ImproveSellerCommentMutation = { __typename?: "Mutation" } & Pick<Mutation, "improveSellerComment">;

export type TranslateCommentMutationVariables = Exact<{
  comment: Scalars["String"];
}>;

export type TranslateCommentMutation = { __typename?: "Mutation" } & Pick<Mutation, "translateComment">;

export type ExplainBuyerMessagesMutationVariables = Exact<{
  buyerMessages: Array<Scalars["String"]> | Scalars["String"];
  language: Scalars["String"];
}>;

export type ExplainBuyerMessagesMutation = { __typename?: "Mutation" } & Pick<Mutation, "explainBuyerMessages">;

export type SummarizeAllConversationMutationVariables = Exact<{
  conversations: Array<Scalars["String"]> | Scalars["String"];
  language: Scalars["String"];
}>;

export type SummarizeAllConversationMutation = {
  __typename?: "Mutation";
} & Pick<Mutation, "summarizeAllConversation">;

export type GetInvoiceDriveInfoQueryVariables = Exact<{
  invoiceIds: Array<Scalars["String"]> | Scalars["String"];
}>;

export type GetInvoiceDriveInfoQuery = { __typename?: "Query" } & {
  getInvoiceDriveInfo?: Maybe<
    { __typename?: "InvoiceDriveInfoSchema" } & Pick<InvoiceDriveInfoSchema, "folderId" | "folderName" | "folderPath" | "datePrefix"> & {
        items: Array<{ __typename?: "DriveItemSchema" } & Pick<DriveItemSchema, "ticketId" | "invoiceCode" | "receiptCode" | "invoiceFilename" | "receiptFilename">>;
      }
  >;
};

export type UploadInvoiceDocsToDriveMutationVariables = Exact<{
  invoiceIds: Array<Scalars["String"]> | Scalars["String"];
}>;

export type UploadInvoiceDocsToDriveMutation = { __typename?: "Mutation" } & {
  uploadInvoiceDocsToDrive: {
    __typename?: "UploadInvoiceDocsToDriveSchema";
  } & Pick<UploadInvoiceDocsToDriveSchema, "folderId"> & {
      results: Array<
        { __typename?: "DriveUploadResultItemSchema" } & Pick<DriveUploadResultItemSchema, "ticketId"> & {
            receipt?: Maybe<{ __typename?: "DriveFileSchema" } & Pick<DriveFileSchema, "id" | "name" | "url">>;
            invoice?: Maybe<{ __typename?: "DriveFileSchema" } & Pick<DriveFileSchema, "id" | "name" | "url">>;
          }
      >;
    };
};

export type GetInvoiceDashboardSummaryQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetInvoiceDashboardSummaryQuery = { __typename?: "Query" } & {
  getInvoiceDashboardSummary: {
    __typename?: "InvoiceDashboardSummarySchema";
  } & Pick<InvoiceDashboardSummarySchema, "countNeedUpdate" | "totalIssueInvoice" | "totalConfirmPayment" | "totalSharedShippingSchedule" | "totalSharedBLCopy"> & {
      issueInvoice: Array<
        { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id" | "ticketNo" | "country" | "port" | "city" | "updated" | "step"> & {
            car?: Maybe<{ __typename?: "CarSchema" } & Pick<CarSchema, "id" | "title">>;
          }
      >;
      confirmPayment: Array<
        { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id" | "ticketNo" | "country" | "port" | "city" | "updated" | "step"> & {
            car?: Maybe<{ __typename?: "CarSchema" } & Pick<CarSchema, "id" | "title">>;
          }
      >;
      sharedShippingSchedule: Array<
        { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id" | "ticketNo" | "country" | "port" | "city" | "updated" | "step"> & {
            car?: Maybe<{ __typename?: "CarSchema" } & Pick<CarSchema, "id" | "title">>;
          }
      >;
      sharedBLCopy: Array<
        { __typename?: "InquirySchema" } & Pick<InquirySchema, "_id" | "ticketNo" | "country" | "port" | "city" | "updated" | "step"> & {
            car?: Maybe<{ __typename?: "CarSchema" } & Pick<CarSchema, "id" | "title">>;
          }
      >;
    };
};

export type GetInvoiceDashboardStatsQueryVariables = Exact<{
  filters: InvoiceDashboardFiltersInput;
}>;

export type GetInvoiceDashboardStatsQuery = { __typename?: "Query" } & {
  getInvoiceDashboardStats: { __typename?: "InvoiceDashboardStatsSchema" } & {
    inquiries: { __typename?: "InvoiceDashboardPeriodStat" } & Pick<InvoiceDashboardPeriodStat, "current" | "lastMonth">;
    invoices: { __typename?: "InvoiceDashboardPeriodStat" } & Pick<InvoiceDashboardPeriodStat, "current" | "lastMonth">;
    payments: { __typename?: "InvoiceDashboardPeriodStat" } & Pick<InvoiceDashboardPeriodStat, "current" | "lastMonth">;
    revenue: { __typename?: "InvoiceDashboardPeriodStat" } & Pick<InvoiceDashboardPeriodStat, "current" | "lastMonth">;
  };
};

export type GetInvoiceDashboardCountryQueryVariables = Exact<{
  filters: InvoiceDashboardFiltersInput;
}>;

export type GetInvoiceDashboardCountryQuery = { __typename?: "Query" } & {
  getInvoiceDashboardCountry: Array<
    { __typename?: "InvoiceDashboardCountryRow" } & Pick<InvoiceDashboardCountryRow, "_id" | "inquiry" | "qualityInquiry" | "invoices" | "sales"> & {
        buyers: Array<{ __typename?: "InvoiceDashboardCountryBuyer" } & Pick<InvoiceDashboardCountryBuyer, "user" | "isQuality">>;
      }
  >;
};

export type LandingTagFieldsFragment = {
  __typename?: "LandingTagSchema";
} & Pick<
  LandingTagSchema,
  | "id"
  | "key"
  | "bodyTypes"
  | "fuelTypes"
  | "driveTypes"
  | "transmissions"
  | "steerings"
  | "exteriorColors"
  | "accessoryIds"
  | "minPrice"
  | "maxPrice"
  | "minDisplacement"
  | "maxDisplacement"
  | "minYear"
  | "maxYear"
  | "description"
  | "heading"
  | "published"
> & {
    models?: Maybe<
      Array<
        { __typename?: "ModelSchema" } & Pick<ModelSchema, "id" | "name"> & {
            make?: Maybe<{ __typename?: "MakeSchema" } & Pick<MakeSchema, "id" | "name">>;
          }
      >
    >;
    saleTags?: Maybe<Array<{ __typename?: "SaleTagSchema" } & Pick<SaleTagSchema, "id" | "name" | "key" | "description" | "published">>>;
  };

export type GetLandingTagsQueryVariables = Exact<{
  filters?: Maybe<GetLandingTagsAdminInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
}>;

export type GetLandingTagsQuery = { __typename?: "Query" } & {
  getLandingTags: { __typename?: "LandingTagAdminResult" } & Pick<LandingTagAdminResult, "total"> & {
      tags: Array<{ __typename?: "LandingTagSchema" } & LandingTagFieldsFragment>;
    };
};

export type UpsertLandingTagMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  data: UpsertLandingTagInput;
}>;

export type UpsertLandingTagMutation = { __typename?: "Mutation" } & {
  upsertLandingTag: {
    __typename?: "LandingTagSchema";
  } & LandingTagFieldsFragment;
};

export type DeleteLandingTagMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DeleteLandingTagMutation = { __typename?: "Mutation" } & {
  deleteLandingTag: { __typename?: "LandingTagSchema" } & Pick<LandingTagSchema, "id" | "key">;
};

export type CountryPageFieldsFragment = {
  __typename?: "CountryPageSchema";
} & Pick<CountryPageSchema, "_id" | "name" | "key" | "region" | "dutiesAndTaxes" | "importDocuments" | "paymentMethodTT" | "models" | "banks" | "modelImages" | "bannerImages"> & {
    regulation?: Maybe<{ __typename?: "CountryPageRegulationSchema" } & Pick<CountryPageRegulationSchema, "year" | "inspection" | "port" | "deliveryTime">>;
    faqs?: Maybe<Array<Maybe<{ __typename?: "FaqSchema" } & Pick<FaqSchema, "question" | "answer">>>>;
  };

export type GetCountriesQueryVariables = Exact<{
  params?: Maybe<GetCountriesParamsInput>;
}>;

export type GetCountriesQuery = { __typename?: "Query" } & {
  getCountries: Array<{ __typename?: "CountryPageSchema" } & CountryPageFieldsFragment>;
};

export type CreateOrUpdateCountryPageMutationVariables = Exact<{
  params?: Maybe<CreateOrUpdateCountryPageInput>;
}>;

export type CreateOrUpdateCountryPageMutation = { __typename?: "Mutation" } & {
  createOrUpdateCountryPage: {
    __typename?: "CountryPageSchema";
  } & CountryPageFieldsFragment;
};

export type UploadModelImageMutationVariables = Exact<{
  fileKey: Scalars["String"];
  params?: Maybe<UploadModelImageParamsInput>;
}>;

export type UploadModelImageMutation = { __typename?: "Mutation" } & {
  uploadModelImage: { __typename?: "MediaSchema" } & Pick<MediaSchema, "filename" | "cdnUri" | "checksum">;
};

export type RemoveImageMutationVariables = Exact<{
  file: LocalPageImageInput;
}>;

export type RemoveImageMutation = { __typename?: "Mutation" } & {
  removeImage: { __typename?: "MediaSchema" } & Pick<MediaSchema, "filename" | "cdnUri" | "checksum">;
};

export type RemoveCountryPageMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type RemoveCountryPageMutation = { __typename?: "Mutation" } & Pick<Mutation, "removeCountryPage">;

export type GetAllMakeQueryVariables = Exact<{
  input: GetAllMakeArgs;
}>;

export type GetAllMakeQuery = { __typename?: "Query" } & {
  getAllMake: Array<{ __typename?: "MakeSchema" } & Pick<MakeSchema, "id" | "_id" | "name" | "key">>;
};

export type GetLocalPageModelsQueryVariables = Exact<{
  input?: Maybe<GetManyModelsArgs>;
}>;

export type GetLocalPageModelsQuery = { __typename?: "Query" } & {
  getManyModels: { __typename?: "GetManyModelsType" } & Pick<GetManyModelsType, "total"> & {
      items: Array<
        { __typename?: "ModelSchema" } & Pick<ModelSchema, "id" | "name" | "key" | "makeModelKey"> & {
            make?: Maybe<{ __typename?: "MakeSchema" } & Pick<MakeSchema, "id" | "name">>;
          }
      >;
    };
};

export type ModelSpecFieldsFragment = { __typename?: "ModelSpecSchema" } & Pick<
  ModelSpecSchema,
  "id" | "modelCode" | "year" | "bodyType" | "door" | "driveType" | "displacement" | "fuelType" | "vehicleWidth" | "vehicleLength" | "vehicleHeight" | "keywords" | "lock"
> & {
    model?: Maybe<{ __typename?: "ModelSchema" } & Pick<ModelSchema, "id" | "name" | "key">>;
  };

export type GetModelSpecsQueryVariables = Exact<{
  filters?: Maybe<GetModelSpecsAdminInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
}>;

export type GetModelSpecsQuery = { __typename?: "Query" } & {
  getModelSpecs: { __typename?: "ModelSpecResult" } & Pick<ModelSpecResult, "total"> & {
      modelspecs?: Maybe<Array<Maybe<{ __typename?: "ModelSpecSchema" } & ModelSpecFieldsFragment>>>;
    };
};

export type UpsertModelSpecMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  data: UpsertModelSpecInput;
}>;

export type UpsertModelSpecMutation = { __typename?: "Mutation" } & {
  upsertModelSpec?: Maybe<{ __typename?: "ModelSpecSchema" } & ModelSpecFieldsFragment>;
};

export type BatchEditModelSpecMutationVariables = Exact<{
  ids: Array<Scalars["ID"]> | Scalars["ID"];
  data: BatchEditModelSpecInput;
}>;

export type BatchEditModelSpecMutation = { __typename?: "Mutation" } & Pick<Mutation, "batchEditModelSpec">;

export type GetModelSpecModelsQueryVariables = Exact<{
  input?: Maybe<GetManyModelsArgs>;
}>;

export type GetModelSpecModelsQuery = { __typename?: "Query" } & {
  getManyModels: { __typename?: "GetManyModelsType" } & Pick<GetManyModelsType, "total"> & {
      items: Array<
        { __typename?: "ModelSchema" } & Pick<ModelSchema, "id" | "name" | "key" | "makeModelKey"> & {
            make?: Maybe<{ __typename?: "MakeSchema" } & Pick<MakeSchema, "id" | "name">>;
          }
      >;
    };
};

export type AdminModelFieldsFragment = { __typename?: "ModelSchema" } & Pick<ModelSchema, "id" | "name" | "key" | "makeModelKey" | "carCount" | "locked"> & {
    make?: Maybe<{ __typename?: "MakeSchema" } & Pick<MakeSchema, "id" | "name">>;
    alias?: Maybe<{ __typename?: "ModelSchema" } & Pick<ModelSchema, "id" | "name" | "makeModelKey">>;
  };

export type GetManagementModelQueryVariables = Exact<{
  filters?: Maybe<GetManagementModelInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
}>;

export type GetManagementModelQuery = { __typename?: "Query" } & {
  getManagementModel: { __typename?: "GetManagementModelType" } & Pick<GetManagementModelType, "total"> & {
      items: Array<{ __typename?: "ModelSchema" } & AdminModelFieldsFragment>;
    };
};

export type UpsertModelMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  data: ModelInputDto;
}>;

export type UpsertModelMutation = { __typename?: "Mutation" } & {
  upsertModel?: Maybe<{ __typename?: "ModelSchema" } & AdminModelFieldsFragment>;
};

export type GetModelOptionsQueryVariables = Exact<{
  filters?: Maybe<GetManagementModelInput>;
  limit?: Maybe<Scalars["Int"]>;
}>;

export type GetModelOptionsQuery = { __typename?: "Query" } & {
  getManagementModel: { __typename?: "GetManagementModelType" } & {
    items: Array<
      { __typename?: "ModelSchema" } & Pick<ModelSchema, "id" | "name"> & {
          make?: Maybe<{ __typename?: "MakeSchema" } & Pick<MakeSchema, "id" | "name">>;
        }
    >;
  };
};

export type GetModelMakeOptionsQueryVariables = Exact<{
  args?: Maybe<GetAllMakeArgs>;
}>;

export type GetModelMakeOptionsQuery = { __typename?: "Query" } & {
  getManagementMake: { __typename?: "GetManagementMakeType" } & {
    items: Array<{ __typename?: "MakeSchema" } & Pick<MakeSchema, "_id" | "name">>;
  };
};

export type GetPageviewsQueryVariables = Exact<{
  args: GetCarAdminPageviewsArgs;
}>;

export type GetPageviewsQuery = { __typename?: "Query" } & {
  getPageviews: { __typename?: "GetCarAdminPageviewsSchema" } & Pick<GetCarAdminPageviewsSchema, "total"> & {
      items: Array<
        { __typename?: "PVSchema" } & Pick<PvSchema, "id" | "created"> & {
            car: { __typename?: "CarSchema" } & Pick<CarSchema, "id" | "title" | "status" | "carUrl" | "priceUSD">;
          }
      >;
    };
};

export type RegulationFieldsFragment = {
  __typename?: "AdminRegulationSchema";
} & Pick<AdminRegulationSchema, "_id" | "country" | "targeted" | "messages"> & {
    rules?: Maybe<Array<{ __typename?: "RuleSchema" } & Pick<RuleSchema, "message" | "rule" | "filter">>>;
    ports?: Maybe<Array<{ __typename?: "AdminRegulationPortSchema" } & Pick<AdminRegulationPortSchema, "port" | "messages">>>;
  };

export type GetRegulationsQueryVariables = Exact<{
  country?: Maybe<Scalars["String"]>;
}>;

export type GetRegulationsQuery = { __typename?: "Query" } & {
  getRegulations: Array<{ __typename?: "AdminRegulationSchema" } & RegulationFieldsFragment>;
};

export type UpsertRegulationMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  data?: Maybe<UpsertRegulationInput>;
}>;

export type UpsertRegulationMutation = { __typename?: "Mutation" } & {
  upsertRegulation: {
    __typename?: "AdminRegulationSchema";
  } & RegulationFieldsFragment;
};

export type RemoveRegulationMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type RemoveRegulationMutation = { __typename?: "Mutation" } & Pick<Mutation, "removeRegulation">;

export type GetSellerMonthlyStatsQueryVariables = Exact<{
  filter: SellerStatsFilterInput;
}>;

export type GetSellerMonthlyStatsQuery = { __typename?: "Query" } & {
  getSellerMonthlyStats: Array<{ __typename?: "SellerMonthlyStatsRow" } & Pick<SellerMonthlyStatsRow, "sellerName" | "companyId" | "plan" | "stockStatus" | "boostVehicles" | "activities" | "soldVehicles">>;
};

export type GetSellerWeeklyStatsQueryVariables = Exact<{
  filter: SellerWeeklyStatsFilterInput;
}>;

export type GetSellerWeeklyStatsQuery = { __typename?: "Query" } & {
  getSellerWeeklyStats: Array<
    { __typename?: "SellerWeeklyStatsRow" } & Pick<SellerWeeklyStatsRow, "sellerName" | "companyId" | "plan"> & {
        periods: Array<{ __typename?: "SellerWeeklyPeriod" } & Pick<SellerWeeklyPeriod, "startDate" | "endDate" | "stockStatus" | "confirmedPayments">>;
      }
  >;
};

export type SissPickingStocksQueryVariables = Exact<{
  filters?: Maybe<SissPickingStockFilters>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
}>;

export type SissPickingStocksQuery = { __typename?: "Query" } & {
  sissPickingStocks: { __typename?: "SissPickingStocksResult" } & Pick<SissPickingStocksResult, "total"> & {
      stocks: Array<
        { __typename?: "SissPickingStockSchema" } & Pick<SissPickingStockSchema, "_id" | "refNo" | "source" | "thumbnail" | "make" | "model" | "year" | "price" | "link" | "note" | "carId" | "ignore" | "createdAt" | "updatedAt">
      >;
    };
};

export type UpdateSissPickingStockMutationVariables = Exact<{
  id: Scalars["ID"];
  input: SissPickingStockUpdateInput;
}>;

export type UpdateSissPickingStockMutation = { __typename?: "Mutation" } & {
  updateSissPickingStock: { __typename?: "SissPickingStockSchema" } & Pick<SissPickingStockSchema, "_id" | "refNo" | "source" | "thumbnail" | "make" | "model" | "year" | "price" | "link" | "note" | "carId" | "ignore" | "updatedAt">;
};

export type SissPickingStockAggsQueryVariables = Exact<{
  make?: Maybe<Scalars["String"]>;
}>;

export type SissPickingStockAggsQuery = { __typename?: "Query" } & {
  sissPickingStockAggs: { __typename?: "SissPickingStockAggs" } & Pick<SissPickingStockAggs, "makes" | "models">;
};

export type GetSaleTagsAdminQueryVariables = Exact<{
  filters?: Maybe<Scalars["JSON"]>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
}>;

export type GetSaleTagsAdminQuery = { __typename?: "Query" } & {
  getSaleTagsAdmin: { __typename?: "SaleTagResult" } & Pick<SaleTagResult, "total"> & {
      tags: Array<
        { __typename?: "SaleTagSchema" } & Pick<
          SaleTagSchema,
          "id" | "name" | "key" | "countries" | "description" | "introduction" | "modifiedAt" | "showOnAdvanced" | "countdown" | "keepUnmatchedCars" | "showOnView" | "createdAt" | "published"
        > & {
            coupon?: Maybe<{ __typename?: "CouponSchema" } & Pick<CouponSchema, "id" | "code">>;
            images?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "id" | "filename" | "cdnUri" | "order" | "mime">>>;
            carConfigs?: Maybe<
              Array<
                { __typename?: "CarConfigSchema" } & Pick<
                  CarConfigSchema,
                  "title" | "minMileage" | "maxMileage" | "keywords" | "minYear" | "maxYear" | "minPrice" | "maxPrice" | "minDisplacement" | "maxDisplacement" | "bodyTypes" | "exteriorColors" | "driveTypes" | "transmissions"
                > & {
                    models?: Maybe<Array<{ __typename?: "ModelSchema" } & Pick<ModelSchema, "id" | "name">>>;
                    make?: Maybe<{ __typename?: "MakeSchema" } & Pick<MakeSchema, "id">>;
                    model?: Maybe<{ __typename?: "ModelSchema" } & Pick<ModelSchema, "id">>;
                    companies?: Maybe<Array<{ __typename?: "CompanySchema" } & Pick<CompanySchema, "id">>>;
                  }
              >
            >;
          }
      >;
    };
};

export type UpsertTagMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  options?: Maybe<UpsertSaleTagInput>;
}>;

export type UpsertTagMutation = { __typename?: "Mutation" } & {
  upsertTag: { __typename?: "SaleTagSchema" } & Pick<
    SaleTagSchema,
    "id" | "name" | "key" | "countries" | "description" | "introduction" | "modifiedAt" | "showOnAdvanced" | "countdown" | "keepUnmatchedCars" | "showOnView" | "createdAt" | "published"
  > & {
      coupon?: Maybe<{ __typename?: "CouponSchema" } & Pick<CouponSchema, "id" | "code">>;
      images?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "id" | "filename" | "cdnUri" | "order" | "mime">>>;
      carConfigs?: Maybe<
        Array<
          { __typename?: "CarConfigSchema" } & Pick<
            CarConfigSchema,
            "title" | "minMileage" | "maxMileage" | "keywords" | "minYear" | "maxYear" | "minPrice" | "maxPrice" | "minDisplacement" | "maxDisplacement" | "bodyTypes" | "exteriorColors" | "driveTypes" | "transmissions"
          > & {
              models?: Maybe<Array<{ __typename?: "ModelSchema" } & Pick<ModelSchema, "id" | "name">>>;
              make?: Maybe<{ __typename?: "MakeSchema" } & Pick<MakeSchema, "id">>;
              model?: Maybe<{ __typename?: "ModelSchema" } & Pick<ModelSchema, "id">>;
              companies?: Maybe<Array<{ __typename?: "CompanySchema" } & Pick<CompanySchema, "id">>>;
            }
        >
      >;
    };
};

export type DeleteTagMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DeleteTagMutation = { __typename?: "Mutation" } & {
  deleteTag?: Maybe<{ __typename?: "SaleTagSchema" } & Pick<SaleTagSchema, "id" | "key">>;
};

export type AddCarTagByIdsMutationVariables = Exact<{
  ids: Scalars["String"];
  key: Scalars["String"];
}>;

export type AddCarTagByIdsMutation = { __typename?: "Mutation" } & Pick<Mutation, "addCarTagByIds">;

export type TestimonialFieldsFragment = {
  __typename?: "SatisfactionSchema";
} & Pick<SatisfactionSchema, "_id" | "ticket_id" | "name" | "country" | "score" | "state" | "published" | "comment" | "created_at" | "updated_at"> & {
    car?: Maybe<{ __typename?: "CarSchema" } & Pick<CarSchema, "carUrl">>;
    feedback?: Maybe<{ __typename?: "FeedbackSchema" } & Pick<FeedbackSchema, "comment" | "communicationSpeed" | "communicationQuality" | "likelyToRecommend" | "cost" | "delivery" | "likeCFJ">>;
    reply?: Maybe<{ __typename?: "ReplySchema" } & Pick<ReplySchema, "comment" | "createdAt">>;
    images?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "_id" | "filename" | "cdnUri" | "mime" | "checksum" | "rejected">>>;
    videos?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "_id" | "filename" | "cdnUri" | "mime" | "checksum">>>;
  };

export type GetSatisfactionsQueryVariables = Exact<{
  params?: Maybe<GetSatisfactionsAdminInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
}>;

export type GetSatisfactionsQuery = { __typename?: "Query" } & {
  getSatisfactions: { __typename?: "SatisfactionAdminResult" } & Pick<SatisfactionAdminResult, "total"> & {
      satisfactions?: Maybe<Array<Maybe<{ __typename?: "SatisfactionSchema" } & TestimonialFieldsFragment>>>;
    };
};

export type ReplyTestimonialMutationVariables = Exact<{
  id: Scalars["ID"];
  option?: Maybe<Scalars["String"]>;
}>;

export type ReplyTestimonialMutation = { __typename?: "Mutation" } & {
  replyTestimonial: { __typename?: "SatisfactionSchema" } & Pick<SatisfactionSchema, "_id"> & {
      reply?: Maybe<{ __typename?: "ReplySchema" } & Pick<ReplySchema, "comment" | "createdAt">>;
    };
};

export type ModifyFeedbackMutationVariables = Exact<{
  id: Scalars["ID"];
  option?: Maybe<Scalars["String"]>;
}>;

export type ModifyFeedbackMutation = { __typename?: "Mutation" } & {
  modifyFeedback: { __typename?: "SatisfactionSchema" } & Pick<SatisfactionSchema, "_id" | "comment"> & {
      feedback?: Maybe<{ __typename?: "FeedbackSchema" } & Pick<FeedbackSchema, "comment">>;
    };
};

export type PublishTestimonialMutationVariables = Exact<{
  id: Scalars["ID"];
  option: Scalars["Boolean"];
}>;

export type PublishTestimonialMutation = { __typename?: "Mutation" } & {
  publishTestimonial: { __typename?: "SatisfactionSchema" } & Pick<SatisfactionSchema, "_id" | "published">;
};

export type UploadTestimonialImageMutationVariables = Exact<{
  id: Scalars["ID"];
  fileKeys: Array<Scalars["String"]> | Scalars["String"];
}>;

export type UploadTestimonialImageMutation = { __typename?: "Mutation" } & {
  uploadTestimonialImage: Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "_id" | "filename" | "cdnUri" | "mime" | "checksum" | "rejected">>;
};

export type UploadTestimonialVideoMutationVariables = Exact<{
  id: Scalars["ID"];
  fileKey: Scalars["String"];
}>;

export type UploadTestimonialVideoMutation = { __typename?: "Mutation" } & {
  uploadTestimonialVideo: { __typename?: "MediaSchema" } & Pick<MediaSchema, "_id" | "filename" | "cdnUri" | "mime" | "checksum">;
};

export type RemoveTestimonialImagesMutationVariables = Exact<{
  id: Scalars["ID"];
  idsImage: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type RemoveTestimonialImagesMutation = { __typename?: "Mutation" } & {
  removeTestimonialImages: { __typename?: "SatisfactionSchema" } & Pick<SatisfactionSchema, "_id"> & {
      images?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "_id" | "filename" | "cdnUri" | "mime" | "checksum" | "rejected">>>;
    };
};

export type RemoveTestimonialVideosMutationVariables = Exact<{
  id: Scalars["ID"];
  idsVideo: Array<Scalars["ID"]> | Scalars["ID"];
}>;

export type RemoveTestimonialVideosMutation = { __typename?: "Mutation" } & {
  removeTestimonialVideos: { __typename?: "SatisfactionSchema" } & Pick<SatisfactionSchema, "_id"> & {
      videos?: Maybe<Array<{ __typename?: "MediaSchema" } & Pick<MediaSchema, "_id" | "filename" | "cdnUri" | "mime" | "checksum">>>;
    };
};

export type UpdateForBuyerMutationVariables = Exact<{
  id: Scalars["ID"];
  option: UpdateForBuyerInput;
}>;

export type UpdateForBuyerMutation = { __typename?: "Mutation" } & {
  updateForBuyer: { __typename?: "SatisfactionSchema" } & Pick<SatisfactionSchema, "_id" | "state" | "score" | "created_at" | "updated_at"> & {
      feedback?: Maybe<{ __typename?: "FeedbackSchema" } & Pick<FeedbackSchema, "cost" | "delivery" | "communicationSpeed" | "communicationQuality" | "likelyToRecommend" | "likeCFJ">>;
    };
};

export type TicketCanaryBucketFieldsFragment = {
  __typename?: "TicketCanaryBucketSchema";
} & Pick<TicketCanaryBucketSchema, "percent" | "overridden">;

export type TicketCanaryPercentQueryVariables = Exact<{ [key: string]: never }>;

export type TicketCanaryPercentQuery = { __typename?: "Query" } & {
  ticketCanaryPercent: { __typename?: "TicketCanarySchema" } & {
    quality: {
      __typename?: "TicketCanaryBucketSchema";
    } & TicketCanaryBucketFieldsFragment;
    nonQuality: {
      __typename?: "TicketCanaryBucketSchema";
    } & TicketCanaryBucketFieldsFragment;
  };
};

export type SetTicketCanaryPercentMutationVariables = Exact<{
  quality?: Maybe<Scalars["Int"]>;
  nonQuality?: Maybe<Scalars["Int"]>;
}>;

export type SetTicketCanaryPercentMutation = { __typename?: "Mutation" } & {
  setTicketCanaryPercent: { __typename?: "TicketCanarySchema" } & {
    quality: {
      __typename?: "TicketCanaryBucketSchema";
    } & TicketCanaryBucketFieldsFragment;
    nonQuality: {
      __typename?: "TicketCanaryBucketSchema";
    } & TicketCanaryBucketFieldsFragment;
  };
};

export type GmailInboundStatusFieldsFragment = {
  __typename?: "GmailInboundStatusSchema";
} & Pick<GmailInboundStatusSchema, "connected" | "email" | "connectedAt" | "lastRefreshAt" | "lastWatchAt" | "watchExpiresAt" | "lastError" | "accessTokenExpiresAt" | "watchEmail" | "oauthClientId" | "scope">;

export type GmailInboundStatusQueryVariables = Exact<{ [key: string]: never }>;

export type GmailInboundStatusQuery = { __typename?: "Query" } & {
  gmailInboundStatus: {
    __typename?: "GmailInboundStatusSchema";
  } & GmailInboundStatusFieldsFragment;
};

export type ConnectGmailInboundMutationVariables = Exact<{
  code: Scalars["String"];
}>;

export type ConnectGmailInboundMutation = { __typename?: "Mutation" } & {
  connectGmailInbound: {
    __typename?: "GmailInboundStatusSchema";
  } & GmailInboundStatusFieldsFragment;
};

export type DisconnectGmailInboundMutationVariables = Exact<{
  [key: string]: never;
}>;

export type DisconnectGmailInboundMutation = { __typename?: "Mutation" } & {
  disconnectGmailInbound: {
    __typename?: "GmailInboundStatusSchema";
  } & GmailInboundStatusFieldsFragment;
};

export type TicketSplitDebugQueryVariables = Exact<{
  args?: Maybe<TicketSplitDebugArgs>;
}>;

export type TicketSplitDebugQuery = { __typename?: "Query" } & {
  ticketSplitDebug: { __typename?: "TicketSplitDebugSchema" } & Pick<TicketSplitDebugSchema, "from" | "to" | "serverTimezone" | "cfjAgentGroupId" | "ratioCountries" | "warnings"> & {
      buckets: Array<
        { __typename?: "TicketSplitBucket" } & Pick<
          TicketSplitBucket,
          "scope" | "country" | "segment" | "bandIndex" | "bandMin" | "bandMax" | "ratioSum" | "totalBuyersOpen" | "denominatorUsed" | "totalTicketsAll" | "poolBuyersOpen" | "wouldAssignTo" | "warnings"
        > & {
            agents: Array<
              { __typename?: "TicketSplitAgentStat" } & Pick<
                TicketSplitAgentStat,
                | "email"
                | "userId"
                | "zendeskId"
                | "name"
                | "foundInUsers"
                | "configuredRatio"
                | "buyersOpen"
                | "ticketsOpen"
                | "buyersAll"
                | "ticketsAll"
                | "actualRatio"
                | "actualRatioOps"
                | "deltaVsConfigured"
                | "accepted"
                | "wouldBeAssigned"
              >
            >;
            unmapped: Array<{ __typename?: "TicketSplitUnmappedStat" } & Pick<TicketSplitUnmappedStat, "assigneeId" | "email" | "buyersOpen" | "ticketsOpen" | "buyersAll" | "ticketsAll" | "reason">>;
          }
      >;
    };
};

export type GetTicketsAdminQueryVariables = Exact<{
  args: GetTicketsAdminArgs;
}>;

export type GetTicketsAdminQuery = { __typename?: "Query" } & {
  getTicketsAdmin: { __typename?: "GetTicketsAdminSchema" } & Pick<GetTicketsAdminSchema, "total"> & {
      tickets: Array<
        { __typename?: "TicketRecordSchema" } & Pick<TicketRecordSchema, "id" | "inquiryId" | "ticketNo" | "subject" | "status" | "assigneeId" | "mergedIntoId" | "createdAt" | "updatedAt"> & {
            assignee?: Maybe<{ __typename?: "InternalTicketUserSchema" } & Pick<InternalTicketUserSchema, "id" | "name" | "email" | "avatarUrl">>;
            requester?: Maybe<{ __typename?: "TicketRequesterSchema" } & Pick<TicketRequesterSchema, "name" | "email" | "phone">>;
          }
      >;
    };
};

export type GetTicketAdminQueryVariables = Exact<{
  id: Scalars["String"];
}>;

export type GetTicketAdminQuery = { __typename?: "Query" } & {
  getTicketAdmin: { __typename?: "TicketRecordSchema" } & Pick<TicketRecordSchema, "id" | "inquiryId" | "ticketNo" | "subject" | "status" | "assigneeId" | "mergedIntoId" | "emailCcAddresses" | "followerIds" | "createdAt" | "updatedAt"> & {
      assignee?: Maybe<{ __typename?: "InternalTicketUserSchema" } & Pick<InternalTicketUserSchema, "id" | "name" | "email" | "avatarUrl">>;
      followers: Array<{ __typename?: "InternalTicketUserSchema" } & Pick<InternalTicketUserSchema, "id" | "name" | "email" | "avatarUrl">>;
      requester?: Maybe<{ __typename?: "TicketRequesterSchema" } & Pick<TicketRequesterSchema, "name" | "email" | "phone">>;
    };
};

export type MergeTicketMutationVariables = Exact<{
  id: Scalars["String"];
  targetTicketId: Scalars["String"];
}>;

export type MergeTicketMutation = { __typename?: "Mutation" } & {
  mergeTicket: { __typename?: "TicketRecordSchema" } & Pick<TicketRecordSchema, "id" | "inquiryId" | "ticketNo" | "subject">;
};

export type AssignTicketMutationVariables = Exact<{
  id: Scalars["String"];
  assigneeUserId?: Maybe<Scalars["String"]>;
}>;

export type AssignTicketMutation = { __typename?: "Mutation" } & {
  assignTicket: { __typename?: "TicketRecordSchema" } & Pick<TicketRecordSchema, "id" | "assigneeId"> & {
      assignee?: Maybe<{ __typename?: "InternalTicketUserSchema" } & Pick<InternalTicketUserSchema, "id" | "name" | "email" | "avatarUrl">>;
    };
};

export type SetTicketFollowersMutationVariables = Exact<{
  id: Scalars["String"];
  followerUserIds: Array<Scalars["String"]> | Scalars["String"];
}>;

export type SetTicketFollowersMutation = { __typename?: "Mutation" } & {
  setTicketFollowers: { __typename?: "TicketRecordSchema" } & Pick<TicketRecordSchema, "id">;
};

export type SetTicketEmailCcMutationVariables = Exact<{
  id: Scalars["String"];
  emailCcAddresses: Array<Scalars["String"]> | Scalars["String"];
}>;

export type SetTicketEmailCcMutation = { __typename?: "Mutation" } & {
  setTicketEmailCc: { __typename?: "TicketRecordSchema" } & Pick<TicketRecordSchema, "id">;
};

export type GetTicketCommentsQueryVariables = Exact<{
  id: Scalars["String"];
}>;

export type GetTicketCommentsQuery = { __typename?: "Query" } & {
  getTicketComments: Array<
    { __typename?: "InvoiceCommentSchema" } & Pick<InvoiceCommentSchema, "_id" | "body" | "html_body" | "public" | "created_at"> & {
        author?: Maybe<{ __typename?: "InvoiceCommentAuthorSchema" } & Pick<InvoiceCommentAuthorSchema, "userId" | "name" | "avatarUrl" | "type">>;
        attachments?: Maybe<Array<{ __typename?: "InvoiceCommentAttachmentSchema" } & Pick<InvoiceCommentAttachmentSchema, "file_name" | "content_url" | "content_type">>>;
      }
  >;
};

export type ReplyTicketCommentMutationVariables = Exact<{
  id: Scalars["String"];
  comment: Scalars["String"];
  isPublic?: Maybe<Scalars["Boolean"]>;
  htmlBody?: Maybe<Scalars["String"]>;
}>;

export type ReplyTicketCommentMutation = { __typename?: "Mutation" } & {
  replyTicketComment: { __typename?: "InvoiceCommentSchema" } & Pick<InvoiceCommentSchema, "_id" | "body" | "html_body" | "public" | "created_at"> & {
      author?: Maybe<{ __typename?: "InvoiceCommentAuthorSchema" } & Pick<InvoiceCommentAuthorSchema, "userId" | "name" | "avatarUrl" | "type">>;
    };
};

export type CreateTicketAdminMutationVariables = Exact<{
  input: CreateTicketAdminInput;
}>;

export type CreateTicketAdminMutation = { __typename?: "Mutation" } & {
  createTicketAdmin: { __typename?: "TicketRecordSchema" } & Pick<TicketRecordSchema, "id" | "ticketNo" | "subject" | "status" | "inquiryId">;
};

export type SetTicketRequesterMutationVariables = Exact<{
  id: Scalars["String"];
  input: UpdateTicketRequesterInput;
}>;

export type SetTicketRequesterMutation = { __typename?: "Mutation" } & {
  setTicketRequester: { __typename?: "TicketRecordSchema" } & Pick<TicketRecordSchema, "id"> & {
      requester?: Maybe<{ __typename?: "TicketRequesterSchema" } & Pick<TicketRequesterSchema, "name" | "email" | "phone">>;
    };
};

export type SetTicketStatusMutationVariables = Exact<{
  id: Scalars["String"];
  status: Scalars["String"];
}>;

export type SetTicketStatusMutation = { __typename?: "Mutation" } & {
  setTicketStatus: { __typename?: "TicketRecordSchema" } & Pick<TicketRecordSchema, "id" | "status">;
};

export type TransformationFieldsFragment = {
  __typename?: "TransformationSchema";
} & Pick<TransformationSchema, "id" | "key" | "type" | "value" | "source" | "locked" | "createdAt" | "modifiedAt"> & {
    company?: Maybe<{ __typename?: "CompanySchema" } & Pick<CompanySchema, "id" | "name">>;
    fullValue?: Maybe<
      { __typename?: "TransformationValueSchema" } & Pick<TransformationValueSchema, "id" | "name"> & {
          make?: Maybe<{ __typename?: "MakeSchema" } & Pick<MakeSchema, "id" | "name">>;
        }
    >;
  };

export type GetTransformationsQueryVariables = Exact<{
  filters?: Maybe<GetTransformationsAdminInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
}>;

export type GetTransformationsQuery = { __typename?: "Query" } & {
  getTransformations: { __typename?: "TransformationResult" } & Pick<TransformationResult, "total"> & {
      transformations?: Maybe<
        Array<
          Maybe<
            {
              __typename?: "TransformationSchema";
            } & TransformationFieldsFragment
          >
        >
      >;
    };
};

export type UpsertTransformationMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  data: UpsertTransformationInput;
}>;

export type UpsertTransformationMutation = { __typename?: "Mutation" } & {
  upsertTransformation?: Maybe<{ __typename?: "TransformationSchema" } & TransformationFieldsFragment>;
};

export type BatchEditTransformationMutationVariables = Exact<{
  ids: Array<Scalars["ID"]> | Scalars["ID"];
  data: BatchEditTransformationInput;
}>;

export type BatchEditTransformationMutation = {
  __typename?: "Mutation";
} & Pick<Mutation, "batchEditTransformation">;

export type DeleteTransformationMutationVariables = Exact<{
  id: Scalars["ID"];
}>;

export type DeleteTransformationMutation = { __typename?: "Mutation" } & Pick<Mutation, "deleteTransformation">;

export type GetTransformationMakesQueryVariables = Exact<{
  input: GetAllMakeArgs;
}>;

export type GetTransformationMakesQuery = { __typename?: "Query" } & {
  getAllMake: Array<{ __typename?: "MakeSchema" } & Pick<MakeSchema, "id" | "name">>;
};

export type GetTransformationAccessoriesQueryVariables = Exact<{
  root?: Maybe<Scalars["Boolean"]>;
  keywords?: Maybe<Scalars["String"]>;
  limit?: Maybe<Scalars["Float"]>;
}>;

export type GetTransformationAccessoriesQuery = { __typename?: "Query" } & {
  getAdminAccessories: Array<{ __typename?: "AccessorySchema" } & Pick<AccessorySchema, "id" | "name">>;
};

export type AdminUserFieldsFragment = { __typename?: "UserSchema" } & Pick<UserSchema, "id" | "name" | "email" | "roles" | "tags" | "status">;

export type AdminUserDetailFieldsFragment = {
  __typename?: "UserSchema";
} & Pick<UserSchema, "namePronounciation" | "address" | "address2" | "phone" | "locale" | "zendeskId"> &
  AdminUserFieldsFragment;

export type GetManagementUserQueryVariables = Exact<{
  filters?: Maybe<GetManagementUserInput>;
  offset?: Maybe<Scalars["Int"]>;
  limit?: Maybe<Scalars["Int"]>;
  sort?: Maybe<Scalars["String"]>;
  order?: Maybe<Scalars["String"]>;
}>;

export type GetManagementUserQuery = { __typename?: "Query" } & {
  getManagementUser: { __typename?: "GetManagementUserType" } & Pick<GetManagementUserType, "total"> & { users: Array<{ __typename?: "UserSchema" } & AdminUserFieldsFragment> };
};

export type GetManagementUserByIdQueryVariables = Exact<{
  id: Scalars["ID"];
}>;

export type GetManagementUserByIdQuery = { __typename?: "Query" } & {
  getManagementUserById: {
    __typename?: "UserSchema";
  } & AdminUserDetailFieldsFragment;
};

export type UpsertUserMutationVariables = Exact<{
  id?: Maybe<Scalars["ID"]>;
  data: UserInputDto;
}>;

export type UpsertUserMutation = { __typename?: "Mutation" } & {
  upsertUser?: Maybe<{ __typename?: "UserSchema" } & AdminUserDetailFieldsFragment>;
};

export type CreateImpersonationTicketMutationVariables = Exact<{
  email: Scalars["String"];
}>;

export type CreateImpersonationTicketMutation = { __typename?: "Mutation" } & {
  createImpersonationTicket: { __typename?: "ImpersonationTicketType" } & Pick<ImpersonationTicketType, "token" | "expiresAt" | "accessToken">;
};

export type ZendeskSyncJobFieldsFragment = {
  __typename?: "ZendeskSyncJobSchema";
} & Pick<ZendeskSyncJobSchema, "status" | "lastId" | "processed" | "skipped" | "failed" | "total" | "startedAt" | "updatedAt" | "stopRequested" | "stale"> & {
    scope?: Maybe<{ __typename?: "ZendeskSyncScopeSchema" } & Pick<ZendeskSyncScopeSchema, "fromDate" | "ticketFrom" | "ticketTo" | "force" | "continuous" | "maxRpm">>;
  };

export type GetZendeskSyncJobQueryVariables = Exact<{ [key: string]: never }>;

export type GetZendeskSyncJobQuery = { __typename?: "Query" } & {
  getZendeskSyncJob: {
    __typename?: "ZendeskSyncJobSchema";
  } & ZendeskSyncJobFieldsFragment;
};

export type GetZendeskSyncFailuresQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetZendeskSyncFailuresQuery = { __typename?: "Query" } & {
  getZendeskSyncFailures: Array<{ __typename?: "ZendeskSyncFailureSchema" } & Pick<ZendeskSyncFailureSchema, "ticketId" | "zendeskTicketId" | "error" | "at">>;
};

export type TriggerZendeskSyncBatchMutationVariables = Exact<{
  input?: Maybe<TriggerZendeskSyncBatchInput>;
}>;

export type TriggerZendeskSyncBatchMutation = { __typename?: "Mutation" } & {
  triggerZendeskSyncBatch: {
    __typename?: "ZendeskSyncJobSchema";
  } & ZendeskSyncJobFieldsFragment;
};

export type StopZendeskSyncJobMutationVariables = Exact<{
  [key: string]: never;
}>;

export type StopZendeskSyncJobMutation = { __typename?: "Mutation" } & {
  stopZendeskSyncJob: {
    __typename?: "ZendeskSyncJobSchema";
  } & ZendeskSyncJobFieldsFragment;
};

export type ResetZendeskSyncJobMutationVariables = Exact<{
  [key: string]: never;
}>;

export type ResetZendeskSyncJobMutation = { __typename?: "Mutation" } & {
  resetZendeskSyncJob: {
    __typename?: "ZendeskSyncJobSchema";
  } & ZendeskSyncJobFieldsFragment;
};

export const LandingTagFieldsFragmentDoc = gql`
  fragment LandingTagFields on LandingTagSchema {
    id
    key
    bodyTypes
    fuelTypes
    driveTypes
    transmissions
    steerings
    exteriorColors
    accessoryIds
    minPrice
    maxPrice
    minDisplacement
    maxDisplacement
    minYear
    maxYear
    models {
      id
      name
      make {
        id
        name
      }
    }
    description
    heading
    published
    saleTags {
      id
      name
      key
      description
      published
    }
  }
`;
export const CountryPageFieldsFragmentDoc = gql`
  fragment CountryPageFields on CountryPageSchema {
    _id
    name
    key
    region
    regulation {
      year
      inspection
      port
      deliveryTime
    }
    dutiesAndTaxes
    importDocuments
    paymentMethodTT
    models
    faqs {
      question
      answer
    }
    banks
    modelImages
    bannerImages
  }
`;
export const ModelSpecFieldsFragmentDoc = gql`
  fragment ModelSpecFields on ModelSpecSchema {
    id
    model {
      id
      name
      key
    }
    modelCode
    year
    bodyType
    door
    driveType
    displacement
    fuelType
    vehicleWidth
    vehicleLength
    vehicleHeight
    keywords
    lock
  }
`;
export const AdminModelFieldsFragmentDoc = gql`
  fragment AdminModelFields on ModelSchema {
    id
    name
    key
    makeModelKey
    carCount
    locked
    make {
      id
      name
    }
    alias {
      id
      name
      makeModelKey
    }
  }
`;
export const RegulationFieldsFragmentDoc = gql`
  fragment RegulationFields on AdminRegulationSchema {
    _id
    country
    targeted
    messages
    rules {
      message
      rule
      filter
    }
    ports {
      port
      messages
    }
  }
`;
export const TestimonialFieldsFragmentDoc = gql`
  fragment TestimonialFields on SatisfactionSchema {
    _id
    ticket_id
    name
    country
    score
    state
    published
    comment
    created_at
    updated_at
    car {
      carUrl
    }
    feedback {
      comment
      communicationSpeed
      communicationQuality
      likelyToRecommend
      cost
      delivery
      likeCFJ
    }
    reply {
      comment
      createdAt
    }
    images {
      _id
      filename
      cdnUri
      mime
      checksum
      rejected
    }
    videos {
      _id
      filename
      cdnUri
      mime
      checksum
    }
  }
`;
export const TicketCanaryBucketFieldsFragmentDoc = gql`
  fragment TicketCanaryBucketFields on TicketCanaryBucketSchema {
    percent
    overridden
  }
`;
export const GmailInboundStatusFieldsFragmentDoc = gql`
  fragment GmailInboundStatusFields on GmailInboundStatusSchema {
    connected
    email
    connectedAt
    lastRefreshAt
    lastWatchAt
    watchExpiresAt
    lastError
    accessTokenExpiresAt
    watchEmail
    oauthClientId
    scope
  }
`;
export const TransformationFieldsFragmentDoc = gql`
  fragment TransformationFields on TransformationSchema {
    id
    key
    type
    value
    source
    locked
    createdAt
    modifiedAt
    company {
      id
      name
    }
    fullValue {
      id
      name
      make {
        id
        name
      }
    }
  }
`;
export const AdminUserFieldsFragmentDoc = gql`
  fragment AdminUserFields on UserSchema {
    id
    name
    email
    roles
    tags
    status
  }
`;
export const AdminUserDetailFieldsFragmentDoc = gql`
  fragment AdminUserDetailFields on UserSchema {
    ...AdminUserFields
    namePronounciation
    address
    address2
    phone
    locale
    zendeskId
  }
  ${AdminUserFieldsFragmentDoc}
`;
export const ZendeskSyncJobFieldsFragmentDoc = gql`
  fragment ZendeskSyncJobFields on ZendeskSyncJobSchema {
    status
    lastId
    processed
    skipped
    failed
    total
    startedAt
    updatedAt
    stopRequested
    stale
    scope {
      fromDate
      ticketFrom
      ticketTo
      force
      continuous
      maxRpm
    }
  }
`;
export const GetAdsDocument = gql`
  query GetAds($filters: GetAdsFiltersInput, $offset: Int, $limit: Int, $sort: String, $order: String) {
    getAds(filters: $filters, offset: $offset, limit: $limit, sort: $sort, order: $order) {
      ads {
        _id
        name
        type
        platform
        position
        attributes
        responsive
        startAt
        endAt
        make {
          _id
        }
        model {
          _id
        }
        slideAttributes
        parallax
        width
        height
        posIndex
        content
        country
        published
      }
      total
    }
  }
`;

/**
 * __useGetAdsQuery__
 *
 * To run a query within a React component, call `useGetAdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetAdsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdsQuery, GetAdsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAdsQuery, GetAdsQueryVariables>(GetAdsDocument, options);
}
export function useGetAdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdsQuery, GetAdsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAdsQuery, GetAdsQueryVariables>(GetAdsDocument, options);
}
export type GetAdsQueryHookResult = ReturnType<typeof useGetAdsQuery>;
export type GetAdsLazyQueryHookResult = ReturnType<typeof useGetAdsLazyQuery>;
export type GetAdsQueryResult = Apollo.QueryResult<GetAdsQuery, GetAdsQueryVariables>;
export const UpsertAdDocument = gql`
  mutation UpsertAd($id: ID, $data: UpsertAdInput!) {
    upsertAd(id: $id, data: $data) {
      _id
      name
      type
      platform
      position
      attributes
      make {
        _id
      }
      model {
        _id
      }
      slideAttributes
      responsive
      parallax
      width
      height
      posIndex
      content
      country
      published
    }
  }
`;
export type UpsertAdMutationFn = Apollo.MutationFunction<UpsertAdMutation, UpsertAdMutationVariables>;

/**
 * __useUpsertAdMutation__
 *
 * To run a mutation, you first call `useUpsertAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertAdMutation, { data, loading, error }] = useUpsertAdMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertAdMutation(baseOptions?: Apollo.MutationHookOptions<UpsertAdMutation, UpsertAdMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertAdMutation, UpsertAdMutationVariables>(UpsertAdDocument, options);
}
export type UpsertAdMutationHookResult = ReturnType<typeof useUpsertAdMutation>;
export type UpsertAdMutationResult = Apollo.MutationResult<UpsertAdMutation>;
export type UpsertAdMutationOptions = Apollo.BaseMutationOptions<UpsertAdMutation, UpsertAdMutationVariables>;
export const DeleteAdDocument = gql`
  mutation DeleteAd($id: ID!) {
    removeAd(id: $id)
  }
`;
export type DeleteAdMutationFn = Apollo.MutationFunction<DeleteAdMutation, DeleteAdMutationVariables>;

/**
 * __useDeleteAdMutation__
 *
 * To run a mutation, you first call `useDeleteAdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAdMutation, { data, loading, error }] = useDeleteAdMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAdMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAdMutation, DeleteAdMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteAdMutation, DeleteAdMutationVariables>(DeleteAdDocument, options);
}
export type DeleteAdMutationHookResult = ReturnType<typeof useDeleteAdMutation>;
export type DeleteAdMutationResult = Apollo.MutationResult<DeleteAdMutation>;
export type DeleteAdMutationOptions = Apollo.BaseMutationOptions<DeleteAdMutation, DeleteAdMutationVariables>;
export const LoginDocument = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      id
      email
      name
      roles
      accessToken
    }
  }
`;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
}
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const SocialLoginDocument = gql`
  mutation SocialLogin($input: SocialLoginInput!) {
    socialLogin(input: $input) {
      id
      email
      name
      roles
      accessToken
    }
  }
`;
export type SocialLoginMutationFn = Apollo.MutationFunction<SocialLoginMutation, SocialLoginMutationVariables>;

/**
 * __useSocialLoginMutation__
 *
 * To run a mutation, you first call `useSocialLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSocialLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [socialLoginMutation, { data, loading, error }] = useSocialLoginMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSocialLoginMutation(baseOptions?: Apollo.MutationHookOptions<SocialLoginMutation, SocialLoginMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SocialLoginMutation, SocialLoginMutationVariables>(SocialLoginDocument, options);
}
export type SocialLoginMutationHookResult = ReturnType<typeof useSocialLoginMutation>;
export type SocialLoginMutationResult = Apollo.MutationResult<SocialLoginMutation>;
export type SocialLoginMutationOptions = Apollo.BaseMutationOptions<SocialLoginMutation, SocialLoginMutationVariables>;
export const RenewTokenDocument = gql`
  mutation RenewToken {
    renewToken {
      id
      email
      accessToken
    }
  }
`;
export type RenewTokenMutationFn = Apollo.MutationFunction<RenewTokenMutation, RenewTokenMutationVariables>;

/**
 * __useRenewTokenMutation__
 *
 * To run a mutation, you first call `useRenewTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewTokenMutation, { data, loading, error }] = useRenewTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRenewTokenMutation(baseOptions?: Apollo.MutationHookOptions<RenewTokenMutation, RenewTokenMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RenewTokenMutation, RenewTokenMutationVariables>(RenewTokenDocument, options);
}
export type RenewTokenMutationHookResult = ReturnType<typeof useRenewTokenMutation>;
export type RenewTokenMutationResult = Apollo.MutationResult<RenewTokenMutation>;
export type RenewTokenMutationOptions = Apollo.BaseMutationOptions<RenewTokenMutation, RenewTokenMutationVariables>;
export const LogoutDocument = gql`
  mutation Logout {
    logout
  }
`;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
}
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const GetBillingCompanyDocument = gql`
  query GetBillingCompany($filters: JSON) {
    getBillingCompany(filters: $filters) {
      _id
      enName
      name
    }
  }
`;

/**
 * __useGetBillingCompanyQuery__
 *
 * To run a query within a React component, call `useGetBillingCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingCompanyQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetBillingCompanyQuery(baseOptions?: Apollo.QueryHookOptions<GetBillingCompanyQuery, GetBillingCompanyQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBillingCompanyQuery, GetBillingCompanyQueryVariables>(GetBillingCompanyDocument, options);
}
export function useGetBillingCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingCompanyQuery, GetBillingCompanyQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBillingCompanyQuery, GetBillingCompanyQueryVariables>(GetBillingCompanyDocument, options);
}
export type GetBillingCompanyQueryHookResult = ReturnType<typeof useGetBillingCompanyQuery>;
export type GetBillingCompanyLazyQueryHookResult = ReturnType<typeof useGetBillingCompanyLazyQuery>;
export type GetBillingCompanyQueryResult = Apollo.QueryResult<GetBillingCompanyQuery, GetBillingCompanyQueryVariables>;
export const GetBillingsDocument = gql`
  query GetBillings($filters: JSON, $offset: Int, $limit: Int, $sort: String, $order: String) {
    getBillings(filters: $filters, offset: $offset, limit: $limit, sort: $sort, order: $order) {
      billings {
        _id
        seq
        company {
          _id
          enName
          name
        }
        items
        period
        status
        paidAt
        sentAt
        dueAt
        overall
        totalTax
        overallBeforeTax
        createdAt
      }
      total
    }
  }
`;

/**
 * __useGetBillingsQuery__
 *
 * To run a query within a React component, call `useGetBillingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBillingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBillingsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetBillingsQuery(baseOptions?: Apollo.QueryHookOptions<GetBillingsQuery, GetBillingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBillingsQuery, GetBillingsQueryVariables>(GetBillingsDocument, options);
}
export function useGetBillingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBillingsQuery, GetBillingsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBillingsQuery, GetBillingsQueryVariables>(GetBillingsDocument, options);
}
export type GetBillingsQueryHookResult = ReturnType<typeof useGetBillingsQuery>;
export type GetBillingsLazyQueryHookResult = ReturnType<typeof useGetBillingsLazyQuery>;
export type GetBillingsQueryResult = Apollo.QueryResult<GetBillingsQuery, GetBillingsQueryVariables>;
export const UpsertBillingDocument = gql`
  mutation UpsertBilling($id: ID, $data: BillingUpsertInput!) {
    upsertBilling(id: $id, data: $data) {
      _id
      seq
      company {
        _id
        enName
        name
      }
      items
      period
      status
      paidAt
      sentAt
      dueAt
      overall
      totalTax
      overallBeforeTax
      createdAt
    }
  }
`;
export type UpsertBillingMutationFn = Apollo.MutationFunction<UpsertBillingMutation, UpsertBillingMutationVariables>;

/**
 * __useUpsertBillingMutation__
 *
 * To run a mutation, you first call `useUpsertBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertBillingMutation, { data, loading, error }] = useUpsertBillingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertBillingMutation(baseOptions?: Apollo.MutationHookOptions<UpsertBillingMutation, UpsertBillingMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertBillingMutation, UpsertBillingMutationVariables>(UpsertBillingDocument, options);
}
export type UpsertBillingMutationHookResult = ReturnType<typeof useUpsertBillingMutation>;
export type UpsertBillingMutationResult = Apollo.MutationResult<UpsertBillingMutation>;
export type UpsertBillingMutationOptions = Apollo.BaseMutationOptions<UpsertBillingMutation, UpsertBillingMutationVariables>;
export const RemoveBillingDocument = gql`
  mutation RemoveBilling($id: ID!) {
    removeBilling(id: $id)
  }
`;
export type RemoveBillingMutationFn = Apollo.MutationFunction<RemoveBillingMutation, RemoveBillingMutationVariables>;

/**
 * __useRemoveBillingMutation__
 *
 * To run a mutation, you first call `useRemoveBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBillingMutation, { data, loading, error }] = useRemoveBillingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveBillingMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBillingMutation, RemoveBillingMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveBillingMutation, RemoveBillingMutationVariables>(RemoveBillingDocument, options);
}
export type RemoveBillingMutationHookResult = ReturnType<typeof useRemoveBillingMutation>;
export type RemoveBillingMutationResult = Apollo.MutationResult<RemoveBillingMutation>;
export type RemoveBillingMutationOptions = Apollo.BaseMutationOptions<RemoveBillingMutation, RemoveBillingMutationVariables>;
export const ResendBillingDocument = gql`
  mutation ResendBilling($id: ID!) {
    resendBilling(id: $id)
  }
`;
export type ResendBillingMutationFn = Apollo.MutationFunction<ResendBillingMutation, ResendBillingMutationVariables>;

/**
 * __useResendBillingMutation__
 *
 * To run a mutation, you first call `useResendBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendBillingMutation, { data, loading, error }] = useResendBillingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendBillingMutation(baseOptions?: Apollo.MutationHookOptions<ResendBillingMutation, ResendBillingMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResendBillingMutation, ResendBillingMutationVariables>(ResendBillingDocument, options);
}
export type ResendBillingMutationHookResult = ReturnType<typeof useResendBillingMutation>;
export type ResendBillingMutationResult = Apollo.MutationResult<ResendBillingMutation>;
export type ResendBillingMutationOptions = Apollo.BaseMutationOptions<ResendBillingMutation, ResendBillingMutationVariables>;
export const CanaryHealthDocument = gql`
  query CanaryHealth($args: CanaryHealthArgs) {
    canaryHealth(args: $args) {
      level
      generatedAt
      windowFrom
      windowTo
      windowHours
      graceMinutes
      internalInquiries
      zendeskInquiries
      unticketedInquiries
      truncated
      durationMs
      checks {
        key
        title
        description
        severity
        status
        count
        total
        note
        durationMs
        samples {
          inquiryId
          ticketNo
          reason
          at
        }
      }
      split {
        key
        label
        configuredPercent
        overridden
        internal
        zendesk
        observedPercent
        expectedMin
        expectedMax
        status
        since
      }
    }
  }
`;

/**
 * __useCanaryHealthQuery__
 *
 * To run a query within a React component, call `useCanaryHealthQuery` and pass it any options that fit your needs.
 * When your component renders, `useCanaryHealthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCanaryHealthQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useCanaryHealthQuery(baseOptions?: Apollo.QueryHookOptions<CanaryHealthQuery, CanaryHealthQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CanaryHealthQuery, CanaryHealthQueryVariables>(CanaryHealthDocument, options);
}
export function useCanaryHealthLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CanaryHealthQuery, CanaryHealthQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CanaryHealthQuery, CanaryHealthQueryVariables>(CanaryHealthDocument, options);
}
export type CanaryHealthQueryHookResult = ReturnType<typeof useCanaryHealthQuery>;
export type CanaryHealthLazyQueryHookResult = ReturnType<typeof useCanaryHealthLazyQuery>;
export type CanaryHealthQueryResult = Apollo.QueryResult<CanaryHealthQuery, CanaryHealthQueryVariables>;
export const ConfirmCarAvailabilityDocument = gql`
  mutation confirmCarAvailability($key: String!) {
    confirmCarAvailability(input: { key: $key }) {
      invoiceId
      availability
    }
  }
`;
export type ConfirmCarAvailabilityMutationFn = Apollo.MutationFunction<ConfirmCarAvailabilityMutation, ConfirmCarAvailabilityMutationVariables>;

/**
 * __useConfirmCarAvailabilityMutation__
 *
 * To run a mutation, you first call `useConfirmCarAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmCarAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmCarAvailabilityMutation, { data, loading, error }] = useConfirmCarAvailabilityMutation({
 *   variables: {
 *      key: // value for 'key'
 *   },
 * });
 */
export function useConfirmCarAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmCarAvailabilityMutation, ConfirmCarAvailabilityMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConfirmCarAvailabilityMutation, ConfirmCarAvailabilityMutationVariables>(ConfirmCarAvailabilityDocument, options);
}
export type ConfirmCarAvailabilityMutationHookResult = ReturnType<typeof useConfirmCarAvailabilityMutation>;
export type ConfirmCarAvailabilityMutationResult = Apollo.MutationResult<ConfirmCarAvailabilityMutation>;
export type ConfirmCarAvailabilityMutationOptions = Apollo.BaseMutationOptions<ConfirmCarAvailabilityMutation, ConfirmCarAvailabilityMutationVariables>;
export const GetCarDocument = gql`
  query GetCar($id: String) {
    getCar(id: $id) {
      id
      refNo
      currency
      oversea
      domestic
      internalNote
      title
      catchPhrase
      status
      price
      priceMin
      internalNote
      modifiedAt
      expiredAt
      VIN
      images {
        id
        filename
        cdnUri
        order
        mime
      }
      youtubeURL
      grade
      inspectionAuthority
      inspectionRatings
      plusPoint
      minusPoint
      modelCode
      tags
      specialities
      currencyKey
      door
      mileage
      displacement
      passengers
      bodyType
      fuelType
      driveType
      steering
      transmission
      exteriorColor
      interiorColor
      vehicleWidth
      vehicleLength
      vehicleHeight
      registrationMonth
      registrationYear
      manufacturedMonth
      manufacturedYear
      m3
      accessories {
        id
      }
      comment
      priceUSD
      priceOriginal
      reservedUntil
      locked
      lockedMedia
      make {
        id
      }
      model {
        id
      }
      company {
        id
        name
        enName
      }
    }
  }
`;

/**
 * __useGetCarQuery__
 *
 * To run a query within a React component, call `useGetCarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCarQuery(baseOptions?: Apollo.QueryHookOptions<GetCarQuery, GetCarQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCarQuery, GetCarQueryVariables>(GetCarDocument, options);
}
export function useGetCarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarQuery, GetCarQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCarQuery, GetCarQueryVariables>(GetCarDocument, options);
}
export type GetCarQueryHookResult = ReturnType<typeof useGetCarQuery>;
export type GetCarLazyQueryHookResult = ReturnType<typeof useGetCarLazyQuery>;
export type GetCarQueryResult = Apollo.QueryResult<GetCarQuery, GetCarQueryVariables>;
export const UpdateCarDocument = gql`
  mutation UpdateCar($id: String!, $data: JSON!) {
    updateCar(id: $id, data: $data) {
      id
      refNo
      currency
      oversea
      domestic
      internalNote
      title
      catchPhrase
      status
      price
      priceMin
      internalNote
      modifiedAt
      expiredAt
      VIN
      images {
        id
        filename
        cdnUri
        order
        mime
      }
      youtubeURL
      grade
      inspectionAuthority
      inspectionRatings
      plusPoint
      minusPoint
      modelCode
      tags
      specialities
      currencyKey
      door
      mileage
      displacement
      passengers
      fuelType
      driveType
      bodyType
      steering
      transmission
      exteriorColor
      interiorColor
      vehicleWidth
      vehicleLength
      vehicleHeight
      registrationMonth
      registrationYear
      manufacturedMonth
      manufacturedYear
      m3
      accessories {
        id
      }
      comment
      priceUSD
      priceOriginal
      locked
      lockedMedia
      reservedUntil
      make {
        id
      }
      model {
        id
      }
      company {
        id
      }
    }
  }
`;
export type UpdateCarMutationFn = Apollo.MutationFunction<UpdateCarMutation, UpdateCarMutationVariables>;

/**
 * __useUpdateCarMutation__
 *
 * To run a mutation, you first call `useUpdateCarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCarMutation, { data, loading, error }] = useUpdateCarMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCarMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCarMutation, UpdateCarMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateCarMutation, UpdateCarMutationVariables>(UpdateCarDocument, options);
}
export type UpdateCarMutationHookResult = ReturnType<typeof useUpdateCarMutation>;
export type UpdateCarMutationResult = Apollo.MutationResult<UpdateCarMutation>;
export type UpdateCarMutationOptions = Apollo.BaseMutationOptions<UpdateCarMutation, UpdateCarMutationVariables>;
export const CountCarsDocument = gql`
  query CountCars($filters: [QueryCarsAdminFilters!]!) {
    countCars(filters: $filters)
  }
`;

/**
 * __useCountCarsQuery__
 *
 * To run a query within a React component, call `useCountCarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCountCarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCountCarsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCountCarsQuery(baseOptions: Apollo.QueryHookOptions<CountCarsQuery, CountCarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CountCarsQuery, CountCarsQueryVariables>(CountCarsDocument, options);
}
export function useCountCarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CountCarsQuery, CountCarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CountCarsQuery, CountCarsQueryVariables>(CountCarsDocument, options);
}
export type CountCarsQueryHookResult = ReturnType<typeof useCountCarsQuery>;
export type CountCarsLazyQueryHookResult = ReturnType<typeof useCountCarsLazyQuery>;
export type CountCarsQueryResult = Apollo.QueryResult<CountCarsQuery, CountCarsQueryVariables>;
export const QueryCarsDocument = gql`
  query QueryCars($filters: QueryCarsAdminFilters, $offset: Int, $limit: Int, $sort: String, $order: String) {
    queryCars(filters: $filters, offset: $offset, limit: $limit, sort: $sort, order: $order) {
      cars {
        id
        status
        refNo
        price
        priceMin
        pvCount
        url
        carUrl
        internalNote
        created
        modifiedAt
        expiredAt
        title
        VIN
        images {
          _id
          filename
          cdnUri
          order
          mime
        }
        tags
        specialities
        currencyKey
        discountPercent
        company {
          id
          name
          enName
          inContract
          plan
        }
      }
      total
    }
  }
`;

/**
 * __useQueryCarsQuery__
 *
 * To run a query within a React component, call `useQueryCarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryCarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryCarsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useQueryCarsQuery(baseOptions?: Apollo.QueryHookOptions<QueryCarsQuery, QueryCarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<QueryCarsQuery, QueryCarsQueryVariables>(QueryCarsDocument, options);
}
export function useQueryCarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryCarsQuery, QueryCarsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<QueryCarsQuery, QueryCarsQueryVariables>(QueryCarsDocument, options);
}
export type QueryCarsQueryHookResult = ReturnType<typeof useQueryCarsQuery>;
export type QueryCarsLazyQueryHookResult = ReturnType<typeof useQueryCarsLazyQuery>;
export type QueryCarsQueryResult = Apollo.QueryResult<QueryCarsQuery, QueryCarsQueryVariables>;
export const ExportCarsCsvDocument = gql`
  mutation ExportCarsCsv($filters: QueryCarsAdminFilters, $sort: String, $order: String) {
    exportCarsCsv(filters: $filters, sort: $sort, order: $order)
  }
`;
export type ExportCarsCsvMutationFn = Apollo.MutationFunction<ExportCarsCsvMutation, ExportCarsCsvMutationVariables>;

/**
 * __useExportCarsCsvMutation__
 *
 * To run a mutation, you first call `useExportCarsCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportCarsCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportCarsCsvMutation, { data, loading, error }] = useExportCarsCsvMutation({
 *   variables: {
 *      filters: // value for 'filters'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useExportCarsCsvMutation(baseOptions?: Apollo.MutationHookOptions<ExportCarsCsvMutation, ExportCarsCsvMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExportCarsCsvMutation, ExportCarsCsvMutationVariables>(ExportCarsCsvDocument, options);
}
export type ExportCarsCsvMutationHookResult = ReturnType<typeof useExportCarsCsvMutation>;
export type ExportCarsCsvMutationResult = Apollo.MutationResult<ExportCarsCsvMutation>;
export type ExportCarsCsvMutationOptions = Apollo.BaseMutationOptions<ExportCarsCsvMutation, ExportCarsCsvMutationVariables>;
export const GetCarAggsDocument = gql`
  query GetCarAggs {
    getCarAggs {
      tags {
        key
        doc_count
      }
      specialities {
        key
        doc_count
      }
    }
  }
`;

/**
 * __useGetCarAggsQuery__
 *
 * To run a query within a React component, call `useGetCarAggsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarAggsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarAggsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCarAggsQuery(baseOptions?: Apollo.QueryHookOptions<GetCarAggsQuery, GetCarAggsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCarAggsQuery, GetCarAggsQueryVariables>(GetCarAggsDocument, options);
}
export function useGetCarAggsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarAggsQuery, GetCarAggsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCarAggsQuery, GetCarAggsQueryVariables>(GetCarAggsDocument, options);
}
export type GetCarAggsQueryHookResult = ReturnType<typeof useGetCarAggsQuery>;
export type GetCarAggsLazyQueryHookResult = ReturnType<typeof useGetCarAggsLazyQuery>;
export type GetCarAggsQueryResult = Apollo.QueryResult<GetCarAggsQuery, GetCarAggsQueryVariables>;
export const BatchCarsDocument = gql`
  mutation BatchCars($ids: [String!]!, $action: String!, $data: JSON) {
    batchCars(ids: $ids, action: $action, data: $data) {
      id
      status
      price
      priceMin
      internalNote
      created
      modifiedAt
      expiredAt
      tags
      specialities
    }
  }
`;
export type BatchCarsMutationFn = Apollo.MutationFunction<BatchCarsMutation, BatchCarsMutationVariables>;

/**
 * __useBatchCarsMutation__
 *
 * To run a mutation, you first call `useBatchCarsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCarsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCarsMutation, { data, loading, error }] = useBatchCarsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      action: // value for 'action'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBatchCarsMutation(baseOptions?: Apollo.MutationHookOptions<BatchCarsMutation, BatchCarsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BatchCarsMutation, BatchCarsMutationVariables>(BatchCarsDocument, options);
}
export type BatchCarsMutationHookResult = ReturnType<typeof useBatchCarsMutation>;
export type BatchCarsMutationResult = Apollo.MutationResult<BatchCarsMutation>;
export type BatchCarsMutationOptions = Apollo.BaseMutationOptions<BatchCarsMutation, BatchCarsMutationVariables>;
export const AddCarImagesDocument = gql`
  mutation AddCarImages($id: String!, $files: [String!]!) {
    addCarImages(id: $id, files: $files) {
      id
      images {
        id
        filename
        cdnUri
        order
        mime
      }
    }
  }
`;
export type AddCarImagesMutationFn = Apollo.MutationFunction<AddCarImagesMutation, AddCarImagesMutationVariables>;

/**
 * __useAddCarImagesMutation__
 *
 * To run a mutation, you first call `useAddCarImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCarImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCarImagesMutation, { data, loading, error }] = useAddCarImagesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useAddCarImagesMutation(baseOptions?: Apollo.MutationHookOptions<AddCarImagesMutation, AddCarImagesMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddCarImagesMutation, AddCarImagesMutationVariables>(AddCarImagesDocument, options);
}
export type AddCarImagesMutationHookResult = ReturnType<typeof useAddCarImagesMutation>;
export type AddCarImagesMutationResult = Apollo.MutationResult<AddCarImagesMutation>;
export type AddCarImagesMutationOptions = Apollo.BaseMutationOptions<AddCarImagesMutation, AddCarImagesMutationVariables>;
export const RemoveCarImagesDocument = gql`
  mutation RemoveCarImages($id: String!, $images: [String!]!) {
    removeCarImages(id: $id, images: $images) {
      id
      images {
        id
        filename
        cdnUri
        order
        mime
      }
    }
  }
`;
export type RemoveCarImagesMutationFn = Apollo.MutationFunction<RemoveCarImagesMutation, RemoveCarImagesMutationVariables>;

/**
 * __useRemoveCarImagesMutation__
 *
 * To run a mutation, you first call `useRemoveCarImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCarImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCarImagesMutation, { data, loading, error }] = useRemoveCarImagesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      images: // value for 'images'
 *   },
 * });
 */
export function useRemoveCarImagesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCarImagesMutation, RemoveCarImagesMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveCarImagesMutation, RemoveCarImagesMutationVariables>(RemoveCarImagesDocument, options);
}
export type RemoveCarImagesMutationHookResult = ReturnType<typeof useRemoveCarImagesMutation>;
export type RemoveCarImagesMutationResult = Apollo.MutationResult<RemoveCarImagesMutation>;
export type RemoveCarImagesMutationOptions = Apollo.BaseMutationOptions<RemoveCarImagesMutation, RemoveCarImagesMutationVariables>;
export const SetCountryScoreDocument = gql`
  mutation SetCountryScore($id: String!, $country: String!, $score: Float!) {
    setCountryScore(id: $id, country: $country, score: $score)
  }
`;
export type SetCountryScoreMutationFn = Apollo.MutationFunction<SetCountryScoreMutation, SetCountryScoreMutationVariables>;

/**
 * __useSetCountryScoreMutation__
 *
 * To run a mutation, you first call `useSetCountryScoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCountryScoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCountryScoreMutation, { data, loading, error }] = useSetCountryScoreMutation({
 *   variables: {
 *      id: // value for 'id'
 *      country: // value for 'country'
 *      score: // value for 'score'
 *   },
 * });
 */
export function useSetCountryScoreMutation(baseOptions?: Apollo.MutationHookOptions<SetCountryScoreMutation, SetCountryScoreMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetCountryScoreMutation, SetCountryScoreMutationVariables>(SetCountryScoreDocument, options);
}
export type SetCountryScoreMutationHookResult = ReturnType<typeof useSetCountryScoreMutation>;
export type SetCountryScoreMutationResult = Apollo.MutationResult<SetCountryScoreMutation>;
export type SetCountryScoreMutationOptions = Apollo.BaseMutationOptions<SetCountryScoreMutation, SetCountryScoreMutationVariables>;
export const GetCarAggsBucketDocument = gql`
  query GetCarAggsBucket($modelCode: String!) {
    getCarAggsBucket(modelCode: $modelCode)
  }
`;

/**
 * __useGetCarAggsBucketQuery__
 *
 * To run a query within a React component, call `useGetCarAggsBucketQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarAggsBucketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarAggsBucketQuery({
 *   variables: {
 *      modelCode: // value for 'modelCode'
 *   },
 * });
 */
export function useGetCarAggsBucketQuery(baseOptions: Apollo.QueryHookOptions<GetCarAggsBucketQuery, GetCarAggsBucketQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCarAggsBucketQuery, GetCarAggsBucketQueryVariables>(GetCarAggsBucketDocument, options);
}
export function useGetCarAggsBucketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarAggsBucketQuery, GetCarAggsBucketQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCarAggsBucketQuery, GetCarAggsBucketQueryVariables>(GetCarAggsBucketDocument, options);
}
export type GetCarAggsBucketQueryHookResult = ReturnType<typeof useGetCarAggsBucketQuery>;
export type GetCarAggsBucketLazyQueryHookResult = ReturnType<typeof useGetCarAggsBucketLazyQuery>;
export type GetCarAggsBucketQueryResult = Apollo.QueryResult<GetCarAggsBucketQuery, GetCarAggsBucketQueryVariables>;
export const GetAdminAccessoriesDocument = gql`
  query GetAdminAccessories {
    getAdminAccessories(root: true, limit: 2000) {
      id
      name
      type
    }
  }
`;

/**
 * __useGetAdminAccessoriesQuery__
 *
 * To run a query within a React component, call `useGetAdminAccessoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminAccessoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminAccessoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminAccessoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminAccessoriesQuery, GetAdminAccessoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAdminAccessoriesQuery, GetAdminAccessoriesQueryVariables>(GetAdminAccessoriesDocument, options);
}
export function useGetAdminAccessoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminAccessoriesQuery, GetAdminAccessoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAdminAccessoriesQuery, GetAdminAccessoriesQueryVariables>(GetAdminAccessoriesDocument, options);
}
export type GetAdminAccessoriesQueryHookResult = ReturnType<typeof useGetAdminAccessoriesQuery>;
export type GetAdminAccessoriesLazyQueryHookResult = ReturnType<typeof useGetAdminAccessoriesLazyQuery>;
export type GetAdminAccessoriesQueryResult = Apollo.QueryResult<GetAdminAccessoriesQuery, GetAdminAccessoriesQueryVariables>;
export const GetManagementMakeDocument = gql`
  query GetManagementMake($args: GetAllMakeArgs) {
    getManagementMake(args: $args) {
      items {
        id
        name
        key
      }
      total
    }
  }
`;

/**
 * __useGetManagementMakeQuery__
 *
 * To run a query within a React component, call `useGetManagementMakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagementMakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagementMakeQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetManagementMakeQuery(baseOptions?: Apollo.QueryHookOptions<GetManagementMakeQuery, GetManagementMakeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetManagementMakeQuery, GetManagementMakeQueryVariables>(GetManagementMakeDocument, options);
}
export function useGetManagementMakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagementMakeQuery, GetManagementMakeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetManagementMakeQuery, GetManagementMakeQueryVariables>(GetManagementMakeDocument, options);
}
export type GetManagementMakeQueryHookResult = ReturnType<typeof useGetManagementMakeQuery>;
export type GetManagementMakeLazyQueryHookResult = ReturnType<typeof useGetManagementMakeLazyQuery>;
export type GetManagementMakeQueryResult = Apollo.QueryResult<GetManagementMakeQuery, GetManagementMakeQueryVariables>;
export const GetManyModelsDocument = gql`
  query GetManyModels($input: GetManyModelsArgs) {
    getManyModels(input: $input) {
      items {
        id
        name
        key
        makeModelKey
      }
      total
    }
  }
`;

/**
 * __useGetManyModelsQuery__
 *
 * To run a query within a React component, call `useGetManyModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManyModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManyModelsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetManyModelsQuery(baseOptions?: Apollo.QueryHookOptions<GetManyModelsQuery, GetManyModelsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetManyModelsQuery, GetManyModelsQueryVariables>(GetManyModelsDocument, options);
}
export function useGetManyModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManyModelsQuery, GetManyModelsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetManyModelsQuery, GetManyModelsQueryVariables>(GetManyModelsDocument, options);
}
export type GetManyModelsQueryHookResult = ReturnType<typeof useGetManyModelsQuery>;
export type GetManyModelsLazyQueryHookResult = ReturnType<typeof useGetManyModelsLazyQuery>;
export type GetManyModelsQueryResult = Apollo.QueryResult<GetManyModelsQuery, GetManyModelsQueryVariables>;
export const DetailsCarContextDocument = gql`
  query DetailsCarContext($id: String) {
    masterdata
    makes(params: { hasCar: true, limit: 1000 }) {
      id
      name
      key
    }
    accessories(params: { root: true, limit: 2000 }) {
      id
      name
      type
    }
    getCarAnalytics(id: $id)
  }
`;

/**
 * __useDetailsCarContextQuery__
 *
 * To run a query within a React component, call `useDetailsCarContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useDetailsCarContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDetailsCarContextQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDetailsCarContextQuery(baseOptions?: Apollo.QueryHookOptions<DetailsCarContextQuery, DetailsCarContextQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<DetailsCarContextQuery, DetailsCarContextQueryVariables>(DetailsCarContextDocument, options);
}
export function useDetailsCarContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DetailsCarContextQuery, DetailsCarContextQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<DetailsCarContextQuery, DetailsCarContextQueryVariables>(DetailsCarContextDocument, options);
}
export type DetailsCarContextQueryHookResult = ReturnType<typeof useDetailsCarContextQuery>;
export type DetailsCarContextLazyQueryHookResult = ReturnType<typeof useDetailsCarContextLazyQuery>;
export type DetailsCarContextQueryResult = Apollo.QueryResult<DetailsCarContextQuery, DetailsCarContextQueryVariables>;
export const CrawlCarDocument = gql`
  mutation CrawlCar($url: String!, $source: CrawlCarSource!, $company: String) {
    crawlCar(url: $url, source: $source, company: $company) {
      id
    }
  }
`;
export type CrawlCarMutationFn = Apollo.MutationFunction<CrawlCarMutation, CrawlCarMutationVariables>;

/**
 * __useCrawlCarMutation__
 *
 * To run a mutation, you first call `useCrawlCarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCrawlCarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [crawlCarMutation, { data, loading, error }] = useCrawlCarMutation({
 *   variables: {
 *      url: // value for 'url'
 *      source: // value for 'source'
 *      company: // value for 'company'
 *   },
 * });
 */
export function useCrawlCarMutation(baseOptions?: Apollo.MutationHookOptions<CrawlCarMutation, CrawlCarMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CrawlCarMutation, CrawlCarMutationVariables>(CrawlCarDocument, options);
}
export type CrawlCarMutationHookResult = ReturnType<typeof useCrawlCarMutation>;
export type CrawlCarMutationResult = Apollo.MutationResult<CrawlCarMutation>;
export type CrawlCarMutationOptions = Apollo.BaseMutationOptions<CrawlCarMutation, CrawlCarMutationVariables>;
export const CarDashboardSummaryDocument = gql`
  query CarDashboardSummary {
    carDashboardSummary {
      carCount
      expireSoon
      countReserved
    }
  }
`;

/**
 * __useCarDashboardSummaryQuery__
 *
 * To run a query within a React component, call `useCarDashboardSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarDashboardSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarDashboardSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCarDashboardSummaryQuery(baseOptions?: Apollo.QueryHookOptions<CarDashboardSummaryQuery, CarDashboardSummaryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CarDashboardSummaryQuery, CarDashboardSummaryQueryVariables>(CarDashboardSummaryDocument, options);
}
export function useCarDashboardSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarDashboardSummaryQuery, CarDashboardSummaryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CarDashboardSummaryQuery, CarDashboardSummaryQueryVariables>(CarDashboardSummaryDocument, options);
}
export type CarDashboardSummaryQueryHookResult = ReturnType<typeof useCarDashboardSummaryQuery>;
export type CarDashboardSummaryLazyQueryHookResult = ReturnType<typeof useCarDashboardSummaryLazyQuery>;
export type CarDashboardSummaryQueryResult = Apollo.QueryResult<CarDashboardSummaryQuery, CarDashboardSummaryQueryVariables>;
export const CarDashboardStatsDocument = gql`
  query CarDashboardStats($filters: DashboardFiltersInput!) {
    carDashboardStats(filters: $filters) {
      cars {
        current
        lastMonth
      }
      views {
        current
        lastMonth
      }
    }
  }
`;

/**
 * __useCarDashboardStatsQuery__
 *
 * To run a query within a React component, call `useCarDashboardStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarDashboardStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarDashboardStatsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCarDashboardStatsQuery(baseOptions: Apollo.QueryHookOptions<CarDashboardStatsQuery, CarDashboardStatsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CarDashboardStatsQuery, CarDashboardStatsQueryVariables>(CarDashboardStatsDocument, options);
}
export function useCarDashboardStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarDashboardStatsQuery, CarDashboardStatsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CarDashboardStatsQuery, CarDashboardStatsQueryVariables>(CarDashboardStatsDocument, options);
}
export type CarDashboardStatsQueryHookResult = ReturnType<typeof useCarDashboardStatsQuery>;
export type CarDashboardStatsLazyQueryHookResult = ReturnType<typeof useCarDashboardStatsLazyQuery>;
export type CarDashboardStatsQueryResult = Apollo.QueryResult<CarDashboardStatsQuery, CarDashboardStatsQueryVariables>;
export const CarDashboardViewsDocument = gql`
  query CarDashboardViews($filters: DashboardFiltersInput!) {
    carDashboardViews(filters: $filters) {
      day
      total
    }
  }
`;

/**
 * __useCarDashboardViewsQuery__
 *
 * To run a query within a React component, call `useCarDashboardViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarDashboardViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarDashboardViewsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useCarDashboardViewsQuery(baseOptions: Apollo.QueryHookOptions<CarDashboardViewsQuery, CarDashboardViewsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CarDashboardViewsQuery, CarDashboardViewsQueryVariables>(CarDashboardViewsDocument, options);
}
export function useCarDashboardViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarDashboardViewsQuery, CarDashboardViewsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CarDashboardViewsQuery, CarDashboardViewsQueryVariables>(CarDashboardViewsDocument, options);
}
export type CarDashboardViewsQueryHookResult = ReturnType<typeof useCarDashboardViewsQuery>;
export type CarDashboardViewsLazyQueryHookResult = ReturnType<typeof useCarDashboardViewsLazyQuery>;
export type CarDashboardViewsQueryResult = Apollo.QueryResult<CarDashboardViewsQuery, CarDashboardViewsQueryVariables>;
export const GetCompaniesAdminDocument = gql`
  query GetCompaniesAdmin($filters: JSON, $offset: Int, $limit: Int, $sort: String, $order: String) {
    getCompaniesAdmin(filters: $filters, offset: $offset, limit: $limit, sort: $sort, order: $order) {
      companies {
        _id
        key
        name
        enName
        address
        addressKana
        postalCode
        telephone
        fax
        email
        website
        carCount
        denyImagesIndex
        denyImages {
          original
          filename
          mime
          checksum
          cdnUri
        }
        cropingImage
        buynowSettings
        inContract
        selfNegotiation
        plan
        assignee
        reservedCount
        updated30days
        soldLastMonth
        saleCount
        status
        importFromTCV
        importFromGoo
        importFromCarsensor
        contractStart
        contractEnd
        persionInCharge
        preferLanguage
        totalEmployees
        annualSale
        daysExp
        capital
        yearEstablished
        ownershipType
        introduction
        bankName
        bankBranch
        bankAccount
        bankHolder
        kanaBankHolder
        bankType
        autoResponse
        monthlyFee
        annualFee
        marginPercent
        marginPercentCIF
        marginUSD
        marginMin
        marginMax
        domesticBankCharge
        serviceChargeUSD
        adjustCIFbyUSD
        adjustCIFbyPercent
        adjustFOBbyUSD
        adjustFOBbyPercent
        adjustShippingbyUSD
        adjustInsuranceTo
        adjustBuyerProtectionTo
        adminNote
        internalNote
        startPay
        registeredGMOAt
        activatedGMO
        dealerPage
        canEditFreight
        serviceTaxInclusive
        published
        members
        scoreBoost
        TCVID
        gooId
        carsensorId
        slug
        images {
          original
          filename
          mime
          checksum
          cdnUri
        }
        signature {
          original
          filename
          mime
          checksum
          cdnUri
        }
      }
      total
    }
  }
`;

/**
 * __useGetCompaniesAdminQuery__
 *
 * To run a query within a React component, call `useGetCompaniesAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesAdminQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetCompaniesAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetCompaniesAdminQuery, GetCompaniesAdminQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCompaniesAdminQuery, GetCompaniesAdminQueryVariables>(GetCompaniesAdminDocument, options);
}
export function useGetCompaniesAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesAdminQuery, GetCompaniesAdminQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCompaniesAdminQuery, GetCompaniesAdminQueryVariables>(GetCompaniesAdminDocument, options);
}
export type GetCompaniesAdminQueryHookResult = ReturnType<typeof useGetCompaniesAdminQuery>;
export type GetCompaniesAdminLazyQueryHookResult = ReturnType<typeof useGetCompaniesAdminLazyQuery>;
export type GetCompaniesAdminQueryResult = Apollo.QueryResult<GetCompaniesAdminQuery, GetCompaniesAdminQueryVariables>;
export const GetManipulatedCompaniesDocument = gql`
  query getManipulatedCompanies($offset: Int, $limit: Int, $sort: String, $order: String) {
    getManipulatedCompanies(offset: $offset, limit: $limit, sort: $sort, order: $order) {
      companies {
        _id
        key
        name
        enName
        address
        addressKana
        postalCode
        telephone
        fax
        email
        website
        carCount
        denyImagesIndex
        denyImages {
          original
          filename
          mime
          checksum
          cdnUri
        }
        cropingImage
        buynowSettings
        inContract
        selfNegotiation
        plan
        assignee
        reservedCount
        updated30days
        soldLastMonth
        saleCount
        status
        importFromTCV
        importFromGoo
        importFromCarsensor
        contractStart
        contractEnd
        persionInCharge
        preferLanguage
        totalEmployees
        annualSale
        daysExp
        capital
        yearEstablished
        ownershipType
        introduction
        bankName
        bankBranch
        bankAccount
        bankHolder
        kanaBankHolder
        bankType
        autoResponse
        monthlyFee
        annualFee
        marginPercent
        marginPercentCIF
        marginUSD
        marginMin
        marginMax
        domesticBankCharge
        serviceChargeUSD
        adjustCIFbyUSD
        adjustCIFbyPercent
        adjustFOBbyUSD
        adjustFOBbyPercent
        adjustShippingbyUSD
        adjustInsuranceTo
        adjustBuyerProtectionTo
        adminNote
        internalNote
        startPay
        registeredGMOAt
        activatedGMO
        dealerPage
        canEditFreight
        serviceTaxInclusive
        published
        members
        scoreBoost
        TCVID
        gooId
        carsensorId
        slug
        images {
          original
          filename
          mime
          checksum
          cdnUri
        }
        signature {
          original
          filename
          mime
          checksum
          cdnUri
        }
      }
      total
    }
  }
`;

/**
 * __useGetManipulatedCompaniesQuery__
 *
 * To run a query within a React component, call `useGetManipulatedCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManipulatedCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManipulatedCompaniesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetManipulatedCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetManipulatedCompaniesQuery, GetManipulatedCompaniesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetManipulatedCompaniesQuery, GetManipulatedCompaniesQueryVariables>(GetManipulatedCompaniesDocument, options);
}
export function useGetManipulatedCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManipulatedCompaniesQuery, GetManipulatedCompaniesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetManipulatedCompaniesQuery, GetManipulatedCompaniesQueryVariables>(GetManipulatedCompaniesDocument, options);
}
export type GetManipulatedCompaniesQueryHookResult = ReturnType<typeof useGetManipulatedCompaniesQuery>;
export type GetManipulatedCompaniesLazyQueryHookResult = ReturnType<typeof useGetManipulatedCompaniesLazyQuery>;
export type GetManipulatedCompaniesQueryResult = Apollo.QueryResult<GetManipulatedCompaniesQuery, GetManipulatedCompaniesQueryVariables>;
export const UpsertCompanyDocument = gql`
  mutation UpsertCompany($id: ID, $data: JSON) {
    upsertCompany(id: $id, data: $data) {
      _id
      key
      name
      enName
      address
      addressKana
      postalCode
      telephone
      fax
      email
      website
      carCount
      daysExp
      denyImagesIndex
      denyImages {
        original
        filename
        mime
        checksum
        cdnUri
      }
      cropingImage
      buynowSettings
      inContract
      selfNegotiation
      plan
      reservedCount
      updated30days
      soldLastMonth
      saleCount
      assignee
      status
      importFromTCV
      importFromGoo
      importFromCarsensor
      contractStart
      contractEnd
      persionInCharge
      preferLanguage
      totalEmployees
      annualSale
      capital
      yearEstablished
      ownershipType
      introduction
      bankName
      bankBranch
      bankAccount
      bankHolder
      kanaBankHolder
      bankType
      autoResponse
      monthlyFee
      annualFee
      marginPercent
      marginPercentCIF
      marginUSD
      marginMin
      marginMax
      domesticBankCharge
      serviceChargeUSD
      adjustCIFbyUSD
      adjustCIFbyPercent
      adjustFOBbyUSD
      adjustFOBbyPercent
      adjustShippingbyUSD
      adjustInsuranceTo
      adjustBuyerProtectionTo
      adminNote
      internalNote
      startPay
      registeredGMOAt
      activatedGMO
      dealerPage
      canEditFreight
      serviceTaxInclusive
      published
      members
      scoreBoost
      TCVID
      gooId
      carsensorId
      slug
      images {
        original
        filename
        mime
        checksum
        cdnUri
      }
      signature {
        original
        filename
        mime
        checksum
        cdnUri
      }
    }
  }
`;
export type UpsertCompanyMutationFn = Apollo.MutationFunction<UpsertCompanyMutation, UpsertCompanyMutationVariables>;

/**
 * __useUpsertCompanyMutation__
 *
 * To run a mutation, you first call `useUpsertCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCompanyMutation, { data, loading, error }] = useUpsertCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCompanyMutation, UpsertCompanyMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertCompanyMutation, UpsertCompanyMutationVariables>(UpsertCompanyDocument, options);
}
export type UpsertCompanyMutationHookResult = ReturnType<typeof useUpsertCompanyMutation>;
export type UpsertCompanyMutationResult = Apollo.MutationResult<UpsertCompanyMutation>;
export type UpsertCompanyMutationOptions = Apollo.BaseMutationOptions<UpsertCompanyMutation, UpsertCompanyMutationVariables>;
export const InviteCompanyDocument = gql`
  mutation InviteCompany($data: InviteCompanyDataInput!) {
    inviteCompany(data: $data) {
      _id
    }
  }
`;
export type InviteCompanyMutationFn = Apollo.MutationFunction<InviteCompanyMutation, InviteCompanyMutationVariables>;

/**
 * __useInviteCompanyMutation__
 *
 * To run a mutation, you first call `useInviteCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteCompanyMutation, { data, loading, error }] = useInviteCompanyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useInviteCompanyMutation(baseOptions?: Apollo.MutationHookOptions<InviteCompanyMutation, InviteCompanyMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InviteCompanyMutation, InviteCompanyMutationVariables>(InviteCompanyDocument, options);
}
export type InviteCompanyMutationHookResult = ReturnType<typeof useInviteCompanyMutation>;
export type InviteCompanyMutationResult = Apollo.MutationResult<InviteCompanyMutation>;
export type InviteCompanyMutationOptions = Apollo.BaseMutationOptions<InviteCompanyMutation, InviteCompanyMutationVariables>;
export const GetMembersDocument = gql`
  query GetMembers($id: ID) {
    getMembers(id: $id) {
      _id
      email
    }
  }
`;

/**
 * __useGetMembersQuery__
 *
 * To run a query within a React component, call `useGetMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembersQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMembersQuery(baseOptions?: Apollo.QueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
}
export function useGetMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMembersQuery, GetMembersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetMembersQuery, GetMembersQueryVariables>(GetMembersDocument, options);
}
export type GetMembersQueryHookResult = ReturnType<typeof useGetMembersQuery>;
export type GetMembersLazyQueryHookResult = ReturnType<typeof useGetMembersLazyQuery>;
export type GetMembersQueryResult = Apollo.QueryResult<GetMembersQuery, GetMembersQueryVariables>;
export const RemoveMemberDocument = gql`
  mutation RemoveMember($id: ID, $idUser: ID) {
    removeMember(id: $id, idUser: $idUser) {
      _id
    }
  }
`;
export type RemoveMemberMutationFn = Apollo.MutationFunction<RemoveMemberMutation, RemoveMemberMutationVariables>;

/**
 * __useRemoveMemberMutation__
 *
 * To run a mutation, you first call `useRemoveMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMemberMutation, { data, loading, error }] = useRemoveMemberMutation({
 *   variables: {
 *      id: // value for 'id'
 *      idUser: // value for 'idUser'
 *   },
 * });
 */
export function useRemoveMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMemberMutation, RemoveMemberMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveMemberMutation, RemoveMemberMutationVariables>(RemoveMemberDocument, options);
}
export type RemoveMemberMutationHookResult = ReturnType<typeof useRemoveMemberMutation>;
export type RemoveMemberMutationResult = Apollo.MutationResult<RemoveMemberMutation>;
export type RemoveMemberMutationOptions = Apollo.BaseMutationOptions<RemoveMemberMutation, RemoveMemberMutationVariables>;
export const UploadImageCompanyDocument = gql`
  mutation UploadImageCompany($files: [String!]!) {
    uploadImageCompany(files: $files) {
      filename
      cdnUri
      checksum
      original
    }
  }
`;
export type UploadImageCompanyMutationFn = Apollo.MutationFunction<UploadImageCompanyMutation, UploadImageCompanyMutationVariables>;

/**
 * __useUploadImageCompanyMutation__
 *
 * To run a mutation, you first call `useUploadImageCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadImageCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadImageCompanyMutation, { data, loading, error }] = useUploadImageCompanyMutation({
 *   variables: {
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUploadImageCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UploadImageCompanyMutation, UploadImageCompanyMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadImageCompanyMutation, UploadImageCompanyMutationVariables>(UploadImageCompanyDocument, options);
}
export type UploadImageCompanyMutationHookResult = ReturnType<typeof useUploadImageCompanyMutation>;
export type UploadImageCompanyMutationResult = Apollo.MutationResult<UploadImageCompanyMutation>;
export type UploadImageCompanyMutationOptions = Apollo.BaseMutationOptions<UploadImageCompanyMutation, UploadImageCompanyMutationVariables>;
export const UploadFileCompanyDocument = gql`
  mutation UploadFileCompany($files: [String!]!) {
    uploadFileCompany(files: $files) {
      filename
      cdnUri
      checksum
      original
      mime
    }
  }
`;
export type UploadFileCompanyMutationFn = Apollo.MutationFunction<UploadFileCompanyMutation, UploadFileCompanyMutationVariables>;

/**
 * __useUploadFileCompanyMutation__
 *
 * To run a mutation, you first call `useUploadFileCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadFileCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadFileCompanyMutation, { data, loading, error }] = useUploadFileCompanyMutation({
 *   variables: {
 *      files: // value for 'files'
 *   },
 * });
 */
export function useUploadFileCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UploadFileCompanyMutation, UploadFileCompanyMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadFileCompanyMutation, UploadFileCompanyMutationVariables>(UploadFileCompanyDocument, options);
}
export type UploadFileCompanyMutationHookResult = ReturnType<typeof useUploadFileCompanyMutation>;
export type UploadFileCompanyMutationResult = Apollo.MutationResult<UploadFileCompanyMutation>;
export type UploadFileCompanyMutationOptions = Apollo.BaseMutationOptions<UploadFileCompanyMutation, UploadFileCompanyMutationVariables>;
export const UncloneStockDocument = gql`
  mutation UncloneStock($data: JSON) {
    uncloneStock(data: $data) {
      _id
    }
  }
`;
export type UncloneStockMutationFn = Apollo.MutationFunction<UncloneStockMutation, UncloneStockMutationVariables>;

/**
 * __useUncloneStockMutation__
 *
 * To run a mutation, you first call `useUncloneStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUncloneStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uncloneStockMutation, { data, loading, error }] = useUncloneStockMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUncloneStockMutation(baseOptions?: Apollo.MutationHookOptions<UncloneStockMutation, UncloneStockMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UncloneStockMutation, UncloneStockMutationVariables>(UncloneStockDocument, options);
}
export type UncloneStockMutationHookResult = ReturnType<typeof useUncloneStockMutation>;
export type UncloneStockMutationResult = Apollo.MutationResult<UncloneStockMutation>;
export type UncloneStockMutationOptions = Apollo.BaseMutationOptions<UncloneStockMutation, UncloneStockMutationVariables>;
export const CloneStockDocument = gql`
  mutation CloneStock($data: JSON) {
    cloneStock(data: $data) {
      _id
    }
  }
`;
export type CloneStockMutationFn = Apollo.MutationFunction<CloneStockMutation, CloneStockMutationVariables>;

/**
 * __useCloneStockMutation__
 *
 * To run a mutation, you first call `useCloneStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneStockMutation, { data, loading, error }] = useCloneStockMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCloneStockMutation(baseOptions?: Apollo.MutationHookOptions<CloneStockMutation, CloneStockMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CloneStockMutation, CloneStockMutationVariables>(CloneStockDocument, options);
}
export type CloneStockMutationHookResult = ReturnType<typeof useCloneStockMutation>;
export type CloneStockMutationResult = Apollo.MutationResult<CloneStockMutation>;
export type CloneStockMutationOptions = Apollo.BaseMutationOptions<CloneStockMutation, CloneStockMutationVariables>;
export const UnlistAllDocument = gql`
  mutation UnlistAll($companyId: ID!, $status: Int) {
    unlistAll(companyId: $companyId, status: $status)
  }
`;
export type UnlistAllMutationFn = Apollo.MutationFunction<UnlistAllMutation, UnlistAllMutationVariables>;

/**
 * __useUnlistAllMutation__
 *
 * To run a mutation, you first call `useUnlistAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlistAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlistAllMutation, { data, loading, error }] = useUnlistAllMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUnlistAllMutation(baseOptions?: Apollo.MutationHookOptions<UnlistAllMutation, UnlistAllMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UnlistAllMutation, UnlistAllMutationVariables>(UnlistAllDocument, options);
}
export type UnlistAllMutationHookResult = ReturnType<typeof useUnlistAllMutation>;
export type UnlistAllMutationResult = Apollo.MutationResult<UnlistAllMutation>;
export type UnlistAllMutationOptions = Apollo.BaseMutationOptions<UnlistAllMutation, UnlistAllMutationVariables>;
export const GetAgentsDocument = gql`
  query GetAgents {
    getAgents {
      _id
      name
      zendeskId
    }
  }
`;

/**
 * __useGetAgentsQuery__
 *
 * To run a query within a React component, call `useGetAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgentsQuery, GetAgentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAgentsQuery, GetAgentsQueryVariables>(GetAgentsDocument, options);
}
export function useGetAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgentsQuery, GetAgentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAgentsQuery, GetAgentsQueryVariables>(GetAgentsDocument, options);
}
export type GetAgentsQueryHookResult = ReturnType<typeof useGetAgentsQuery>;
export type GetAgentsLazyQueryHookResult = ReturnType<typeof useGetAgentsLazyQuery>;
export type GetAgentsQueryResult = Apollo.QueryResult<GetAgentsQuery, GetAgentsQueryVariables>;
export const SendEmailsDocument = gql`
  mutation SendEmails($subject: String!, $content: String!, $ids: [ID!]!, $attachments: [JSON!]) {
    sendSellersNotification(subject: $subject, content: $content, ids: $ids, attachments: $attachments)
  }
`;
export type SendEmailsMutationFn = Apollo.MutationFunction<SendEmailsMutation, SendEmailsMutationVariables>;

/**
 * __useSendEmailsMutation__
 *
 * To run a mutation, you first call `useSendEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailsMutation, { data, loading, error }] = useSendEmailsMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *      content: // value for 'content'
 *      ids: // value for 'ids'
 *      attachments: // value for 'attachments'
 *   },
 * });
 */
export function useSendEmailsMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailsMutation, SendEmailsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendEmailsMutation, SendEmailsMutationVariables>(SendEmailsDocument, options);
}
export type SendEmailsMutationHookResult = ReturnType<typeof useSendEmailsMutation>;
export type SendEmailsMutationResult = Apollo.MutationResult<SendEmailsMutation>;
export type SendEmailsMutationOptions = Apollo.BaseMutationOptions<SendEmailsMutation, SendEmailsMutationVariables>;
export const GetCouponsDocument = gql`
  query GetCoupons($filters: JSON, $offset: Int, $limit: Int, $sort: String, $order: String) {
    getCoupons(filters: $filters, offset: $offset, limit: $limit, sort: $sort, order: $order) {
      coupons {
        _id
        code
        type
        user {
          _id
          email
          name
        }
        agent
        discountPercent
        maxPaymentTimes
        maxUSD
        discountUSD
        expired
        created
        isRemoved
        owner {
          _id
        }
        refers
        balanceUSD
        applyConditions
      }
      total
    }
  }
`;

/**
 * __useGetCouponsQuery__
 *
 * To run a query within a React component, call `useGetCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCouponsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetCouponsQuery(baseOptions?: Apollo.QueryHookOptions<GetCouponsQuery, GetCouponsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCouponsQuery, GetCouponsQueryVariables>(GetCouponsDocument, options);
}
export function useGetCouponsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCouponsQuery, GetCouponsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCouponsQuery, GetCouponsQueryVariables>(GetCouponsDocument, options);
}
export type GetCouponsQueryHookResult = ReturnType<typeof useGetCouponsQuery>;
export type GetCouponsLazyQueryHookResult = ReturnType<typeof useGetCouponsLazyQuery>;
export type GetCouponsQueryResult = Apollo.QueryResult<GetCouponsQuery, GetCouponsQueryVariables>;
export const CreateCouponDocument = gql`
  mutation CreateCoupon {
    createCoupon {
      _id
      code
      type
      user {
        _id
        email
        name
      }
      agent
      discountPercent
      discountUSD
      maxPaymentTimes
      expired
      maxUSD
      created
      isRemoved
      owner {
        _id
      }
      refers
      balanceUSD
      applyConditions
    }
  }
`;
export type CreateCouponMutationFn = Apollo.MutationFunction<CreateCouponMutation, CreateCouponMutationVariables>;

/**
 * __useCreateCouponMutation__
 *
 * To run a mutation, you first call `useCreateCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCouponMutation, { data, loading, error }] = useCreateCouponMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateCouponMutation(baseOptions?: Apollo.MutationHookOptions<CreateCouponMutation, CreateCouponMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateCouponMutation, CreateCouponMutationVariables>(CreateCouponDocument, options);
}
export type CreateCouponMutationHookResult = ReturnType<typeof useCreateCouponMutation>;
export type CreateCouponMutationResult = Apollo.MutationResult<CreateCouponMutation>;
export type CreateCouponMutationOptions = Apollo.BaseMutationOptions<CreateCouponMutation, CreateCouponMutationVariables>;
export const EditCouponDocument = gql`
  mutation EditCoupon($id: ID!, $data: JSON!) {
    editCoupon(id: $id, data: $data) {
      _id
      code
      type
      user {
        _id
        email
        name
      }
      agent
      discountPercent
      maxPaymentTimes
      discountUSD
      expired
      maxUSD
      created
      isRemoved
      owner {
        _id
      }
      refers
      balanceUSD
      applyConditions
    }
  }
`;
export type EditCouponMutationFn = Apollo.MutationFunction<EditCouponMutation, EditCouponMutationVariables>;

/**
 * __useEditCouponMutation__
 *
 * To run a mutation, you first call `useEditCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCouponMutation, { data, loading, error }] = useEditCouponMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useEditCouponMutation(baseOptions?: Apollo.MutationHookOptions<EditCouponMutation, EditCouponMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EditCouponMutation, EditCouponMutationVariables>(EditCouponDocument, options);
}
export type EditCouponMutationHookResult = ReturnType<typeof useEditCouponMutation>;
export type EditCouponMutationResult = Apollo.MutationResult<EditCouponMutation>;
export type EditCouponMutationOptions = Apollo.BaseMutationOptions<EditCouponMutation, EditCouponMutationVariables>;
export const DeleteCouponDocument = gql`
  mutation DeleteCoupon($id: ID!) {
    deleteCoupon(id: $id)
  }
`;
export type DeleteCouponMutationFn = Apollo.MutationFunction<DeleteCouponMutation, DeleteCouponMutationVariables>;

/**
 * __useDeleteCouponMutation__
 *
 * To run a mutation, you first call `useDeleteCouponMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCouponMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCouponMutation, { data, loading, error }] = useDeleteCouponMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCouponMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCouponMutation, DeleteCouponMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteCouponMutation, DeleteCouponMutationVariables>(DeleteCouponDocument, options);
}
export type DeleteCouponMutationHookResult = ReturnType<typeof useDeleteCouponMutation>;
export type DeleteCouponMutationResult = Apollo.MutationResult<DeleteCouponMutation>;
export type DeleteCouponMutationOptions = Apollo.BaseMutationOptions<DeleteCouponMutation, DeleteCouponMutationVariables>;
export const GetCarCouponsDocument = gql`
  query GetCarCoupons($carIds: [ID!]!) {
    getCarCoupons(carIds: $carIds) {
      _id
      discountUSD
      car {
        _id
      }
    }
  }
`;

/**
 * __useGetCarCouponsQuery__
 *
 * To run a query within a React component, call `useGetCarCouponsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCarCouponsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCarCouponsQuery({
 *   variables: {
 *      carIds: // value for 'carIds'
 *   },
 * });
 */
export function useGetCarCouponsQuery(baseOptions: Apollo.QueryHookOptions<GetCarCouponsQuery, GetCarCouponsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCarCouponsQuery, GetCarCouponsQueryVariables>(GetCarCouponsDocument, options);
}
export function useGetCarCouponsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCarCouponsQuery, GetCarCouponsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCarCouponsQuery, GetCarCouponsQueryVariables>(GetCarCouponsDocument, options);
}
export type GetCarCouponsQueryHookResult = ReturnType<typeof useGetCarCouponsQuery>;
export type GetCarCouponsLazyQueryHookResult = ReturnType<typeof useGetCarCouponsLazyQuery>;
export type GetCarCouponsQueryResult = Apollo.QueryResult<GetCarCouponsQuery, GetCarCouponsQueryVariables>;
export const GetOrdersByCouponDocument = gql`
  query GetOrdersByCoupon($coupon: String!, $steps: [Float!]!, $skip: Int!, $take: Int!, $sortBy: String, $orderBy: String) {
    getOrderManagementStats(coupon: $coupon, steps: $steps, skip: $skip, take: $take, sortBy: $sortBy, orderBy: $orderBy) {
      totalCount
      nodes {
        id
        coupon
        couponValue
        confirmedPaymentAt
        country
        port
        ticket {
          id
        }
        internalTicket {
          ticketNo
        }
        car {
          title
          titleShort
          carUrl
        }
      }
    }
  }
`;

/**
 * __useGetOrdersByCouponQuery__
 *
 * To run a query within a React component, call `useGetOrdersByCouponQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersByCouponQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersByCouponQuery({
 *   variables: {
 *      coupon: // value for 'coupon'
 *      steps: // value for 'steps'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      sortBy: // value for 'sortBy'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetOrdersByCouponQuery(baseOptions: Apollo.QueryHookOptions<GetOrdersByCouponQuery, GetOrdersByCouponQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetOrdersByCouponQuery, GetOrdersByCouponQueryVariables>(GetOrdersByCouponDocument, options);
}
export function useGetOrdersByCouponLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersByCouponQuery, GetOrdersByCouponQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetOrdersByCouponQuery, GetOrdersByCouponQueryVariables>(GetOrdersByCouponDocument, options);
}
export type GetOrdersByCouponQueryHookResult = ReturnType<typeof useGetOrdersByCouponQuery>;
export type GetOrdersByCouponLazyQueryHookResult = ReturnType<typeof useGetOrdersByCouponLazyQuery>;
export type GetOrdersByCouponQueryResult = Apollo.QueryResult<GetOrdersByCouponQuery, GetOrdersByCouponQueryVariables>;
export const UploadImportCsvDocument = gql`
  mutation UploadImportCSV($companyId: ID!, $format: String!, $fileKey: String!, $originalFilename: String!, $clearOldCar: Boolean) {
    uploadImportCSV(companyId: $companyId, format: $format, fileKey: $fileKey, originalFilename: $originalFilename, clearOldCar: $clearOldCar) {
      _id
    }
  }
`;
export type UploadImportCsvMutationFn = Apollo.MutationFunction<UploadImportCsvMutation, UploadImportCsvMutationVariables>;

/**
 * __useUploadImportCsvMutation__
 *
 * To run a mutation, you first call `useUploadImportCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadImportCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadImportCsvMutation, { data, loading, error }] = useUploadImportCsvMutation({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      format: // value for 'format'
 *      fileKey: // value for 'fileKey'
 *      originalFilename: // value for 'originalFilename'
 *      clearOldCar: // value for 'clearOldCar'
 *   },
 * });
 */
export function useUploadImportCsvMutation(baseOptions?: Apollo.MutationHookOptions<UploadImportCsvMutation, UploadImportCsvMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadImportCsvMutation, UploadImportCsvMutationVariables>(UploadImportCsvDocument, options);
}
export type UploadImportCsvMutationHookResult = ReturnType<typeof useUploadImportCsvMutation>;
export type UploadImportCsvMutationResult = Apollo.MutationResult<UploadImportCsvMutation>;
export type UploadImportCsvMutationOptions = Apollo.BaseMutationOptions<UploadImportCsvMutation, UploadImportCsvMutationVariables>;
export const RetryImportCsvDocument = gql`
  mutation RetryImportCSV($id: ID!) {
    retryCSV(id: $id)
  }
`;
export type RetryImportCsvMutationFn = Apollo.MutationFunction<RetryImportCsvMutation, RetryImportCsvMutationVariables>;

/**
 * __useRetryImportCsvMutation__
 *
 * To run a mutation, you first call `useRetryImportCsvMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryImportCsvMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryImportCsvMutation, { data, loading, error }] = useRetryImportCsvMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRetryImportCsvMutation(baseOptions?: Apollo.MutationHookOptions<RetryImportCsvMutation, RetryImportCsvMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RetryImportCsvMutation, RetryImportCsvMutationVariables>(RetryImportCsvDocument, options);
}
export type RetryImportCsvMutationHookResult = ReturnType<typeof useRetryImportCsvMutation>;
export type RetryImportCsvMutationResult = Apollo.MutationResult<RetryImportCsvMutation>;
export type RetryImportCsvMutationOptions = Apollo.BaseMutationOptions<RetryImportCsvMutation, RetryImportCsvMutationVariables>;
export const GetFreightsDocument = gql`
  query GetFreights($filters: FreightFilterInput, $offset: Int, $limit: Int, $sort: String, $order: String) {
    freights(filters: $filters, offset: $offset, limit: $limit, sort: $sort, order: $order) {
      data {
        _id
        country
        port
        m3USD
        m3JPY
        m3NZD
        carUSD
        carJPY
        carNZD
        inspectName
        inspectFee
        condOverM3
        condUnderM3
        condOverHeightCm
        condUnderHeightCm
        condOverWeightTon
        condUnderWeightTon
        company
        parent {
          _id
          country
          port
        }
        isCustomized
        cities
        shippingMethod
        priority
        inform
        needInspection
        canBuyNow
      }
      total
    }
  }
`;

/**
 * __useGetFreightsQuery__
 *
 * To run a query within a React component, call `useGetFreightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreightsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetFreightsQuery(baseOptions?: Apollo.QueryHookOptions<GetFreightsQuery, GetFreightsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFreightsQuery, GetFreightsQueryVariables>(GetFreightsDocument, options);
}
export function useGetFreightsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFreightsQuery, GetFreightsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFreightsQuery, GetFreightsQueryVariables>(GetFreightsDocument, options);
}
export type GetFreightsQueryHookResult = ReturnType<typeof useGetFreightsQuery>;
export type GetFreightsLazyQueryHookResult = ReturnType<typeof useGetFreightsLazyQuery>;
export type GetFreightsQueryResult = Apollo.QueryResult<GetFreightsQuery, GetFreightsQueryVariables>;
export const GetFreightCountriesDocument = gql`
  query GetFreightCountries($filters: FreightFilterInput, $offset: Int, $limit: Int, $sort: String, $order: String) {
    freights(filters: $filters, offset: $offset, limit: $limit, sort: $sort, order: $order) {
      data {
        country
      }
    }
  }
`;

/**
 * __useGetFreightCountriesQuery__
 *
 * To run a query within a React component, call `useGetFreightCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFreightCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFreightCountriesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetFreightCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetFreightCountriesQuery, GetFreightCountriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetFreightCountriesQuery, GetFreightCountriesQueryVariables>(GetFreightCountriesDocument, options);
}
export function useGetFreightCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFreightCountriesQuery, GetFreightCountriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetFreightCountriesQuery, GetFreightCountriesQueryVariables>(GetFreightCountriesDocument, options);
}
export type GetFreightCountriesQueryHookResult = ReturnType<typeof useGetFreightCountriesQuery>;
export type GetFreightCountriesLazyQueryHookResult = ReturnType<typeof useGetFreightCountriesLazyQuery>;
export type GetFreightCountriesQueryResult = Apollo.QueryResult<GetFreightCountriesQuery, GetFreightCountriesQueryVariables>;
export const UpsertFreightDocument = gql`
  mutation UpsertFreight($id: ID, $data: UpsertFreightInput, $filter: UpsertFreightFilterInput) {
    upsertFreight(id: $id, data: $data, filter: $filter) {
      _id
      country
      port
      m3USD
      m3JPY
      m3NZD
      carUSD
      carJPY
      carNZD
      inspectName
      inspectFee
      condOverM3
      condUnderM3
      condOverHeightCm
      condUnderHeightCm
      condOverWeightTon
      condUnderWeightTon
      company
      parent {
        _id
        country
        port
      }
      isCustomized
      cities
      shippingMethod
      priority
      inform
      needInspection
      canBuyNow
    }
  }
`;
export type UpsertFreightMutationFn = Apollo.MutationFunction<UpsertFreightMutation, UpsertFreightMutationVariables>;

/**
 * __useUpsertFreightMutation__
 *
 * To run a mutation, you first call `useUpsertFreightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertFreightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertFreightMutation, { data, loading, error }] = useUpsertFreightMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useUpsertFreightMutation(baseOptions?: Apollo.MutationHookOptions<UpsertFreightMutation, UpsertFreightMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertFreightMutation, UpsertFreightMutationVariables>(UpsertFreightDocument, options);
}
export type UpsertFreightMutationHookResult = ReturnType<typeof useUpsertFreightMutation>;
export type UpsertFreightMutationResult = Apollo.MutationResult<UpsertFreightMutation>;
export type UpsertFreightMutationOptions = Apollo.BaseMutationOptions<UpsertFreightMutation, UpsertFreightMutationVariables>;
export const DeleteFreightDocument = gql`
  mutation DeleteFreight($id: ID) {
    deleteFreight(id: $id)
  }
`;
export type DeleteFreightMutationFn = Apollo.MutationFunction<DeleteFreightMutation, DeleteFreightMutationVariables>;

/**
 * __useDeleteFreightMutation__
 *
 * To run a mutation, you first call `useDeleteFreightMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFreightMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFreightMutation, { data, loading, error }] = useDeleteFreightMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFreightMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFreightMutation, DeleteFreightMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteFreightMutation, DeleteFreightMutationVariables>(DeleteFreightDocument, options);
}
export type DeleteFreightMutationHookResult = ReturnType<typeof useDeleteFreightMutation>;
export type DeleteFreightMutationResult = Apollo.MutationResult<DeleteFreightMutation>;
export type DeleteFreightMutationOptions = Apollo.BaseMutationOptions<DeleteFreightMutation, DeleteFreightMutationVariables>;
export const EditPriorityDocument = gql`
  mutation EditPriority($id: ID, $priority: Int) {
    editPriority(id: $id, priority: $priority) {
      _id
    }
  }
`;
export type EditPriorityMutationFn = Apollo.MutationFunction<EditPriorityMutation, EditPriorityMutationVariables>;

/**
 * __useEditPriorityMutation__
 *
 * To run a mutation, you first call `useEditPriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditPriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editPriorityMutation, { data, loading, error }] = useEditPriorityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      priority: // value for 'priority'
 *   },
 * });
 */
export function useEditPriorityMutation(baseOptions?: Apollo.MutationHookOptions<EditPriorityMutation, EditPriorityMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<EditPriorityMutation, EditPriorityMutationVariables>(EditPriorityDocument, options);
}
export type EditPriorityMutationHookResult = ReturnType<typeof useEditPriorityMutation>;
export type EditPriorityMutationResult = Apollo.MutationResult<EditPriorityMutation>;
export type EditPriorityMutationOptions = Apollo.BaseMutationOptions<EditPriorityMutation, EditPriorityMutationVariables>;
export const PrepareInvoiceCallDocument = gql`
  mutation PrepareInvoiceCall($input: PrepareInvoiceCallInput!) {
    prepareInvoiceCall(input: $input) {
      commentId
      token
      to
      expiresAt
    }
  }
`;
export type PrepareInvoiceCallMutationFn = Apollo.MutationFunction<PrepareInvoiceCallMutation, PrepareInvoiceCallMutationVariables>;

/**
 * __usePrepareInvoiceCallMutation__
 *
 * To run a mutation, you first call `usePrepareInvoiceCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepareInvoiceCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepareInvoiceCallMutation, { data, loading, error }] = usePrepareInvoiceCallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrepareInvoiceCallMutation(baseOptions?: Apollo.MutationHookOptions<PrepareInvoiceCallMutation, PrepareInvoiceCallMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PrepareInvoiceCallMutation, PrepareInvoiceCallMutationVariables>(PrepareInvoiceCallDocument, options);
}
export type PrepareInvoiceCallMutationHookResult = ReturnType<typeof usePrepareInvoiceCallMutation>;
export type PrepareInvoiceCallMutationResult = Apollo.MutationResult<PrepareInvoiceCallMutation>;
export type PrepareInvoiceCallMutationOptions = Apollo.BaseMutationOptions<PrepareInvoiceCallMutation, PrepareInvoiceCallMutationVariables>;
export const GetInvoiceCallStateDocument = gql`
  query GetInvoiceCallState($args: GetInvoicesCommentsAdminArgs!) {
    getInvoiceCommentsAdmin(args: $args) {
      comments {
        comments {
          _id
          call {
            status
            recordingStatus
          }
          attachments {
            content_url
            content_type
          }
        }
      }
    }
  }
`;

/**
 * __useGetInvoiceCallStateQuery__
 *
 * To run a query within a React component, call `useGetInvoiceCallStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceCallStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceCallStateQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetInvoiceCallStateQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceCallStateQuery, GetInvoiceCallStateQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvoiceCallStateQuery, GetInvoiceCallStateQueryVariables>(GetInvoiceCallStateDocument, options);
}
export function useGetInvoiceCallStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceCallStateQuery, GetInvoiceCallStateQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvoiceCallStateQuery, GetInvoiceCallStateQueryVariables>(GetInvoiceCallStateDocument, options);
}
export type GetInvoiceCallStateQueryHookResult = ReturnType<typeof useGetInvoiceCallStateQuery>;
export type GetInvoiceCallStateLazyQueryHookResult = ReturnType<typeof useGetInvoiceCallStateLazyQuery>;
export type GetInvoiceCallStateQueryResult = Apollo.QueryResult<GetInvoiceCallStateQuery, GetInvoiceCallStateQueryVariables>;
export const PrepareIncomingInvoiceCallsDocument = gql`
  mutation PrepareIncomingInvoiceCalls {
    prepareIncomingInvoiceCalls {
      token
      expiresAt
    }
  }
`;
export type PrepareIncomingInvoiceCallsMutationFn = Apollo.MutationFunction<PrepareIncomingInvoiceCallsMutation, PrepareIncomingInvoiceCallsMutationVariables>;

/**
 * __usePrepareIncomingInvoiceCallsMutation__
 *
 * To run a mutation, you first call `usePrepareIncomingInvoiceCallsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepareIncomingInvoiceCallsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepareIncomingInvoiceCallsMutation, { data, loading, error }] = usePrepareIncomingInvoiceCallsMutation({
 *   variables: {
 *   },
 * });
 */
export function usePrepareIncomingInvoiceCallsMutation(baseOptions?: Apollo.MutationHookOptions<PrepareIncomingInvoiceCallsMutation, PrepareIncomingInvoiceCallsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PrepareIncomingInvoiceCallsMutation, PrepareIncomingInvoiceCallsMutationVariables>(PrepareIncomingInvoiceCallsDocument, options);
}
export type PrepareIncomingInvoiceCallsMutationHookResult = ReturnType<typeof usePrepareIncomingInvoiceCallsMutation>;
export type PrepareIncomingInvoiceCallsMutationResult = Apollo.MutationResult<PrepareIncomingInvoiceCallsMutation>;
export type PrepareIncomingInvoiceCallsMutationOptions = Apollo.BaseMutationOptions<PrepareIncomingInvoiceCallsMutation, PrepareIncomingInvoiceCallsMutationVariables>;
export const InvoiceCallPresenceDocument = gql`
  mutation InvoiceCallPresence($available: Boolean!, $busy: Boolean!) {
    invoiceCallPresence(available: $available, busy: $busy)
  }
`;
export type InvoiceCallPresenceMutationFn = Apollo.MutationFunction<InvoiceCallPresenceMutation, InvoiceCallPresenceMutationVariables>;

/**
 * __useInvoiceCallPresenceMutation__
 *
 * To run a mutation, you first call `useInvoiceCallPresenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvoiceCallPresenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invoiceCallPresenceMutation, { data, loading, error }] = useInvoiceCallPresenceMutation({
 *   variables: {
 *      available: // value for 'available'
 *      busy: // value for 'busy'
 *   },
 * });
 */
export function useInvoiceCallPresenceMutation(baseOptions?: Apollo.MutationHookOptions<InvoiceCallPresenceMutation, InvoiceCallPresenceMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InvoiceCallPresenceMutation, InvoiceCallPresenceMutationVariables>(InvoiceCallPresenceDocument, options);
}
export type InvoiceCallPresenceMutationHookResult = ReturnType<typeof useInvoiceCallPresenceMutation>;
export type InvoiceCallPresenceMutationResult = Apollo.MutationResult<InvoiceCallPresenceMutation>;
export type InvoiceCallPresenceMutationOptions = Apollo.BaseMutationOptions<InvoiceCallPresenceMutation, InvoiceCallPresenceMutationVariables>;
export const GetCommentsAdminDocument = gql`
  query getCommentsAdmin($args: GetCommentsAdminArgs!) {
    getCommentsAdmin(args: $args) {
      items {
        id
        invoiceId
        body
        plainBody
        htmlBody
        isPublic
        syncStatus
        source
        createdAt
        updatedAt
        deletedAt
        author {
          userId
          externalUserId
          name
          avatarUrl
          type
        }
        syncInfo {
          provider
          externalId
          externalParentId
          externalUrl
        }
        attachments {
          id
          filename
          cdnUri
          mime
        }
      }
      total
    }
  }
`;

/**
 * __useGetCommentsAdminQuery__
 *
 * To run a query within a React component, call `useGetCommentsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentsAdminQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetCommentsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetCommentsAdminQuery, GetCommentsAdminQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCommentsAdminQuery, GetCommentsAdminQueryVariables>(GetCommentsAdminDocument, options);
}
export function useGetCommentsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentsAdminQuery, GetCommentsAdminQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCommentsAdminQuery, GetCommentsAdminQueryVariables>(GetCommentsAdminDocument, options);
}
export type GetCommentsAdminQueryHookResult = ReturnType<typeof useGetCommentsAdminQuery>;
export type GetCommentsAdminLazyQueryHookResult = ReturnType<typeof useGetCommentsAdminLazyQuery>;
export type GetCommentsAdminQueryResult = Apollo.QueryResult<GetCommentsAdminQuery, GetCommentsAdminQueryVariables>;
export const GetInvoicesAggsDocument = gql`
  query GetInvoicesAggs($args: GetInvoicesAggsArgs) {
    getInvoicesAggs(args: $args) {
      agents {
        _id
        name
        zendeskId
      }
      folders {
        _id
      }
      openTickets
      waitForTTTickets
      followUpBuyerTickets
      needShareShip
      needShareBL
      needSendDocs
      needReleaseMoney
      newInvoices
      soldDelivering
      sissFollow
      invoicePriceOrver14500
      invoicePriceUnder14500
    }
  }
`;

/**
 * __useGetInvoicesAggsQuery__
 *
 * To run a query within a React component, call `useGetInvoicesAggsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesAggsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesAggsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetInvoicesAggsQuery(baseOptions?: Apollo.QueryHookOptions<GetInvoicesAggsQuery, GetInvoicesAggsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvoicesAggsQuery, GetInvoicesAggsQueryVariables>(GetInvoicesAggsDocument, options);
}
export function useGetInvoicesAggsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesAggsQuery, GetInvoicesAggsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvoicesAggsQuery, GetInvoicesAggsQueryVariables>(GetInvoicesAggsDocument, options);
}
export type GetInvoicesAggsQueryHookResult = ReturnType<typeof useGetInvoicesAggsQuery>;
export type GetInvoicesAggsLazyQueryHookResult = ReturnType<typeof useGetInvoicesAggsLazyQuery>;
export type GetInvoicesAggsQueryResult = Apollo.QueryResult<GetInvoicesAggsQuery, GetInvoicesAggsQueryVariables>;
export const GetInvoicesFoldersDocument = gql`
  query GetInvoicesFolders {
    getInvoicesFolders
  }
`;

/**
 * __useGetInvoicesFoldersQuery__
 *
 * To run a query within a React component, call `useGetInvoicesFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesFoldersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvoicesFoldersQuery(baseOptions?: Apollo.QueryHookOptions<GetInvoicesFoldersQuery, GetInvoicesFoldersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvoicesFoldersQuery, GetInvoicesFoldersQueryVariables>(GetInvoicesFoldersDocument, options);
}
export function useGetInvoicesFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesFoldersQuery, GetInvoicesFoldersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvoicesFoldersQuery, GetInvoicesFoldersQueryVariables>(GetInvoicesFoldersDocument, options);
}
export type GetInvoicesFoldersQueryHookResult = ReturnType<typeof useGetInvoicesFoldersQuery>;
export type GetInvoicesFoldersLazyQueryHookResult = ReturnType<typeof useGetInvoicesFoldersLazyQuery>;
export type GetInvoicesFoldersQueryResult = Apollo.QueryResult<GetInvoicesFoldersQuery, GetInvoicesFoldersQueryVariables>;
export const GetInvoicesAdminDocument = gql`
  query GetInvoicesAdmin($args: GetInvoicesAdminArgs!) {
    getInvoicesAdmin(args: $args) {
      invoices {
        _id
        availability
        name
        address
        phone
        email
        carId
        coupon
        sellerTakenOver
        ticket {
          id
          assignee {
            id
            name
          }
          status
          requester_id
        }
        internalTicket {
          id
          ticketNo
          subject
          status
          assigneeId
          followerIds
          emailCcAddresses
          reopenedAt
          followers {
            id
            name
            email
          }
          assignee {
            id
            name
          }
        }
        ticketNo
        ticketStatus
        vesselName
        insurance
        inspection
        country
        port
        customCosts {
          name
          amount
        }
        city
        tags {
          name
          createdAt
        }
        isTargetCountry
        passRegulation
        isQuality
        ETD
        ETA
        actualArrivalDate
        stats {
          lastAgentAnswerAt
          lastAgentCalledAt
          buyerRepliedTimes
          lastBuyerRepliedAt
          agentReplyTimes
          waitAvgMins
          negoType
          carRanks
          numberOfUserInquiry
          numberOfUserPayment
          numberOfCarInquiry
          numberOfViewCarBefore
        }
        isBuyNow
        isBNPL
        consigneeName
        consigneeAddress
        consigneePhone
        consigneeEmail
        documentName
        documentAddress
        documentPhone
        documentEmail
        showShipper
        showBreakdown
        transferTwice
        costFOB
        sellerFOB
        costInspection
        costInsurance
        costShipping
        costDelivery
        costService
        costProtection
        costOffer
        costOfferOriginal
        paypalAmount
        costBuynowDiscount
        reservedUSD
        receivedUSD
        shipping
        additionalCosts
        additionalDesc
        customCosts {
          name
          amount
        }
        costDiscount
        exchangeRate
        serviceCharge
        addonServices {
          id
          key
          name
          cost
        }
        serviceChargeTax
        bankCharge
        transferCharge
        transferChargePublic
        paymentJPY
        step
        folder
        saleEvents {
          name
          value
          createdAt
        }
        documents {
          id
          documentType
          name
          createdAt
          source
        }
        internalNote
        utm_source
        utm_campaign
        utm_medium
        platform
        extra {
          issueAt
          estimatedProfitJPY
          actualProfitJPY
          actualProfitDate
          withTaxEstimatedProfitJPY
          withTaxActualProfitJPY
          followupLevel
        }
        autoFollowup {
          state
          nextActionAt
        }
        currency
        invoiceAmount
        amountAfterCoupon
        banks
        sendSMSTo
        hideVIN
        releasedAt
        trackingShip {
          shareDate
          via
          code
          url
        }
        reservedUntil
        paypal {
          status
          amount
          orderId
          invoiceId
          authorizationId
          paymentId
          invoiceURL
          date
          payURL
          checkoutCompleted
          breakdown
        }
        user {
          id
          name
          tags
        }
        company {
          id
          plan
          name
          enName
          address
          marginPercent
          marginPercentCIF
          serviceChargeUSD
          marginMin
          marginMax
          serviceTaxInclusive
        }
        car {
          id
          title
          url
          displacement
          mileage
          driveTypeKey
          door
          steeringKey
          grade
          displacement
          fuelKey
          transmissionKey
          transmission
          exteriorColor
          passengers
          VIN
          cfjNo
          refNo
          carUrl
          companyId
          year
          titleShort
          images {
            filename
            cdnUri
            order
            mime
          }
          makeName
          modelName_
          modelCode
          vehicleLength
          vehicleWidth
          vehicleHeight
          registrationYear
          registrationMonth
          expiredAt
          status
          plan
        }
        updated
        lastActivityAt
        created
        important
        sendSMSTo
      }
      total
    }
  }
`;

/**
 * __useGetInvoicesAdminQuery__
 *
 * To run a query within a React component, call `useGetInvoicesAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesAdminQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetInvoicesAdminQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesAdminQuery, GetInvoicesAdminQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvoicesAdminQuery, GetInvoicesAdminQueryVariables>(GetInvoicesAdminDocument, options);
}
export function useGetInvoicesAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesAdminQuery, GetInvoicesAdminQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvoicesAdminQuery, GetInvoicesAdminQueryVariables>(GetInvoicesAdminDocument, options);
}
export type GetInvoicesAdminQueryHookResult = ReturnType<typeof useGetInvoicesAdminQuery>;
export type GetInvoicesAdminLazyQueryHookResult = ReturnType<typeof useGetInvoicesAdminLazyQuery>;
export type GetInvoicesAdminQueryResult = Apollo.QueryResult<GetInvoicesAdminQuery, GetInvoicesAdminQueryVariables>;
export const GetInvoiceCommentsAdminDocument = gql`
  query GetInvoiceCommentsAdmin($args: GetInvoicesCommentsAdminArgs!) {
    getInvoiceCommentsAdmin(args: $args) {
      comments {
        comments {
          _id
          id
          created_at
          public
          html_body
          url
          type
          body
          plain_body
          author {
            userId
            name
            avatarUrl
            type
          }
          attachments {
            file_name
            content_url
            content_type
          }
          senderWarning {
            email
            reason
          }
        }
      }
      mergedFrom {
        id
        ticketNo
        subject
      }
      ticketAudits {
        audits {
          id
          ticket_id
          author_id
          created_at
          events {
            id
            type
            body
            author_id
            html_body
            public
            field_name
            previous_value
            value
            attachments {
              id
              file_name
              content_url
              content_type
            }
          }
        }
        count
        next_page
        previous_page
      }
    }
  }
`;

/**
 * __useGetInvoiceCommentsAdminQuery__
 *
 * To run a query within a React component, call `useGetInvoiceCommentsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceCommentsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceCommentsAdminQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetInvoiceCommentsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceCommentsAdminQuery, GetInvoiceCommentsAdminQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvoiceCommentsAdminQuery, GetInvoiceCommentsAdminQueryVariables>(GetInvoiceCommentsAdminDocument, options);
}
export function useGetInvoiceCommentsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceCommentsAdminQuery, GetInvoiceCommentsAdminQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvoiceCommentsAdminQuery, GetInvoiceCommentsAdminQueryVariables>(GetInvoiceCommentsAdminDocument, options);
}
export type GetInvoiceCommentsAdminQueryHookResult = ReturnType<typeof useGetInvoiceCommentsAdminQuery>;
export type GetInvoiceCommentsAdminLazyQueryHookResult = ReturnType<typeof useGetInvoiceCommentsAdminLazyQuery>;
export type GetInvoiceCommentsAdminQueryResult = Apollo.QueryResult<GetInvoiceCommentsAdminQuery, GetInvoiceCommentsAdminQueryVariables>;
export const GetBuyerStatsDocument = gql`
  query GetBuyerStats($args: GetBuyerStatsArgs!) {
    getBuyerStats(args: $args) {
      _id
      purchased
      cancelled
      issued
      inquiries
    }
  }
`;

/**
 * __useGetBuyerStatsQuery__
 *
 * To run a query within a React component, call `useGetBuyerStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBuyerStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBuyerStatsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetBuyerStatsQuery(baseOptions: Apollo.QueryHookOptions<GetBuyerStatsQuery, GetBuyerStatsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBuyerStatsQuery, GetBuyerStatsQueryVariables>(GetBuyerStatsDocument, options);
}
export function useGetBuyerStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBuyerStatsQuery, GetBuyerStatsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBuyerStatsQuery, GetBuyerStatsQueryVariables>(GetBuyerStatsDocument, options);
}
export type GetBuyerStatsQueryHookResult = ReturnType<typeof useGetBuyerStatsQuery>;
export type GetBuyerStatsLazyQueryHookResult = ReturnType<typeof useGetBuyerStatsLazyQuery>;
export type GetBuyerStatsQueryResult = Apollo.QueryResult<GetBuyerStatsQuery, GetBuyerStatsQueryVariables>;
export const GetInvoiceLoggingDocument = gql`
  query GetInvoiceLogging($args: GetInvoiceLoggingArgs!) {
    getInvoiceLogging(args: $args) {
      logs {
        id
        target
        type
        operator
        payload
        createdAt
      }
      total
    }
  }
`;

/**
 * __useGetInvoiceLoggingQuery__
 *
 * To run a query within a React component, call `useGetInvoiceLoggingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceLoggingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceLoggingQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetInvoiceLoggingQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceLoggingQuery, GetInvoiceLoggingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvoiceLoggingQuery, GetInvoiceLoggingQueryVariables>(GetInvoiceLoggingDocument, options);
}
export function useGetInvoiceLoggingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceLoggingQuery, GetInvoiceLoggingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvoiceLoggingQuery, GetInvoiceLoggingQueryVariables>(GetInvoiceLoggingDocument, options);
}
export type GetInvoiceLoggingQueryHookResult = ReturnType<typeof useGetInvoiceLoggingQuery>;
export type GetInvoiceLoggingLazyQueryHookResult = ReturnType<typeof useGetInvoiceLoggingLazyQuery>;
export type GetInvoiceLoggingQueryResult = Apollo.QueryResult<GetInvoiceLoggingQuery, GetInvoiceLoggingQueryVariables>;
export const GetInvoicesCarDocument = gql`
  query GetInvoicesCar($args: GetInvoicesCarArgs!) {
    getInvoicesCar(args: $args) {
      _id
      inquiryCount
    }
  }
`;

/**
 * __useGetInvoicesCarQuery__
 *
 * To run a query within a React component, call `useGetInvoicesCarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesCarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesCarQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetInvoicesCarQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesCarQuery, GetInvoicesCarQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvoicesCarQuery, GetInvoicesCarQueryVariables>(GetInvoicesCarDocument, options);
}
export function useGetInvoicesCarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesCarQuery, GetInvoicesCarQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvoicesCarQuery, GetInvoicesCarQueryVariables>(GetInvoicesCarDocument, options);
}
export type GetInvoicesCarQueryHookResult = ReturnType<typeof useGetInvoicesCarQuery>;
export type GetInvoicesCarLazyQueryHookResult = ReturnType<typeof useGetInvoicesCarLazyQuery>;
export type GetInvoicesCarQueryResult = Apollo.QueryResult<GetInvoicesCarQuery, GetInvoicesCarQueryVariables>;
export const UpdateInvoiceDocument = gql`
  mutation UpdateInvoice($input: UpdateInvoiceArgs!) {
    updateInvoice(input: $input) {
      _id
    }
  }
`;
export type UpdateInvoiceMutationFn = Apollo.MutationFunction<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;

/**
 * __useUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceMutation, { data, loading, error }] = useUpdateInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>(UpdateInvoiceDocument, options);
}
export type UpdateInvoiceMutationHookResult = ReturnType<typeof useUpdateInvoiceMutation>;
export type UpdateInvoiceMutationResult = Apollo.MutationResult<UpdateInvoiceMutation>;
export type UpdateInvoiceMutationOptions = Apollo.BaseMutationOptions<UpdateInvoiceMutation, UpdateInvoiceMutationVariables>;
export const AdminUpdateInvoiceDocument = gql`
  mutation AdminUpdateInvoice($input: UpdateInvoiceArgs!) {
    updateInvoice(input: $input) {
      _id
      step
      receivedUSD
      exchangeRate
      tags {
        name
        createdAt
      }
      saleEvents {
        name
        value
        createdAt
      }
    }
  }
`;
export type AdminUpdateInvoiceMutationFn = Apollo.MutationFunction<AdminUpdateInvoiceMutation, AdminUpdateInvoiceMutationVariables>;

/**
 * __useAdminUpdateInvoiceMutation__
 *
 * To run a mutation, you first call `useAdminUpdateInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminUpdateInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminUpdateInvoiceMutation, { data, loading, error }] = useAdminUpdateInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminUpdateInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<AdminUpdateInvoiceMutation, AdminUpdateInvoiceMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminUpdateInvoiceMutation, AdminUpdateInvoiceMutationVariables>(AdminUpdateInvoiceDocument, options);
}
export type AdminUpdateInvoiceMutationHookResult = ReturnType<typeof useAdminUpdateInvoiceMutation>;
export type AdminUpdateInvoiceMutationResult = Apollo.MutationResult<AdminUpdateInvoiceMutation>;
export type AdminUpdateInvoiceMutationOptions = Apollo.BaseMutationOptions<AdminUpdateInvoiceMutation, AdminUpdateInvoiceMutationVariables>;
export const ReplyCommentInvoiceDocument = gql`
  mutation ReplyCommentInvoice($input: ReplyCommentInvoiceArgs!) {
    replyCommentInvoice(input: $input) {
      success
      message
    }
  }
`;
export type ReplyCommentInvoiceMutationFn = Apollo.MutationFunction<ReplyCommentInvoiceMutation, ReplyCommentInvoiceMutationVariables>;

/**
 * __useReplyCommentInvoiceMutation__
 *
 * To run a mutation, you first call `useReplyCommentInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplyCommentInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replyCommentInvoiceMutation, { data, loading, error }] = useReplyCommentInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReplyCommentInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<ReplyCommentInvoiceMutation, ReplyCommentInvoiceMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReplyCommentInvoiceMutation, ReplyCommentInvoiceMutationVariables>(ReplyCommentInvoiceDocument, options);
}
export type ReplyCommentInvoiceMutationHookResult = ReturnType<typeof useReplyCommentInvoiceMutation>;
export type ReplyCommentInvoiceMutationResult = Apollo.MutationResult<ReplyCommentInvoiceMutation>;
export type ReplyCommentInvoiceMutationOptions = Apollo.BaseMutationOptions<ReplyCommentInvoiceMutation, ReplyCommentInvoiceMutationVariables>;
export const UploadInvoiceDocumentDocument = gql`
  mutation UploadInvoiceDocument($input: UploadInvoiceDocumentArgs!) {
    uploadInvoiceDocument(input: $input) {
      _id
    }
  }
`;
export type UploadInvoiceDocumentMutationFn = Apollo.MutationFunction<UploadInvoiceDocumentMutation, UploadInvoiceDocumentMutationVariables>;

/**
 * __useUploadInvoiceDocumentMutation__
 *
 * To run a mutation, you first call `useUploadInvoiceDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadInvoiceDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadInvoiceDocumentMutation, { data, loading, error }] = useUploadInvoiceDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadInvoiceDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadInvoiceDocumentMutation, UploadInvoiceDocumentMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadInvoiceDocumentMutation, UploadInvoiceDocumentMutationVariables>(UploadInvoiceDocumentDocument, options);
}
export type UploadInvoiceDocumentMutationHookResult = ReturnType<typeof useUploadInvoiceDocumentMutation>;
export type UploadInvoiceDocumentMutationResult = Apollo.MutationResult<UploadInvoiceDocumentMutation>;
export type UploadInvoiceDocumentMutationOptions = Apollo.BaseMutationOptions<UploadInvoiceDocumentMutation, UploadInvoiceDocumentMutationVariables>;
export const BatchInvoicesActionDocument = gql`
  mutation BatchInvoicesAction($input: BatchInvoicesActionArgs!) {
    batchInvoicesAction(input: $input) {
      _id
    }
  }
`;
export type BatchInvoicesActionMutationFn = Apollo.MutationFunction<BatchInvoicesActionMutation, BatchInvoicesActionMutationVariables>;

/**
 * __useBatchInvoicesActionMutation__
 *
 * To run a mutation, you first call `useBatchInvoicesActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchInvoicesActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchInvoicesActionMutation, { data, loading, error }] = useBatchInvoicesActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchInvoicesActionMutation(baseOptions?: Apollo.MutationHookOptions<BatchInvoicesActionMutation, BatchInvoicesActionMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BatchInvoicesActionMutation, BatchInvoicesActionMutationVariables>(BatchInvoicesActionDocument, options);
}
export type BatchInvoicesActionMutationHookResult = ReturnType<typeof useBatchInvoicesActionMutation>;
export type BatchInvoicesActionMutationResult = Apollo.MutationResult<BatchInvoicesActionMutation>;
export type BatchInvoicesActionMutationOptions = Apollo.BaseMutationOptions<BatchInvoicesActionMutation, BatchInvoicesActionMutationVariables>;
export const AskForSupportDocument = gql`
  mutation AskForSupport($input: AskForSupportArgs!) {
    askForSupport(input: $input) {
      id
    }
  }
`;
export type AskForSupportMutationFn = Apollo.MutationFunction<AskForSupportMutation, AskForSupportMutationVariables>;

/**
 * __useAskForSupportMutation__
 *
 * To run a mutation, you first call `useAskForSupportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAskForSupportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [askForSupportMutation, { data, loading, error }] = useAskForSupportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAskForSupportMutation(baseOptions?: Apollo.MutationHookOptions<AskForSupportMutation, AskForSupportMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AskForSupportMutation, AskForSupportMutationVariables>(AskForSupportDocument, options);
}
export type AskForSupportMutationHookResult = ReturnType<typeof useAskForSupportMutation>;
export type AskForSupportMutationResult = Apollo.MutationResult<AskForSupportMutation>;
export type AskForSupportMutationOptions = Apollo.BaseMutationOptions<AskForSupportMutation, AskForSupportMutationVariables>;
export const SetInvoiceAvailabilityDocument = gql`
  mutation SetInvoiceAvailability($input: SetAvailabilityArgs!) {
    setAvailability(input: $input) {
      _id
      availability
    }
  }
`;
export type SetInvoiceAvailabilityMutationFn = Apollo.MutationFunction<SetInvoiceAvailabilityMutation, SetInvoiceAvailabilityMutationVariables>;

/**
 * __useSetInvoiceAvailabilityMutation__
 *
 * To run a mutation, you first call `useSetInvoiceAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetInvoiceAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setInvoiceAvailabilityMutation, { data, loading, error }] = useSetInvoiceAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetInvoiceAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<SetInvoiceAvailabilityMutation, SetInvoiceAvailabilityMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetInvoiceAvailabilityMutation, SetInvoiceAvailabilityMutationVariables>(SetInvoiceAvailabilityDocument, options);
}
export type SetInvoiceAvailabilityMutationHookResult = ReturnType<typeof useSetInvoiceAvailabilityMutation>;
export type SetInvoiceAvailabilityMutationResult = Apollo.MutationResult<SetInvoiceAvailabilityMutation>;
export type SetInvoiceAvailabilityMutationOptions = Apollo.BaseMutationOptions<SetInvoiceAvailabilityMutation, SetInvoiceAvailabilityMutationVariables>;
export const IssueInvoiceDocument = gql`
  mutation IssueInvoice($input: IssueInvoiceArgs!) {
    issueInvoice(input: $input) {
      _id
    }
  }
`;
export type IssueInvoiceMutationFn = Apollo.MutationFunction<IssueInvoiceMutation, IssueInvoiceMutationVariables>;

/**
 * __useIssueInvoiceMutation__
 *
 * To run a mutation, you first call `useIssueInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueInvoiceMutation, { data, loading, error }] = useIssueInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIssueInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<IssueInvoiceMutation, IssueInvoiceMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<IssueInvoiceMutation, IssueInvoiceMutationVariables>(IssueInvoiceDocument, options);
}
export type IssueInvoiceMutationHookResult = ReturnType<typeof useIssueInvoiceMutation>;
export type IssueInvoiceMutationResult = Apollo.MutationResult<IssueInvoiceMutation>;
export type IssueInvoiceMutationOptions = Apollo.BaseMutationOptions<IssueInvoiceMutation, IssueInvoiceMutationVariables>;
export const ConfirmTtDocument = gql`
  mutation ConfirmTT($input: ConfirmTTArgs!) {
    confirmTT(input: $input) {
      _id
    }
  }
`;
export type ConfirmTtMutationFn = Apollo.MutationFunction<ConfirmTtMutation, ConfirmTtMutationVariables>;

/**
 * __useConfirmTtMutation__
 *
 * To run a mutation, you first call `useConfirmTtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmTtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmTtMutation, { data, loading, error }] = useConfirmTtMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmTtMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmTtMutation, ConfirmTtMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConfirmTtMutation, ConfirmTtMutationVariables>(ConfirmTtDocument, options);
}
export type ConfirmTtMutationHookResult = ReturnType<typeof useConfirmTtMutation>;
export type ConfirmTtMutationResult = Apollo.MutationResult<ConfirmTtMutation>;
export type ConfirmTtMutationOptions = Apollo.BaseMutationOptions<ConfirmTtMutation, ConfirmTtMutationVariables>;
export const ShareShippingScheduleDocument = gql`
  mutation ShareShippingSchedule($input: ShareShippingScheduleArgs!) {
    shareShippingSchedule(input: $input) {
      _id
    }
  }
`;
export type ShareShippingScheduleMutationFn = Apollo.MutationFunction<ShareShippingScheduleMutation, ShareShippingScheduleMutationVariables>;

/**
 * __useShareShippingScheduleMutation__
 *
 * To run a mutation, you first call `useShareShippingScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareShippingScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareShippingScheduleMutation, { data, loading, error }] = useShareShippingScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareShippingScheduleMutation(baseOptions?: Apollo.MutationHookOptions<ShareShippingScheduleMutation, ShareShippingScheduleMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ShareShippingScheduleMutation, ShareShippingScheduleMutationVariables>(ShareShippingScheduleDocument, options);
}
export type ShareShippingScheduleMutationHookResult = ReturnType<typeof useShareShippingScheduleMutation>;
export type ShareShippingScheduleMutationResult = Apollo.MutationResult<ShareShippingScheduleMutation>;
export type ShareShippingScheduleMutationOptions = Apollo.BaseMutationOptions<ShareShippingScheduleMutation, ShareShippingScheduleMutationVariables>;
export const ShareTrackingDocument = gql`
  mutation ShareTracking($input: ShareTrackingArgs!) {
    shareTracking(input: $input) {
      _id
    }
  }
`;
export type ShareTrackingMutationFn = Apollo.MutationFunction<ShareTrackingMutation, ShareTrackingMutationVariables>;

/**
 * __useShareTrackingMutation__
 *
 * To run a mutation, you first call `useShareTrackingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareTrackingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareTrackingMutation, { data, loading, error }] = useShareTrackingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareTrackingMutation(baseOptions?: Apollo.MutationHookOptions<ShareTrackingMutation, ShareTrackingMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ShareTrackingMutation, ShareTrackingMutationVariables>(ShareTrackingDocument, options);
}
export type ShareTrackingMutationHookResult = ReturnType<typeof useShareTrackingMutation>;
export type ShareTrackingMutationResult = Apollo.MutationResult<ShareTrackingMutation>;
export type ShareTrackingMutationOptions = Apollo.BaseMutationOptions<ShareTrackingMutation, ShareTrackingMutationVariables>;
export const ShareBlCopyDocument = gql`
  mutation ShareBLCopy($input: ShareBLCopyArgs!) {
    shareBLCopy(input: $input) {
      _id
    }
  }
`;
export type ShareBlCopyMutationFn = Apollo.MutationFunction<ShareBlCopyMutation, ShareBlCopyMutationVariables>;

/**
 * __useShareBlCopyMutation__
 *
 * To run a mutation, you first call `useShareBlCopyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShareBlCopyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shareBlCopyMutation, { data, loading, error }] = useShareBlCopyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShareBlCopyMutation(baseOptions?: Apollo.MutationHookOptions<ShareBlCopyMutation, ShareBlCopyMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ShareBlCopyMutation, ShareBlCopyMutationVariables>(ShareBlCopyDocument, options);
}
export type ShareBlCopyMutationHookResult = ReturnType<typeof useShareBlCopyMutation>;
export type ShareBlCopyMutationResult = Apollo.MutationResult<ShareBlCopyMutation>;
export type ShareBlCopyMutationOptions = Apollo.BaseMutationOptions<ShareBlCopyMutation, ShareBlCopyMutationVariables>;
export const CarReceivedDocument = gql`
  mutation CarReceived($input: CarReceivedArgs!) {
    carReceived(input: $input) {
      _id
    }
  }
`;
export type CarReceivedMutationFn = Apollo.MutationFunction<CarReceivedMutation, CarReceivedMutationVariables>;

/**
 * __useCarReceivedMutation__
 *
 * To run a mutation, you first call `useCarReceivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarReceivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carReceivedMutation, { data, loading, error }] = useCarReceivedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCarReceivedMutation(baseOptions?: Apollo.MutationHookOptions<CarReceivedMutation, CarReceivedMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CarReceivedMutation, CarReceivedMutationVariables>(CarReceivedDocument, options);
}
export type CarReceivedMutationHookResult = ReturnType<typeof useCarReceivedMutation>;
export type CarReceivedMutationResult = Apollo.MutationResult<CarReceivedMutation>;
export type CarReceivedMutationOptions = Apollo.BaseMutationOptions<CarReceivedMutation, CarReceivedMutationVariables>;
export const SetActualArrivalDateDocument = gql`
  mutation SetActualArrivalDate($input: SetActualArrivalDateInput!) {
    setActualArrivalDate(input: $input) {
      _id
    }
  }
`;
export type SetActualArrivalDateMutationFn = Apollo.MutationFunction<SetActualArrivalDateMutation, SetActualArrivalDateMutationVariables>;

/**
 * __useSetActualArrivalDateMutation__
 *
 * To run a mutation, you first call `useSetActualArrivalDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActualArrivalDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActualArrivalDateMutation, { data, loading, error }] = useSetActualArrivalDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetActualArrivalDateMutation(baseOptions?: Apollo.MutationHookOptions<SetActualArrivalDateMutation, SetActualArrivalDateMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetActualArrivalDateMutation, SetActualArrivalDateMutationVariables>(SetActualArrivalDateDocument, options);
}
export type SetActualArrivalDateMutationHookResult = ReturnType<typeof useSetActualArrivalDateMutation>;
export type SetActualArrivalDateMutationResult = Apollo.MutationResult<SetActualArrivalDateMutation>;
export type SetActualArrivalDateMutationOptions = Apollo.BaseMutationOptions<SetActualArrivalDateMutation, SetActualArrivalDateMutationVariables>;
export const CancelOrderDocument = gql`
  mutation CancelOrder($input: CancelOrderArgs!) {
    cancelOrder(input: $input) {
      _id
    }
  }
`;
export type CancelOrderMutationFn = Apollo.MutationFunction<CancelOrderMutation, CancelOrderMutationVariables>;

/**
 * __useCancelOrderMutation__
 *
 * To run a mutation, you first call `useCancelOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOrderMutation, { data, loading, error }] = useCancelOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelOrderMutation(baseOptions?: Apollo.MutationHookOptions<CancelOrderMutation, CancelOrderMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CancelOrderMutation, CancelOrderMutationVariables>(CancelOrderDocument, options);
}
export type CancelOrderMutationHookResult = ReturnType<typeof useCancelOrderMutation>;
export type CancelOrderMutationResult = Apollo.MutationResult<CancelOrderMutation>;
export type CancelOrderMutationOptions = Apollo.BaseMutationOptions<CancelOrderMutation, CancelOrderMutationVariables>;
export const ConfirmPaymentDocument = gql`
  mutation ConfirmPayment($input: ConfirmPaymentArgs!) {
    confirmPayment(input: $input) {
      _id
    }
  }
`;
export type ConfirmPaymentMutationFn = Apollo.MutationFunction<ConfirmPaymentMutation, ConfirmPaymentMutationVariables>;

/**
 * __useConfirmPaymentMutation__
 *
 * To run a mutation, you first call `useConfirmPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPaymentMutation, { data, loading, error }] = useConfirmPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfirmPaymentMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmPaymentMutation, ConfirmPaymentMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConfirmPaymentMutation, ConfirmPaymentMutationVariables>(ConfirmPaymentDocument, options);
}
export type ConfirmPaymentMutationHookResult = ReturnType<typeof useConfirmPaymentMutation>;
export type ConfirmPaymentMutationResult = Apollo.MutationResult<ConfirmPaymentMutation>;
export type ConfirmPaymentMutationOptions = Apollo.BaseMutationOptions<ConfirmPaymentMutation, ConfirmPaymentMutationVariables>;
export const ReleaseMoneyDocument = gql`
  mutation ReleaseMoney($input: ReleaseMoneyArgs!) {
    releaseMoney(input: $input) {
      _id
    }
  }
`;
export type ReleaseMoneyMutationFn = Apollo.MutationFunction<ReleaseMoneyMutation, ReleaseMoneyMutationVariables>;

/**
 * __useReleaseMoneyMutation__
 *
 * To run a mutation, you first call `useReleaseMoneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReleaseMoneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [releaseMoneyMutation, { data, loading, error }] = useReleaseMoneyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReleaseMoneyMutation(baseOptions?: Apollo.MutationHookOptions<ReleaseMoneyMutation, ReleaseMoneyMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReleaseMoneyMutation, ReleaseMoneyMutationVariables>(ReleaseMoneyDocument, options);
}
export type ReleaseMoneyMutationHookResult = ReturnType<typeof useReleaseMoneyMutation>;
export type ReleaseMoneyMutationResult = Apollo.MutationResult<ReleaseMoneyMutation>;
export type ReleaseMoneyMutationOptions = Apollo.BaseMutationOptions<ReleaseMoneyMutation, ReleaseMoneyMutationVariables>;
export const AdminInvoiceStatusDocument = gql`
  mutation AdminInvoiceStatus($input: SetManualStatusArgs!) {
    setManualStatus(input: $input) {
      _id
    }
  }
`;
export type AdminInvoiceStatusMutationFn = Apollo.MutationFunction<AdminInvoiceStatusMutation, AdminInvoiceStatusMutationVariables>;

/**
 * __useAdminInvoiceStatusMutation__
 *
 * To run a mutation, you first call `useAdminInvoiceStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminInvoiceStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminInvoiceStatusMutation, { data, loading, error }] = useAdminInvoiceStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminInvoiceStatusMutation(baseOptions?: Apollo.MutationHookOptions<AdminInvoiceStatusMutation, AdminInvoiceStatusMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdminInvoiceStatusMutation, AdminInvoiceStatusMutationVariables>(AdminInvoiceStatusDocument, options);
}
export type AdminInvoiceStatusMutationHookResult = ReturnType<typeof useAdminInvoiceStatusMutation>;
export type AdminInvoiceStatusMutationResult = Apollo.MutationResult<AdminInvoiceStatusMutation>;
export type AdminInvoiceStatusMutationOptions = Apollo.BaseMutationOptions<AdminInvoiceStatusMutation, AdminInvoiceStatusMutationVariables>;
export const InquiryTagHistoriesDocument = gql`
  query InquiryTagHistories($input: InquiryTagHistoriesArgs!) {
    inquiryTagHistories(input: $input) {
      _id
      name
      tagCreatedAt
      toStatus
      removedAt
    }
  }
`;

/**
 * __useInquiryTagHistoriesQuery__
 *
 * To run a query within a React component, call `useInquiryTagHistoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInquiryTagHistoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInquiryTagHistoriesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInquiryTagHistoriesQuery(baseOptions: Apollo.QueryHookOptions<InquiryTagHistoriesQuery, InquiryTagHistoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<InquiryTagHistoriesQuery, InquiryTagHistoriesQueryVariables>(InquiryTagHistoriesDocument, options);
}
export function useInquiryTagHistoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InquiryTagHistoriesQuery, InquiryTagHistoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<InquiryTagHistoriesQuery, InquiryTagHistoriesQueryVariables>(InquiryTagHistoriesDocument, options);
}
export type InquiryTagHistoriesQueryHookResult = ReturnType<typeof useInquiryTagHistoriesQuery>;
export type InquiryTagHistoriesLazyQueryHookResult = ReturnType<typeof useInquiryTagHistoriesLazyQuery>;
export type InquiryTagHistoriesQueryResult = Apollo.QueryResult<InquiryTagHistoriesQuery, InquiryTagHistoriesQueryVariables>;
export const RestoreInquiryTagDocument = gql`
  mutation RestoreInquiryTag($input: RestoreInquiryTagArgs!) {
    restoreInquiryTag(input: $input) {
      _id
    }
  }
`;
export type RestoreInquiryTagMutationFn = Apollo.MutationFunction<RestoreInquiryTagMutation, RestoreInquiryTagMutationVariables>;

/**
 * __useRestoreInquiryTagMutation__
 *
 * To run a mutation, you first call `useRestoreInquiryTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreInquiryTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreInquiryTagMutation, { data, loading, error }] = useRestoreInquiryTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRestoreInquiryTagMutation(baseOptions?: Apollo.MutationHookOptions<RestoreInquiryTagMutation, RestoreInquiryTagMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RestoreInquiryTagMutation, RestoreInquiryTagMutationVariables>(RestoreInquiryTagDocument, options);
}
export type RestoreInquiryTagMutationHookResult = ReturnType<typeof useRestoreInquiryTagMutation>;
export type RestoreInquiryTagMutationResult = Apollo.MutationResult<RestoreInquiryTagMutation>;
export type RestoreInquiryTagMutationOptions = Apollo.BaseMutationOptions<RestoreInquiryTagMutation, RestoreInquiryTagMutationVariables>;
export const IssueInvoicePaypalDocument = gql`
  mutation IssueInvoicePaypal($input: IssuePaypalArgs!) {
    issuePaypal(input: $input) {
      _id
    }
  }
`;
export type IssueInvoicePaypalMutationFn = Apollo.MutationFunction<IssueInvoicePaypalMutation, IssueInvoicePaypalMutationVariables>;

/**
 * __useIssueInvoicePaypalMutation__
 *
 * To run a mutation, you first call `useIssueInvoicePaypalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueInvoicePaypalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueInvoicePaypalMutation, { data, loading, error }] = useIssueInvoicePaypalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIssueInvoicePaypalMutation(baseOptions?: Apollo.MutationHookOptions<IssueInvoicePaypalMutation, IssueInvoicePaypalMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<IssueInvoicePaypalMutation, IssueInvoicePaypalMutationVariables>(IssueInvoicePaypalDocument, options);
}
export type IssueInvoicePaypalMutationHookResult = ReturnType<typeof useIssueInvoicePaypalMutation>;
export type IssueInvoicePaypalMutationResult = Apollo.MutationResult<IssueInvoicePaypalMutation>;
export type IssueInvoicePaypalMutationOptions = Apollo.BaseMutationOptions<IssueInvoicePaypalMutation, IssueInvoicePaypalMutationVariables>;
export const FollowUpInvoiceDocument = gql`
  mutation FollowUpInvoice($input: FollowUpArgs!) {
    followUp(input: $input) {
      _id
    }
  }
`;
export type FollowUpInvoiceMutationFn = Apollo.MutationFunction<FollowUpInvoiceMutation, FollowUpInvoiceMutationVariables>;

/**
 * __useFollowUpInvoiceMutation__
 *
 * To run a mutation, you first call `useFollowUpInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowUpInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followUpInvoiceMutation, { data, loading, error }] = useFollowUpInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFollowUpInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<FollowUpInvoiceMutation, FollowUpInvoiceMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<FollowUpInvoiceMutation, FollowUpInvoiceMutationVariables>(FollowUpInvoiceDocument, options);
}
export type FollowUpInvoiceMutationHookResult = ReturnType<typeof useFollowUpInvoiceMutation>;
export type FollowUpInvoiceMutationResult = Apollo.MutationResult<FollowUpInvoiceMutation>;
export type FollowUpInvoiceMutationOptions = Apollo.BaseMutationOptions<FollowUpInvoiceMutation, FollowUpInvoiceMutationVariables>;
export const CapturePaypalDocument = gql`
  mutation CapturePaypal($input: CapturePaypalArgs!) {
    capturePaypal(input: $input) {
      _id
    }
  }
`;
export type CapturePaypalMutationFn = Apollo.MutationFunction<CapturePaypalMutation, CapturePaypalMutationVariables>;

/**
 * __useCapturePaypalMutation__
 *
 * To run a mutation, you first call `useCapturePaypalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCapturePaypalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [capturePaypalMutation, { data, loading, error }] = useCapturePaypalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCapturePaypalMutation(baseOptions?: Apollo.MutationHookOptions<CapturePaypalMutation, CapturePaypalMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CapturePaypalMutation, CapturePaypalMutationVariables>(CapturePaypalDocument, options);
}
export type CapturePaypalMutationHookResult = ReturnType<typeof useCapturePaypalMutation>;
export type CapturePaypalMutationResult = Apollo.MutationResult<CapturePaypalMutation>;
export type CapturePaypalMutationOptions = Apollo.BaseMutationOptions<CapturePaypalMutation, CapturePaypalMutationVariables>;
export const GetCommentTrackingDocument = gql`
  query getCommentTracking($input: GetCommentTrackingArgs!) {
    getCommentTracking(input: $input) {
      status
      bounceType
      bounceSubType
      complaintFeedbackType
      reason
      ipAddress
      userAgent
      link
      linkTags
      timestamp
      createdAt
    }
  }
`;

/**
 * __useGetCommentTrackingQuery__
 *
 * To run a query within a React component, call `useGetCommentTrackingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommentTrackingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommentTrackingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetCommentTrackingQuery(baseOptions: Apollo.QueryHookOptions<GetCommentTrackingQuery, GetCommentTrackingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCommentTrackingQuery, GetCommentTrackingQueryVariables>(GetCommentTrackingDocument, options);
}
export function useGetCommentTrackingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommentTrackingQuery, GetCommentTrackingQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCommentTrackingQuery, GetCommentTrackingQueryVariables>(GetCommentTrackingDocument, options);
}
export type GetCommentTrackingQueryHookResult = ReturnType<typeof useGetCommentTrackingQuery>;
export type GetCommentTrackingLazyQueryHookResult = ReturnType<typeof useGetCommentTrackingLazyQuery>;
export type GetCommentTrackingQueryResult = Apollo.QueryResult<GetCommentTrackingQuery, GetCommentTrackingQueryVariables>;
export const ImproveSellerCommentDocument = gql`
  mutation ImproveSellerComment($comment: String!, $buyerName: String!) {
    improveSellerComment(comment: $comment, buyerName: $buyerName)
  }
`;
export type ImproveSellerCommentMutationFn = Apollo.MutationFunction<ImproveSellerCommentMutation, ImproveSellerCommentMutationVariables>;

/**
 * __useImproveSellerCommentMutation__
 *
 * To run a mutation, you first call `useImproveSellerCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImproveSellerCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [improveSellerCommentMutation, { data, loading, error }] = useImproveSellerCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *      buyerName: // value for 'buyerName'
 *   },
 * });
 */
export function useImproveSellerCommentMutation(baseOptions?: Apollo.MutationHookOptions<ImproveSellerCommentMutation, ImproveSellerCommentMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ImproveSellerCommentMutation, ImproveSellerCommentMutationVariables>(ImproveSellerCommentDocument, options);
}
export type ImproveSellerCommentMutationHookResult = ReturnType<typeof useImproveSellerCommentMutation>;
export type ImproveSellerCommentMutationResult = Apollo.MutationResult<ImproveSellerCommentMutation>;
export type ImproveSellerCommentMutationOptions = Apollo.BaseMutationOptions<ImproveSellerCommentMutation, ImproveSellerCommentMutationVariables>;
export const TranslateCommentDocument = gql`
  mutation TranslateComment($comment: String!) {
    translateComment(comment: $comment)
  }
`;
export type TranslateCommentMutationFn = Apollo.MutationFunction<TranslateCommentMutation, TranslateCommentMutationVariables>;

/**
 * __useTranslateCommentMutation__
 *
 * To run a mutation, you first call `useTranslateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTranslateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [translateCommentMutation, { data, loading, error }] = useTranslateCommentMutation({
 *   variables: {
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useTranslateCommentMutation(baseOptions?: Apollo.MutationHookOptions<TranslateCommentMutation, TranslateCommentMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TranslateCommentMutation, TranslateCommentMutationVariables>(TranslateCommentDocument, options);
}
export type TranslateCommentMutationHookResult = ReturnType<typeof useTranslateCommentMutation>;
export type TranslateCommentMutationResult = Apollo.MutationResult<TranslateCommentMutation>;
export type TranslateCommentMutationOptions = Apollo.BaseMutationOptions<TranslateCommentMutation, TranslateCommentMutationVariables>;
export const ExplainBuyerMessagesDocument = gql`
  mutation ExplainBuyerMessages($buyerMessages: [String!]!, $language: String!) {
    explainBuyerMessages(buyerMessages: $buyerMessages, language: $language)
  }
`;
export type ExplainBuyerMessagesMutationFn = Apollo.MutationFunction<ExplainBuyerMessagesMutation, ExplainBuyerMessagesMutationVariables>;

/**
 * __useExplainBuyerMessagesMutation__
 *
 * To run a mutation, you first call `useExplainBuyerMessagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExplainBuyerMessagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [explainBuyerMessagesMutation, { data, loading, error }] = useExplainBuyerMessagesMutation({
 *   variables: {
 *      buyerMessages: // value for 'buyerMessages'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useExplainBuyerMessagesMutation(baseOptions?: Apollo.MutationHookOptions<ExplainBuyerMessagesMutation, ExplainBuyerMessagesMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ExplainBuyerMessagesMutation, ExplainBuyerMessagesMutationVariables>(ExplainBuyerMessagesDocument, options);
}
export type ExplainBuyerMessagesMutationHookResult = ReturnType<typeof useExplainBuyerMessagesMutation>;
export type ExplainBuyerMessagesMutationResult = Apollo.MutationResult<ExplainBuyerMessagesMutation>;
export type ExplainBuyerMessagesMutationOptions = Apollo.BaseMutationOptions<ExplainBuyerMessagesMutation, ExplainBuyerMessagesMutationVariables>;
export const SummarizeAllConversationDocument = gql`
  mutation SummarizeAllConversation($conversations: [String!]!, $language: String!) {
    summarizeAllConversation(conversations: $conversations, language: $language)
  }
`;
export type SummarizeAllConversationMutationFn = Apollo.MutationFunction<SummarizeAllConversationMutation, SummarizeAllConversationMutationVariables>;

/**
 * __useSummarizeAllConversationMutation__
 *
 * To run a mutation, you first call `useSummarizeAllConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSummarizeAllConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [summarizeAllConversationMutation, { data, loading, error }] = useSummarizeAllConversationMutation({
 *   variables: {
 *      conversations: // value for 'conversations'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSummarizeAllConversationMutation(baseOptions?: Apollo.MutationHookOptions<SummarizeAllConversationMutation, SummarizeAllConversationMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SummarizeAllConversationMutation, SummarizeAllConversationMutationVariables>(SummarizeAllConversationDocument, options);
}
export type SummarizeAllConversationMutationHookResult = ReturnType<typeof useSummarizeAllConversationMutation>;
export type SummarizeAllConversationMutationResult = Apollo.MutationResult<SummarizeAllConversationMutation>;
export type SummarizeAllConversationMutationOptions = Apollo.BaseMutationOptions<SummarizeAllConversationMutation, SummarizeAllConversationMutationVariables>;
export const GetInvoiceDriveInfoDocument = gql`
  query GetInvoiceDriveInfo($invoiceIds: [String!]!) {
    getInvoiceDriveInfo(invoiceIds: $invoiceIds) {
      folderId
      folderName
      folderPath
      datePrefix
      items {
        ticketId
        invoiceCode
        receiptCode
        invoiceFilename
        receiptFilename
      }
    }
  }
`;

/**
 * __useGetInvoiceDriveInfoQuery__
 *
 * To run a query within a React component, call `useGetInvoiceDriveInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceDriveInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceDriveInfoQuery({
 *   variables: {
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function useGetInvoiceDriveInfoQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceDriveInfoQuery, GetInvoiceDriveInfoQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvoiceDriveInfoQuery, GetInvoiceDriveInfoQueryVariables>(GetInvoiceDriveInfoDocument, options);
}
export function useGetInvoiceDriveInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceDriveInfoQuery, GetInvoiceDriveInfoQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvoiceDriveInfoQuery, GetInvoiceDriveInfoQueryVariables>(GetInvoiceDriveInfoDocument, options);
}
export type GetInvoiceDriveInfoQueryHookResult = ReturnType<typeof useGetInvoiceDriveInfoQuery>;
export type GetInvoiceDriveInfoLazyQueryHookResult = ReturnType<typeof useGetInvoiceDriveInfoLazyQuery>;
export type GetInvoiceDriveInfoQueryResult = Apollo.QueryResult<GetInvoiceDriveInfoQuery, GetInvoiceDriveInfoQueryVariables>;
export const UploadInvoiceDocsToDriveDocument = gql`
  mutation UploadInvoiceDocsToDrive($invoiceIds: [String!]!) {
    uploadInvoiceDocsToDrive(invoiceIds: $invoiceIds) {
      folderId
      results {
        ticketId
        receipt {
          id
          name
          url
        }
        invoice {
          id
          name
          url
        }
      }
    }
  }
`;
export type UploadInvoiceDocsToDriveMutationFn = Apollo.MutationFunction<UploadInvoiceDocsToDriveMutation, UploadInvoiceDocsToDriveMutationVariables>;

/**
 * __useUploadInvoiceDocsToDriveMutation__
 *
 * To run a mutation, you first call `useUploadInvoiceDocsToDriveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadInvoiceDocsToDriveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadInvoiceDocsToDriveMutation, { data, loading, error }] = useUploadInvoiceDocsToDriveMutation({
 *   variables: {
 *      invoiceIds: // value for 'invoiceIds'
 *   },
 * });
 */
export function useUploadInvoiceDocsToDriveMutation(baseOptions?: Apollo.MutationHookOptions<UploadInvoiceDocsToDriveMutation, UploadInvoiceDocsToDriveMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadInvoiceDocsToDriveMutation, UploadInvoiceDocsToDriveMutationVariables>(UploadInvoiceDocsToDriveDocument, options);
}
export type UploadInvoiceDocsToDriveMutationHookResult = ReturnType<typeof useUploadInvoiceDocsToDriveMutation>;
export type UploadInvoiceDocsToDriveMutationResult = Apollo.MutationResult<UploadInvoiceDocsToDriveMutation>;
export type UploadInvoiceDocsToDriveMutationOptions = Apollo.BaseMutationOptions<UploadInvoiceDocsToDriveMutation, UploadInvoiceDocsToDriveMutationVariables>;
export const GetInvoiceDashboardSummaryDocument = gql`
  query GetInvoiceDashboardSummary {
    getInvoiceDashboardSummary {
      countNeedUpdate
      issueInvoice {
        _id
        ticketNo
        country
        port
        city
        car {
          id
          title
        }
        updated
        step
      }
      totalIssueInvoice
      confirmPayment {
        _id
        ticketNo
        country
        port
        city
        car {
          id
          title
        }
        updated
        step
      }
      totalConfirmPayment
      sharedShippingSchedule {
        _id
        ticketNo
        country
        port
        city
        car {
          id
          title
        }
        updated
        step
      }
      totalSharedShippingSchedule
      sharedBLCopy {
        _id
        ticketNo
        country
        port
        city
        car {
          id
          title
        }
        updated
        step
      }
      totalSharedBLCopy
    }
  }
`;

/**
 * __useGetInvoiceDashboardSummaryQuery__
 *
 * To run a query within a React component, call `useGetInvoiceDashboardSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceDashboardSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceDashboardSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvoiceDashboardSummaryQuery(baseOptions?: Apollo.QueryHookOptions<GetInvoiceDashboardSummaryQuery, GetInvoiceDashboardSummaryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvoiceDashboardSummaryQuery, GetInvoiceDashboardSummaryQueryVariables>(GetInvoiceDashboardSummaryDocument, options);
}
export function useGetInvoiceDashboardSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceDashboardSummaryQuery, GetInvoiceDashboardSummaryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvoiceDashboardSummaryQuery, GetInvoiceDashboardSummaryQueryVariables>(GetInvoiceDashboardSummaryDocument, options);
}
export type GetInvoiceDashboardSummaryQueryHookResult = ReturnType<typeof useGetInvoiceDashboardSummaryQuery>;
export type GetInvoiceDashboardSummaryLazyQueryHookResult = ReturnType<typeof useGetInvoiceDashboardSummaryLazyQuery>;
export type GetInvoiceDashboardSummaryQueryResult = Apollo.QueryResult<GetInvoiceDashboardSummaryQuery, GetInvoiceDashboardSummaryQueryVariables>;
export const GetInvoiceDashboardStatsDocument = gql`
  query GetInvoiceDashboardStats($filters: InvoiceDashboardFiltersInput!) {
    getInvoiceDashboardStats(filters: $filters) {
      inquiries {
        current
        lastMonth
      }
      invoices {
        current
        lastMonth
      }
      payments {
        current
        lastMonth
      }
      revenue {
        current
        lastMonth
      }
    }
  }
`;

/**
 * __useGetInvoiceDashboardStatsQuery__
 *
 * To run a query within a React component, call `useGetInvoiceDashboardStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceDashboardStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceDashboardStatsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetInvoiceDashboardStatsQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceDashboardStatsQuery, GetInvoiceDashboardStatsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvoiceDashboardStatsQuery, GetInvoiceDashboardStatsQueryVariables>(GetInvoiceDashboardStatsDocument, options);
}
export function useGetInvoiceDashboardStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceDashboardStatsQuery, GetInvoiceDashboardStatsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvoiceDashboardStatsQuery, GetInvoiceDashboardStatsQueryVariables>(GetInvoiceDashboardStatsDocument, options);
}
export type GetInvoiceDashboardStatsQueryHookResult = ReturnType<typeof useGetInvoiceDashboardStatsQuery>;
export type GetInvoiceDashboardStatsLazyQueryHookResult = ReturnType<typeof useGetInvoiceDashboardStatsLazyQuery>;
export type GetInvoiceDashboardStatsQueryResult = Apollo.QueryResult<GetInvoiceDashboardStatsQuery, GetInvoiceDashboardStatsQueryVariables>;
export const GetInvoiceDashboardCountryDocument = gql`
  query GetInvoiceDashboardCountry($filters: InvoiceDashboardFiltersInput!) {
    getInvoiceDashboardCountry(filters: $filters) {
      _id
      inquiry
      qualityInquiry
      buyers {
        user
        isQuality
      }
      invoices
      sales
    }
  }
`;

/**
 * __useGetInvoiceDashboardCountryQuery__
 *
 * To run a query within a React component, call `useGetInvoiceDashboardCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceDashboardCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceDashboardCountryQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetInvoiceDashboardCountryQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceDashboardCountryQuery, GetInvoiceDashboardCountryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetInvoiceDashboardCountryQuery, GetInvoiceDashboardCountryQueryVariables>(GetInvoiceDashboardCountryDocument, options);
}
export function useGetInvoiceDashboardCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceDashboardCountryQuery, GetInvoiceDashboardCountryQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetInvoiceDashboardCountryQuery, GetInvoiceDashboardCountryQueryVariables>(GetInvoiceDashboardCountryDocument, options);
}
export type GetInvoiceDashboardCountryQueryHookResult = ReturnType<typeof useGetInvoiceDashboardCountryQuery>;
export type GetInvoiceDashboardCountryLazyQueryHookResult = ReturnType<typeof useGetInvoiceDashboardCountryLazyQuery>;
export type GetInvoiceDashboardCountryQueryResult = Apollo.QueryResult<GetInvoiceDashboardCountryQuery, GetInvoiceDashboardCountryQueryVariables>;
export const GetLandingTagsDocument = gql`
  query GetLandingTags($filters: GetLandingTagsAdminInput, $offset: Int, $limit: Int, $sort: String, $order: String) {
    getLandingTags(filters: $filters, offset: $offset, limit: $limit, sort: $sort, order: $order) {
      tags {
        ...LandingTagFields
      }
      total
    }
  }
  ${LandingTagFieldsFragmentDoc}
`;

/**
 * __useGetLandingTagsQuery__
 *
 * To run a query within a React component, call `useGetLandingTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLandingTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLandingTagsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetLandingTagsQuery(baseOptions?: Apollo.QueryHookOptions<GetLandingTagsQuery, GetLandingTagsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLandingTagsQuery, GetLandingTagsQueryVariables>(GetLandingTagsDocument, options);
}
export function useGetLandingTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLandingTagsQuery, GetLandingTagsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLandingTagsQuery, GetLandingTagsQueryVariables>(GetLandingTagsDocument, options);
}
export type GetLandingTagsQueryHookResult = ReturnType<typeof useGetLandingTagsQuery>;
export type GetLandingTagsLazyQueryHookResult = ReturnType<typeof useGetLandingTagsLazyQuery>;
export type GetLandingTagsQueryResult = Apollo.QueryResult<GetLandingTagsQuery, GetLandingTagsQueryVariables>;
export const UpsertLandingTagDocument = gql`
  mutation UpsertLandingTag($id: ID, $data: UpsertLandingTagInput!) {
    upsertLandingTag(id: $id, data: $data) {
      ...LandingTagFields
    }
  }
  ${LandingTagFieldsFragmentDoc}
`;
export type UpsertLandingTagMutationFn = Apollo.MutationFunction<UpsertLandingTagMutation, UpsertLandingTagMutationVariables>;

/**
 * __useUpsertLandingTagMutation__
 *
 * To run a mutation, you first call `useUpsertLandingTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertLandingTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertLandingTagMutation, { data, loading, error }] = useUpsertLandingTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertLandingTagMutation(baseOptions?: Apollo.MutationHookOptions<UpsertLandingTagMutation, UpsertLandingTagMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertLandingTagMutation, UpsertLandingTagMutationVariables>(UpsertLandingTagDocument, options);
}
export type UpsertLandingTagMutationHookResult = ReturnType<typeof useUpsertLandingTagMutation>;
export type UpsertLandingTagMutationResult = Apollo.MutationResult<UpsertLandingTagMutation>;
export type UpsertLandingTagMutationOptions = Apollo.BaseMutationOptions<UpsertLandingTagMutation, UpsertLandingTagMutationVariables>;
export const DeleteLandingTagDocument = gql`
  mutation DeleteLandingTag($id: ID!) {
    deleteLandingTag(id: $id) {
      id
      key
    }
  }
`;
export type DeleteLandingTagMutationFn = Apollo.MutationFunction<DeleteLandingTagMutation, DeleteLandingTagMutationVariables>;

/**
 * __useDeleteLandingTagMutation__
 *
 * To run a mutation, you first call `useDeleteLandingTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLandingTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLandingTagMutation, { data, loading, error }] = useDeleteLandingTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLandingTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteLandingTagMutation, DeleteLandingTagMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteLandingTagMutation, DeleteLandingTagMutationVariables>(DeleteLandingTagDocument, options);
}
export type DeleteLandingTagMutationHookResult = ReturnType<typeof useDeleteLandingTagMutation>;
export type DeleteLandingTagMutationResult = Apollo.MutationResult<DeleteLandingTagMutation>;
export type DeleteLandingTagMutationOptions = Apollo.BaseMutationOptions<DeleteLandingTagMutation, DeleteLandingTagMutationVariables>;
export const GetCountriesDocument = gql`
  query GetCountries($params: GetCountriesParamsInput) {
    getCountries(params: $params) {
      ...CountryPageFields
    }
  }
  ${CountryPageFieldsFragmentDoc}
`;

/**
 * __useGetCountriesQuery__
 *
 * To run a query within a React component, call `useGetCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCountriesQuery({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useGetCountriesQuery(baseOptions?: Apollo.QueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
}
export function useGetCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCountriesQuery, GetCountriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCountriesQuery, GetCountriesQueryVariables>(GetCountriesDocument, options);
}
export type GetCountriesQueryHookResult = ReturnType<typeof useGetCountriesQuery>;
export type GetCountriesLazyQueryHookResult = ReturnType<typeof useGetCountriesLazyQuery>;
export type GetCountriesQueryResult = Apollo.QueryResult<GetCountriesQuery, GetCountriesQueryVariables>;
export const CreateOrUpdateCountryPageDocument = gql`
  mutation CreateOrUpdateCountryPage($params: CreateOrUpdateCountryPageInput) {
    createOrUpdateCountryPage(params: $params) {
      ...CountryPageFields
    }
  }
  ${CountryPageFieldsFragmentDoc}
`;
export type CreateOrUpdateCountryPageMutationFn = Apollo.MutationFunction<CreateOrUpdateCountryPageMutation, CreateOrUpdateCountryPageMutationVariables>;

/**
 * __useCreateOrUpdateCountryPageMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateCountryPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateCountryPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateCountryPageMutation, { data, loading, error }] = useCreateOrUpdateCountryPageMutation({
 *   variables: {
 *      params: // value for 'params'
 *   },
 * });
 */
export function useCreateOrUpdateCountryPageMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateCountryPageMutation, CreateOrUpdateCountryPageMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateOrUpdateCountryPageMutation, CreateOrUpdateCountryPageMutationVariables>(CreateOrUpdateCountryPageDocument, options);
}
export type CreateOrUpdateCountryPageMutationHookResult = ReturnType<typeof useCreateOrUpdateCountryPageMutation>;
export type CreateOrUpdateCountryPageMutationResult = Apollo.MutationResult<CreateOrUpdateCountryPageMutation>;
export type CreateOrUpdateCountryPageMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateCountryPageMutation, CreateOrUpdateCountryPageMutationVariables>;
export const UploadModelImageDocument = gql`
  mutation UploadModelImage($fileKey: String!, $params: UploadModelImageParamsInput) {
    uploadModelImage(fileKey: $fileKey, params: $params) {
      filename
      cdnUri
      checksum
    }
  }
`;
export type UploadModelImageMutationFn = Apollo.MutationFunction<UploadModelImageMutation, UploadModelImageMutationVariables>;

/**
 * __useUploadModelImageMutation__
 *
 * To run a mutation, you first call `useUploadModelImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadModelImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadModelImageMutation, { data, loading, error }] = useUploadModelImageMutation({
 *   variables: {
 *      fileKey: // value for 'fileKey'
 *      params: // value for 'params'
 *   },
 * });
 */
export function useUploadModelImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadModelImageMutation, UploadModelImageMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadModelImageMutation, UploadModelImageMutationVariables>(UploadModelImageDocument, options);
}
export type UploadModelImageMutationHookResult = ReturnType<typeof useUploadModelImageMutation>;
export type UploadModelImageMutationResult = Apollo.MutationResult<UploadModelImageMutation>;
export type UploadModelImageMutationOptions = Apollo.BaseMutationOptions<UploadModelImageMutation, UploadModelImageMutationVariables>;
export const RemoveImageDocument = gql`
  mutation RemoveImage($file: LocalPageImageInput!) {
    removeImage(file: $file) {
      filename
      cdnUri
      checksum
    }
  }
`;
export type RemoveImageMutationFn = Apollo.MutationFunction<RemoveImageMutation, RemoveImageMutationVariables>;

/**
 * __useRemoveImageMutation__
 *
 * To run a mutation, you first call `useRemoveImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeImageMutation, { data, loading, error }] = useRemoveImageMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useRemoveImageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveImageMutation, RemoveImageMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveImageMutation, RemoveImageMutationVariables>(RemoveImageDocument, options);
}
export type RemoveImageMutationHookResult = ReturnType<typeof useRemoveImageMutation>;
export type RemoveImageMutationResult = Apollo.MutationResult<RemoveImageMutation>;
export type RemoveImageMutationOptions = Apollo.BaseMutationOptions<RemoveImageMutation, RemoveImageMutationVariables>;
export const RemoveCountryPageDocument = gql`
  mutation RemoveCountryPage($id: ID!) {
    removeCountryPage(id: $id)
  }
`;
export type RemoveCountryPageMutationFn = Apollo.MutationFunction<RemoveCountryPageMutation, RemoveCountryPageMutationVariables>;

/**
 * __useRemoveCountryPageMutation__
 *
 * To run a mutation, you first call `useRemoveCountryPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCountryPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCountryPageMutation, { data, loading, error }] = useRemoveCountryPageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveCountryPageMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCountryPageMutation, RemoveCountryPageMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveCountryPageMutation, RemoveCountryPageMutationVariables>(RemoveCountryPageDocument, options);
}
export type RemoveCountryPageMutationHookResult = ReturnType<typeof useRemoveCountryPageMutation>;
export type RemoveCountryPageMutationResult = Apollo.MutationResult<RemoveCountryPageMutation>;
export type RemoveCountryPageMutationOptions = Apollo.BaseMutationOptions<RemoveCountryPageMutation, RemoveCountryPageMutationVariables>;
export const GetAllMakeDocument = gql`
  query GetAllMake($input: GetAllMakeArgs!) {
    getAllMake(input: $input) {
      id
      _id
      name
      key
    }
  }
`;

/**
 * __useGetAllMakeQuery__
 *
 * To run a query within a React component, call `useGetAllMakeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllMakeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllMakeQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetAllMakeQuery(baseOptions: Apollo.QueryHookOptions<GetAllMakeQuery, GetAllMakeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAllMakeQuery, GetAllMakeQueryVariables>(GetAllMakeDocument, options);
}
export function useGetAllMakeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllMakeQuery, GetAllMakeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetAllMakeQuery, GetAllMakeQueryVariables>(GetAllMakeDocument, options);
}
export type GetAllMakeQueryHookResult = ReturnType<typeof useGetAllMakeQuery>;
export type GetAllMakeLazyQueryHookResult = ReturnType<typeof useGetAllMakeLazyQuery>;
export type GetAllMakeQueryResult = Apollo.QueryResult<GetAllMakeQuery, GetAllMakeQueryVariables>;
export const GetLocalPageModelsDocument = gql`
  query GetLocalPageModels($input: GetManyModelsArgs) {
    getManyModels(input: $input) {
      items {
        id
        name
        key
        makeModelKey
        make {
          id
          name
        }
      }
      total
    }
  }
`;

/**
 * __useGetLocalPageModelsQuery__
 *
 * To run a query within a React component, call `useGetLocalPageModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalPageModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalPageModelsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetLocalPageModelsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocalPageModelsQuery, GetLocalPageModelsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLocalPageModelsQuery, GetLocalPageModelsQueryVariables>(GetLocalPageModelsDocument, options);
}
export function useGetLocalPageModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocalPageModelsQuery, GetLocalPageModelsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLocalPageModelsQuery, GetLocalPageModelsQueryVariables>(GetLocalPageModelsDocument, options);
}
export type GetLocalPageModelsQueryHookResult = ReturnType<typeof useGetLocalPageModelsQuery>;
export type GetLocalPageModelsLazyQueryHookResult = ReturnType<typeof useGetLocalPageModelsLazyQuery>;
export type GetLocalPageModelsQueryResult = Apollo.QueryResult<GetLocalPageModelsQuery, GetLocalPageModelsQueryVariables>;
export const GetModelSpecsDocument = gql`
  query GetModelSpecs($filters: GetModelSpecsAdminInput, $offset: Int, $limit: Int, $sort: String, $order: String) {
    getModelSpecs(filters: $filters, offset: $offset, limit: $limit, sort: $sort, order: $order) {
      modelspecs {
        ...ModelSpecFields
      }
      total
    }
  }
  ${ModelSpecFieldsFragmentDoc}
`;

/**
 * __useGetModelSpecsQuery__
 *
 * To run a query within a React component, call `useGetModelSpecsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelSpecsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelSpecsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetModelSpecsQuery(baseOptions?: Apollo.QueryHookOptions<GetModelSpecsQuery, GetModelSpecsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetModelSpecsQuery, GetModelSpecsQueryVariables>(GetModelSpecsDocument, options);
}
export function useGetModelSpecsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModelSpecsQuery, GetModelSpecsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetModelSpecsQuery, GetModelSpecsQueryVariables>(GetModelSpecsDocument, options);
}
export type GetModelSpecsQueryHookResult = ReturnType<typeof useGetModelSpecsQuery>;
export type GetModelSpecsLazyQueryHookResult = ReturnType<typeof useGetModelSpecsLazyQuery>;
export type GetModelSpecsQueryResult = Apollo.QueryResult<GetModelSpecsQuery, GetModelSpecsQueryVariables>;
export const UpsertModelSpecDocument = gql`
  mutation UpsertModelSpec($id: ID, $data: UpsertModelSpecInput!) {
    upsertModelSpec(id: $id, data: $data) {
      ...ModelSpecFields
    }
  }
  ${ModelSpecFieldsFragmentDoc}
`;
export type UpsertModelSpecMutationFn = Apollo.MutationFunction<UpsertModelSpecMutation, UpsertModelSpecMutationVariables>;

/**
 * __useUpsertModelSpecMutation__
 *
 * To run a mutation, you first call `useUpsertModelSpecMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertModelSpecMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertModelSpecMutation, { data, loading, error }] = useUpsertModelSpecMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertModelSpecMutation(baseOptions?: Apollo.MutationHookOptions<UpsertModelSpecMutation, UpsertModelSpecMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertModelSpecMutation, UpsertModelSpecMutationVariables>(UpsertModelSpecDocument, options);
}
export type UpsertModelSpecMutationHookResult = ReturnType<typeof useUpsertModelSpecMutation>;
export type UpsertModelSpecMutationResult = Apollo.MutationResult<UpsertModelSpecMutation>;
export type UpsertModelSpecMutationOptions = Apollo.BaseMutationOptions<UpsertModelSpecMutation, UpsertModelSpecMutationVariables>;
export const BatchEditModelSpecDocument = gql`
  mutation BatchEditModelSpec($ids: [ID!]!, $data: BatchEditModelSpecInput!) {
    batchEditModelSpec(ids: $ids, data: $data)
  }
`;
export type BatchEditModelSpecMutationFn = Apollo.MutationFunction<BatchEditModelSpecMutation, BatchEditModelSpecMutationVariables>;

/**
 * __useBatchEditModelSpecMutation__
 *
 * To run a mutation, you first call `useBatchEditModelSpecMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchEditModelSpecMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchEditModelSpecMutation, { data, loading, error }] = useBatchEditModelSpecMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBatchEditModelSpecMutation(baseOptions?: Apollo.MutationHookOptions<BatchEditModelSpecMutation, BatchEditModelSpecMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BatchEditModelSpecMutation, BatchEditModelSpecMutationVariables>(BatchEditModelSpecDocument, options);
}
export type BatchEditModelSpecMutationHookResult = ReturnType<typeof useBatchEditModelSpecMutation>;
export type BatchEditModelSpecMutationResult = Apollo.MutationResult<BatchEditModelSpecMutation>;
export type BatchEditModelSpecMutationOptions = Apollo.BaseMutationOptions<BatchEditModelSpecMutation, BatchEditModelSpecMutationVariables>;
export const GetModelSpecModelsDocument = gql`
  query GetModelSpecModels($input: GetManyModelsArgs) {
    getManyModels(input: $input) {
      items {
        id
        name
        key
        makeModelKey
        make {
          id
          name
        }
      }
      total
    }
  }
`;

/**
 * __useGetModelSpecModelsQuery__
 *
 * To run a query within a React component, call `useGetModelSpecModelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelSpecModelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelSpecModelsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetModelSpecModelsQuery(baseOptions?: Apollo.QueryHookOptions<GetModelSpecModelsQuery, GetModelSpecModelsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetModelSpecModelsQuery, GetModelSpecModelsQueryVariables>(GetModelSpecModelsDocument, options);
}
export function useGetModelSpecModelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModelSpecModelsQuery, GetModelSpecModelsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetModelSpecModelsQuery, GetModelSpecModelsQueryVariables>(GetModelSpecModelsDocument, options);
}
export type GetModelSpecModelsQueryHookResult = ReturnType<typeof useGetModelSpecModelsQuery>;
export type GetModelSpecModelsLazyQueryHookResult = ReturnType<typeof useGetModelSpecModelsLazyQuery>;
export type GetModelSpecModelsQueryResult = Apollo.QueryResult<GetModelSpecModelsQuery, GetModelSpecModelsQueryVariables>;
export const GetManagementModelDocument = gql`
  query GetManagementModel($filters: GetManagementModelInput, $offset: Int, $limit: Int, $sort: String, $order: String) {
    getManagementModel(filters: $filters, offset: $offset, limit: $limit, sort: $sort, order: $order) {
      items {
        ...AdminModelFields
      }
      total
    }
  }
  ${AdminModelFieldsFragmentDoc}
`;

/**
 * __useGetManagementModelQuery__
 *
 * To run a query within a React component, call `useGetManagementModelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagementModelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagementModelQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetManagementModelQuery(baseOptions?: Apollo.QueryHookOptions<GetManagementModelQuery, GetManagementModelQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetManagementModelQuery, GetManagementModelQueryVariables>(GetManagementModelDocument, options);
}
export function useGetManagementModelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagementModelQuery, GetManagementModelQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetManagementModelQuery, GetManagementModelQueryVariables>(GetManagementModelDocument, options);
}
export type GetManagementModelQueryHookResult = ReturnType<typeof useGetManagementModelQuery>;
export type GetManagementModelLazyQueryHookResult = ReturnType<typeof useGetManagementModelLazyQuery>;
export type GetManagementModelQueryResult = Apollo.QueryResult<GetManagementModelQuery, GetManagementModelQueryVariables>;
export const UpsertModelDocument = gql`
  mutation UpsertModel($id: ID, $data: ModelInputDto!) {
    upsertModel(id: $id, data: $data) {
      ...AdminModelFields
    }
  }
  ${AdminModelFieldsFragmentDoc}
`;
export type UpsertModelMutationFn = Apollo.MutationFunction<UpsertModelMutation, UpsertModelMutationVariables>;

/**
 * __useUpsertModelMutation__
 *
 * To run a mutation, you first call `useUpsertModelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertModelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertModelMutation, { data, loading, error }] = useUpsertModelMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertModelMutation(baseOptions?: Apollo.MutationHookOptions<UpsertModelMutation, UpsertModelMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertModelMutation, UpsertModelMutationVariables>(UpsertModelDocument, options);
}
export type UpsertModelMutationHookResult = ReturnType<typeof useUpsertModelMutation>;
export type UpsertModelMutationResult = Apollo.MutationResult<UpsertModelMutation>;
export type UpsertModelMutationOptions = Apollo.BaseMutationOptions<UpsertModelMutation, UpsertModelMutationVariables>;
export const GetModelOptionsDocument = gql`
  query GetModelOptions($filters: GetManagementModelInput, $limit: Int) {
    getManagementModel(filters: $filters, limit: $limit) {
      items {
        id
        name
        make {
          id
          name
        }
      }
    }
  }
`;

/**
 * __useGetModelOptionsQuery__
 *
 * To run a query within a React component, call `useGetModelOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelOptionsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetModelOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetModelOptionsQuery, GetModelOptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetModelOptionsQuery, GetModelOptionsQueryVariables>(GetModelOptionsDocument, options);
}
export function useGetModelOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModelOptionsQuery, GetModelOptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetModelOptionsQuery, GetModelOptionsQueryVariables>(GetModelOptionsDocument, options);
}
export type GetModelOptionsQueryHookResult = ReturnType<typeof useGetModelOptionsQuery>;
export type GetModelOptionsLazyQueryHookResult = ReturnType<typeof useGetModelOptionsLazyQuery>;
export type GetModelOptionsQueryResult = Apollo.QueryResult<GetModelOptionsQuery, GetModelOptionsQueryVariables>;
export const GetModelMakeOptionsDocument = gql`
  query GetModelMakeOptions($args: GetAllMakeArgs) {
    getManagementMake(args: $args) {
      items {
        _id
        name
      }
    }
  }
`;

/**
 * __useGetModelMakeOptionsQuery__
 *
 * To run a query within a React component, call `useGetModelMakeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetModelMakeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetModelMakeOptionsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetModelMakeOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetModelMakeOptionsQuery, GetModelMakeOptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetModelMakeOptionsQuery, GetModelMakeOptionsQueryVariables>(GetModelMakeOptionsDocument, options);
}
export function useGetModelMakeOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetModelMakeOptionsQuery, GetModelMakeOptionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetModelMakeOptionsQuery, GetModelMakeOptionsQueryVariables>(GetModelMakeOptionsDocument, options);
}
export type GetModelMakeOptionsQueryHookResult = ReturnType<typeof useGetModelMakeOptionsQuery>;
export type GetModelMakeOptionsLazyQueryHookResult = ReturnType<typeof useGetModelMakeOptionsLazyQuery>;
export type GetModelMakeOptionsQueryResult = Apollo.QueryResult<GetModelMakeOptionsQuery, GetModelMakeOptionsQueryVariables>;
export const GetPageviewsDocument = gql`
  query getPageviews($args: GetCarAdminPageviewsArgs!) {
    getPageviews(args: $args) {
      items {
        id
        car {
          id
          title
          status
          carUrl
          priceUSD
        }
        created
      }
      total
    }
  }
`;

/**
 * __useGetPageviewsQuery__
 *
 * To run a query within a React component, call `useGetPageviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPageviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPageviewsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetPageviewsQuery(baseOptions: Apollo.QueryHookOptions<GetPageviewsQuery, GetPageviewsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPageviewsQuery, GetPageviewsQueryVariables>(GetPageviewsDocument, options);
}
export function useGetPageviewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPageviewsQuery, GetPageviewsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPageviewsQuery, GetPageviewsQueryVariables>(GetPageviewsDocument, options);
}
export type GetPageviewsQueryHookResult = ReturnType<typeof useGetPageviewsQuery>;
export type GetPageviewsLazyQueryHookResult = ReturnType<typeof useGetPageviewsLazyQuery>;
export type GetPageviewsQueryResult = Apollo.QueryResult<GetPageviewsQuery, GetPageviewsQueryVariables>;
export const GetRegulationsDocument = gql`
  query getRegulations($country: String) {
    getRegulations(country: $country) {
      ...RegulationFields
    }
  }
  ${RegulationFieldsFragmentDoc}
`;

/**
 * __useGetRegulationsQuery__
 *
 * To run a query within a React component, call `useGetRegulationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegulationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegulationsQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useGetRegulationsQuery(baseOptions?: Apollo.QueryHookOptions<GetRegulationsQuery, GetRegulationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRegulationsQuery, GetRegulationsQueryVariables>(GetRegulationsDocument, options);
}
export function useGetRegulationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRegulationsQuery, GetRegulationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetRegulationsQuery, GetRegulationsQueryVariables>(GetRegulationsDocument, options);
}
export type GetRegulationsQueryHookResult = ReturnType<typeof useGetRegulationsQuery>;
export type GetRegulationsLazyQueryHookResult = ReturnType<typeof useGetRegulationsLazyQuery>;
export type GetRegulationsQueryResult = Apollo.QueryResult<GetRegulationsQuery, GetRegulationsQueryVariables>;
export const UpsertRegulationDocument = gql`
  mutation upsertRegulation($id: ID, $data: UpsertRegulationInput) {
    upsertRegulation(id: $id, data: $data) {
      ...RegulationFields
    }
  }
  ${RegulationFieldsFragmentDoc}
`;
export type UpsertRegulationMutationFn = Apollo.MutationFunction<UpsertRegulationMutation, UpsertRegulationMutationVariables>;

/**
 * __useUpsertRegulationMutation__
 *
 * To run a mutation, you first call `useUpsertRegulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRegulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRegulationMutation, { data, loading, error }] = useUpsertRegulationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertRegulationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertRegulationMutation, UpsertRegulationMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertRegulationMutation, UpsertRegulationMutationVariables>(UpsertRegulationDocument, options);
}
export type UpsertRegulationMutationHookResult = ReturnType<typeof useUpsertRegulationMutation>;
export type UpsertRegulationMutationResult = Apollo.MutationResult<UpsertRegulationMutation>;
export type UpsertRegulationMutationOptions = Apollo.BaseMutationOptions<UpsertRegulationMutation, UpsertRegulationMutationVariables>;
export const RemoveRegulationDocument = gql`
  mutation removeRegulation($id: ID!) {
    removeRegulation(id: $id)
  }
`;
export type RemoveRegulationMutationFn = Apollo.MutationFunction<RemoveRegulationMutation, RemoveRegulationMutationVariables>;

/**
 * __useRemoveRegulationMutation__
 *
 * To run a mutation, you first call `useRemoveRegulationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRegulationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRegulationMutation, { data, loading, error }] = useRemoveRegulationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveRegulationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRegulationMutation, RemoveRegulationMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveRegulationMutation, RemoveRegulationMutationVariables>(RemoveRegulationDocument, options);
}
export type RemoveRegulationMutationHookResult = ReturnType<typeof useRemoveRegulationMutation>;
export type RemoveRegulationMutationResult = Apollo.MutationResult<RemoveRegulationMutation>;
export type RemoveRegulationMutationOptions = Apollo.BaseMutationOptions<RemoveRegulationMutation, RemoveRegulationMutationVariables>;
export const GetSellerMonthlyStatsDocument = gql`
  query GetSellerMonthlyStats($filter: SellerStatsFilterInput!) {
    getSellerMonthlyStats(filter: $filter) {
      sellerName
      companyId
      plan
      stockStatus
      boostVehicles
      activities
      soldVehicles
    }
  }
`;

/**
 * __useGetSellerMonthlyStatsQuery__
 *
 * To run a query within a React component, call `useGetSellerMonthlyStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSellerMonthlyStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSellerMonthlyStatsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSellerMonthlyStatsQuery(baseOptions: Apollo.QueryHookOptions<GetSellerMonthlyStatsQuery, GetSellerMonthlyStatsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSellerMonthlyStatsQuery, GetSellerMonthlyStatsQueryVariables>(GetSellerMonthlyStatsDocument, options);
}
export function useGetSellerMonthlyStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSellerMonthlyStatsQuery, GetSellerMonthlyStatsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSellerMonthlyStatsQuery, GetSellerMonthlyStatsQueryVariables>(GetSellerMonthlyStatsDocument, options);
}
export type GetSellerMonthlyStatsQueryHookResult = ReturnType<typeof useGetSellerMonthlyStatsQuery>;
export type GetSellerMonthlyStatsLazyQueryHookResult = ReturnType<typeof useGetSellerMonthlyStatsLazyQuery>;
export type GetSellerMonthlyStatsQueryResult = Apollo.QueryResult<GetSellerMonthlyStatsQuery, GetSellerMonthlyStatsQueryVariables>;
export const GetSellerWeeklyStatsDocument = gql`
  query GetSellerWeeklyStats($filter: SellerWeeklyStatsFilterInput!) {
    getSellerWeeklyStats(filter: $filter) {
      sellerName
      companyId
      plan
      periods {
        startDate
        endDate
        stockStatus
        confirmedPayments
      }
    }
  }
`;

/**
 * __useGetSellerWeeklyStatsQuery__
 *
 * To run a query within a React component, call `useGetSellerWeeklyStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSellerWeeklyStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSellerWeeklyStatsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetSellerWeeklyStatsQuery(baseOptions: Apollo.QueryHookOptions<GetSellerWeeklyStatsQuery, GetSellerWeeklyStatsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSellerWeeklyStatsQuery, GetSellerWeeklyStatsQueryVariables>(GetSellerWeeklyStatsDocument, options);
}
export function useGetSellerWeeklyStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSellerWeeklyStatsQuery, GetSellerWeeklyStatsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSellerWeeklyStatsQuery, GetSellerWeeklyStatsQueryVariables>(GetSellerWeeklyStatsDocument, options);
}
export type GetSellerWeeklyStatsQueryHookResult = ReturnType<typeof useGetSellerWeeklyStatsQuery>;
export type GetSellerWeeklyStatsLazyQueryHookResult = ReturnType<typeof useGetSellerWeeklyStatsLazyQuery>;
export type GetSellerWeeklyStatsQueryResult = Apollo.QueryResult<GetSellerWeeklyStatsQuery, GetSellerWeeklyStatsQueryVariables>;
export const SissPickingStocksDocument = gql`
  query SissPickingStocks($filters: SissPickingStockFilters, $offset: Int, $limit: Int, $sort: String, $order: String) {
    sissPickingStocks(filters: $filters, offset: $offset, limit: $limit, sort: $sort, order: $order) {
      stocks {
        _id
        refNo
        source
        thumbnail
        make
        model
        year
        price
        link
        note
        carId
        ignore
        createdAt
        updatedAt
      }
      total
    }
  }
`;

/**
 * __useSissPickingStocksQuery__
 *
 * To run a query within a React component, call `useSissPickingStocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSissPickingStocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSissPickingStocksQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useSissPickingStocksQuery(baseOptions?: Apollo.QueryHookOptions<SissPickingStocksQuery, SissPickingStocksQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SissPickingStocksQuery, SissPickingStocksQueryVariables>(SissPickingStocksDocument, options);
}
export function useSissPickingStocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SissPickingStocksQuery, SissPickingStocksQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SissPickingStocksQuery, SissPickingStocksQueryVariables>(SissPickingStocksDocument, options);
}
export type SissPickingStocksQueryHookResult = ReturnType<typeof useSissPickingStocksQuery>;
export type SissPickingStocksLazyQueryHookResult = ReturnType<typeof useSissPickingStocksLazyQuery>;
export type SissPickingStocksQueryResult = Apollo.QueryResult<SissPickingStocksQuery, SissPickingStocksQueryVariables>;
export const UpdateSissPickingStockDocument = gql`
  mutation UpdateSissPickingStock($id: ID!, $input: SissPickingStockUpdateInput!) {
    updateSissPickingStock(id: $id, input: $input) {
      _id
      refNo
      source
      thumbnail
      make
      model
      year
      price
      link
      note
      carId
      ignore
      updatedAt
    }
  }
`;
export type UpdateSissPickingStockMutationFn = Apollo.MutationFunction<UpdateSissPickingStockMutation, UpdateSissPickingStockMutationVariables>;

/**
 * __useUpdateSissPickingStockMutation__
 *
 * To run a mutation, you first call `useUpdateSissPickingStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSissPickingStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSissPickingStockMutation, { data, loading, error }] = useUpdateSissPickingStockMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSissPickingStockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSissPickingStockMutation, UpdateSissPickingStockMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateSissPickingStockMutation, UpdateSissPickingStockMutationVariables>(UpdateSissPickingStockDocument, options);
}
export type UpdateSissPickingStockMutationHookResult = ReturnType<typeof useUpdateSissPickingStockMutation>;
export type UpdateSissPickingStockMutationResult = Apollo.MutationResult<UpdateSissPickingStockMutation>;
export type UpdateSissPickingStockMutationOptions = Apollo.BaseMutationOptions<UpdateSissPickingStockMutation, UpdateSissPickingStockMutationVariables>;
export const SissPickingStockAggsDocument = gql`
  query SissPickingStockAggs($make: String) {
    sissPickingStockAggs(make: $make) {
      makes
      models
    }
  }
`;

/**
 * __useSissPickingStockAggsQuery__
 *
 * To run a query within a React component, call `useSissPickingStockAggsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSissPickingStockAggsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSissPickingStockAggsQuery({
 *   variables: {
 *      make: // value for 'make'
 *   },
 * });
 */
export function useSissPickingStockAggsQuery(baseOptions?: Apollo.QueryHookOptions<SissPickingStockAggsQuery, SissPickingStockAggsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<SissPickingStockAggsQuery, SissPickingStockAggsQueryVariables>(SissPickingStockAggsDocument, options);
}
export function useSissPickingStockAggsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SissPickingStockAggsQuery, SissPickingStockAggsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<SissPickingStockAggsQuery, SissPickingStockAggsQueryVariables>(SissPickingStockAggsDocument, options);
}
export type SissPickingStockAggsQueryHookResult = ReturnType<typeof useSissPickingStockAggsQuery>;
export type SissPickingStockAggsLazyQueryHookResult = ReturnType<typeof useSissPickingStockAggsLazyQuery>;
export type SissPickingStockAggsQueryResult = Apollo.QueryResult<SissPickingStockAggsQuery, SissPickingStockAggsQueryVariables>;
export const GetSaleTagsAdminDocument = gql`
  query GetSaleTagsAdmin($filters: JSON, $offset: Int, $limit: Int, $sort: String, $order: String) {
    getSaleTagsAdmin(filters: $filters, offset: $offset, limit: $limit, sort: $sort, order: $order) {
      tags {
        id
        name
        key
        countries
        coupon {
          id
          code
        }
        description
        introduction
        modifiedAt
        showOnAdvanced
        countdown
        keepUnmatchedCars
        showOnView
        createdAt
        published
        images {
          id
          filename
          cdnUri
          order
          mime
        }
        carConfigs {
          title
          models {
            id
            name
          }
          make {
            id
          }
          model {
            id
          }
          companies {
            id
          }
          minMileage
          maxMileage
          keywords
          minYear
          maxYear
          minPrice
          maxPrice
          minDisplacement
          maxDisplacement
          bodyTypes
          exteriorColors
          driveTypes
          transmissions
        }
      }
      total
    }
  }
`;

/**
 * __useGetSaleTagsAdminQuery__
 *
 * To run a query within a React component, call `useGetSaleTagsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSaleTagsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSaleTagsAdminQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetSaleTagsAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetSaleTagsAdminQuery, GetSaleTagsAdminQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSaleTagsAdminQuery, GetSaleTagsAdminQueryVariables>(GetSaleTagsAdminDocument, options);
}
export function useGetSaleTagsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSaleTagsAdminQuery, GetSaleTagsAdminQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSaleTagsAdminQuery, GetSaleTagsAdminQueryVariables>(GetSaleTagsAdminDocument, options);
}
export type GetSaleTagsAdminQueryHookResult = ReturnType<typeof useGetSaleTagsAdminQuery>;
export type GetSaleTagsAdminLazyQueryHookResult = ReturnType<typeof useGetSaleTagsAdminLazyQuery>;
export type GetSaleTagsAdminQueryResult = Apollo.QueryResult<GetSaleTagsAdminQuery, GetSaleTagsAdminQueryVariables>;
export const UpsertTagDocument = gql`
  mutation UpsertTag($id: ID, $options: UpsertSaleTagInput) {
    upsertTag(id: $id, options: $options) {
      id
      name
      key
      countries
      coupon {
        id
        code
      }
      description
      introduction
      modifiedAt
      showOnAdvanced
      countdown
      keepUnmatchedCars
      showOnView
      createdAt
      published
      images {
        id
        filename
        cdnUri
        order
        mime
      }
      carConfigs {
        title
        models {
          id
          name
        }
        make {
          id
        }
        model {
          id
        }
        companies {
          id
        }
        minMileage
        maxMileage
        keywords
        minYear
        maxYear
        minPrice
        maxPrice
        minDisplacement
        maxDisplacement
        bodyTypes
        exteriorColors
        driveTypes
        transmissions
      }
    }
  }
`;
export type UpsertTagMutationFn = Apollo.MutationFunction<UpsertTagMutation, UpsertTagMutationVariables>;

/**
 * __useUpsertTagMutation__
 *
 * To run a mutation, you first call `useUpsertTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTagMutation, { data, loading, error }] = useUpsertTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useUpsertTagMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTagMutation, UpsertTagMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertTagMutation, UpsertTagMutationVariables>(UpsertTagDocument, options);
}
export type UpsertTagMutationHookResult = ReturnType<typeof useUpsertTagMutation>;
export type UpsertTagMutationResult = Apollo.MutationResult<UpsertTagMutation>;
export type UpsertTagMutationOptions = Apollo.BaseMutationOptions<UpsertTagMutation, UpsertTagMutationVariables>;
export const DeleteTagDocument = gql`
  mutation DeleteTag($id: ID!) {
    deleteTag(id: $id) {
      id
      key
    }
  }
`;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
}
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const AddCarTagByIdsDocument = gql`
  mutation AddCarTagByIds($ids: String!, $key: String!) {
    addCarTagByIds(ids: $ids, key: $key)
  }
`;
export type AddCarTagByIdsMutationFn = Apollo.MutationFunction<AddCarTagByIdsMutation, AddCarTagByIdsMutationVariables>;

/**
 * __useAddCarTagByIdsMutation__
 *
 * To run a mutation, you first call `useAddCarTagByIdsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCarTagByIdsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCarTagByIdsMutation, { data, loading, error }] = useAddCarTagByIdsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      key: // value for 'key'
 *   },
 * });
 */
export function useAddCarTagByIdsMutation(baseOptions?: Apollo.MutationHookOptions<AddCarTagByIdsMutation, AddCarTagByIdsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AddCarTagByIdsMutation, AddCarTagByIdsMutationVariables>(AddCarTagByIdsDocument, options);
}
export type AddCarTagByIdsMutationHookResult = ReturnType<typeof useAddCarTagByIdsMutation>;
export type AddCarTagByIdsMutationResult = Apollo.MutationResult<AddCarTagByIdsMutation>;
export type AddCarTagByIdsMutationOptions = Apollo.BaseMutationOptions<AddCarTagByIdsMutation, AddCarTagByIdsMutationVariables>;
export const GetSatisfactionsDocument = gql`
  query GetSatisfactions($params: GetSatisfactionsAdminInput, $offset: Int, $limit: Int) {
    getSatisfactions(params: $params, offset: $offset, limit: $limit) {
      satisfactions {
        ...TestimonialFields
      }
      total
    }
  }
  ${TestimonialFieldsFragmentDoc}
`;

/**
 * __useGetSatisfactionsQuery__
 *
 * To run a query within a React component, call `useGetSatisfactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSatisfactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSatisfactionsQuery({
 *   variables: {
 *      params: // value for 'params'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetSatisfactionsQuery(baseOptions?: Apollo.QueryHookOptions<GetSatisfactionsQuery, GetSatisfactionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSatisfactionsQuery, GetSatisfactionsQueryVariables>(GetSatisfactionsDocument, options);
}
export function useGetSatisfactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSatisfactionsQuery, GetSatisfactionsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSatisfactionsQuery, GetSatisfactionsQueryVariables>(GetSatisfactionsDocument, options);
}
export type GetSatisfactionsQueryHookResult = ReturnType<typeof useGetSatisfactionsQuery>;
export type GetSatisfactionsLazyQueryHookResult = ReturnType<typeof useGetSatisfactionsLazyQuery>;
export type GetSatisfactionsQueryResult = Apollo.QueryResult<GetSatisfactionsQuery, GetSatisfactionsQueryVariables>;
export const ReplyTestimonialDocument = gql`
  mutation ReplyTestimonial($id: ID!, $option: String) {
    replyTestimonial(id: $id, option: $option) {
      _id
      reply {
        comment
        createdAt
      }
    }
  }
`;
export type ReplyTestimonialMutationFn = Apollo.MutationFunction<ReplyTestimonialMutation, ReplyTestimonialMutationVariables>;

/**
 * __useReplyTestimonialMutation__
 *
 * To run a mutation, you first call `useReplyTestimonialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplyTestimonialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replyTestimonialMutation, { data, loading, error }] = useReplyTestimonialMutation({
 *   variables: {
 *      id: // value for 'id'
 *      option: // value for 'option'
 *   },
 * });
 */
export function useReplyTestimonialMutation(baseOptions?: Apollo.MutationHookOptions<ReplyTestimonialMutation, ReplyTestimonialMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReplyTestimonialMutation, ReplyTestimonialMutationVariables>(ReplyTestimonialDocument, options);
}
export type ReplyTestimonialMutationHookResult = ReturnType<typeof useReplyTestimonialMutation>;
export type ReplyTestimonialMutationResult = Apollo.MutationResult<ReplyTestimonialMutation>;
export type ReplyTestimonialMutationOptions = Apollo.BaseMutationOptions<ReplyTestimonialMutation, ReplyTestimonialMutationVariables>;
export const ModifyFeedbackDocument = gql`
  mutation ModifyFeedback($id: ID!, $option: String) {
    modifyFeedback(id: $id, option: $option) {
      _id
      comment
      feedback {
        comment
      }
    }
  }
`;
export type ModifyFeedbackMutationFn = Apollo.MutationFunction<ModifyFeedbackMutation, ModifyFeedbackMutationVariables>;

/**
 * __useModifyFeedbackMutation__
 *
 * To run a mutation, you first call `useModifyFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyFeedbackMutation, { data, loading, error }] = useModifyFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *      option: // value for 'option'
 *   },
 * });
 */
export function useModifyFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<ModifyFeedbackMutation, ModifyFeedbackMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ModifyFeedbackMutation, ModifyFeedbackMutationVariables>(ModifyFeedbackDocument, options);
}
export type ModifyFeedbackMutationHookResult = ReturnType<typeof useModifyFeedbackMutation>;
export type ModifyFeedbackMutationResult = Apollo.MutationResult<ModifyFeedbackMutation>;
export type ModifyFeedbackMutationOptions = Apollo.BaseMutationOptions<ModifyFeedbackMutation, ModifyFeedbackMutationVariables>;
export const PublishTestimonialDocument = gql`
  mutation PublishTestimonial($id: ID!, $option: Boolean!) {
    publishTestimonial(id: $id, option: $option) {
      _id
      published
    }
  }
`;
export type PublishTestimonialMutationFn = Apollo.MutationFunction<PublishTestimonialMutation, PublishTestimonialMutationVariables>;

/**
 * __usePublishTestimonialMutation__
 *
 * To run a mutation, you first call `usePublishTestimonialMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishTestimonialMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishTestimonialMutation, { data, loading, error }] = usePublishTestimonialMutation({
 *   variables: {
 *      id: // value for 'id'
 *      option: // value for 'option'
 *   },
 * });
 */
export function usePublishTestimonialMutation(baseOptions?: Apollo.MutationHookOptions<PublishTestimonialMutation, PublishTestimonialMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PublishTestimonialMutation, PublishTestimonialMutationVariables>(PublishTestimonialDocument, options);
}
export type PublishTestimonialMutationHookResult = ReturnType<typeof usePublishTestimonialMutation>;
export type PublishTestimonialMutationResult = Apollo.MutationResult<PublishTestimonialMutation>;
export type PublishTestimonialMutationOptions = Apollo.BaseMutationOptions<PublishTestimonialMutation, PublishTestimonialMutationVariables>;
export const UploadTestimonialImageDocument = gql`
  mutation UploadTestimonialImage($id: ID!, $fileKeys: [String!]!) {
    uploadTestimonialImage(id: $id, fileKeys: $fileKeys) {
      _id
      filename
      cdnUri
      mime
      checksum
      rejected
    }
  }
`;
export type UploadTestimonialImageMutationFn = Apollo.MutationFunction<UploadTestimonialImageMutation, UploadTestimonialImageMutationVariables>;

/**
 * __useUploadTestimonialImageMutation__
 *
 * To run a mutation, you first call `useUploadTestimonialImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadTestimonialImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadTestimonialImageMutation, { data, loading, error }] = useUploadTestimonialImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fileKeys: // value for 'fileKeys'
 *   },
 * });
 */
export function useUploadTestimonialImageMutation(baseOptions?: Apollo.MutationHookOptions<UploadTestimonialImageMutation, UploadTestimonialImageMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadTestimonialImageMutation, UploadTestimonialImageMutationVariables>(UploadTestimonialImageDocument, options);
}
export type UploadTestimonialImageMutationHookResult = ReturnType<typeof useUploadTestimonialImageMutation>;
export type UploadTestimonialImageMutationResult = Apollo.MutationResult<UploadTestimonialImageMutation>;
export type UploadTestimonialImageMutationOptions = Apollo.BaseMutationOptions<UploadTestimonialImageMutation, UploadTestimonialImageMutationVariables>;
export const UploadTestimonialVideoDocument = gql`
  mutation UploadTestimonialVideo($id: ID!, $fileKey: String!) {
    uploadTestimonialVideo(id: $id, fileKey: $fileKey) {
      _id
      filename
      cdnUri
      mime
      checksum
    }
  }
`;
export type UploadTestimonialVideoMutationFn = Apollo.MutationFunction<UploadTestimonialVideoMutation, UploadTestimonialVideoMutationVariables>;

/**
 * __useUploadTestimonialVideoMutation__
 *
 * To run a mutation, you first call `useUploadTestimonialVideoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadTestimonialVideoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadTestimonialVideoMutation, { data, loading, error }] = useUploadTestimonialVideoMutation({
 *   variables: {
 *      id: // value for 'id'
 *      fileKey: // value for 'fileKey'
 *   },
 * });
 */
export function useUploadTestimonialVideoMutation(baseOptions?: Apollo.MutationHookOptions<UploadTestimonialVideoMutation, UploadTestimonialVideoMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UploadTestimonialVideoMutation, UploadTestimonialVideoMutationVariables>(UploadTestimonialVideoDocument, options);
}
export type UploadTestimonialVideoMutationHookResult = ReturnType<typeof useUploadTestimonialVideoMutation>;
export type UploadTestimonialVideoMutationResult = Apollo.MutationResult<UploadTestimonialVideoMutation>;
export type UploadTestimonialVideoMutationOptions = Apollo.BaseMutationOptions<UploadTestimonialVideoMutation, UploadTestimonialVideoMutationVariables>;
export const RemoveTestimonialImagesDocument = gql`
  mutation RemoveTestimonialImages($id: ID!, $idsImage: [ID!]!) {
    removeTestimonialImages(id: $id, idsImage: $idsImage) {
      _id
      images {
        _id
        filename
        cdnUri
        mime
        checksum
        rejected
      }
    }
  }
`;
export type RemoveTestimonialImagesMutationFn = Apollo.MutationFunction<RemoveTestimonialImagesMutation, RemoveTestimonialImagesMutationVariables>;

/**
 * __useRemoveTestimonialImagesMutation__
 *
 * To run a mutation, you first call `useRemoveTestimonialImagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTestimonialImagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTestimonialImagesMutation, { data, loading, error }] = useRemoveTestimonialImagesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      idsImage: // value for 'idsImage'
 *   },
 * });
 */
export function useRemoveTestimonialImagesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTestimonialImagesMutation, RemoveTestimonialImagesMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveTestimonialImagesMutation, RemoveTestimonialImagesMutationVariables>(RemoveTestimonialImagesDocument, options);
}
export type RemoveTestimonialImagesMutationHookResult = ReturnType<typeof useRemoveTestimonialImagesMutation>;
export type RemoveTestimonialImagesMutationResult = Apollo.MutationResult<RemoveTestimonialImagesMutation>;
export type RemoveTestimonialImagesMutationOptions = Apollo.BaseMutationOptions<RemoveTestimonialImagesMutation, RemoveTestimonialImagesMutationVariables>;
export const RemoveTestimonialVideosDocument = gql`
  mutation RemoveTestimonialVideos($id: ID!, $idsVideo: [ID!]!) {
    removeTestimonialVideos(id: $id, idsVideo: $idsVideo) {
      _id
      videos {
        _id
        filename
        cdnUri
        mime
        checksum
      }
    }
  }
`;
export type RemoveTestimonialVideosMutationFn = Apollo.MutationFunction<RemoveTestimonialVideosMutation, RemoveTestimonialVideosMutationVariables>;

/**
 * __useRemoveTestimonialVideosMutation__
 *
 * To run a mutation, you first call `useRemoveTestimonialVideosMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTestimonialVideosMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTestimonialVideosMutation, { data, loading, error }] = useRemoveTestimonialVideosMutation({
 *   variables: {
 *      id: // value for 'id'
 *      idsVideo: // value for 'idsVideo'
 *   },
 * });
 */
export function useRemoveTestimonialVideosMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTestimonialVideosMutation, RemoveTestimonialVideosMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RemoveTestimonialVideosMutation, RemoveTestimonialVideosMutationVariables>(RemoveTestimonialVideosDocument, options);
}
export type RemoveTestimonialVideosMutationHookResult = ReturnType<typeof useRemoveTestimonialVideosMutation>;
export type RemoveTestimonialVideosMutationResult = Apollo.MutationResult<RemoveTestimonialVideosMutation>;
export type RemoveTestimonialVideosMutationOptions = Apollo.BaseMutationOptions<RemoveTestimonialVideosMutation, RemoveTestimonialVideosMutationVariables>;
export const UpdateForBuyerDocument = gql`
  mutation UpdateForBuyer($id: ID!, $option: UpdateForBuyerInput!) {
    updateForBuyer(id: $id, option: $option) {
      _id
      state
      score
      created_at
      updated_at
      feedback {
        cost
        delivery
        communicationSpeed
        communicationQuality
        likelyToRecommend
        likeCFJ
      }
    }
  }
`;
export type UpdateForBuyerMutationFn = Apollo.MutationFunction<UpdateForBuyerMutation, UpdateForBuyerMutationVariables>;

/**
 * __useUpdateForBuyerMutation__
 *
 * To run a mutation, you first call `useUpdateForBuyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateForBuyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateForBuyerMutation, { data, loading, error }] = useUpdateForBuyerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      option: // value for 'option'
 *   },
 * });
 */
export function useUpdateForBuyerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateForBuyerMutation, UpdateForBuyerMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateForBuyerMutation, UpdateForBuyerMutationVariables>(UpdateForBuyerDocument, options);
}
export type UpdateForBuyerMutationHookResult = ReturnType<typeof useUpdateForBuyerMutation>;
export type UpdateForBuyerMutationResult = Apollo.MutationResult<UpdateForBuyerMutation>;
export type UpdateForBuyerMutationOptions = Apollo.BaseMutationOptions<UpdateForBuyerMutation, UpdateForBuyerMutationVariables>;
export const TicketCanaryPercentDocument = gql`
  query ticketCanaryPercent {
    ticketCanaryPercent {
      quality {
        ...TicketCanaryBucketFields
      }
      nonQuality {
        ...TicketCanaryBucketFields
      }
    }
  }
  ${TicketCanaryBucketFieldsFragmentDoc}
`;

/**
 * __useTicketCanaryPercentQuery__
 *
 * To run a query within a React component, call `useTicketCanaryPercentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketCanaryPercentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketCanaryPercentQuery({
 *   variables: {
 *   },
 * });
 */
export function useTicketCanaryPercentQuery(baseOptions?: Apollo.QueryHookOptions<TicketCanaryPercentQuery, TicketCanaryPercentQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TicketCanaryPercentQuery, TicketCanaryPercentQueryVariables>(TicketCanaryPercentDocument, options);
}
export function useTicketCanaryPercentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketCanaryPercentQuery, TicketCanaryPercentQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TicketCanaryPercentQuery, TicketCanaryPercentQueryVariables>(TicketCanaryPercentDocument, options);
}
export type TicketCanaryPercentQueryHookResult = ReturnType<typeof useTicketCanaryPercentQuery>;
export type TicketCanaryPercentLazyQueryHookResult = ReturnType<typeof useTicketCanaryPercentLazyQuery>;
export type TicketCanaryPercentQueryResult = Apollo.QueryResult<TicketCanaryPercentQuery, TicketCanaryPercentQueryVariables>;
export const SetTicketCanaryPercentDocument = gql`
  mutation setTicketCanaryPercent($quality: Int, $nonQuality: Int) {
    setTicketCanaryPercent(quality: $quality, nonQuality: $nonQuality) {
      quality {
        ...TicketCanaryBucketFields
      }
      nonQuality {
        ...TicketCanaryBucketFields
      }
    }
  }
  ${TicketCanaryBucketFieldsFragmentDoc}
`;
export type SetTicketCanaryPercentMutationFn = Apollo.MutationFunction<SetTicketCanaryPercentMutation, SetTicketCanaryPercentMutationVariables>;

/**
 * __useSetTicketCanaryPercentMutation__
 *
 * To run a mutation, you first call `useSetTicketCanaryPercentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTicketCanaryPercentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTicketCanaryPercentMutation, { data, loading, error }] = useSetTicketCanaryPercentMutation({
 *   variables: {
 *      quality: // value for 'quality'
 *      nonQuality: // value for 'nonQuality'
 *   },
 * });
 */
export function useSetTicketCanaryPercentMutation(baseOptions?: Apollo.MutationHookOptions<SetTicketCanaryPercentMutation, SetTicketCanaryPercentMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetTicketCanaryPercentMutation, SetTicketCanaryPercentMutationVariables>(SetTicketCanaryPercentDocument, options);
}
export type SetTicketCanaryPercentMutationHookResult = ReturnType<typeof useSetTicketCanaryPercentMutation>;
export type SetTicketCanaryPercentMutationResult = Apollo.MutationResult<SetTicketCanaryPercentMutation>;
export type SetTicketCanaryPercentMutationOptions = Apollo.BaseMutationOptions<SetTicketCanaryPercentMutation, SetTicketCanaryPercentMutationVariables>;
export const GmailInboundStatusDocument = gql`
  query gmailInboundStatus {
    gmailInboundStatus {
      ...GmailInboundStatusFields
    }
  }
  ${GmailInboundStatusFieldsFragmentDoc}
`;

/**
 * __useGmailInboundStatusQuery__
 *
 * To run a query within a React component, call `useGmailInboundStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGmailInboundStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGmailInboundStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGmailInboundStatusQuery(baseOptions?: Apollo.QueryHookOptions<GmailInboundStatusQuery, GmailInboundStatusQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GmailInboundStatusQuery, GmailInboundStatusQueryVariables>(GmailInboundStatusDocument, options);
}
export function useGmailInboundStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GmailInboundStatusQuery, GmailInboundStatusQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GmailInboundStatusQuery, GmailInboundStatusQueryVariables>(GmailInboundStatusDocument, options);
}
export type GmailInboundStatusQueryHookResult = ReturnType<typeof useGmailInboundStatusQuery>;
export type GmailInboundStatusLazyQueryHookResult = ReturnType<typeof useGmailInboundStatusLazyQuery>;
export type GmailInboundStatusQueryResult = Apollo.QueryResult<GmailInboundStatusQuery, GmailInboundStatusQueryVariables>;
export const ConnectGmailInboundDocument = gql`
  mutation connectGmailInbound($code: String!) {
    connectGmailInbound(code: $code) {
      ...GmailInboundStatusFields
    }
  }
  ${GmailInboundStatusFieldsFragmentDoc}
`;
export type ConnectGmailInboundMutationFn = Apollo.MutationFunction<ConnectGmailInboundMutation, ConnectGmailInboundMutationVariables>;

/**
 * __useConnectGmailInboundMutation__
 *
 * To run a mutation, you first call `useConnectGmailInboundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectGmailInboundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectGmailInboundMutation, { data, loading, error }] = useConnectGmailInboundMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConnectGmailInboundMutation(baseOptions?: Apollo.MutationHookOptions<ConnectGmailInboundMutation, ConnectGmailInboundMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ConnectGmailInboundMutation, ConnectGmailInboundMutationVariables>(ConnectGmailInboundDocument, options);
}
export type ConnectGmailInboundMutationHookResult = ReturnType<typeof useConnectGmailInboundMutation>;
export type ConnectGmailInboundMutationResult = Apollo.MutationResult<ConnectGmailInboundMutation>;
export type ConnectGmailInboundMutationOptions = Apollo.BaseMutationOptions<ConnectGmailInboundMutation, ConnectGmailInboundMutationVariables>;
export const DisconnectGmailInboundDocument = gql`
  mutation disconnectGmailInbound {
    disconnectGmailInbound {
      ...GmailInboundStatusFields
    }
  }
  ${GmailInboundStatusFieldsFragmentDoc}
`;
export type DisconnectGmailInboundMutationFn = Apollo.MutationFunction<DisconnectGmailInboundMutation, DisconnectGmailInboundMutationVariables>;

/**
 * __useDisconnectGmailInboundMutation__
 *
 * To run a mutation, you first call `useDisconnectGmailInboundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectGmailInboundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectGmailInboundMutation, { data, loading, error }] = useDisconnectGmailInboundMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisconnectGmailInboundMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectGmailInboundMutation, DisconnectGmailInboundMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DisconnectGmailInboundMutation, DisconnectGmailInboundMutationVariables>(DisconnectGmailInboundDocument, options);
}
export type DisconnectGmailInboundMutationHookResult = ReturnType<typeof useDisconnectGmailInboundMutation>;
export type DisconnectGmailInboundMutationResult = Apollo.MutationResult<DisconnectGmailInboundMutation>;
export type DisconnectGmailInboundMutationOptions = Apollo.BaseMutationOptions<DisconnectGmailInboundMutation, DisconnectGmailInboundMutationVariables>;
export const TicketSplitDebugDocument = gql`
  query TicketSplitDebug($args: TicketSplitDebugArgs) {
    ticketSplitDebug(args: $args) {
      from
      to
      serverTimezone
      cfjAgentGroupId
      ratioCountries
      warnings
      buckets {
        scope
        country
        segment
        bandIndex
        bandMin
        bandMax
        ratioSum
        totalBuyersOpen
        denominatorUsed
        totalTicketsAll
        poolBuyersOpen
        wouldAssignTo
        warnings
        agents {
          email
          userId
          zendeskId
          name
          foundInUsers
          configuredRatio
          buyersOpen
          ticketsOpen
          buyersAll
          ticketsAll
          actualRatio
          actualRatioOps
          deltaVsConfigured
          accepted
          wouldBeAssigned
        }
        unmapped {
          assigneeId
          email
          buyersOpen
          ticketsOpen
          buyersAll
          ticketsAll
          reason
        }
      }
    }
  }
`;

/**
 * __useTicketSplitDebugQuery__
 *
 * To run a query within a React component, call `useTicketSplitDebugQuery` and pass it any options that fit your needs.
 * When your component renders, `useTicketSplitDebugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTicketSplitDebugQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useTicketSplitDebugQuery(baseOptions?: Apollo.QueryHookOptions<TicketSplitDebugQuery, TicketSplitDebugQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TicketSplitDebugQuery, TicketSplitDebugQueryVariables>(TicketSplitDebugDocument, options);
}
export function useTicketSplitDebugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TicketSplitDebugQuery, TicketSplitDebugQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TicketSplitDebugQuery, TicketSplitDebugQueryVariables>(TicketSplitDebugDocument, options);
}
export type TicketSplitDebugQueryHookResult = ReturnType<typeof useTicketSplitDebugQuery>;
export type TicketSplitDebugLazyQueryHookResult = ReturnType<typeof useTicketSplitDebugLazyQuery>;
export type TicketSplitDebugQueryResult = Apollo.QueryResult<TicketSplitDebugQuery, TicketSplitDebugQueryVariables>;
export const GetTicketsAdminDocument = gql`
  query GetTicketsAdmin($args: GetTicketsAdminArgs!) {
    getTicketsAdmin(args: $args) {
      tickets {
        id
        inquiryId
        ticketNo
        subject
        status
        assigneeId
        mergedIntoId
        assignee {
          id
          name
          email
          avatarUrl
        }
        requester {
          name
          email
          phone
        }
        createdAt
        updatedAt
      }
      total
    }
  }
`;

/**
 * __useGetTicketsAdminQuery__
 *
 * To run a query within a React component, call `useGetTicketsAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketsAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketsAdminQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetTicketsAdminQuery(baseOptions: Apollo.QueryHookOptions<GetTicketsAdminQuery, GetTicketsAdminQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTicketsAdminQuery, GetTicketsAdminQueryVariables>(GetTicketsAdminDocument, options);
}
export function useGetTicketsAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTicketsAdminQuery, GetTicketsAdminQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTicketsAdminQuery, GetTicketsAdminQueryVariables>(GetTicketsAdminDocument, options);
}
export type GetTicketsAdminQueryHookResult = ReturnType<typeof useGetTicketsAdminQuery>;
export type GetTicketsAdminLazyQueryHookResult = ReturnType<typeof useGetTicketsAdminLazyQuery>;
export type GetTicketsAdminQueryResult = Apollo.QueryResult<GetTicketsAdminQuery, GetTicketsAdminQueryVariables>;
export const GetTicketAdminDocument = gql`
  query GetTicketAdmin($id: String!) {
    getTicketAdmin(id: $id) {
      id
      inquiryId
      ticketNo
      subject
      status
      assigneeId
      mergedIntoId
      assignee {
        id
        name
        email
        avatarUrl
      }
      emailCcAddresses
      followerIds
      followers {
        id
        name
        email
        avatarUrl
      }
      requester {
        name
        email
        phone
      }
      createdAt
      updatedAt
    }
  }
`;

/**
 * __useGetTicketAdminQuery__
 *
 * To run a query within a React component, call `useGetTicketAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketAdminQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTicketAdminQuery(baseOptions: Apollo.QueryHookOptions<GetTicketAdminQuery, GetTicketAdminQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTicketAdminQuery, GetTicketAdminQueryVariables>(GetTicketAdminDocument, options);
}
export function useGetTicketAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTicketAdminQuery, GetTicketAdminQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTicketAdminQuery, GetTicketAdminQueryVariables>(GetTicketAdminDocument, options);
}
export type GetTicketAdminQueryHookResult = ReturnType<typeof useGetTicketAdminQuery>;
export type GetTicketAdminLazyQueryHookResult = ReturnType<typeof useGetTicketAdminLazyQuery>;
export type GetTicketAdminQueryResult = Apollo.QueryResult<GetTicketAdminQuery, GetTicketAdminQueryVariables>;
export const MergeTicketDocument = gql`
  mutation MergeTicket($id: String!, $targetTicketId: String!) {
    mergeTicket(id: $id, targetTicketId: $targetTicketId) {
      id
      inquiryId
      ticketNo
      subject
    }
  }
`;
export type MergeTicketMutationFn = Apollo.MutationFunction<MergeTicketMutation, MergeTicketMutationVariables>;

/**
 * __useMergeTicketMutation__
 *
 * To run a mutation, you first call `useMergeTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeTicketMutation, { data, loading, error }] = useMergeTicketMutation({
 *   variables: {
 *      id: // value for 'id'
 *      targetTicketId: // value for 'targetTicketId'
 *   },
 * });
 */
export function useMergeTicketMutation(baseOptions?: Apollo.MutationHookOptions<MergeTicketMutation, MergeTicketMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MergeTicketMutation, MergeTicketMutationVariables>(MergeTicketDocument, options);
}
export type MergeTicketMutationHookResult = ReturnType<typeof useMergeTicketMutation>;
export type MergeTicketMutationResult = Apollo.MutationResult<MergeTicketMutation>;
export type MergeTicketMutationOptions = Apollo.BaseMutationOptions<MergeTicketMutation, MergeTicketMutationVariables>;
export const AssignTicketDocument = gql`
  mutation AssignTicket($id: String!, $assigneeUserId: String) {
    assignTicket(id: $id, assigneeUserId: $assigneeUserId) {
      id
      assigneeId
      assignee {
        id
        name
        email
        avatarUrl
      }
    }
  }
`;
export type AssignTicketMutationFn = Apollo.MutationFunction<AssignTicketMutation, AssignTicketMutationVariables>;

/**
 * __useAssignTicketMutation__
 *
 * To run a mutation, you first call `useAssignTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTicketMutation, { data, loading, error }] = useAssignTicketMutation({
 *   variables: {
 *      id: // value for 'id'
 *      assigneeUserId: // value for 'assigneeUserId'
 *   },
 * });
 */
export function useAssignTicketMutation(baseOptions?: Apollo.MutationHookOptions<AssignTicketMutation, AssignTicketMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AssignTicketMutation, AssignTicketMutationVariables>(AssignTicketDocument, options);
}
export type AssignTicketMutationHookResult = ReturnType<typeof useAssignTicketMutation>;
export type AssignTicketMutationResult = Apollo.MutationResult<AssignTicketMutation>;
export type AssignTicketMutationOptions = Apollo.BaseMutationOptions<AssignTicketMutation, AssignTicketMutationVariables>;
export const SetTicketFollowersDocument = gql`
  mutation SetTicketFollowers($id: String!, $followerUserIds: [String!]!) {
    setTicketFollowers(id: $id, followerUserIds: $followerUserIds) {
      id
    }
  }
`;
export type SetTicketFollowersMutationFn = Apollo.MutationFunction<SetTicketFollowersMutation, SetTicketFollowersMutationVariables>;

/**
 * __useSetTicketFollowersMutation__
 *
 * To run a mutation, you first call `useSetTicketFollowersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTicketFollowersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTicketFollowersMutation, { data, loading, error }] = useSetTicketFollowersMutation({
 *   variables: {
 *      id: // value for 'id'
 *      followerUserIds: // value for 'followerUserIds'
 *   },
 * });
 */
export function useSetTicketFollowersMutation(baseOptions?: Apollo.MutationHookOptions<SetTicketFollowersMutation, SetTicketFollowersMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetTicketFollowersMutation, SetTicketFollowersMutationVariables>(SetTicketFollowersDocument, options);
}
export type SetTicketFollowersMutationHookResult = ReturnType<typeof useSetTicketFollowersMutation>;
export type SetTicketFollowersMutationResult = Apollo.MutationResult<SetTicketFollowersMutation>;
export type SetTicketFollowersMutationOptions = Apollo.BaseMutationOptions<SetTicketFollowersMutation, SetTicketFollowersMutationVariables>;
export const SetTicketEmailCcDocument = gql`
  mutation SetTicketEmailCc($id: String!, $emailCcAddresses: [String!]!) {
    setTicketEmailCc(id: $id, emailCcAddresses: $emailCcAddresses) {
      id
    }
  }
`;
export type SetTicketEmailCcMutationFn = Apollo.MutationFunction<SetTicketEmailCcMutation, SetTicketEmailCcMutationVariables>;

/**
 * __useSetTicketEmailCcMutation__
 *
 * To run a mutation, you first call `useSetTicketEmailCcMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTicketEmailCcMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTicketEmailCcMutation, { data, loading, error }] = useSetTicketEmailCcMutation({
 *   variables: {
 *      id: // value for 'id'
 *      emailCcAddresses: // value for 'emailCcAddresses'
 *   },
 * });
 */
export function useSetTicketEmailCcMutation(baseOptions?: Apollo.MutationHookOptions<SetTicketEmailCcMutation, SetTicketEmailCcMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetTicketEmailCcMutation, SetTicketEmailCcMutationVariables>(SetTicketEmailCcDocument, options);
}
export type SetTicketEmailCcMutationHookResult = ReturnType<typeof useSetTicketEmailCcMutation>;
export type SetTicketEmailCcMutationResult = Apollo.MutationResult<SetTicketEmailCcMutation>;
export type SetTicketEmailCcMutationOptions = Apollo.BaseMutationOptions<SetTicketEmailCcMutation, SetTicketEmailCcMutationVariables>;
export const GetTicketCommentsDocument = gql`
  query GetTicketComments($id: String!) {
    getTicketComments(id: $id) {
      _id
      body
      html_body
      public
      author {
        userId
        name
        avatarUrl
        type
      }
      attachments {
        file_name
        content_url
        content_type
      }
      created_at
    }
  }
`;

/**
 * __useGetTicketCommentsQuery__
 *
 * To run a query within a React component, call `useGetTicketCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTicketCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTicketCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTicketCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetTicketCommentsQuery, GetTicketCommentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTicketCommentsQuery, GetTicketCommentsQueryVariables>(GetTicketCommentsDocument, options);
}
export function useGetTicketCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTicketCommentsQuery, GetTicketCommentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTicketCommentsQuery, GetTicketCommentsQueryVariables>(GetTicketCommentsDocument, options);
}
export type GetTicketCommentsQueryHookResult = ReturnType<typeof useGetTicketCommentsQuery>;
export type GetTicketCommentsLazyQueryHookResult = ReturnType<typeof useGetTicketCommentsLazyQuery>;
export type GetTicketCommentsQueryResult = Apollo.QueryResult<GetTicketCommentsQuery, GetTicketCommentsQueryVariables>;
export const ReplyTicketCommentDocument = gql`
  mutation ReplyTicketComment($id: String!, $comment: String!, $isPublic: Boolean, $htmlBody: String) {
    replyTicketComment(id: $id, comment: $comment, isPublic: $isPublic, htmlBody: $htmlBody) {
      _id
      body
      html_body
      public
      author {
        userId
        name
        avatarUrl
        type
      }
      created_at
    }
  }
`;
export type ReplyTicketCommentMutationFn = Apollo.MutationFunction<ReplyTicketCommentMutation, ReplyTicketCommentMutationVariables>;

/**
 * __useReplyTicketCommentMutation__
 *
 * To run a mutation, you first call `useReplyTicketCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplyTicketCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replyTicketCommentMutation, { data, loading, error }] = useReplyTicketCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comment: // value for 'comment'
 *      isPublic: // value for 'isPublic'
 *      htmlBody: // value for 'htmlBody'
 *   },
 * });
 */
export function useReplyTicketCommentMutation(baseOptions?: Apollo.MutationHookOptions<ReplyTicketCommentMutation, ReplyTicketCommentMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ReplyTicketCommentMutation, ReplyTicketCommentMutationVariables>(ReplyTicketCommentDocument, options);
}
export type ReplyTicketCommentMutationHookResult = ReturnType<typeof useReplyTicketCommentMutation>;
export type ReplyTicketCommentMutationResult = Apollo.MutationResult<ReplyTicketCommentMutation>;
export type ReplyTicketCommentMutationOptions = Apollo.BaseMutationOptions<ReplyTicketCommentMutation, ReplyTicketCommentMutationVariables>;
export const CreateTicketAdminDocument = gql`
  mutation CreateTicketAdmin($input: CreateTicketAdminInput!) {
    createTicketAdmin(input: $input) {
      id
      ticketNo
      subject
      status
      inquiryId
    }
  }
`;
export type CreateTicketAdminMutationFn = Apollo.MutationFunction<CreateTicketAdminMutation, CreateTicketAdminMutationVariables>;

/**
 * __useCreateTicketAdminMutation__
 *
 * To run a mutation, you first call `useCreateTicketAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTicketAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTicketAdminMutation, { data, loading, error }] = useCreateTicketAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTicketAdminMutation(baseOptions?: Apollo.MutationHookOptions<CreateTicketAdminMutation, CreateTicketAdminMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateTicketAdminMutation, CreateTicketAdminMutationVariables>(CreateTicketAdminDocument, options);
}
export type CreateTicketAdminMutationHookResult = ReturnType<typeof useCreateTicketAdminMutation>;
export type CreateTicketAdminMutationResult = Apollo.MutationResult<CreateTicketAdminMutation>;
export type CreateTicketAdminMutationOptions = Apollo.BaseMutationOptions<CreateTicketAdminMutation, CreateTicketAdminMutationVariables>;
export const SetTicketRequesterDocument = gql`
  mutation SetTicketRequester($id: String!, $input: UpdateTicketRequesterInput!) {
    setTicketRequester(id: $id, input: $input) {
      id
      requester {
        name
        email
        phone
      }
    }
  }
`;
export type SetTicketRequesterMutationFn = Apollo.MutationFunction<SetTicketRequesterMutation, SetTicketRequesterMutationVariables>;

/**
 * __useSetTicketRequesterMutation__
 *
 * To run a mutation, you first call `useSetTicketRequesterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTicketRequesterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTicketRequesterMutation, { data, loading, error }] = useSetTicketRequesterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTicketRequesterMutation(baseOptions?: Apollo.MutationHookOptions<SetTicketRequesterMutation, SetTicketRequesterMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetTicketRequesterMutation, SetTicketRequesterMutationVariables>(SetTicketRequesterDocument, options);
}
export type SetTicketRequesterMutationHookResult = ReturnType<typeof useSetTicketRequesterMutation>;
export type SetTicketRequesterMutationResult = Apollo.MutationResult<SetTicketRequesterMutation>;
export type SetTicketRequesterMutationOptions = Apollo.BaseMutationOptions<SetTicketRequesterMutation, SetTicketRequesterMutationVariables>;
export const SetTicketStatusDocument = gql`
  mutation SetTicketStatus($id: String!, $status: String!) {
    setTicketStatus(id: $id, status: $status) {
      id
      status
    }
  }
`;
export type SetTicketStatusMutationFn = Apollo.MutationFunction<SetTicketStatusMutation, SetTicketStatusMutationVariables>;

/**
 * __useSetTicketStatusMutation__
 *
 * To run a mutation, you first call `useSetTicketStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTicketStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTicketStatusMutation, { data, loading, error }] = useSetTicketStatusMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useSetTicketStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetTicketStatusMutation, SetTicketStatusMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetTicketStatusMutation, SetTicketStatusMutationVariables>(SetTicketStatusDocument, options);
}
export type SetTicketStatusMutationHookResult = ReturnType<typeof useSetTicketStatusMutation>;
export type SetTicketStatusMutationResult = Apollo.MutationResult<SetTicketStatusMutation>;
export type SetTicketStatusMutationOptions = Apollo.BaseMutationOptions<SetTicketStatusMutation, SetTicketStatusMutationVariables>;
export const GetTransformationsDocument = gql`
  query GetTransformations($filters: GetTransformationsAdminInput, $offset: Int, $limit: Int, $sort: String, $order: String) {
    getTransformations(filters: $filters, offset: $offset, limit: $limit, sort: $sort, order: $order) {
      transformations {
        ...TransformationFields
      }
      total
    }
  }
  ${TransformationFieldsFragmentDoc}
`;

/**
 * __useGetTransformationsQuery__
 *
 * To run a query within a React component, call `useGetTransformationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransformationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransformationsQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetTransformationsQuery(baseOptions?: Apollo.QueryHookOptions<GetTransformationsQuery, GetTransformationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTransformationsQuery, GetTransformationsQueryVariables>(GetTransformationsDocument, options);
}
export function useGetTransformationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransformationsQuery, GetTransformationsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTransformationsQuery, GetTransformationsQueryVariables>(GetTransformationsDocument, options);
}
export type GetTransformationsQueryHookResult = ReturnType<typeof useGetTransformationsQuery>;
export type GetTransformationsLazyQueryHookResult = ReturnType<typeof useGetTransformationsLazyQuery>;
export type GetTransformationsQueryResult = Apollo.QueryResult<GetTransformationsQuery, GetTransformationsQueryVariables>;
export const UpsertTransformationDocument = gql`
  mutation UpsertTransformation($id: ID, $data: UpsertTransformationInput!) {
    upsertTransformation(id: $id, data: $data) {
      ...TransformationFields
    }
  }
  ${TransformationFieldsFragmentDoc}
`;
export type UpsertTransformationMutationFn = Apollo.MutationFunction<UpsertTransformationMutation, UpsertTransformationMutationVariables>;

/**
 * __useUpsertTransformationMutation__
 *
 * To run a mutation, you first call `useUpsertTransformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTransformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTransformationMutation, { data, loading, error }] = useUpsertTransformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertTransformationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTransformationMutation, UpsertTransformationMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertTransformationMutation, UpsertTransformationMutationVariables>(UpsertTransformationDocument, options);
}
export type UpsertTransformationMutationHookResult = ReturnType<typeof useUpsertTransformationMutation>;
export type UpsertTransformationMutationResult = Apollo.MutationResult<UpsertTransformationMutation>;
export type UpsertTransformationMutationOptions = Apollo.BaseMutationOptions<UpsertTransformationMutation, UpsertTransformationMutationVariables>;
export const BatchEditTransformationDocument = gql`
  mutation BatchEditTransformation($ids: [ID!]!, $data: BatchEditTransformationInput!) {
    batchEditTransformation(ids: $ids, data: $data)
  }
`;
export type BatchEditTransformationMutationFn = Apollo.MutationFunction<BatchEditTransformationMutation, BatchEditTransformationMutationVariables>;

/**
 * __useBatchEditTransformationMutation__
 *
 * To run a mutation, you first call `useBatchEditTransformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchEditTransformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchEditTransformationMutation, { data, loading, error }] = useBatchEditTransformationMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useBatchEditTransformationMutation(baseOptions?: Apollo.MutationHookOptions<BatchEditTransformationMutation, BatchEditTransformationMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<BatchEditTransformationMutation, BatchEditTransformationMutationVariables>(BatchEditTransformationDocument, options);
}
export type BatchEditTransformationMutationHookResult = ReturnType<typeof useBatchEditTransformationMutation>;
export type BatchEditTransformationMutationResult = Apollo.MutationResult<BatchEditTransformationMutation>;
export type BatchEditTransformationMutationOptions = Apollo.BaseMutationOptions<BatchEditTransformationMutation, BatchEditTransformationMutationVariables>;
export const DeleteTransformationDocument = gql`
  mutation DeleteTransformation($id: ID!) {
    deleteTransformation(id: $id)
  }
`;
export type DeleteTransformationMutationFn = Apollo.MutationFunction<DeleteTransformationMutation, DeleteTransformationMutationVariables>;

/**
 * __useDeleteTransformationMutation__
 *
 * To run a mutation, you first call `useDeleteTransformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTransformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTransformationMutation, { data, loading, error }] = useDeleteTransformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTransformationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTransformationMutation, DeleteTransformationMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteTransformationMutation, DeleteTransformationMutationVariables>(DeleteTransformationDocument, options);
}
export type DeleteTransformationMutationHookResult = ReturnType<typeof useDeleteTransformationMutation>;
export type DeleteTransformationMutationResult = Apollo.MutationResult<DeleteTransformationMutation>;
export type DeleteTransformationMutationOptions = Apollo.BaseMutationOptions<DeleteTransformationMutation, DeleteTransformationMutationVariables>;
export const GetTransformationMakesDocument = gql`
  query GetTransformationMakes($input: GetAllMakeArgs!) {
    getAllMake(input: $input) {
      id
      name
    }
  }
`;

/**
 * __useGetTransformationMakesQuery__
 *
 * To run a query within a React component, call `useGetTransformationMakesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransformationMakesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransformationMakesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetTransformationMakesQuery(baseOptions: Apollo.QueryHookOptions<GetTransformationMakesQuery, GetTransformationMakesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTransformationMakesQuery, GetTransformationMakesQueryVariables>(GetTransformationMakesDocument, options);
}
export function useGetTransformationMakesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransformationMakesQuery, GetTransformationMakesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTransformationMakesQuery, GetTransformationMakesQueryVariables>(GetTransformationMakesDocument, options);
}
export type GetTransformationMakesQueryHookResult = ReturnType<typeof useGetTransformationMakesQuery>;
export type GetTransformationMakesLazyQueryHookResult = ReturnType<typeof useGetTransformationMakesLazyQuery>;
export type GetTransformationMakesQueryResult = Apollo.QueryResult<GetTransformationMakesQuery, GetTransformationMakesQueryVariables>;
export const GetTransformationAccessoriesDocument = gql`
  query GetTransformationAccessories($root: Boolean, $keywords: String, $limit: Float) {
    getAdminAccessories(root: $root, keywords: $keywords, limit: $limit) {
      id
      name
    }
  }
`;

/**
 * __useGetTransformationAccessoriesQuery__
 *
 * To run a query within a React component, call `useGetTransformationAccessoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransformationAccessoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransformationAccessoriesQuery({
 *   variables: {
 *      root: // value for 'root'
 *      keywords: // value for 'keywords'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetTransformationAccessoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetTransformationAccessoriesQuery, GetTransformationAccessoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetTransformationAccessoriesQuery, GetTransformationAccessoriesQueryVariables>(GetTransformationAccessoriesDocument, options);
}
export function useGetTransformationAccessoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransformationAccessoriesQuery, GetTransformationAccessoriesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetTransformationAccessoriesQuery, GetTransformationAccessoriesQueryVariables>(GetTransformationAccessoriesDocument, options);
}
export type GetTransformationAccessoriesQueryHookResult = ReturnType<typeof useGetTransformationAccessoriesQuery>;
export type GetTransformationAccessoriesLazyQueryHookResult = ReturnType<typeof useGetTransformationAccessoriesLazyQuery>;
export type GetTransformationAccessoriesQueryResult = Apollo.QueryResult<GetTransformationAccessoriesQuery, GetTransformationAccessoriesQueryVariables>;
export const GetManagementUserDocument = gql`
  query GetManagementUser($filters: GetManagementUserInput, $offset: Int, $limit: Int, $sort: String, $order: String) {
    getManagementUser(filters: $filters, offset: $offset, limit: $limit, sort: $sort, order: $order) {
      users {
        ...AdminUserFields
      }
      total
    }
  }
  ${AdminUserFieldsFragmentDoc}
`;

/**
 * __useGetManagementUserQuery__
 *
 * To run a query within a React component, call `useGetManagementUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagementUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagementUserQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      sort: // value for 'sort'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetManagementUserQuery(baseOptions?: Apollo.QueryHookOptions<GetManagementUserQuery, GetManagementUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetManagementUserQuery, GetManagementUserQueryVariables>(GetManagementUserDocument, options);
}
export function useGetManagementUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagementUserQuery, GetManagementUserQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetManagementUserQuery, GetManagementUserQueryVariables>(GetManagementUserDocument, options);
}
export type GetManagementUserQueryHookResult = ReturnType<typeof useGetManagementUserQuery>;
export type GetManagementUserLazyQueryHookResult = ReturnType<typeof useGetManagementUserLazyQuery>;
export type GetManagementUserQueryResult = Apollo.QueryResult<GetManagementUserQuery, GetManagementUserQueryVariables>;
export const GetManagementUserByIdDocument = gql`
  query GetManagementUserById($id: ID!) {
    getManagementUserById(id: $id) {
      ...AdminUserDetailFields
    }
  }
  ${AdminUserDetailFieldsFragmentDoc}
`;

/**
 * __useGetManagementUserByIdQuery__
 *
 * To run a query within a React component, call `useGetManagementUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManagementUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManagementUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetManagementUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetManagementUserByIdQuery, GetManagementUserByIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetManagementUserByIdQuery, GetManagementUserByIdQueryVariables>(GetManagementUserByIdDocument, options);
}
export function useGetManagementUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetManagementUserByIdQuery, GetManagementUserByIdQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetManagementUserByIdQuery, GetManagementUserByIdQueryVariables>(GetManagementUserByIdDocument, options);
}
export type GetManagementUserByIdQueryHookResult = ReturnType<typeof useGetManagementUserByIdQuery>;
export type GetManagementUserByIdLazyQueryHookResult = ReturnType<typeof useGetManagementUserByIdLazyQuery>;
export type GetManagementUserByIdQueryResult = Apollo.QueryResult<GetManagementUserByIdQuery, GetManagementUserByIdQueryVariables>;
export const UpsertUserDocument = gql`
  mutation UpsertUser($id: ID, $data: UserInputDto!) {
    upsertUser(id: $id, data: $data) {
      ...AdminUserDetailFields
    }
  }
  ${AdminUserDetailFieldsFragmentDoc}
`;
export type UpsertUserMutationFn = Apollo.MutationFunction<UpsertUserMutation, UpsertUserMutationVariables>;

/**
 * __useUpsertUserMutation__
 *
 * To run a mutation, you first call `useUpsertUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserMutation, { data, loading, error }] = useUpsertUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpsertUserMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserMutation, UpsertUserMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpsertUserMutation, UpsertUserMutationVariables>(UpsertUserDocument, options);
}
export type UpsertUserMutationHookResult = ReturnType<typeof useUpsertUserMutation>;
export type UpsertUserMutationResult = Apollo.MutationResult<UpsertUserMutation>;
export type UpsertUserMutationOptions = Apollo.BaseMutationOptions<UpsertUserMutation, UpsertUserMutationVariables>;
export const CreateImpersonationTicketDocument = gql`
  mutation CreateImpersonationTicket($email: String!) {
    createImpersonationTicket(email: $email) {
      token
      expiresAt
      accessToken
    }
  }
`;
export type CreateImpersonationTicketMutationFn = Apollo.MutationFunction<CreateImpersonationTicketMutation, CreateImpersonationTicketMutationVariables>;

/**
 * __useCreateImpersonationTicketMutation__
 *
 * To run a mutation, you first call `useCreateImpersonationTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateImpersonationTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createImpersonationTicketMutation, { data, loading, error }] = useCreateImpersonationTicketMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCreateImpersonationTicketMutation(baseOptions?: Apollo.MutationHookOptions<CreateImpersonationTicketMutation, CreateImpersonationTicketMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateImpersonationTicketMutation, CreateImpersonationTicketMutationVariables>(CreateImpersonationTicketDocument, options);
}
export type CreateImpersonationTicketMutationHookResult = ReturnType<typeof useCreateImpersonationTicketMutation>;
export type CreateImpersonationTicketMutationResult = Apollo.MutationResult<CreateImpersonationTicketMutation>;
export type CreateImpersonationTicketMutationOptions = Apollo.BaseMutationOptions<CreateImpersonationTicketMutation, CreateImpersonationTicketMutationVariables>;
export const GetZendeskSyncJobDocument = gql`
  query getZendeskSyncJob {
    getZendeskSyncJob {
      ...ZendeskSyncJobFields
    }
  }
  ${ZendeskSyncJobFieldsFragmentDoc}
`;

/**
 * __useGetZendeskSyncJobQuery__
 *
 * To run a query within a React component, call `useGetZendeskSyncJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZendeskSyncJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZendeskSyncJobQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetZendeskSyncJobQuery(baseOptions?: Apollo.QueryHookOptions<GetZendeskSyncJobQuery, GetZendeskSyncJobQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetZendeskSyncJobQuery, GetZendeskSyncJobQueryVariables>(GetZendeskSyncJobDocument, options);
}
export function useGetZendeskSyncJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZendeskSyncJobQuery, GetZendeskSyncJobQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetZendeskSyncJobQuery, GetZendeskSyncJobQueryVariables>(GetZendeskSyncJobDocument, options);
}
export type GetZendeskSyncJobQueryHookResult = ReturnType<typeof useGetZendeskSyncJobQuery>;
export type GetZendeskSyncJobLazyQueryHookResult = ReturnType<typeof useGetZendeskSyncJobLazyQuery>;
export type GetZendeskSyncJobQueryResult = Apollo.QueryResult<GetZendeskSyncJobQuery, GetZendeskSyncJobQueryVariables>;
export const GetZendeskSyncFailuresDocument = gql`
  query getZendeskSyncFailures {
    getZendeskSyncFailures {
      ticketId
      zendeskTicketId
      error
      at
    }
  }
`;

/**
 * __useGetZendeskSyncFailuresQuery__
 *
 * To run a query within a React component, call `useGetZendeskSyncFailuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZendeskSyncFailuresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZendeskSyncFailuresQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetZendeskSyncFailuresQuery(baseOptions?: Apollo.QueryHookOptions<GetZendeskSyncFailuresQuery, GetZendeskSyncFailuresQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetZendeskSyncFailuresQuery, GetZendeskSyncFailuresQueryVariables>(GetZendeskSyncFailuresDocument, options);
}
export function useGetZendeskSyncFailuresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZendeskSyncFailuresQuery, GetZendeskSyncFailuresQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetZendeskSyncFailuresQuery, GetZendeskSyncFailuresQueryVariables>(GetZendeskSyncFailuresDocument, options);
}
export type GetZendeskSyncFailuresQueryHookResult = ReturnType<typeof useGetZendeskSyncFailuresQuery>;
export type GetZendeskSyncFailuresLazyQueryHookResult = ReturnType<typeof useGetZendeskSyncFailuresLazyQuery>;
export type GetZendeskSyncFailuresQueryResult = Apollo.QueryResult<GetZendeskSyncFailuresQuery, GetZendeskSyncFailuresQueryVariables>;
export const TriggerZendeskSyncBatchDocument = gql`
  mutation triggerZendeskSyncBatch($input: TriggerZendeskSyncBatchInput) {
    triggerZendeskSyncBatch(input: $input) {
      ...ZendeskSyncJobFields
    }
  }
  ${ZendeskSyncJobFieldsFragmentDoc}
`;
export type TriggerZendeskSyncBatchMutationFn = Apollo.MutationFunction<TriggerZendeskSyncBatchMutation, TriggerZendeskSyncBatchMutationVariables>;

/**
 * __useTriggerZendeskSyncBatchMutation__
 *
 * To run a mutation, you first call `useTriggerZendeskSyncBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriggerZendeskSyncBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triggerZendeskSyncBatchMutation, { data, loading, error }] = useTriggerZendeskSyncBatchMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriggerZendeskSyncBatchMutation(baseOptions?: Apollo.MutationHookOptions<TriggerZendeskSyncBatchMutation, TriggerZendeskSyncBatchMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TriggerZendeskSyncBatchMutation, TriggerZendeskSyncBatchMutationVariables>(TriggerZendeskSyncBatchDocument, options);
}
export type TriggerZendeskSyncBatchMutationHookResult = ReturnType<typeof useTriggerZendeskSyncBatchMutation>;
export type TriggerZendeskSyncBatchMutationResult = Apollo.MutationResult<TriggerZendeskSyncBatchMutation>;
export type TriggerZendeskSyncBatchMutationOptions = Apollo.BaseMutationOptions<TriggerZendeskSyncBatchMutation, TriggerZendeskSyncBatchMutationVariables>;
export const StopZendeskSyncJobDocument = gql`
  mutation stopZendeskSyncJob {
    stopZendeskSyncJob {
      ...ZendeskSyncJobFields
    }
  }
  ${ZendeskSyncJobFieldsFragmentDoc}
`;
export type StopZendeskSyncJobMutationFn = Apollo.MutationFunction<StopZendeskSyncJobMutation, StopZendeskSyncJobMutationVariables>;

/**
 * __useStopZendeskSyncJobMutation__
 *
 * To run a mutation, you first call `useStopZendeskSyncJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopZendeskSyncJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopZendeskSyncJobMutation, { data, loading, error }] = useStopZendeskSyncJobMutation({
 *   variables: {
 *   },
 * });
 */
export function useStopZendeskSyncJobMutation(baseOptions?: Apollo.MutationHookOptions<StopZendeskSyncJobMutation, StopZendeskSyncJobMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StopZendeskSyncJobMutation, StopZendeskSyncJobMutationVariables>(StopZendeskSyncJobDocument, options);
}
export type StopZendeskSyncJobMutationHookResult = ReturnType<typeof useStopZendeskSyncJobMutation>;
export type StopZendeskSyncJobMutationResult = Apollo.MutationResult<StopZendeskSyncJobMutation>;
export type StopZendeskSyncJobMutationOptions = Apollo.BaseMutationOptions<StopZendeskSyncJobMutation, StopZendeskSyncJobMutationVariables>;
export const ResetZendeskSyncJobDocument = gql`
  mutation resetZendeskSyncJob {
    resetZendeskSyncJob {
      ...ZendeskSyncJobFields
    }
  }
  ${ZendeskSyncJobFieldsFragmentDoc}
`;
export type ResetZendeskSyncJobMutationFn = Apollo.MutationFunction<ResetZendeskSyncJobMutation, ResetZendeskSyncJobMutationVariables>;

/**
 * __useResetZendeskSyncJobMutation__
 *
 * To run a mutation, you first call `useResetZendeskSyncJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetZendeskSyncJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetZendeskSyncJobMutation, { data, loading, error }] = useResetZendeskSyncJobMutation({
 *   variables: {
 *   },
 * });
 */
export function useResetZendeskSyncJobMutation(baseOptions?: Apollo.MutationHookOptions<ResetZendeskSyncJobMutation, ResetZendeskSyncJobMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ResetZendeskSyncJobMutation, ResetZendeskSyncJobMutationVariables>(ResetZendeskSyncJobDocument, options);
}
export type ResetZendeskSyncJobMutationHookResult = ReturnType<typeof useResetZendeskSyncJobMutation>;
export type ResetZendeskSyncJobMutationResult = Apollo.MutationResult<ResetZendeskSyncJobMutation>;
export type ResetZendeskSyncJobMutationOptions = Apollo.BaseMutationOptions<ResetZendeskSyncJobMutation, ResetZendeskSyncJobMutationVariables>;
